// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"5Tqlz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _reactRouterDom = require("react-router-dom");
var _reactHelmetAsync = require("react-helmet-async");
var _main = require("./screens/Main/Main");
var _mainDefault = parcelHelpers.interopDefault(_main);
var _alternatives = require("./screens/Alternatives/Alternatives");
var _alternativesDefault = parcelHelpers.interopDefault(_alternatives);
var _documentationPage = require("./screens/DocumentationPage/DocumentationPage");
var _documentationPageDefault = parcelHelpers.interopDefault(_documentationPage);
var _comparisonPage = require("./screens/ComparisonPage/ComparisonPage");
var _comparisonPageDefault = parcelHelpers.interopDefault(_comparisonPage);
var _blog = require("./screens/Blog/Blog");
var _specificBlog = require("./screens/SpecificBlog/SpecificBlog");
var _specificBlogDefault = parcelHelpers.interopDefault(_specificBlog);
var _feature = require("./screens/FeaturePage/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _requestADemo = require("./screens/RequestADemo/RequestADemo");
var _requestADemoDefault = parcelHelpers.interopDefault(_requestADemo);
var _notFoundPage = require("./screens/NotFoundPage/NotFoundPage");
var _notFoundPageDefault = parcelHelpers.interopDefault(_notFoundPage);
var _thanksForSubmission = require("./screens/ThanksForSubmission/ThanksForSubmission");
var _thanksForSubmissionDefault = parcelHelpers.interopDefault(_thanksForSubmission);
var _blogData = require("./blogData");
function App() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmetAsync.HelmetProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/blog",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blog.Blog), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/alternatives/:companyName",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonPageDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/feature/:featureName",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/alternatives",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alternativesDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/request-a-demo",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requestADemoDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/thank-you/submission",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thanksForSubmissionDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/documentation",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentationPageDefault.default), {})
                    }),
                    (0, _blogData.blogPosts).map((post, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: `/blog/${(0, _blogData.createSlug)(post.title)}`,
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _specificBlogDefault.default), {
                                label: post.label,
                                title: post.title,
                                metaDescription: post.metaDescription,
                                metaTitle: post.metaTitle,
                                content: post.content,
                                authorName: post.author,
                                date: post.date,
                                readTime: post.readTime,
                                authorImageUrl: post.authorImageUrl,
                                blogImage: post.blogImage
                            })
                        }, index)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "*",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFoundPageDefault.default), {})
                    })
                ]
            })
        })
    });
}
const app = document.getElementById("app");
const root = (0, _clientDefault.default).createRoot(app);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(App, {}));

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom/client":"5ccwt","react-router-dom":"l6ORY","react-helmet-async":"5Z9jX","./screens/Main/Main":"bOU1C","./screens/Alternatives/Alternatives":"3Iv0m","./screens/DocumentationPage/DocumentationPage":"jpLAL","./screens/ComparisonPage/ComparisonPage":"EuFTd","./screens/Blog/Blog":"cZ0YM","./screens/SpecificBlog/SpecificBlog":"gHXHB","./screens/FeaturePage/Feature":"2N59i","./screens/RequestADemo/RequestADemo":"lNOdI","./screens/NotFoundPage/NotFoundPage":"71jiP","./screens/ThanksForSubmission/ThanksForSubmission":"7UjHy","./blogData":"xrdVS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.2.0";

},{}],"5ccwt":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"b8T3j":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var Mg = Uf(null), Ng = null, Og = null, Pg = null;
function Qg() {
    Pg = Og = Ng = null;
}
function Rg(a) {
    var b = Mg.current;
    E(Mg);
    a._currentValue = b;
}
function Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function Tg(a, b) {
    Ng = a;
    Pg = Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (Ug = !0), a.firstContext = null);
}
function Vg(a) {
    var b = a._currentValue;
    if (Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Og) {
            if (null === Ng) throw Error(p(308));
            Og = a;
            Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Og = Og.next = a;
    }
    return b;
}
var Wg = null;
function Xg(a) {
    null === Wg ? Wg = [
        a
    ] : Wg.push(a);
}
function Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return Zg(a, d);
}
function Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $g = !1;
function ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return Zg(a, c);
}
function eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function gh(a, b, c, d) {
    var e = a.updateQueue;
    $g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            $g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var jh = (new aa.Component).refs;
function kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = L(), d = lh(a), e = ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = dh(a, e, d);
        null !== b && (mh(b, a, d, c), eh(b, a, d));
    }
};
function oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function ph(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = Vg(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && nh.enqueueReplaceState(b, b.state, null);
}
function rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = jh;
    ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = Vg(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && nh.enqueueReplaceState(e, e.state, null), gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function uh(a) {
    var b = a._init;
    return b(a._payload);
}
function vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && uh(f) === b.type)) return d = e(b, c.props), d.ref = sh(a, b, c), d.return = a, d;
        d = yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = yh(b.type, b.key, b.props, null, a.mode, c), c.ref = sh(a, null, b), c.return = a, c;
                case wa:
                    return b = zh(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Ah(b, a.mode, c, null), b.return = a, b;
            th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = yh(f.type, f.key, f.props, null, a.mode, h), h.ref = sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Bh = vh(!0), Ch = vh(!1), Dh = {}, Eh = Uf(Dh), Fh = Uf(Dh), Gh = Uf(Dh);
function Hh(a) {
    if (a === Dh) throw Error(p(174));
    return a;
}
function Ih(a, b) {
    G(Gh, b);
    G(Fh, a);
    G(Eh, Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(Eh);
    G(Eh, b);
}
function Jh() {
    E(Eh);
    E(Fh);
    E(Gh);
}
function Kh(a) {
    Hh(Gh.current);
    var b = Hh(Eh.current);
    var c = lb(b, a.type);
    b !== c && (G(Fh, a), G(Eh, c));
}
function Lh(a) {
    Fh.current === a && (E(Eh), E(Fh));
}
var M = Uf(0);
function Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Nh = [];
function Oh() {
    for(var a = 0; a < Nh.length; a++)Nh[a]._workInProgressVersionPrimary = null;
    Nh.length = 0;
}
var Ph = ua.ReactCurrentDispatcher, Qh = ua.ReactCurrentBatchConfig, Rh = 0, N = null, O = null, P = null, Sh = !1, Th = !1, Uh = 0, Vh = 0;
function Q() {
    throw Error(p(321));
}
function Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Xh(a, b, c, d, e, f) {
    Rh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Ph.current = null === a || null === a.memoizedState ? Yh : Zh;
    a = c(d, e);
    if (Th) {
        f = 0;
        do {
            Th = !1;
            Uh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            Ph.current = $h;
            a = c(d, e);
        }while (Th);
    }
    Ph.current = ai;
    b = null !== O && null !== O.next;
    Rh = 0;
    P = O = N = null;
    Sh = !1;
    if (b) throw Error(p(300));
    return a;
}
function bi() {
    var a = 0 !== Uh;
    Uh = 0;
    return a;
}
function ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function di() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(p(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function fi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                N.lanes |= m;
                hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, N.lanes |= f, hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function gi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function hi() {}
function ii(a, b) {
    var c = N, d = di(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, Ug = !0);
    d = d.queue;
    ji(ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== P && P.memoizedState.tag & 1) {
        c.flags |= 2048;
        li(9, mi.bind(null, c, d, e, b), void 0, null);
        if (null === R) throw Error(p(349));
        0 !== (Rh & 30) || ni(c, b, e);
    }
    return e;
}
function ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    oi(b) && pi(a);
}
function ki(a, b, c) {
    return c(function() {
        oi(b) && pi(a);
    });
}
function oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function pi(a) {
    var b = Zg(a, 1);
    null !== b && mh(b, a, 1, -1);
}
function qi(a) {
    var b = ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ri.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function si() {
    return di().memoizedState;
}
function ti(a, b, c, d) {
    var e = ci();
    N.flags |= a;
    e.memoizedState = li(1 | b, c, void 0, void 0 === d ? null : d);
}
function ui(a, b, c, d) {
    var e = di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && Wh(d, g.deps)) {
            e.memoizedState = li(b, c, f, d);
            return;
        }
    }
    N.flags |= a;
    e.memoizedState = li(1 | b, c, f, d);
}
function vi(a, b) {
    return ti(8390656, 8, a, b);
}
function ji(a, b) {
    return ui(2048, 8, a, b);
}
function wi(a, b) {
    return ui(4, 2, a, b);
}
function xi(a, b) {
    return ui(4, 4, a, b);
}
function yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return ui(4, 4, yi.bind(null, b, a), c);
}
function Ai() {}
function Bi(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ci(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Di(a, b, c) {
    if (0 === (Rh & 21)) return a.baseState && (a.baseState = !1, Ug = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), N.lanes |= c, hh |= c, a.baseState = !0);
    return b;
}
function Ei(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Qh.transition;
    Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Qh.transition = d;
    }
}
function Fi() {
    return di().memoizedState;
}
function Gi(a, b, c) {
    var d = lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, c);
    else if (c = Yg(a, b, c, d), null !== c) {
        var e = L();
        mh(c, a, d, e);
        Ji(c, b, d);
    }
}
function ri(a, b, c) {
    var d = lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = Yg(a, b, e, d);
        null !== c && (e = L(), mh(c, a, d, e), Ji(c, b, d));
    }
}
function Hi(a) {
    var b = a.alternate;
    return a === N || null !== b && b === N;
}
function Ii(a, b) {
    Th = Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var ai = {
    readContext: Vg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useInsertionEffect: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useDeferredValue: Q,
    useTransition: Q,
    useMutableSource: Q,
    useSyncExternalStore: Q,
    useId: Q,
    unstable_isNewReconciler: !1
}, Yh = {
    readContext: Vg,
    useCallback: function(a, b) {
        ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: Vg,
    useEffect: vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ti(4194308, 4, yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Gi.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: qi,
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        return ci().memoizedState = a;
    },
    useTransition: function() {
        var a = qi(!1), b = a[0];
        a = Ei.bind(null, a[1]);
        ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = N, e = ci();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === R) throw Error(p(349));
            0 !== (Rh & 30) || ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        vi(ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        li(9, mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = ci(), b = R.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Zh = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: fi,
    useRef: si,
    useState: function() {
        return fi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = fi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
}, $h = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: gi,
    useRef: si,
    useState: function() {
        return gi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return null === O ? b.memoizedState = a : Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = gi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
};
function Ki(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Ni = "function" === typeof WeakMap ? WeakMap : Map;
function Oi(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Pi || (Pi = !0, Qi = d);
        Mi(a, b);
    };
    return c;
}
function Ri(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Mi(a, b);
        "function" !== typeof d && (null === Si ? Si = new Set([
            this
        ]) : Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ui.bind(null, a, b, c), b.then(a, a));
}
function Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ch(-1, 1), b.tag = 2, dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Xi = ua.ReactCurrentOwner, Ug = !1;
function Yi(a, b, c, d) {
    b.child = null === a ? Ch(b, null, c, d) : Bh(b, a.child, c, d);
}
function Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    Tg(b, e);
    d = Xh(a, b, c, d, f, e);
    c = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Yi(a, b, d, e);
    return b.child;
}
function aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, cj(a, b, f, d, e);
        a = yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return $i(a, b, e);
    }
    b.flags |= 1;
    a = wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (Ug = !0);
            else return b.lanes = a.lanes, $i(a, b, e);
        }
    }
    return dj(a, b, c, d, e);
}
function ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(fj, gj), gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(fj, gj), gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(fj, gj);
            gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(fj, gj), gj |= d;
    Yi(a, b, e, c);
    return b.child;
}
function hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function dj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    Tg(b, e);
    c = Xh(a, b, c, d, f, e);
    d = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Yi(a, b, c, e);
    return b.child;
}
function ij(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    Tg(b, e);
    if (null === b.stateNode) jj(a, b), ph(b, c, d), rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = Vg(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && qh(b, g, d, l);
        $g = !1;
        var r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || $g ? ("function" === typeof m && (kh(b, c, m, d), k = b.memoizedState), (h = $g || oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = Vg(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && qh(b, g, d, k);
        $g = !1;
        r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || $g ? ("function" === typeof y && (kh(b, c, y, d), n = b.memoizedState), (l = $g || oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return kj(a, b, c, d, f, e);
}
function kj(a, b, c, d, e, f) {
    hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), $i(a, b, f);
    d = b.stateNode;
    Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Bh(b, a.child, null, f), b.child = Bh(b, null, h, f)) : Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function lj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    Ih(a, b.containerInfo);
}
function mj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Yi(a, b, c, d);
    return b.child;
}
var nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function pj(a, b, c) {
    var d = b.pendingProps, e = M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(M, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = qj(g, d, 0, null), a = Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = oj(c), b.memoizedState = nj, a) : rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = wh(h, f) : (f = Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function rj(a, b) {
    b = qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function tj(a, b, c, d) {
    null !== d && Jg(d);
    Bh(b, a.child, null, c);
    a = rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Li(Error(p(422))), tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Bh(b, a.child, null, g);
        b.child.memoizedState = oj(g);
        b.memoizedState = nj;
        return f;
    }
    if (0 === (b.mode & 1)) return tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Li(f, d, void 0);
        return tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (Ug || h) {
        d = R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, Zg(a, e), mh(d, a, e, -1));
        }
        uj();
        d = Li(Error(p(421)));
        return tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    Sg(a.return, b, c);
}
function xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Yi(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && wj(a, c, b);
            else if (19 === a.tag) wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            xj(b, !0, c, null, f);
            break;
        case "together":
            xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function zj(a, b, c) {
    switch(b.tag){
        case 3:
            lj(b);
            Ig();
            break;
        case 5:
            Kh(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(M, M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return pj(a, b, c);
                G(M, M.current & 1);
                a = $i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(M, M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(M, M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, ej(a, b, c);
    }
    return $i(a, b, c);
}
var Aj, Bj, Cj, Dj;
Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Bj = function() {};
Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Hh(Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Ej(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Fj(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            Jh();
            E(Wf);
            E(H);
            Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Gj(zg), zg = null));
            Bj(a, b);
            S(b);
            return null;
        case 5:
            Lh(b);
            var e = Hh(Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = Hh(Gh.current);
                Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Gj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (M.current & 1) ? 0 === T && (T = 3) : uj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return Jh(), Bj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return Rg(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(M);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Ej(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(M, M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Hj && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Hj && 1073741824 !== c && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = M.current, G(M, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (gj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Jj(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return Jh(), E(Wf), E(H), Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Lh(b), null;
        case 13:
            E(M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(M), null;
        case 4:
            return Jh(), null;
        case 10:
            return Rg(b.type._context), null;
        case 22:
        case 23:
            return Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Kj = !1, U = !1, Lj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Oj = !1;
function Pj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Oj;
    Oj = !1;
    return n;
}
function Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
function Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Xj(a, b, c), a = a.sibling; null !== a;)Xj(a, b, c), a = a.sibling;
}
var X = null, Yj = !1;
function Zj(a, b, c) {
    for(c = c.child; null !== c;)ak(a, b, c), c = c.sibling;
}
function ak(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Mj(c, b);
        case 6:
            var d = X, e = Yj;
            X = null;
            Zj(a, b, c);
            X = d;
            Yj = e;
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Yj;
            X = c.stateNode.containerInfo;
            Yj = !0;
            Zj(a, b, c);
            X = d;
            Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Nj(c, b, g) : 0 !== (f & 4) && Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Zj(a, b, c);
            break;
        case 1:
            if (!U && (Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Zj(a, b, c);
            break;
        case 21:
            Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Zj(a, b, c), U = d) : Zj(a, b, c);
            break;
        default:
            Zj(a, b, c);
    }
}
function bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Lj);
        b.forEach(function(b) {
            var d = ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Yj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            ak(f, g, e);
            X = null;
            Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)ek(b, a), b = b.sibling;
}
function ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            dk(b, a);
            fk(a);
            if (d & 4) {
                try {
                    Qj(3, a, a.return), Rj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Qj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            break;
        case 5:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            dk(b, a);
            fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            dk(b, a);
            fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            dk(b, a);
            fk(a);
            break;
        case 13:
            dk(b, a);
            fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (gk = B()));
            d & 4 && bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, dk(b, a), U = l) : dk(b, a);
            fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Qj(4, r, r.return);
                                break;
                            case 1:
                                Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            dk(b, a);
            fk(a);
            d & 4 && bk(a);
            break;
        case 21:
            break;
        default:
            dk(b, a), fk(a);
    }
}
function fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Vj(a);
                    Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Vj(a);
                    Wj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function ik(a, b, c) {
    V = a;
    jk(a, b, c);
}
function jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Kj;
                var l = U;
                Kj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? kk(e) : null !== k ? (k.return = g, V = k) : kk(e);
                for(; null !== f;)V = f, jk(f, b, c), f = f.sibling;
                V = e;
                Kj = h;
                U = l;
            }
            lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : lk(a, b, c);
    }
}
function lk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Sj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function hk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Rj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var mk = Math.ceil, nk = ua.ReactCurrentDispatcher, ok = ua.ReactCurrentOwner, pk = ua.ReactCurrentBatchConfig, K = 0, R = null, Y = null, Z = 0, gj = 0, fj = Uf(0), T = 0, qk = null, hh = 0, rk = 0, sk = 0, tk = null, uk = null, gk = 0, Hj = Infinity, vk = null, Pi = !1, Qi = null, Si = null, wk = !1, xk = null, yk = 0, zk = 0, Ak = null, Bk = -1, Ck = 0;
function L() {
    return 0 !== (K & 6) ? B() : -1 !== Bk ? Bk : Bk = B();
}
function lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Ck && (Ck = yc()), Ck;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function mh(a, b, c, d) {
    if (50 < zk) throw zk = 0, Ak = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== R) a === R && (0 === (K & 2) && (rk |= c), 4 === T && Dk(a, Z)), Ek(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Hj = B() + 500, fg && jg());
}
function Ek(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Fk.bind(null, a)) : hg(Fk.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Gk(c, Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Hk(a, b) {
    Bk = -1;
    Ck = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Ik() && a.callbackNode !== c) return null;
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Jk(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Kk();
        if (R !== a || Z !== b) vk = null, Hj = B() + 500, Lk(a, b);
        for(;;)try {
            Mk();
            break;
        } catch (h) {
            Nk(a, h);
        }
        Qg();
        nk.current = f;
        K = e;
        null !== Y ? b = 0 : (R = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Ok(a, e)));
        if (1 === b) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
        if (6 === b) Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Pk(e) && (b = Jk(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Ok(a, f))), 1 === b)) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Qk(a, uk, vk);
                    break;
                case 3:
                    Dk(a, d);
                    if ((d & 130023424) === d && (b = gk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), b);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 4:
                    Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), d);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 5:
                    Qk(a, uk, vk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Ek(a, B());
    return a.callbackNode === c ? Hk.bind(null, a) : null;
}
function Ok(a, b) {
    var c = tk;
    a.current.memoizedState.isDehydrated && (Lk(a, b).flags |= 256);
    a = Jk(a, b);
    2 !== a && (b = uk, uk = c, null !== b && Gj(b));
    return a;
}
function Gj(a) {
    null === uk ? uk = a : uk.push.apply(uk, a);
}
function Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Dk(a, b) {
    b &= ~sk;
    b &= ~rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Fk(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Ik();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Ek(a, B()), null;
    var c = Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Ok(a, d));
    }
    if (1 === c) throw c = qk, Lk(a, 0), Dk(a, b), Ek(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Qk(a, uk, vk);
    Ek(a, B());
    return null;
}
function Rk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Hj = B() + 500, fg && jg());
    }
}
function Sk(a) {
    null !== xk && 0 === xk.tag && 0 === (K & 6) && Ik();
    var b = K;
    K |= 1;
    var c = pk.transition, d = C;
    try {
        if (pk.transition = null, C = 1, a) return a();
    } finally{
        C = d, pk.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Ij() {
    gj = fj.current;
    E(fj);
}
function Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                Jh();
                E(Wf);
                E(H);
                Oh();
                break;
            case 5:
                Lh(d);
                break;
            case 4:
                Jh();
                break;
            case 13:
                E(M);
                break;
            case 19:
                E(M);
                break;
            case 10:
                Rg(d.type._context);
                break;
            case 22:
            case 23:
                Ij();
        }
        c = c.return;
    }
    R = a;
    Y = a = wh(a.current, null);
    Z = gj = b;
    T = 0;
    qk = null;
    sk = rk = hh = 0;
    uk = tk = null;
    if (null !== Wg) {
        for(b = 0; b < Wg.length; b++)if (c = Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        Wg = null;
    }
    return a;
}
function Nk(a, b) {
    do {
        var c = Y;
        try {
            Qg();
            Ph.current = ai;
            if (Sh) {
                for(var d = N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Sh = !1;
            }
            Rh = 0;
            P = O = N = null;
            Th = !1;
            Uh = 0;
            ok.current = null;
            if (null === c || null === c.return) {
                T = 1;
                qk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Wi(y, g, h, f, b);
                        y.mode & 1 && Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Ti(f, l, b);
                            uj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Wi(J, g, h, f, b);
                        Jg(Ki(k, h));
                        break a;
                    }
                }
                f = k = Ki(k, h);
                4 !== T && (T = 2);
                null === tk ? tk = [
                    f
                ] : tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Oi(f, k, b);
                            fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Si || !Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Ri(f, h, b);
                                fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Tk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Kk() {
    var a = nk.current;
    nk.current = ai;
    return null === a ? ai : a;
}
function uj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === R || 0 === (hh & 268435455) && 0 === (rk & 268435455) || Dk(R, Z);
}
function Jk(a, b) {
    var c = K;
    K |= 2;
    var d = Kk();
    if (R !== a || Z !== b) vk = null, Lk(a, b);
    for(;;)try {
        Uk();
        break;
    } catch (e) {
        Nk(a, e);
    }
    Qg();
    K = c;
    nk.current = d;
    if (null !== Y) throw Error(p(261));
    R = null;
    Z = 0;
    return T;
}
function Uk() {
    for(; null !== Y;)Vk(Y);
}
function Mk() {
    for(; null !== Y && !cc();)Vk(Y);
}
function Vk(a) {
    var b = Wk(a.alternate, a, gj);
    a.memoizedProps = a.pendingProps;
    null === b ? Tk(a) : Y = b;
    ok.current = null;
}
function Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Fj(c, b, gj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Qk(a, b, c) {
    var d = C, e = pk.transition;
    try {
        pk.transition = null, C = 1, Xk(a, b, c, d);
    } finally{
        pk.transition = e, C = d;
    }
    return null;
}
function Xk(a, b, c, d) {
    do Ik();
    while (null !== xk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === R && (Y = R = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || wk || (wk = !0, Gk(hc, function() {
        Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = pk.transition;
        pk.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        ok.current = null;
        Pj(a, c);
        ek(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        ik(c, a, e);
        dc();
        K = h;
        C = g;
        pk.transition = f;
    } else a.current = c;
    wk && (wk = !1, xk = a, yk = e);
    f = a.pendingLanes;
    0 === f && (Si = null);
    mc(c.stateNode, d);
    Ek(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Pi) throw Pi = !1, a = Qi, Qi = null, a;
    0 !== (yk & 1) && 0 !== a.tag && Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === Ak ? zk++ : (zk = 0, Ak = a) : zk = 0;
    jg();
    return null;
}
function Ik() {
    if (null !== xk) {
        var a = Dc(yk), b = pk.transition, c = C;
        try {
            pk.transition = null;
            C = 16 > a ? 16 : a;
            if (null === xk) var d = !1;
            else {
                a = xk;
                xk = null;
                yk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Tj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Rj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, pk.transition = b;
        }
    }
    return !1;
}
function Yk(a, b, c) {
    b = Ki(c, b);
    b = Oi(a, b, 1);
    a = dh(a, b, 1);
    b = L();
    null !== a && (Ac(a, 1, b), Ek(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Si || !Si.has(d))) {
                a = Ki(c, a);
                a = Ri(b, a, 1);
                b = dh(b, a, 1);
                a = L();
                null !== b && (Ac(b, 1, a), Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = L();
    a.pingedLanes |= a.suspendedLanes & c;
    R === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - gk ? Lk(a, 0) : sk |= c);
    Ek(a, b);
}
function Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = L();
    a = Zg(a, b);
    null !== a && (Ac(a, b, c), Ek(a, c));
}
function vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Zk(a, c);
}
function ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Zk(a, c);
}
var Wk;
Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return Ug = !1, zj(a, b, c);
            Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else Ug = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            jj(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            Tg(b, c);
            e = Xh(null, b, d, a, e, c);
            var f = bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ah(b), e.updater = nh, b.stateNode = e, e._reactInternals = b, rh(b, d, a, c), b = kj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $k(d);
                a = Lg(d, a);
                switch(e){
                    case 0:
                        b = dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = aj(null, b, d, Lg(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), ij(a, b, d, e, c);
        case 3:
            a: {
                lj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                bh(a, b);
                gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ki(Error(p(423)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ki(Error(p(424)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = $i(a, b, c);
                        break a;
                    }
                    Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Kh(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), hj(a, b), Yi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return pj(a, b, c);
        case 4:
            return Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Bh(b, null, d, c) : Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), Zi(a, b, d, e, c);
        case 7:
            return Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = $i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, Tg(b, c), e = Vg(e), d = d(e), b.flags |= 1, Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Lg(d, b.pendingProps), e = Lg(d.type, e), aj(a, b, d, e, c);
        case 15:
            return cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), jj(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, Tg(b, c), ph(b, d, e), rh(b, d, e, c), kj(null, b, d, !0, a, c);
        case 19:
            return yj(a, b, c);
        case 22:
            return ej(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Gk(a, b) {
    return ac(a, b);
}
function al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new al(a, b, c, d);
}
function bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $k(a) {
    if ("function" === typeof a) return bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function wh(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Ah(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Ah(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function qj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function xh(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function zh(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function cl(a, b, c, d, e, f, g, h, k) {
    a = new bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    ah(f);
    return a;
}
function dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function el(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function fl(a, b, c, d, e, f, g, h, k) {
    a = cl(c, d, !0, a, e, f, g, h, k);
    a.context = el(null);
    c = a.current;
    d = L();
    e = lh(c);
    f = ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    dh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Ek(a, d);
    return a;
}
function gl(a, b, c, d) {
    var e = b.current, f = L(), g = lh(e);
    c = el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = dh(e, b, g);
    null !== a && (mh(a, e, g, f), eh(a, e, g));
    return g;
}
function hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function jl(a, b) {
    il(a, b);
    (a = a.alternate) && il(a, b);
}
function kl() {
    return null;
}
var ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ml(a) {
    this._internalRoot = a;
}
nl.prototype.render = ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    gl(a, b, null, null);
};
nl.prototype.unmount = ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Sk(function() {
            gl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function nl(a) {
    this._internalRoot = a;
}
nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function ql() {}
function rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = hl(g);
                f.call(a);
            };
        }
        var g = fl(b, d, a, 0, null, !1, !1, "", ql);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = hl(k);
            h.call(a);
        };
    }
    var k = cl(a, 0, !1, null, null, !1, !1, "", ql);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Sk(function() {
        gl(b, k, c, d);
    });
    return k;
}
function sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = hl(g);
                h.call(a);
            };
        }
        gl(b, g, a, e);
    } else g = rl(c, b, a, e, d);
    return hl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Ek(b, B()), 0 === (K & 6) && (Hj = B() + 500, jg()));
            }
            break;
        case 13:
            Sk(function() {
                var b = Zg(a, 1);
                if (null !== b) {
                    var c = L();
                    mh(b, a, 1, c);
                }
            }), jl(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = Zg(a, 134217728);
        if (null !== b) {
            var c = L();
            mh(b, a, 134217728, c);
        }
        jl(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = lh(a), c = Zg(a, b);
        if (null !== c) {
            var d = L();
            mh(c, a, b, d);
        }
        jl(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Rk;
Hb = Sk;
var tl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Rk
    ]
}, ul = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var vl = {
    bundleType: ul.bundleType,
    version: ul.version,
    rendererPackageName: ul.rendererPackageName,
    rendererConfig: ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: ul.findFiberByHostInstance || kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!wl.isDisabled && wl.supportsFiber) try {
        kc = wl.inject(vl), lc = wl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!ol(b)) throw Error(p(200));
    return dl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!ol(a)) throw Error(p(299));
    var c = !1, d = "", e = ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = cl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ml(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Sk(a);
};
exports.hydrate = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!ol(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new nl(b);
};
exports.render = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!pl(a)) throw Error(p(40));
    return a._reactRootContainer ? (Sk(function() {
        sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Rk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!pl(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return sl(a, b, c, !1, d);
};
exports.version = "18.2.0-next-9e3b772b8-20220608";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"l6ORY":[function(require,module,exports) {
/**
 * React Router DOM v6.19.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "unstable_useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function DataRoutes(_ref3) {
    let { routes, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, unstable_viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, unstable_viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, unstable_viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            unstable_viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = _react.useState(key || "");
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"6uln9","react-dom":"b8T3j","react-router":"kbGcH","@remix-run/router":"aNWKZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbGcH":[function(require,module,exports) {
/**
 * React Router v6.19.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    // Use the full pathname for the leaf match so we include splat values
    // for "." links
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getPathContributingMatches)(matches).map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, state } = _ref2;
    return useRoutesImpl(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? AwaitRenderStatus.error : promise._data !== undefined ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties
    }).initialize();
}

},{"react":"6uln9","@remix-run/router":"aNWKZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aNWKZ":[function(require,module,exports) {
/**
 * @remix-run/router v1.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_getPathContributingMatches", ()=>getPathContributingMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    safelyDecodeURI(pathname));
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:\w+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        warning(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else if (isPathRelative) {
        let fromSegments = routePathnames[routePathnames.length - 1].replace(/^\//, "").split("/");
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="path", each leading .. segment means "go up one URL segment"
            while(toSegments[0] === ".."){
                toSegments.shift();
                fromSegments.pop();
            }
            to.pathname = toSegments.join("/");
        }
        from = "/" + fromSegments.join("/");
    } else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="route" (the default), each leading .. segment means
            // "go up one route" instead of "go up one URL segment".  This is a key
            // difference from how <a href> works and a major reason we call this a
            // "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited, loaderData, errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState(_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results, loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        if (isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                updateFetcherState(key, getLoadingFetcher(submission));
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results, loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission, fetcherSubmission, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        invariant(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return callLoaderOrAction("loader", createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: ResultType.error,
                        error: getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results,
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if (isQueryRouteResponse(e)) {
                if (e.type === ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            result = await callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest,
                requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return _extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: _extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest,
                    requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getPathContributingMatches(contextualMatches).map((m)=>m.pathnameBase), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if (isResponse(result)) {
        let status = result.status;
        // Process redirects
        if (redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!ABSOLUTE_URL_REGEX.test(location)) location = normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = stripBasename(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: ResultType.redirect,
                status,
                location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === ResultType.error ? ResultType.error : ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === ResultType.error) return {
            type: resultType,
            error: new ErrorResponseImpl(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === ResultType.error) return {
        type: resultType,
        error: result
    };
    if (isDeferredData(result)) {
        var _result$init, _result$init2;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if (isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, match, controller } = revalidatingFetchers[index];
        invariant(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if (isRedirectResult(result)) return {
            result,
            idx: i
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isQueryRouteResponse(obj) {
    return obj && isResponse(obj.response) && (obj.type === ResultType.data || obj.type === ResultType.error);
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            invariant(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"5Z9jX":[function(require,module,exports) {
// src/index.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Helmet", ()=>Helmet);
parcelHelpers.export(exports, "HelmetData", ()=>HelmetData);
parcelHelpers.export(exports, "HelmetProvider", ()=>HelmetProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
// src/constants.ts
var TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})(TAG_NAMES || {});
var SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var VALID_TAG_NAMES = Object.values(TAG_NAMES);
var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var getTitleFromPropsList = (propsList)=>{
    let innermostTitle = getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var getOnChangeClientState = (propsList)=>getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var reducePropsToState = (propsList)=>({
        baseTag: getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: getAnyTrueFromPropsList(propsList, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if (checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = generateElementAttributesAsString(attributes);
    const flattenedTitle = flattenArray(title);
    return attributeString ? `<${type} ${HELMET_ATTRIBUTE}="true" ${attributeString}>${encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${HELMET_ATTRIBUTE}="true">${encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [HELMET_ATTRIBUTE]: true
    };
    const props = convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, _reactDefault.default).createElement("title" /* TITLE */ , props, title)
    ];
};
var generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, _reactDefault.default).createElement(type, mappedTag);
    });
var getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>convertElementAttributesToReactProps(tags),
                toString: ()=>generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>generateTagsAsReactComponent(type, tags),
                toString: ()=>generateTagsAsString(type, tags, encode)
            };
    }
};
var getPriorityMethods = ({ metaTags, linkTags, scriptTags, encode })=>{
    const meta = prioritizer(metaTags, SEO_PRIORITY_TAGS.meta);
    const link = prioritizer(linkTags, SEO_PRIORITY_TAGS.link);
    const script = prioritizer(scriptTags, SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var mapStateOnServer = (props)=>{
    const { baseTag, bodyAttributes, encode = true, htmlAttributes, noscriptTags, styleTags, title = "", titleAttributes, prioritizeSeoTags } = props;
    let { linkTags, metaTags, scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>{},
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods, linkTags, metaTags, scriptTags } = getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: getMethodsForTag("title" /* TITLE */ , {
            title,
            titleAttributes
        }, encode)
    };
};
var server_default = mapStateOnServer;
// src/HelmetData.ts
var instances = [];
var isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var HelmetData = class {
    instances = [];
    canUseDOM = isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? instances : this.instances).indexOf(instance);
                (this.canUseDOM ? instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
// src/Provider.tsx
var defaultValue = {};
var Context = (0, _reactDefault.default).createContext(defaultValue);
var HelmetProvider = class _HelmetProvider extends (0, _react.Component) {
    static canUseDOM = isDocument;
    helmetData;
    constructor(props){
        super(props);
        this.helmetData = new HelmetData(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        return /* @__PURE__ */ (0, _reactDefault.default).createElement(Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute(HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags,
        newTags
    };
};
var updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute(HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = flattenArray(title);
    updateAttributes("title" /* TITLE */ , attributes);
};
var commitTagChanges = (newState, cb)=>{
    const { baseTag, bodyAttributes, htmlAttributes, linkTags, metaTags, noscriptTags, onChangeClientState, scriptTags, styleTags, title, titleAttributes } = newState;
    updateAttributes("body" /* BODY */ , bodyAttributes);
    updateAttributes("html" /* HTML */ , htmlAttributes);
    updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: updateTags("base" /* BASE */ , baseTag),
        linkTags: updateTags("link" /* LINK */ , linkTags),
        metaTags: updateTags("meta" /* META */ , metaTags),
        noscriptTags: updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags, oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var _helmetCallback = null;
var handleStateChangeOnClient = (newState)=>{
    if (_helmetCallback) cancelAnimationFrame(_helmetCallback);
    if (newState.defer) _helmetCallback = requestAnimationFrame(()=>{
        commitTagChanges(newState, ()=>{
            _helmetCallback = null;
        });
    });
    else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};
var client_default = handleStateChangeOnClient;
// src/Dispatcher.tsx
var HelmetDispatcher = class extends (0, _react.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, _shallowequalDefault.default)(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances, setHelmet } = this.props.context;
        let serverState = null;
        const state = reducePropsToState(helmetInstances.get().map((instance)=>{
            const props = {
                ...instance.props
            };
            delete props.context;
            return props;
        }));
        if (HelmetProvider.canUseDOM) client_default(state);
        else if (server_default) serverState = server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
// src/index.tsx
var Helmet = class extends (0, _react.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, _reactFastCompareDefault.default)(without(this.props, "helmetData"), without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, _invariantDefault.default)(VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, _invariantDefault.default)(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, _reactDefault.default).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof HelmetData)) {
            const data = helmetData;
            helmetData = new HelmetData(data.context, true);
            delete newProps.helmetData;
        }
        return helmetData ? /* @__PURE__ */ (0, _reactDefault.default).createElement(HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, _reactDefault.default).createElement(Context.Consumer, null, (context)=>/* @__PURE__ */ (0, _reactDefault.default).createElement(HelmetDispatcher, {
                ...newProps,
                context
            }));
    }
};

},{"react":"6uln9","react-fast-compare":"7oSaD","invariant":"9pmgK","shallowequal":"4Nq3A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7oSaD":[function(require,module,exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"9pmgK":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"4Nq3A":[function(require,module,exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"bOU1C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Main", ()=>Main);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("../../components/Button");
var _quote = require("../../components/Quote");
var _avatar = require("../../icons/Avatar");
var _iconsCloudLaptop = require("../../icons/IconsCloudLaptop");
var _iconsHouse1 = require("../../icons/IconsHouse1");
var _iconsHouse2 = require("../../icons/IconsHouse2");
var _iconsPhone = require("../../icons/IconsPhone");
var _iconsPlug1 = require("../../icons/IconsPlug1");
var _styleCss = require("./style.css");
var _iconsMill = require("../../icons/IconsMill");
var _workerPng = require("../../assets/worker.png");
var _workerPngDefault = parcelHelpers.interopDefault(_workerPng);
var _placeholderPng = require("../../assets/placeholder.png");
var _placeholderPngDefault = parcelHelpers.interopDefault(_placeholderPng);
var _trailbluvideoMp4 = require("../../assets/trailbluvideo.mp4");
var _trailbluvideoMp4Default = parcelHelpers.interopDefault(_trailbluvideoMp4);
var _coloredFibaBankaPng = require("../../assets/coloredFibaBanka.png");
var _coloredFibaBankaPngDefault = parcelHelpers.interopDefault(_coloredFibaBankaPng);
var _coloredAktifBankPng = require("../../assets/coloredAktifBank.png");
var _coloredAktifBankPngDefault = parcelHelpers.interopDefault(_coloredAktifBankPng);
var _osigoLogoPng = require("../../assets/osigoLogo.png");
var _osigoLogoPngDefault = parcelHelpers.interopDefault(_osigoLogoPng);
var _imeceLogoPng = require("../../assets/imeceLogo.png");
var _imeceLogoPngDefault = parcelHelpers.interopDefault(_imeceLogoPng);
//import LogoCompany from "../../assets/coloredLogo.png";
var _turkiyesigortaPng = require("../../assets/turkiyesigorta.png");
var _turkiyesigortaPngDefault = parcelHelpers.interopDefault(_turkiyesigortaPng);
var _mobileWebAppTestingSvg = require("../../assets/mobile-web-app-testing.svg");
var _mobileWebAppTestingSvgDefault = parcelHelpers.interopDefault(_mobileWebAppTestingSvg);
var _dataDrivenTestingSvg = require("../../assets/data-driven-testing.svg");
var _dataDrivenTestingSvgDefault = parcelHelpers.interopDefault(_dataDrivenTestingSvg);
var _visualTestingSvg = require("../../assets/visual-testing.svg");
var _visualTestingSvgDefault = parcelHelpers.interopDefault(_visualTestingSvg);
var _frame171Svg = require("../../assets/frame-17-1.svg");
var _frame171SvgDefault = parcelHelpers.interopDefault(_frame171Svg);
var _frame17Svg = require("../../assets/frame-17.svg");
var _frame17SvgDefault = parcelHelpers.interopDefault(_frame17Svg);
var _header = require("../../components/Header/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footerJsx = require("../../components/Footer/Footer.jsx");
var _footerJsxDefault = parcelHelpers.interopDefault(_footerJsx);
var _capterraSvg = require("../../assets/capterra.svg");
var _capterraSvgDefault = parcelHelpers.interopDefault(_capterraSvg);
var _getAppPng = require("../../assets/getApp.png");
var _getAppPngDefault = parcelHelpers.interopDefault(_getAppPng);
var _reactHelmetAsync = require("react-helmet-async");
var _trailbluIntroPng = require("../../assets/TrailbluIntro.png");
var _trailbluIntroPngDefault = parcelHelpers.interopDefault(_trailbluIntroPng);
const Main = ()=>{
    (0, _react.useEffect)(()=>{
        const scrollers = document.querySelectorAll("#scroller");
        if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) addAnimation();
        function addAnimation() {
            scrollers.forEach((scroller)=>{
                scroller.setAttribute("data-animated", true);
                const scrollerInner = scroller.querySelector(".scroller-inner");
                const scrollerContent = Array.from(scrollerInner.children);
                scrollerContent.forEach((item)=>{
                    const duplicatedItem = item.cloneNode(true);
                    duplicatedItem.setAttribute("aria-hidden", true);
                    scrollerInner.appendChild(duplicatedItem);
                });
            });
        }
    }, []);
    const [menuVisible, setMenuVisible] = (0, _react.useState)(false);
    const toggleMenu = ()=>{
        setMenuVisible(!menuVisible);
    };
    const handleMenuItemClick = ()=>{
        setMenuVisible(false);
    };
    //-----------------
    const videoRef = (0, _react.useRef)(null);
    const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        // Check if the video element is available in the DOM
        if (isModalOpen && videoRef.current) {
            const playVideo = async ()=>{
                try {
                    await videoRef.current.play();
                } catch (error) {
                    console.error("Error playing the video:", error);
                }
            };
            playVideo();
        }
        // Cleanup function to pause and reset video when modal closes or component unmounts
        return ()=>{
            if (videoRef.current) {
                videoRef.current.pause();
                videoRef.current.currentTime = 0;
            }
        };
    }, [
        isModalOpen
    ]);
    const toggleModal = ()=>{
        setIsModalOpen(!isModalOpen);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "MAIN",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                        children: "AI-Powered, No-Code Test Automation | TRAILBLU"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "description",
                        content: "TRAILBLU: No-Code Testing, AI-Powered Crawler, Self-Healing, Visual Testing, and DevOps integration. Effortlessly transform mobile and web app testing. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Empower Seamless Testing: TRAILBLU's AI-driven No-Code Testing Solution"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:description",
                        content: "Explore TRAILBLU, the pinnacle of no-code testing empowered by AI. Revolutionize your testing journey effortlessly with our cutting-edge platform."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image",
                        content: (0, _trailbluIntroPngDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: "TRAILBLU Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:card",
                        content: " summary_large_image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@trailblu"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:title",
                        content: "Trailblu - AI-Powered Test Automation"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Trailblu"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.trailblu.com/"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:description",
                        content: "TRAILBLU is an AI-powered test automation tool that helps you test your mobile and web apps in minutes \u2013 without a single line of code. We test your app for you, so you can spend time building instead of fixing."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.trailblu.com/worker.2a57633e.png"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image:alt",
                        content: "TRAILBLU Image"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "div-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                        className: "text-wrapper-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "new-line-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    class: "highlight-container",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            class: "highlight",
                                                            children: "Generative AI-Powered,"
                                                        }),
                                                        " "
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "new-line-2",
                                                children: "No-Code Test Automation "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "p",
                                        children: "TRAILBLU is a Generative AI-Powered test automation tool that helps you test your mobile and web apps in minutes \u2013 without a single line of code. We test your app for you, so you can spend time building instead of fixing."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/request-a-demo",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            className: "button-2",
                                            stateProp: "normal",
                                            style: "solid",
                                            text: "Get started",
                                            type: "regular"
                                        })
                                    })
                                ]
                            })
                        }),
                        isModalOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal",
                            onClick: ()=>setIsModalOpen(false),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                ref: videoRef,
                                className: "modal-video",
                                controls: true,
                                preload: "auto",
                                poster: (0, _placeholderPngDefault.default),
                                onClick: (e)=>e.stopPropagation(),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                        src: (0, _trailbluvideoMp4Default.default),
                                        type: "video/mp4"
                                    }),
                                    "Your browser does not support the video tag."
                                ]
                            })
                        }),
                        !isModalOpen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "placeholder",
                            onClick: toggleModal,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: (0, _placeholderPngDefault.default),
                                    alt: "Click to play video",
                                    style: {
                                        width: "100%",
                                        cursor: "pointer"
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "play-button",
                                    children: "Play"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "Trusted by"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-7",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                class: "scroller",
                                id: "scroller",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    class: "scroller-inner",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "img-wrapper2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "companies",
                                                alt: "Fibabanka",
                                                src: (0, _coloredFibaBankaPngDefault.default)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "img-wrapper2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "companies",
                                                alt: "Osigo",
                                                src: (0, _osigoLogoPngDefault.default)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "img-wrapper2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "companies",
                                                alt: "TurkiyeSigorta",
                                                src: (0, _turkiyesigortaPngDefault.default)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "img-wrapper2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "companies",
                                                alt: "Aktifbank",
                                                src: (0, _coloredAktifBankPngDefault.default)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "img-wrapper2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "companies",
                                                alt: "Imece",
                                                src: (0, _imeceLogoPngDefault.default)
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "frame-8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-wrapper-5",
                        children: "Great features"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-9-copy",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-2-copy",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "starter",
                                                children: "Generative AI-Powered Test Creation"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "icon-instance-node-2",
                                                alt: "Trailblu mobile testing",
                                                src: (0, _mobileWebAppTestingSvgDefault.default)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32-copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "automate-mobile-and-2",
                                                children: "Embrace the future of testing with our advanced GPT technology, ensuring thorough coverage and reliability in every aspect of your application."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/feature/generative-ai-powered-test-creation",
                                                style: {
                                                    width: "100%",
                                                    justifyContent: "center",
                                                    display: "flex"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "outline",
                                                    text: "Read more",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-2-copy",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "starter",
                                                children: "AI-Powered No-Code Testing"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsCloudLaptop.IconsCloudLaptop), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32-copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "automate-mobile-and-2",
                                                children: "Forget about tedious, time-consuming test writing. With No-Code Testing, you can quickly write tests and get fast insights."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/feature/ai-powered-no-code-test-automation",
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "outline",
                                                    text: "Read more",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-2-copy",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "starter",
                                                children: "AI-Powered Visual Testing"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsPhone.IconsPhone), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32-copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "automate-mobile-and-2",
                                                children: "Harness the power of AI to transform your visual quality assurance. Our tool provides comprehensive coverage, intuitive insights, and smart detection of even the most subtle visual issues."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/feature/ai-powered-visual-testing",
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "outline",
                                                    text: "Read more",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-2-copy",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "starter",
                                                children: "AI-Powered Self-Healing"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsPlug1.IconsPlug1), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32-copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "automate-mobile-and-2",
                                                children: "With TRAILBLU's AI-powered self-healing, you can get more from your existing tests by automatically identifying and fixing flaky tests."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/feature/ai-powered-self-healing",
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "outline",
                                                    text: "Read more",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-13",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-14",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-wrapper-6",
                                    children: "You\u2019re here because you want the best"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper-7",
                                    children: "And we know it"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-15",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "CARD-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "icon-instance-node-2",
                                            alt: "Trailblu mobile testing",
                                            src: (0, _mobileWebAppTestingSvgDefault.default)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-16",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "text-wrapper-8",
                                                    children: "Mobile and Web App Testing"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-wrapper-9",
                                                    children: "Quickly test different layouts & designs of your mobile or web app in the cloud from anywhere."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "CARD-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "icon-instance-node-2",
                                            alt: "Trailblu laptop globe",
                                            src: (0, _dataDrivenTestingSvgDefault.default)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-16",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "text-wrapper-8",
                                                    children: "Data-driven Testing"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-wrapper-9",
                                                    children: "Speed up your testing and save time with TRAILBLU that lets you easily connect your test data with test cases."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "CARD-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "icon-instance-node-2",
                                            alt: "Trailblu mobile feed",
                                            src: (0, _visualTestingSvgDefault.default)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-16",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "text-wrapper-8",
                                                    children: "API Testing"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-wrapper-9",
                                                    children: "Effortlessly validate and optimize your APIs for seamless integration and performance, ensuring robust communication between your services with TRAILBLU's automated API testing."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "CARD-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "icon-instance-node-2",
                                            alt: "Trailblu mobile testing",
                                            src: (0, _mobileWebAppTestingSvgDefault.default)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-16",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "text-wrapper-8",
                                                    children: "Seamless DevOps and CI/CD Integrations"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-wrapper-9",
                                                    children: "Simplify your workflow with drag-and-drop integrations for leading CI/CD tools like Jenkins and Azure DevOps, along with popular bug tracking platforms such as Jira. Effortlessly connect your pipelines to automate testing, track issues, and accelerate development cycles\u2014saving you time and enhancing team collaboration."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "frame-8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-17",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-wrapper-5",
                                children: "Our clients love us!"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-wrapper-7",
                                children: "Look at what they say about us"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-18",
                        style: {
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "quote-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quote.Quote), {
                                        className: "quote-instance",
                                        divClassName: "quote-2",
                                        frame: (0, _frame171SvgDefault.default)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quote.Quote), {
                                        className: "quote-instance",
                                        divClassName: "quote-2",
                                        frame: (0, _frame17SvgDefault.default),
                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatar.Avatar), {
                                            className: "property-1-male"
                                        }),
                                        text: "If you can right click with your mouse, you can write tests with TRAILBLU. It is that simple. TRAILBLU empowers us to get measurable results quickly and easily.",
                                        text1: "Erdem Oguz",
                                        text2: "Test and R&D Director, Aktifbank"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "64px",
                                    paddingRight: "40px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "capterra-2",
                                        target: "_blank",
                                        href: "https://www.capterra.com/p/10014205/TRAILBLU/#reviews",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: (0, _capterraSvgDefault.default),
                                            alt: "Trailblu Capterra",
                                            style: {
                                                borderRadius: "5%",
                                                display: "flex",
                                                width: "100%"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "getapp-2",
                                        target: "_blank",
                                        href: "https://www.getapp.com/it-management-software/a/trailblu/reviews/",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "getapp-img-2",
                                            src: (0, _getAppPngDefault.default),
                                            alt: "Trailblu GetApp"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "frame-19",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-20",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-wrapper-10",
                                children: "Get started"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-wrapper-11",
                                children: "Choose one of our plans"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-21",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "starter",
                                                children: "Starter"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMill.IconsMill), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "automate-mobile-and-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Automate"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "mobile and web app testing",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/request-a-demo",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "solid",
                                                    text: "Request a demo",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "starter",
                                                children: "Business"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsHouse1.IconsHouse1), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "automate-mobile-and-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Automate"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "mobile and web app testing",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Professional features"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-13",
                                                        children: " for remote teams"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/request-a-demo",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "solid",
                                                    text: "Request a demo",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "starter",
                                                children: "Enterprise"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsHouse2.IconsHouse2), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "automate-mobile-and-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Automate"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "mobile and web app testing",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Professional features"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "for remote teams",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Advanced features"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "for large teams, priority support",
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/request-a-demo",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "solid",
                                                    text: "Request a demo",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerJsxDefault.default), {})
        ]
    });
};
exports.default = Main;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Button":"d3NfG","../../components/Quote":"fSBya","../../icons/Avatar":"de7Kt","../../icons/IconsCloudLaptop":"5ghaX","../../icons/IconsHouse1":"cvuiF","../../icons/IconsHouse2":"gfYuP","../../icons/IconsPhone":"fEH0X","../../icons/IconsPlug1":"99oWe","./style.css":"jTpBI","../../icons/IconsMill":"d7m2z","../../assets/worker.png":"kLtSv","../../assets/placeholder.png":"3jo39","../../assets/trailbluvideo.mp4":"h7MUz","../../assets/coloredFibaBanka.png":"1gu8p","../../assets/coloredAktifBank.png":"7ZdGm","../../assets/osigoLogo.png":"4MzbP","../../assets/imeceLogo.png":"dAahR","../../assets/turkiyesigorta.png":"3EslU","../../assets/mobile-web-app-testing.svg":"iJWO5","../../assets/data-driven-testing.svg":"dCDK5","../../assets/visual-testing.svg":"g0h4V","../../assets/frame-17-1.svg":"lb6qu","../../assets/frame-17.svg":"7LFsY","../../components/Header/Header":"j0rW0","../../components/Footer/Footer.jsx":"2Br4S","../../assets/capterra.svg":"5a5l8","../../assets/getApp.png":"jVwXD","react-helmet-async":"5Z9jX","../../assets/TrailbluIntro.png":"1rplF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d3NfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>(0, _button.Button));
var _button = require("./Button");

},{"./Button":"jAaxT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jAaxT":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const Button = ({ stateProp, type, style, className, text = "Request a demo", onClick })=>{
    const [state, dispatch] = (0, _react.useReducer)(reducer, {
        state: stateProp || "normal",
        type: type || "regular",
        style: style || "solid"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: `button ${state.style} ${state.state} ${state.type} ${className}`,
        onMouseEnter: ()=>{
            dispatch("mouse_enter");
        },
        onMouseLeave: ()=>{
            dispatch("mouse_leave");
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "request-a-demo",
            children: text
        })
    });
};
function reducer(state, action) {
    switch(action){
        case "mouse_enter":
            return {
                ...state,
                state: "hover"
            };
        case "mouse_leave":
            return {
                ...state,
                state: "normal"
            };
    }
    return state;
}
Button.propTypes = {
    stateProp: (0, _propTypesDefault.default).oneOf([
        "hover",
        "normal"
    ]),
    type: (0, _propTypesDefault.default).oneOf([
        "cta",
        "regular"
    ]),
    style: (0, _propTypesDefault.default).oneOf([
        "text",
        "solid",
        "outline"
    ]),
    text: (0, _propTypesDefault.default).string
};
exports.default = Button;

},{"react/jsx-runtime":"gaGEj","prop-types":"6FKs7","react":"6uln9","./style.css":"b6ulx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6FKs7":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"7ziwC"}],"7ziwC":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"4Cml4"}],"4Cml4":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"b6ulx":[function() {},{}],"fSBya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Quote", ()=>(0, _quote.Quote));
var _quote = require("./Quote");

},{"./Quote":"cR8Xb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cR8Xb":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Quote", ()=>Quote);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _avatar1 = require("../../icons/Avatar1");
var _frame212Svg = require("../../assets/frame-21-2.svg");
var _frame212SvgDefault = parcelHelpers.interopDefault(_frame212Svg);
var _frame172Svg = require("../../assets/frame-17-2.svg");
var _frame172SvgDefault = parcelHelpers.interopDefault(_frame172Svg);
var _styleCss = require("./style.css");
const Quote = ({ className, frame = {
    Frame172: (0, _frame172SvgDefault.default)
}, divClassName, text = "For our mobile app testing, we used to employ QAs with programming skills. Now, our QAs no longer need to know programming. With TRAILBLU, we can automate all our tests and get our product to market faster.", icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatar1.Avatar1), {
    className: "avatar-1"
}), text1 = "Nilay Kose", text2 = "Test and Quality Manager, Fibabanka" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `quote ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "TOP",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "img",
                        alt: "Trailblu Frame-21-2",
                        src: (0, _frame212SvgDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "for-our-mobile-app-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "for-our-mobile-app",
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "frame-2",
                        alt: "Trailblu Frame-2",
                        src: frame
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "BOTTOM",
                children: [
                    icon,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "div",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `nilay-kose ${divClassName}`,
                                children: text1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "test-and-quality",
                                children: text2
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Quote.propTypes = {
    frame: (0, _propTypesDefault.default).string,
    text: (0, _propTypesDefault.default).string,
    text1: (0, _propTypesDefault.default).string,
    text2: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gaGEj","prop-types":"6FKs7","react":"6uln9","../../icons/Avatar1":"ldA4J","../../assets/frame-21-2.svg":"6i26B","../../assets/frame-17-2.svg":"6mNwo","./style.css":"fzVfJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ldA4J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Avatar1", ()=>(0, _avatar1.Avatar1));
var _avatar1 = require("./Avatar1");

},{"./Avatar1":"5jw5a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5jw5a":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Avatar1", ()=>Avatar1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Avatar1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `avatar-1 ${className}`,
        fill: "none",
        height: "80",
        viewBox: "0 0 80 80",
        width: "80",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                className: "rect",
                fill: "#BBCCEE",
                height: "80",
                rx: "40",
                width: "80"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_5_784)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M38.892 64.7185C37.5743 64.4187 36.2512 64.1311 34.9387 63.8086C34.5134 63.704 34.0933 63.6413 33.6575 63.65C33.7342 63.2072 33.5494 62.958 33.1276 62.7924C29.5926 61.4066 27.6961 58.602 26.652 55.121C25.892 52.59 25.4022 49.991 25.1843 47.3572C25.0222 45.3962 24.8583 43.3951 25.634 41.5091C27.29 37.4825 28.6339 33.3496 29.861 29.1784C30.1155 28.3103 30.3892 28.2075 31.2189 28.516C36.0961 30.3341 40.9437 32.248 46.0109 33.5082C47.6668 33.9196 49.3245 34.3345 50.8306 35.1921C52.0438 35.8841 52.6922 36.8724 52.6329 38.314C52.6015 39.0931 52.68 39.8775 52.7061 40.6602C52.8491 44.9517 53.067 49.245 52.2564 53.5016C51.8468 55.6509 51.2872 57.7775 49.8718 59.4892C47.252 62.6564 43.8337 64.2705 39.7165 64.3455C39.3697 64.3525 39.0942 64.4291 38.8903 64.715L38.892 64.7185ZM39.5283 48.5007C41.6165 48.5111 42.4027 47.1794 41.4928 45.2759C40.7031 43.6252 40.1349 41.8961 40.1593 40.0292C40.1645 39.6509 40.0739 39.3825 39.6416 39.4226C39.1413 39.4697 39.1884 39.8775 39.1866 40.2157C39.1762 42.1715 39.8263 43.9634 40.5881 45.7222C40.7676 46.1353 41.1302 46.5118 40.7955 47.0051C40.4295 47.5437 39.8769 47.5367 39.3174 47.5036C38.8293 47.474 38.4214 47.2788 38.1338 46.8761C37.9176 46.5728 37.6283 46.4281 37.3232 46.6582C36.9363 46.9511 37.1699 47.284 37.393 47.5577C37.9421 48.2288 38.6585 48.5443 39.5265 48.5007H39.5283ZM39.2006 54.4063C40.3005 54.3889 41.3254 54.1448 42.1429 53.3587C42.4271 53.085 42.7809 52.7225 42.3713 52.3268C41.9651 51.9328 41.7194 52.3773 41.4544 52.6231C40.3946 53.6045 38.4737 53.7003 37.3877 52.8009C37.0984 52.5621 36.8143 52.2972 36.511 52.651C36.2373 52.9717 36.4465 53.3134 36.7219 53.5609C37.4243 54.1954 38.275 54.415 39.2006 54.4081V54.4063ZM46.7813 38.2094C45.9969 38.2164 45.3101 38.4552 44.7942 39.0722C44.6164 39.2849 44.5519 39.5376 44.7698 39.7764C44.9877 40.0153 45.2352 40.003 45.4531 39.7991C46.349 38.9589 47.2502 39.0409 48.1619 39.7625C48.4408 39.9839 48.7406 40.0919 48.9863 39.7625C49.2339 39.4313 49.016 39.1681 48.758 38.9502C48.188 38.4674 47.5343 38.2042 46.7796 38.2094H46.7813ZM31.8447 38.2129C31.1962 38.2251 30.5984 38.4813 30.0807 38.9345C29.8296 39.1559 29.5943 39.4174 29.8401 39.7503C30.126 40.1373 30.4136 39.9264 30.7221 39.705C31.6407 39.0426 32.0974 39.0513 32.9498 39.7276C33.2078 39.9316 33.4501 40.0536 33.7028 39.7799C33.9416 39.5202 33.8458 39.2465 33.6436 39.0025C33.1886 38.4534 32.5925 38.2164 31.8464 38.2146L31.8447 38.2129Z",
                        fill: "#FAD6CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M38.892 64.7186C39.096 64.4327 39.3714 64.356 39.7182 64.349C43.8372 64.2758 47.2537 62.66 49.8736 59.4928C51.289 57.781 51.8485 55.6544 52.2581 53.5052C53.0687 49.2485 52.8525 44.9553 52.7078 40.6638C52.6817 39.8811 52.6033 39.0967 52.6346 38.3175C52.6939 36.8743 52.0455 35.8859 50.8323 35.1957C49.328 34.338 47.6685 33.9232 46.0126 33.5118C40.9454 32.2515 36.0978 30.3376 31.2206 28.5196C30.3909 28.211 30.1172 28.3139 29.8627 29.1819C28.6356 33.3532 27.2899 37.4861 25.6357 41.5127C24.86 43.3987 25.0239 45.398 25.186 47.3608C25.4039 49.9946 25.8937 52.5936 26.6537 55.1245C27.6978 58.6055 29.5943 61.4102 33.1293 62.7959C33.5494 62.9615 33.7342 63.2108 33.6592 63.6535C33.3106 63.9481 32.9637 63.8139 32.6029 63.671C31.2049 63.1184 29.9917 62.2904 28.9616 61.2045C28.6739 60.9029 28.4264 60.8175 27.9941 60.8628C26.4253 61.0284 24.9611 60.495 23.5074 60.014C20.7184 59.0918 18.0672 57.9013 15.7 56.1007C13.3625 54.321 12.8117 51.8458 13.0523 49.1893C13.8802 40.0118 17.2183 31.76 22.5504 24.2995C23.6869 22.7098 25.1145 21.4112 26.7914 20.3566C28.4317 19.3247 29.9046 18.0418 31.6128 17.097C35.6272 14.878 39.8315 14.4109 44.205 15.7409C48.3361 16.9977 52.2285 18.7442 55.5735 21.5628C58.7547 24.242 60.9248 27.6376 62.5372 31.4201C64.8555 36.8603 66.5829 42.4766 67.3046 48.3683C67.5085 50.0364 67.5504 51.7168 67.254 53.3936C66.9961 54.8509 66.3075 56.0153 65.0403 56.7735C61.1305 59.1145 56.907 60.3695 52.3348 60.3765C52.2198 60.3765 52.0838 60.3974 51.9914 60.3486C50.9752 59.8013 50.4261 60.4306 49.7794 61.1016C47.0672 63.9185 43.6821 65.2189 39.8193 65.3757C39.3295 65.3949 38.946 65.3025 38.8955 64.7203L38.892 64.7186ZM24.0652 45.405C24.0512 43.9408 24.1297 42.4801 24.6997 41.1239C26.4672 36.9178 27.8059 32.5671 29.1341 28.211C29.4095 27.3081 29.9824 27.0176 30.8528 27.3395C36.4743 29.4173 42.0679 31.5683 47.9056 32.9941C49.2548 33.3236 50.5743 33.7803 51.7422 34.5803C52.8577 35.3438 53.5916 36.3583 53.616 37.7458C53.6718 41.0821 53.9245 44.4149 53.8182 47.7547C53.6997 51.4849 53.3528 55.1716 51.6358 58.5776C51.3953 59.0552 51.5609 59.247 52.0559 59.3446C53.3127 59.5956 54.5433 59.3533 55.7583 59.1232C58.8453 58.5358 61.8382 57.6608 64.5052 55.9124C65.4482 55.2936 66.0182 54.4517 66.25 53.3257C66.5951 51.6471 66.501 49.9684 66.2849 48.3055C65.5127 42.3964 63.7905 36.7505 61.3955 31.3085C59.4868 26.9717 56.7762 23.2693 52.7357 20.6704C49.6626 18.6937 46.3298 17.3027 42.7948 16.4189C40.5706 15.8629 38.3255 15.889 36.0856 16.4155C34.2588 16.846 32.5454 17.5677 31.0219 18.6379C28.1406 20.6582 25.0065 22.3786 22.9531 25.4099C18.1195 32.5357 14.9243 40.2942 14.0615 48.9121C13.8262 51.2653 14.0999 53.5732 16.2125 55.203C19.2577 57.5527 22.7387 58.9123 26.4323 59.7978C27.2254 59.9878 27.0267 59.5294 26.8576 59.0657C25.2453 54.6522 24.2796 50.1062 24.0669 45.4067L24.0652 45.405Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M39.53 48.5007C38.6602 48.546 37.9455 48.2305 37.3947 47.5594C37.1698 47.2858 36.9363 46.9528 37.325 46.66C37.63 46.4299 37.9194 46.5746 38.1355 46.8779C38.4231 47.2805 38.831 47.4775 39.3191 47.5054C39.8769 47.5385 40.4312 47.5455 40.7972 47.0069C41.1319 46.5153 40.7693 46.1388 40.5898 45.7239C39.8281 43.9652 39.1779 42.1732 39.1884 40.2175C39.1901 39.8793 39.143 39.4714 39.6433 39.4244C40.0756 39.3843 40.1662 39.6527 40.161 40.031C40.1366 41.8978 40.7048 43.627 41.4945 45.2777C42.4026 47.1794 41.6182 48.5129 39.53 48.5007Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M39.2005 54.4064C38.2749 54.4133 37.4261 54.1937 36.7218 53.5592C36.4464 53.3117 36.239 52.9701 36.5109 52.6493C36.8142 52.2937 37.0984 52.5587 37.3877 52.7992C38.4737 53.6987 40.3963 53.6028 41.4544 52.6214C41.7193 52.3757 41.9634 51.9312 42.3712 52.3251C42.7809 52.7225 42.427 53.0851 42.1429 53.357C41.3254 54.1432 40.3004 54.3872 39.2005 54.4046V54.4064Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M46.7814 38.2094C47.5361 38.2042 48.1898 38.4674 48.7598 38.9502C49.016 39.1681 49.2357 39.4296 48.9881 39.7625C48.7424 40.092 48.4408 39.9839 48.1636 39.7625C47.252 39.0391 46.3508 38.959 45.4549 39.7991C45.2352 40.0048 44.9895 40.0153 44.7716 39.7765C44.5537 39.5377 44.6182 39.2849 44.796 39.0723C45.3119 38.4552 45.9987 38.2147 46.7831 38.2094H46.7814Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M31.8448 38.2129C32.5908 38.2129 33.187 38.4517 33.6419 39.0008C33.8441 39.2448 33.94 39.5185 33.7012 39.7782C33.4484 40.0519 33.2061 39.9299 32.9482 39.7259C32.0958 39.0514 31.6391 39.0426 30.7205 39.7033C30.4137 39.9247 30.1243 40.1373 29.8385 39.7486C29.5944 39.4157 29.828 39.1542 30.079 38.9328C30.5967 38.4796 31.1928 38.2234 31.843 38.2112L31.8448 38.2129Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M24.0653 45.4049C24.278 50.1043 25.2437 54.6503 26.856 59.0639C27.0251 59.5275 27.2256 59.986 26.4307 59.796C22.7371 58.9105 19.2561 57.5508 16.2109 55.2011C14.0983 53.5713 13.8246 51.2635 14.0599 48.9103C14.9245 40.2924 18.1179 32.5338 22.9515 25.4063C25.0066 22.3768 28.1407 20.6563 31.0203 18.6343C32.5455 17.5641 34.2572 16.8424 36.084 16.4119C38.3239 15.8837 40.5673 15.8576 42.7932 16.4154C46.3282 17.2991 49.661 18.6884 52.7341 20.6668C56.7746 23.2658 59.4834 26.9681 61.3939 31.305C63.7889 36.7469 65.5111 42.3928 66.2833 48.3019C66.5012 49.9649 66.5953 51.6435 66.2484 53.3221C66.0166 54.4481 65.4466 55.2918 64.5036 55.9088C61.8366 57.6572 58.8437 58.5322 55.7567 59.1196C54.5417 59.3515 53.3128 59.592 52.0543 59.341C51.5593 59.2434 51.3954 59.0499 51.6342 58.5741C53.3512 55.168 53.6981 51.4814 53.8166 47.7511C53.9229 44.4113 53.6702 41.0785 53.6144 37.7422C53.5917 36.3547 52.8562 35.3402 51.7406 34.5768C50.5727 33.7784 49.2532 33.32 47.904 32.9905C42.0663 31.5664 36.471 29.4137 30.8512 27.3359C29.9785 27.014 29.4056 27.3045 29.1325 28.2075C27.8025 32.5635 26.4656 36.9143 24.6981 41.1204C24.1281 42.4765 24.0479 43.9372 24.0636 45.4014L24.0653 45.4049Z",
                        fill: "#7799CC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_5_784",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "50.3757",
                        transform: "translate(13 15)",
                        width: "54.465"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6i26B":[function(require,module,exports) {
module.exports = require("5874825ae7bb081").getBundleURL("4oMEl") + "frame-21-2.5a555d7e.svg";

},{"5874825ae7bb081":"c7Tr5"}],"6mNwo":[function(require,module,exports) {
module.exports = require("3ae9696217010553").getBundleURL("4oMEl") + "frame-17-2.3151b1fc.svg";

},{"3ae9696217010553":"c7Tr5"}],"fzVfJ":[function() {},{}],"de7Kt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Avatar", ()=>(0, _avatar.Avatar));
var _avatar = require("./Avatar");

},{"./Avatar":"3Qf55","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Qf55":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Avatar", ()=>Avatar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Avatar = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `avatar ${className}`,
        fill: "none",
        height: "80",
        viewBox: "0 0 80 80",
        width: "80",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                className: "rect",
                fill: "#BBCCEE",
                height: "80",
                rx: "40",
                width: "80"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_5_786)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M38.4355 11.0017C42.9536 11.1586 46.6751 13.1196 49.9347 16.116C50.0411 16.2136 50.1544 16.3095 50.2415 16.4245C51.962 18.7045 54.2262 20.1966 56.7956 21.4307C59.6595 22.8078 60.7925 25.4503 60.85 28.5304C60.9128 31.9347 60.1563 35.1559 58.3591 38.0826C58.0593 38.5689 58.021 38.8077 58.5788 39.1494C60.0674 40.0575 60.2347 41.5461 59.9715 43.0678C59.7101 44.5809 58.9257 45.8115 57.3237 46.1985C56.6701 46.3553 56.5359 46.6151 56.5446 47.2321C56.6178 51.9298 55.9676 56.4985 53.8602 60.7603C50.754 67.0477 45.1604 69.366 38.8207 68.9529C35.1951 68.7176 31.9581 67.5271 29.3051 64.9839C26.8717 62.6499 25.4337 59.7267 24.4715 56.542C23.5842 53.6049 23.206 50.5893 23.1398 47.5302C23.1258 46.8434 23.1014 46.3484 22.2037 46.0782C20.6506 45.611 19.9987 44.2601 19.8017 42.7419C19.6169 41.3125 19.915 39.9808 21.2398 39.1633C21.7836 38.8269 21.6703 38.541 21.4803 38.107C20.3996 35.6248 19.5228 33.0729 19.1672 30.3798C18.9075 28.4153 18.857 26.4456 19.6692 24.5544C20.2846 23.1215 21.2502 22.0025 22.7423 21.5405C24.7103 20.9322 26.0943 19.7138 27.2291 18.0369C28.5486 16.0864 30.0634 14.2823 32.0278 12.9174C33.9557 11.5822 36.0875 10.9599 38.4355 11.0017ZM22.8521 38.5236C23.8318 35.8462 25.364 33.4215 26.0333 30.6413C26.2773 29.6285 26.4917 28.5984 26.9903 27.6693C27.6736 26.3933 28.6846 26.0395 29.9675 26.6897C30.7397 27.0819 31.4509 27.5961 32.1969 28.0423C37.2118 31.0404 42.3888 32.0898 47.9058 29.4037C49.5669 28.5949 51.0765 29.0254 52.4047 30.1933C53.3774 31.0492 54.0206 32.1595 54.6167 33.2943C55.5057 34.9921 56.1349 36.7944 56.7782 38.7206C59.154 35.1838 60.2034 31.4187 59.7153 27.2753C59.4486 25.0145 58.2284 23.3499 56.2587 22.2378C55.7044 21.9258 55.117 21.6695 54.5365 21.4063C53.088 20.7474 51.8399 19.8445 50.8272 18.5964C48.5803 15.8249 45.76 13.8238 42.3732 12.7082C37.9404 11.2475 33.9662 11.9535 30.649 15.4327C29.5021 16.6337 28.4806 17.9358 27.5446 19.2972C26.5684 20.7195 25.3204 21.7201 23.6731 22.2325C21.3879 22.9437 20.3334 24.6398 20.0946 26.8919C19.6518 31.0648 21.2067 34.7899 22.8487 38.5271L22.8521 38.5236ZM39.4848 45.5465C39.6661 45.5622 39.809 45.5814 39.9537 45.5884C40.9787 45.6337 41.0083 45.5762 40.5429 44.621C39.9555 43.4147 39.5702 42.1388 39.3262 40.8245C39.2373 40.3451 39.2617 39.8431 39.2652 39.3498C39.2669 39.0012 39.4813 38.8077 39.8282 38.8408C40.149 38.8722 40.2483 39.1093 40.2344 39.4056C40.2239 39.6078 40.1908 39.81 40.2047 40.0104C40.339 42.015 41.4266 43.7285 41.9287 45.6215C41.974 45.7906 42.1343 45.8132 42.2738 45.8376C44.5729 46.2316 46.4485 47.4884 48.3311 48.7608C50.5274 50.2442 52.0683 49.913 53.9282 47.9973C56.1628 45.6947 56.3058 42.7802 55.9641 40.0296C55.5928 37.0332 54.2803 34.1902 52.4256 31.708C51.0834 29.9109 49.743 29.5937 47.7349 30.5907C45.9849 31.4588 44.1459 31.8771 42.2041 31.912C37.9038 31.9869 34.0673 30.6552 30.5636 28.1974C28.6654 26.8657 27.9838 27.1167 27.4313 29.3688C26.8038 31.919 25.8555 34.3349 24.7486 36.7003C23.83 38.6648 23.1973 40.6432 23.5773 42.8918C23.8719 44.6384 23.9921 46.4041 25.0136 47.9259C26.1658 49.6411 28.2139 50.2111 30.0634 49.289C30.7066 48.9683 31.2957 48.5272 31.8814 48.1054C32.7774 47.4587 33.7047 46.8783 34.7122 46.4111C35.6605 45.9719 36.7133 45.9161 37.6755 45.4751C38.1426 45.2624 38.8852 45.693 39.4866 45.5448L39.4848 45.5465ZM24.3896 48.8741C24.163 49.1025 24.2519 49.3099 24.2606 49.4999C24.3878 51.9158 24.8044 54.2865 25.54 56.5856C27.5829 62.9758 31.4805 67.3022 38.5418 67.9193C44.6845 68.4561 50.0167 66.2947 53.0253 60.1904C54.3082 57.5879 54.9775 54.8059 55.3139 51.935C55.4708 50.5946 55.5772 49.2541 55.5109 47.6975C55.056 48.2083 54.7474 48.5778 54.4162 48.9229C52.4239 50.9937 50.3513 51.2482 47.9354 49.7143C47.348 49.3413 46.7832 48.9316 46.1993 48.5517C44.9739 47.7533 43.6683 47.1485 42.225 46.8486C41.7788 46.7563 41.4144 46.7528 40.9874 46.9829C40.1211 47.45 39.1728 47.457 38.3135 46.9916C37.7975 46.7109 37.3373 46.7319 36.8161 46.833C34.9963 47.1851 33.4642 48.1054 32.0488 49.2419C29.7391 51.0966 26.809 51.4557 24.3896 48.8724V48.8741ZM59.0773 42.2765C59.0721 41.2568 58.7984 40.5177 58.075 40.0035C57.4963 39.5921 57.1285 39.7385 57.0937 40.4497C57.0239 41.8703 56.9019 43.2857 56.7084 44.6924C56.616 45.3705 56.9472 45.3757 57.3917 45.1456C58.6189 44.5146 59.0076 43.4025 59.0756 42.2765H59.0773ZM22.7929 44.8232C22.6813 43.352 22.5785 41.8808 22.4547 40.4114C22.3989 39.7438 22.0695 39.7193 21.6128 40.1063C20.7552 40.8332 20.6733 41.8076 20.8301 42.8099C20.9818 43.7912 21.4472 44.6157 22.3676 45.1003C22.6499 45.2485 22.8835 45.2467 22.7946 44.8232H22.7929Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M22.8523 38.5236C21.2103 34.7863 19.6572 31.0613 20.0982 26.8883C20.337 24.6363 21.3916 22.9402 23.6768 22.229C25.324 21.7166 26.5721 20.716 27.5482 19.2936C28.4825 17.9323 29.5057 16.6319 30.6527 15.4292C33.9698 11.9517 37.9423 11.244 42.3768 12.7065C45.7636 13.822 48.584 15.8231 50.8308 18.5947C51.8436 19.8427 53.0916 20.7456 54.5401 21.4045C55.1206 21.6678 55.708 21.924 56.2623 22.236C58.232 23.3481 59.4522 25.0128 59.7189 27.2736C60.207 31.4169 59.1576 35.182 56.7818 38.7188C56.1386 36.7927 55.5093 34.9903 54.6203 33.2925C54.0259 32.156 53.3827 31.0474 52.4083 30.1915C51.0801 29.0219 49.5706 28.5931 47.9094 29.4019C42.3925 32.088 37.2154 31.0404 32.2005 28.0405C31.4545 27.5943 30.7433 27.0801 29.9711 26.6879C28.6882 26.0377 27.6772 26.3916 26.9939 27.6675C26.4954 28.5983 26.281 29.6268 26.0369 30.6395C25.3676 33.4215 23.8336 35.8444 22.8558 38.5218L22.8523 38.5236ZM29.9049 23.3342C30.8775 25.6717 33.7554 27.4339 35.8297 27.1498C35.8122 27.101 35.8088 27.026 35.7739 27.0069C33.8321 25.9122 31.9216 24.7687 29.9049 23.3342ZM54.0015 30.0869C54.5523 28.4798 53.2677 26.3375 51.61 26.0621C52.4188 27.4235 53.184 28.7116 54.0015 30.0869Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M39.485 45.5466C38.8819 45.693 38.141 45.2624 37.6739 45.4768C36.71 45.9161 35.6589 45.9736 34.7106 46.4129C33.7031 46.88 32.7775 47.4605 31.8798 48.1072C31.2924 48.5307 30.705 48.97 30.0618 49.2907C28.2123 50.2146 26.1659 49.6446 25.012 47.9276C23.9888 46.4042 23.8703 44.6384 23.5757 42.8936C23.1957 40.645 23.8284 38.6665 24.747 36.7021C25.8522 34.3367 26.8022 31.9207 27.4297 29.3706C27.984 27.1167 28.6638 26.8657 30.562 28.1992C34.0674 30.657 37.9022 31.9904 42.2025 31.9137C44.1443 31.8789 45.985 31.4605 47.7333 30.5925C49.7414 29.5972 51.0818 29.9127 52.424 31.7098C54.2787 34.192 55.5912 37.035 55.9625 40.0314C56.3042 42.7803 56.1595 45.6965 53.9266 47.9991C52.0684 49.9148 50.5258 50.246 48.3295 48.7626C46.4469 47.4919 44.5731 46.2351 42.2722 45.8394C42.1327 45.815 41.9706 45.7906 41.9271 45.6233C41.425 43.7302 40.3374 42.0168 40.2031 40.0122C40.1892 39.8117 40.2223 39.6095 40.2328 39.4073C40.2467 39.111 40.1474 38.874 39.8266 38.8426C39.4797 38.8095 39.2653 39.0029 39.2636 39.3516C39.2601 39.8431 39.2357 40.3469 39.3246 40.8262C39.5686 42.1405 39.9539 43.4165 40.5413 44.6227C41.0067 45.5779 40.9771 45.6337 39.9521 45.5901C39.8074 45.5832 39.6645 45.5657 39.4832 45.5483L39.485 45.5466ZM50.6461 40.373C50.6513 40.0261 50.4595 39.8919 50.2748 39.749C49.1278 38.8513 47.0204 38.8408 46.0617 39.7316C45.8194 39.9564 45.5911 40.2005 45.8264 40.5508C45.9972 40.8053 46.2552 40.8681 46.501 40.6728C47.6253 39.7804 48.7286 39.9216 49.8529 40.6781C50.2835 40.9692 50.5467 40.7687 50.6443 40.373H50.6461ZM31.1739 39.0727C30.5603 39.057 29.9084 39.2696 29.3244 39.6862C29.0159 39.9059 28.6464 40.1551 28.9671 40.5944C29.2547 40.9866 29.5563 40.7408 29.8665 40.5439C30.7416 39.9895 31.6323 39.7926 32.4934 40.5752C32.7514 40.8105 33.0268 40.8611 33.2534 40.6014C33.4765 40.3451 33.3754 40.0662 33.1558 39.8239C32.6503 39.2679 32.0053 39.0744 31.1721 39.0727H31.1739Z",
                        fill: "#FAD5CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M24.3897 48.8742C26.8109 51.4557 29.741 51.0967 32.0489 49.2437C33.4643 48.1072 34.9982 47.1869 36.8163 46.8348C37.3375 46.7337 37.7977 46.7145 38.3136 46.9934C39.173 47.4588 40.1212 47.4518 40.9875 46.9847C41.4146 46.7546 41.7789 46.7581 42.2251 46.8505C43.6702 47.1503 44.9758 47.7534 46.1994 48.5535C46.7834 48.9335 47.3481 49.3431 47.9355 49.7161C50.3515 51.25 52.424 50.9956 54.4164 48.9247C54.7476 48.5796 55.0561 48.2118 55.5111 47.6993C55.5773 49.2559 55.471 50.5964 55.3141 51.9368C54.9777 54.8077 54.3083 57.5897 53.0254 60.1922C50.0168 66.2965 44.6864 68.458 38.542 67.9211C31.4807 67.304 27.5831 62.9776 25.5402 56.5874C24.8046 54.2883 24.388 51.9177 24.2607 49.5017C24.2503 49.3117 24.1631 49.1043 24.3897 48.8759V48.8742ZM39.5233 56.3347C41.0921 56.265 42.7324 56.4532 44.2925 55.8553C45.5475 55.3725 46.4365 54.1541 46.3737 53.0263C46.3179 52.017 45.5039 51.2727 44.0136 50.9485C41.8696 50.4796 39.6994 50.5389 37.5292 50.6975C36.4293 50.7777 35.3381 50.9154 34.3289 51.4052C32.5405 52.2732 32.3714 54.29 33.9907 55.4596C34.5171 55.8396 35.1203 56.0331 35.753 56.1569C36.9871 56.3957 38.2352 56.3207 39.5233 56.3382V56.3347Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M59.0773 42.2783C59.0093 43.4043 58.6206 44.5164 57.3935 45.1474C56.9472 45.3758 56.6178 45.3723 56.7102 44.6942C56.9019 43.2858 57.0257 41.8721 57.0954 40.4515C57.1303 39.7403 57.4981 39.5939 58.0768 40.0053C58.8002 40.5195 59.0738 41.2586 59.0791 42.2783H59.0773Z",
                        fill: "#FAD5CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M22.7929 44.8232C22.8818 45.2468 22.6482 45.2502 22.3658 45.1003C21.4455 44.6158 20.9801 43.7913 20.8284 42.8099C20.6733 41.8076 20.7552 40.8332 21.6111 40.1064C22.0695 39.7176 22.3972 39.7438 22.453 40.4114C22.5768 41.8808 22.6796 43.352 22.7912 44.8232H22.7929Z",
                        fill: "#FAD5CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M29.9048 23.3342C31.9198 24.7688 33.832 25.9123 35.7738 27.0069C35.8087 27.0261 35.8122 27.1011 35.8296 27.1499C33.7553 27.434 30.8792 25.6735 29.9048 23.3342Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M54.0014 30.087C53.1839 28.7116 52.4204 27.4235 51.6099 26.0621C53.2676 26.3358 54.5522 28.4798 54.0014 30.087Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M50.6479 40.373C50.552 40.7687 50.2871 40.9674 49.8565 40.6781C48.7322 39.9198 47.6271 39.7786 46.5045 40.6728C46.257 40.8698 46.0008 40.8053 45.83 40.5508C45.5946 40.2005 45.823 39.9564 46.0653 39.7316C47.024 38.8408 49.1296 38.8513 50.2784 39.749C50.4631 39.8937 50.6549 40.0261 50.6496 40.373H50.6479Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M31.1739 39.0744C32.0071 39.0762 32.6521 39.2714 33.1576 39.8257C33.379 40.068 33.4783 40.3469 33.2552 40.6031C33.0286 40.8646 32.7532 40.8123 32.4952 40.577C31.6341 39.7943 30.7416 39.9913 29.8683 40.5456C29.5581 40.7426 29.2565 40.9883 28.9689 40.5961C28.6464 40.1569 29.016 39.9076 29.3262 39.688C29.9084 39.2731 30.5604 39.0587 31.1757 39.0744H31.1739Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M39.5233 56.3346C38.2351 56.3154 36.9871 56.3921 35.7529 56.1533C35.1202 56.0313 34.5171 55.836 33.9907 55.456C32.3713 54.2882 32.5404 52.2714 34.3288 51.4016C35.3381 50.9118 36.431 50.7741 37.5292 50.6939C39.6993 50.5353 41.8695 50.476 44.0135 50.9449C45.5021 51.2709 46.3161 52.0152 46.3737 53.0227C46.4364 54.1505 45.5474 55.3706 44.2924 55.8517C42.7323 56.4514 41.0921 56.2614 39.5233 56.3311V56.3346ZM39.4832 55.2817C40.353 55.2817 41.2245 55.3079 42.0926 55.2748C42.9066 55.2416 43.7189 55.1283 44.4196 54.6682C45.0088 54.2812 45.4219 53.7199 45.34 53.0035C45.2633 52.3185 44.5992 52.1773 44.0553 51.9942C43.7555 51.8931 43.4365 51.8426 43.1228 51.792C41.3361 51.4975 39.5372 51.5759 37.7436 51.6665C36.7918 51.7153 35.8349 51.8478 34.9424 52.2208C34.4543 52.4248 33.9418 52.6793 33.9035 53.2789C33.8617 53.9395 34.212 54.4503 34.7907 54.7605C35.0923 54.9227 35.4287 55.036 35.7616 55.1214C36.9888 55.4369 38.2438 55.2608 39.4849 55.2835L39.4832 55.2817Z",
                        fill: "#003355"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M39.4849 55.2835C38.2421 55.2609 36.9871 55.4387 35.7617 55.1214C35.4287 55.036 35.0923 54.9227 34.7908 54.7606C34.212 54.4503 33.8617 53.9379 33.9035 53.279C33.9419 52.6794 34.4543 52.4249 34.9424 52.2209C35.8366 51.8479 36.7918 51.7154 37.7436 51.6666C39.5372 51.576 41.3361 51.4975 43.1228 51.7921C43.4365 51.8444 43.7555 51.895 44.0553 51.9943C44.6009 52.1773 45.2633 52.3168 45.34 53.0036C45.4202 53.72 45.0088 54.2813 44.4197 54.6682C43.7189 55.1302 42.9066 55.2435 42.0926 55.2748C41.2245 55.3097 40.353 55.2818 39.4832 55.2818L39.4849 55.2835ZM39.8458 54.5741C40.8899 54.5166 41.9898 54.3161 42.87 53.5004C43.1454 53.2441 43.461 52.9373 43.0879 52.5469C42.7358 52.1773 42.497 52.5033 42.2251 52.7351C40.93 53.8403 38.8626 53.8629 37.6024 52.7839C37.3305 52.5521 37.0795 52.3638 36.7884 52.6706C36.5077 52.967 36.6751 53.2668 36.9051 53.5143C37.6738 54.337 38.6692 54.5584 39.844 54.5741H39.8458Z",
                        fill: "#FAD5CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M39.8441 54.5723C38.6692 54.5566 37.6722 54.3352 36.9052 53.5125C36.6751 53.2667 36.5078 52.9652 36.7884 52.6688C37.0795 52.362 37.3305 52.5486 37.6024 52.7821C38.8627 53.8611 40.93 53.8385 42.2251 52.7333C42.4971 52.5015 42.7359 52.1755 43.088 52.5451C43.461 52.9355 43.1455 53.2423 42.8701 53.4986C41.9898 54.3161 40.8899 54.5148 39.8458 54.5723H39.8441Z",
                        fill: "#003355"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_5_786",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "58",
                        transform: "translate(19 11)",
                        width: "41.8519"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ghaX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsCloudLaptop", ()=>(0, _iconsCloudLaptop.IconsCloudLaptop));
var _iconsCloudLaptop = require("./IconsCloudLaptop");

},{"./IconsCloudLaptop":"qq7Pv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"qq7Pv":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsCloudLaptop", ()=>IconsCloudLaptop);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsCloudLaptop = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-cloud-laptop ${className}`,
        fill: "none",
        height: "128",
        viewBox: "0 0 128 128",
        width: "128",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M93.8238 81.6001H34.1758C29.5038 81.6001 25.6638 77.7601 25.6638 73.0881V39.0401C25.6638 34.3681 29.5038 30.5281 34.1758 30.5281H93.7598C98.4318 30.5281 102.272 34.3681 102.272 39.0401V73.1521C102.272 77.8241 98.4958 81.6001 93.8238 81.6001ZM34.1758 33.9201C31.3598 33.9201 29.0558 36.2241 29.0558 39.0401V73.1521C29.0558 75.9681 31.3598 78.2721 34.1758 78.2721H93.7598C96.5758 78.2721 98.8798 75.9681 98.8798 73.1521V39.0401C98.8798 36.2241 96.5758 33.9201 93.7598 33.9201H34.1758Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M103.168 97.4722H24.8319C22.0159 97.4722 19.7119 95.1682 19.7119 92.3522V89.6642C19.7119 86.8482 22.0159 84.5442 24.8319 84.5442H103.104C105.92 84.5442 108.224 86.8482 108.224 89.6642V92.3522C108.224 95.2322 105.984 97.4722 103.168 97.4722ZM24.8319 88.0002C23.8719 88.0002 23.1039 88.7682 23.1039 89.7282V92.4162C23.1039 93.3762 23.8719 94.1442 24.8319 94.1442H103.104C104.064 94.1442 104.832 93.3762 104.832 92.4162V89.7282C104.832 88.7682 104.064 88.0002 103.104 88.0002H24.8319Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M77.6959 69.888H50.3039C46.2079 69.888 42.8799 66.56 42.8799 62.464C42.8799 59.392 44.7359 56.704 47.4879 55.552C47.6799 51.84 50.6239 48.832 54.3359 48.576C55.9359 44.8 59.7759 42.24 63.9999 42.24C68.2239 42.24 72.0639 44.8 73.7279 48.576C77.4399 48.896 80.3839 51.84 80.5759 55.552C83.2639 56.704 85.1199 59.392 85.1199 62.4C85.1839 66.56 81.8559 69.888 77.6959 69.888ZM54.8479 51.968C52.6079 51.968 50.8159 53.76 50.8159 56C50.8159 56.192 50.8159 56.32 50.8799 56.576C51.0079 57.472 50.4319 58.304 49.5359 58.496C47.6159 58.88 46.2719 60.544 46.2719 62.464C46.2719 64.704 48.0639 66.496 50.3039 66.496H77.7599C79.9999 66.496 81.7919 64.704 81.7919 62.464C81.7919 60.544 80.4479 58.88 78.5279 58.496C77.6319 58.304 77.0559 57.472 77.1839 56.576C77.1839 56.384 77.2479 56.192 77.2479 56C77.2479 53.76 75.4559 51.968 73.2159 51.968C73.0879 51.968 72.9599 51.968 72.7679 51.968C71.9359 52.032 71.1679 51.52 70.9759 50.752C70.0799 47.744 67.1999 45.568 64.0639 45.568C60.8639 45.568 58.0479 47.68 57.1519 50.752C56.8959 51.52 56.1919 52.032 55.3599 51.968C55.1679 51.968 55.0399 51.968 54.8479 51.968Z",
                fill: "#A591D7"
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cvuiF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsHouse1", ()=>(0, _iconsHouse1.IconsHouse1));
var _iconsHouse1 = require("./IconsHouse1");

},{"./IconsHouse1":"dxNqL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxNqL":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsHouse1", ()=>IconsHouse1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsHouse1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-house1 ${className}`,
        fill: "none",
        height: "128",
        viewBox: "0 0 128 128",
        width: "128",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M121.984 115.379H6.1951C6.0927 115.379 6.0415 115.174 6.0415 114.918C6.0415 114.662 6.1183 114.458 6.1951 114.458H121.984",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M73.6 14.3872C72.064 14.3872 70.5536 14.8992 69.3248 15.8208C67.6352 13.7984 65.1008 12.5952 62.464 12.5952C57.5488 12.5952 53.5552 16.5888 53.5552 21.504C53.5552 23.0912 54.8352 24.3712 56.4224 24.3712H77.8752C79.4624 24.3712 80.7424 23.0912 80.7424 21.504C80.7424 17.5872 77.5424 14.3872 73.6 14.3872ZM77.8752 23.4496H56.4224C55.3472 23.4496 54.4768 22.5792 54.4768 21.504C54.4768 17.1008 58.0608 13.5168 62.464 13.5168C65.024 13.5168 67.3536 14.6944 68.8896 16.7424C68.9664 16.8448 69.0688 16.9216 69.1968 16.9216C69.3248 16.9472 69.4528 16.896 69.5552 16.8192C70.6816 15.8464 72.1408 15.3088 73.6256 15.3088C77.056 15.3088 79.8464 18.0992 79.8464 21.5296C79.8208 22.5792 78.9504 23.4496 77.8752 23.4496Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M104.704 96.2817H63.5134V96.7169H104.704V96.2817Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M104.704 73.9841H63.5134V74.4193H104.704V73.9841Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.557 104.499H99.4302V106.01H100.557V104.499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.557 100.019H99.4302V101.299H100.557V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.531 88.3457H97.3311V91.1873H100.531V88.3457Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.557 66.1248H99.4302V67.6352H100.557V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.557 61.6704H99.4302V62.9504H100.557V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.557 63.7695H99.4302V65.2799H100.557V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.557 68.48H99.4302V69.76H100.557V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.557 102.118H99.4302V103.629H100.557V102.118Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M100.557 106.854H99.4302V108.134H100.557V106.854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.5854 106.854H97.2798V108.134H98.5854V106.854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.5854 104.499H97.2798V106.01H98.5854V104.499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.5854 102.118H97.2798V103.629H98.5854V102.118Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.5854 100.019H97.2798V101.299H98.5854V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.5854 68.48H97.2798V69.76H98.5854V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.5854 66.1248H97.2798V67.6352H98.5854V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.5854 63.7695H97.2798V65.2799H98.5854V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.5854 61.6704H97.2798V62.9504H98.5854V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4608 106.854H95.104V108.134H96.4608V106.854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4608 104.499H95.104V106.01H96.4608V104.499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4608 102.118H95.104V103.629H96.4608V102.118Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4608 100.019H95.104V101.299H96.4608V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4608 68.48H95.104V69.76H96.4608V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4608 66.1248H95.104V67.6352H96.4608V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4608 63.7695H95.104V65.2799H96.4608V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4608 61.6704H95.104V62.9504H96.4608V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.259 106.854H93.1838V108.134H94.259V106.854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.259 104.499H93.1838V106.01H94.259V104.499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.259 102.118H93.1838V103.629H94.259V102.118Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.259 100.019H93.1838V101.299H94.259V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.259 68.48H93.1838V69.76H94.259V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.259 66.1248H93.1838V67.6352H94.259V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.259 63.7695H93.1838V65.2799H94.259V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.259 61.6704H93.1838V62.9504H94.259V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M75.4431 36.736V39.2704H93.0303V36.736C92.0063 36.6336 91.0591 36.1984 90.3167 35.456C89.4719 34.6112 89.0111 33.5104 89.0111 32.3072V29.696H79.4367V32.3072C79.4623 34.6368 77.6959 36.5312 75.4431 36.736ZM84.2495 31.5648C86.0415 31.5648 87.5007 33.024 87.5007 34.816C87.5007 36.608 86.0415 38.0672 84.2495 38.0672C82.4575 38.0672 80.9983 36.608 80.9983 34.816C80.9983 33.024 82.4575 31.5648 84.2495 31.5648Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.4862 88.3457H93.1838V91.1873H96.4862V88.3457Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M101.504 70.6047H92.2368V70.8351H101.504V70.6047Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M101.504 92.0063H92.2368V92.2367H101.504V92.0063Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M101.504 108.954H92.2368V109.184H101.504V108.954Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M104.704 114.15V97.5615H63.5134V114.15H66.8926V99.6095C66.8926 99.3791 67.0718 99.1999 67.3022 99.1999H75.315C75.5454 99.1999 75.7246 99.3791 75.7246 99.6095V114.15H104.704ZM91.3918 108.544C91.3918 108.314 91.571 108.134 91.8014 108.134H92.339V106.496C92.339 106.47 92.339 106.47 92.339 106.445C92.339 106.419 92.339 106.419 92.339 106.394V101.786C92.339 101.76 92.339 101.76 92.339 101.734C92.339 101.709 92.339 101.709 92.339 101.683V99.6351C92.339 99.4047 92.5182 99.2255 92.7486 99.2255H100.941C101.171 99.2255 101.35 99.4047 101.35 99.6351V108.16H101.888C102.118 108.16 102.297 108.339 102.297 108.57V109.619C102.297 109.85 102.118 110.029 101.888 110.029H91.7758C91.5454 110.029 91.3662 109.85 91.3662 109.619V108.544H91.3918ZM78.643 108.544C78.643 108.314 78.8222 108.134 79.0526 108.134H79.5902V106.496C79.5902 106.47 79.5902 106.47 79.5902 106.445C79.5902 106.419 79.5902 106.419 79.5902 106.394V101.786C79.5902 101.76 79.5902 101.76 79.5902 101.734C79.5902 101.709 79.5902 101.709 79.5902 101.683V99.6351C79.5902 99.4047 79.7694 99.2255 79.9998 99.2255H88.1918C88.4222 99.2255 88.6014 99.4047 88.6014 99.6351V108.16H89.139C89.3694 108.16 89.5486 108.339 89.5486 108.57V109.619C89.5486 109.85 89.3694 110.029 89.139 110.029H79.027C78.7966 110.029 78.6174 109.85 78.6174 109.619V108.544H78.643Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M63.5134 75.2639V95.4367H104.704V75.2639H63.5134ZM76.7742 92.6719C76.7742 92.9023 76.595 93.0815 76.3646 93.0815H66.2526C66.0222 93.0815 65.843 92.9023 65.843 92.6719V91.6223C65.843 91.3919 66.0222 91.2127 66.2526 91.2127H66.7902V77.4911C66.7902 77.2607 66.9694 77.0815 67.1998 77.0815H75.3918C75.6222 77.0815 75.8014 77.2607 75.8014 77.4911V91.2127H76.339C76.5694 91.2127 76.7486 91.3919 76.7486 91.6223V92.6719H76.7742ZM89.5742 92.6719C89.5742 92.9023 89.395 93.0815 89.1646 93.0815H79.0526C78.8222 93.0815 78.643 92.9023 78.643 92.6719V91.6223C78.643 91.3919 78.8222 91.2127 79.0526 91.2127H79.5902V77.4911C79.5902 77.2607 79.7694 77.0815 79.9998 77.0815H88.1918C88.4222 77.0815 88.6014 77.2607 88.6014 77.4911V91.2127H89.139C89.3694 91.2127 89.5486 91.3919 89.5486 91.6223V92.6719H89.5742ZM101.913 93.0815H91.8014C91.571 93.0815 91.3918 92.9023 91.3918 92.6719V91.6223C91.3918 91.3919 91.571 91.2127 91.8014 91.2127H92.339V77.4911C92.339 77.2607 92.5182 77.0815 92.7486 77.0815H100.941C101.171 77.0815 101.35 77.2607 101.35 77.4911V91.2127H101.888C102.118 91.2127 102.297 91.3919 102.297 91.6223V92.6719C102.349 92.9023 102.144 93.0815 101.913 93.0815Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M63.5134 73.1393H104.704V57.5745H63.5134V73.1393ZM91.3918 70.1697C91.3918 69.9393 91.571 69.7601 91.8014 69.7601H92.339V68.1217C92.339 68.0961 92.339 68.0961 92.339 68.0705C92.339 68.0449 92.339 68.0449 92.339 68.0193V63.4113C92.339 63.3857 92.339 63.3857 92.339 63.3601C92.339 63.3345 92.339 63.3345 92.339 63.3089V61.2609C92.339 61.0305 92.5182 60.8513 92.7486 60.8513H100.941C101.171 60.8513 101.35 61.0305 101.35 61.2609V69.7857H101.888C102.118 69.7857 102.297 69.9649 102.297 70.1953V71.2449C102.297 71.4753 102.118 71.6545 101.888 71.6545H91.7758C91.5454 71.6545 91.3662 71.4753 91.3662 71.2449V70.1697H91.3918ZM78.643 70.1697C78.643 69.9393 78.8222 69.7601 79.0526 69.7601H79.5902V68.1217C79.5902 68.0961 79.5902 68.0961 79.5902 68.0705C79.5902 68.0449 79.5902 68.0449 79.5902 68.0193V63.4113C79.5902 63.3857 79.5902 63.3857 79.5902 63.3601C79.5902 63.3345 79.5902 63.3345 79.5902 63.3089V61.2609C79.5902 61.0305 79.7694 60.8513 79.9998 60.8513H88.1918C88.4222 60.8513 88.6014 61.0305 88.6014 61.2609V69.7857H89.139C89.3694 69.7857 89.5486 69.9649 89.5486 70.1953V71.2449C89.5486 71.4753 89.3694 71.6545 89.139 71.6545H79.027C78.7966 71.6545 78.6174 71.4753 78.6174 71.2449V70.1697H78.643ZM65.843 70.1697C65.843 69.9393 66.0222 69.7601 66.2526 69.7601H66.7902V68.1217C66.7902 68.0961 66.7902 68.0961 66.7902 68.0705C66.7902 68.0449 66.7902 68.0449 66.7902 68.0193V63.4113C66.7902 63.3857 66.7902 63.3857 66.7902 63.3601C66.7902 63.3345 66.7902 63.3345 66.7902 63.3089V61.2609C66.7902 61.0305 66.9694 60.8513 67.1998 60.8513H75.3918C75.6222 60.8513 75.8014 61.0305 75.8014 61.2609V69.7857H76.339C76.5694 69.7857 76.7486 69.9649 76.7486 70.1953V71.2449C76.7486 71.4753 76.5694 71.6545 76.339 71.6545H66.227C65.9966 71.6545 65.8174 71.4753 65.8174 71.2449V70.1697H65.843Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M78.8992 54.4H89.5744V42.4448H78.8992V54.4ZM79.5392 43.4688C79.5392 43.2384 79.7184 43.0592 79.9488 43.0592H88.5248C88.7552 43.0592 88.9344 43.2384 88.9344 43.4688V53.4016C88.9344 53.632 88.7552 53.8112 88.5248 53.8112H79.9488C79.7184 53.8112 79.5392 53.632 79.5392 53.4016V43.4688Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M88.115 43.8784H80.3838V52.9664H88.115V43.8784Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7824 104.499H86.656V106.01H87.7824V104.499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7824 100.019H86.656V101.299H87.7824V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7823 88.3457H84.5823V91.1873H87.7823V88.3457Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7824 66.1248H86.656V67.6352H87.7824V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7824 61.6704H86.656V62.9504H87.7824V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7824 63.7695H86.656V65.2799H87.7824V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7824 68.48H86.656V69.76H87.7824V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7824 102.118H86.656V103.629H87.7824V102.118Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M87.7824 106.854H86.656V108.134H87.7824V106.854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M85.8366 106.854H84.531V108.134H85.8366V106.854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M85.8366 104.499H84.531V106.01H85.8366V104.499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M85.8366 102.118H84.531V103.629H85.8366V102.118Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M85.8366 100.019H84.531V101.299H85.8366V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M85.8366 68.48H84.531V69.76H85.8366V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M85.8366 66.1248H84.531V67.6352H85.8366V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M85.8366 63.7695H84.531V65.2799H85.8366V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M85.8366 61.6704H84.531V62.9504H85.8366V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.6864 106.854H82.3296V108.134H83.6864V106.854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.6864 104.499H82.3296V106.01H83.6864V104.499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.6864 102.118H82.3296V103.629H83.6864V102.118Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.6864 100.019H82.3296V101.299H83.6864V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.6864 68.48H82.3296V69.76H83.6864V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.6864 66.1248H82.3296V67.6352H83.6864V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.6864 63.7695H82.3296V65.2799H83.6864V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.6864 61.6704H82.3296V62.9504H83.6864V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5103 106.854H80.4351V108.134H81.5103V106.854Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5103 104.499H80.4351V106.01H81.5103V104.499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5103 102.118H80.4351V103.629H81.5103V102.118Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5103 100.019H80.4351V101.299H81.5103V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5103 68.48H80.4351V69.76H81.5103V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5103 66.1248H80.4351V67.6352H81.5103V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5103 63.7695H80.4351V65.2799H81.5103V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5103 61.6704H80.4351V62.9504H81.5103V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.7375 88.3457H80.4351V91.1873H83.7375V88.3457Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M88.7296 70.6047H79.4624V70.8351H88.7296V70.6047Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M88.7296 92.0063H79.4624V92.2367H88.7296V92.0063Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M88.7296 108.954H79.4624V109.184H88.7296V108.954Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M74.9822 88.3457H71.7822V91.1873H74.9822V88.3457Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M75.008 66.1248H73.8816V67.6352H75.008V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M75.008 61.6704H73.8816V62.9504H75.008V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M75.008 63.7695H73.8816V65.2799H75.008V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M75.008 68.48H73.8816V69.76H75.008V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M73.8047 101.222H68.8127V114.15H73.8047V101.222ZM73.4463 108.877C73.4463 109.107 73.2671 109.286 73.0367 109.286C72.8063 109.286 72.6272 109.107 72.6272 108.877V107.085C72.6272 106.854 72.8063 106.675 73.0367 106.675C73.2671 106.675 73.4463 106.854 73.4463 107.085V108.877Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M73.0368 68.48H71.7312V69.76H73.0368V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M73.0368 66.1248H71.7312V67.6352H73.0368V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M73.0368 63.7695H71.7312V65.2799H73.0368V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M73.0368 61.6704H71.7312V62.9504H73.0368V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M70.912 68.48H69.5552V69.76H70.912V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M70.912 66.1248H69.5552V67.6352H70.912V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M70.912 63.7695H69.5552V65.2799H70.912V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M70.912 61.6704H69.5552V62.9504H70.912V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M68.7102 68.48H67.635V69.76H68.7102V68.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M68.7102 66.1248H67.635V67.6352H68.7102V66.1248Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M68.7102 63.7695H67.635V65.2799H68.7102V63.7695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M68.7102 61.6704H67.635V62.9504H68.7102V61.6704Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M74.9055 114.15V100.019H67.7119V114.15H67.9679V100.813C67.9679 100.582 68.1471 100.403 68.3775 100.403H74.2399C74.4703 100.403 74.6495 100.582 74.6495 100.813V114.15H74.9055Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M70.9374 88.3457H67.635V91.1873H70.9374V88.3457Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M75.9552 70.6047H66.688V70.8351H75.9552V70.6047Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M75.9552 92.0063H66.688V92.2367H75.9552V92.0063Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M105.805 57.1648C105.805 56.9344 105.625 56.7552 105.395 56.7552C105.318 56.7552 105.241 56.7552 105.139 56.7552C100.019 56.6272 95.9998 52.48 95.9998 47.36V39.7056C95.9998 39.4752 95.8206 39.296 95.5902 39.296H93.9006V36.352C93.9006 36.1216 93.7214 35.9424 93.491 35.9424C92.5438 35.9424 91.6222 35.5584 90.9566 34.8928C90.2654 34.2016 89.907 33.3056 89.907 32.3584V29.3376C89.907 29.1072 89.7278 28.928 89.4974 28.928H79.1038C78.8734 28.928 78.6942 29.1072 78.6942 29.3376V32.3584C78.6942 34.3296 77.0814 35.9424 75.0846 35.9424C74.8542 35.9424 74.675 36.1216 74.675 36.352V39.296H72.9854C72.755 39.296 72.5758 39.4752 72.5758 39.7056V47.36C72.5758 52.5568 68.3518 56.7808 63.1806 56.7808C62.9502 56.7808 62.771 56.96 62.771 57.1904V73.5744V74.8544V95.872V97.152V114.586C62.771 114.816 62.9502 114.995 63.1806 114.995H67.4046H68.5054H74.2398H75.3406H105.139C105.369 114.995 105.549 114.816 105.549 114.586V97.152V95.872V74.8544V73.5744V57.5744C105.677 57.4976 105.805 57.344 105.805 57.1648ZM68.8126 101.222H73.8046V114.15H68.8126V101.222ZM74.2398 100.403H68.403C68.1726 100.403 67.9934 100.582 67.9934 100.813V114.15H67.7374V100.019H74.931V114.15H74.675V100.813C74.6494 100.582 74.4702 100.403 74.2398 100.403ZM75.315 99.1744H67.3022C67.0718 99.1744 66.8926 99.3536 66.8926 99.584V114.125H63.5134V97.536H104.704V114.125H75.7502V99.584C75.7502 99.3792 75.571 99.1744 75.315 99.1744ZM104.704 73.1392H63.5134V57.5744H104.704V73.1392ZM104.704 74.4192H63.5134V73.984H104.704V74.4192ZM104.704 96.7168H63.5134V96.2816H104.704V96.7168ZM63.5134 95.4368V75.264H104.704V95.4368H63.5134ZM79.4622 29.7216H89.0366V32.3328C89.0366 33.5104 89.4974 34.6368 90.3422 35.4816C91.0846 36.224 92.0318 36.6592 93.0558 36.7616V39.296H75.4686V36.7616C77.7214 36.5568 79.4878 34.6624 79.4878 32.3584V29.7216H79.4622ZM73.3438 47.3344V40.1152H95.155V47.3344C95.155 51.584 97.6638 55.1936 101.299 56.7552H67.1486C70.7838 55.168 73.3438 51.5584 73.3438 47.3344Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M84.2495 38.0417C86.0415 38.0417 87.5007 36.5825 87.5007 34.7905C87.5007 32.9985 86.0415 31.5393 84.2495 31.5393C82.4575 31.5393 80.9983 32.9985 80.9983 34.7905C80.9983 36.5825 82.4575 38.0417 84.2495 38.0417ZM84.2495 32.3841C85.5807 32.3841 86.6559 33.4593 86.6559 34.7905C86.6559 36.1217 85.5807 37.1969 84.2495 37.1969C82.9183 37.1969 81.8431 36.1217 81.8431 34.7905C81.8431 33.4849 82.9183 32.3841 84.2495 32.3841Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M90.0094 41.6001H78.4894C78.259 41.6001 78.0798 41.7793 78.0798 42.0097V54.8097C78.0798 55.0401 78.259 55.2193 78.4894 55.2193H90.0094C90.2398 55.2193 90.419 55.0401 90.419 54.8097V42.0097C90.419 41.7793 90.2398 41.6001 90.0094 41.6001ZM89.5742 54.4001H78.899V42.4449H89.5742V54.4001Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M79.9487 53.7857H88.5247C88.7551 53.7857 88.9343 53.6065 88.9343 53.3761V43.4433C88.9343 43.2129 88.7551 43.0337 88.5247 43.0337H79.9487C79.7183 43.0337 79.5391 43.2129 79.5391 43.4433V53.3761C79.5391 53.6065 79.7183 53.7857 79.9487 53.7857ZM80.3839 43.8785H88.1151V52.9665H80.3839V43.8785Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M79.0527 110.029H89.1647C89.3951 110.029 89.5743 109.85 89.5743 109.619V108.544C89.5743 108.314 89.3951 108.134 89.1647 108.134H88.6271V99.6096C88.6271 99.3792 88.4479 99.2 88.2175 99.2H80.0255C79.7951 99.2 79.6159 99.3792 79.6159 99.6096V101.658C79.6159 101.683 79.6159 101.683 79.6159 101.709C79.6159 101.734 79.6159 101.734 79.6159 101.76V106.368C79.6159 106.394 79.6159 106.394 79.6159 106.419C79.6159 106.445 79.6159 106.445 79.6159 106.47V108.109H79.0783C78.8479 108.109 78.6687 108.288 78.6687 108.518V109.568C78.6431 109.824 78.8223 110.029 79.0527 110.029ZM87.7823 101.299H86.6559V100.019H87.7823V101.299ZM84.5311 108.109V106.829H85.8367V108.109H84.5311ZM82.3295 108.109V106.829H83.6863V108.109H82.3295ZM85.8367 103.654H84.5311V102.144H85.8367V103.654ZM84.5311 106.01V104.499H85.8367V106.01H84.5311ZM86.6559 104.499H87.7823V106.01H86.6559V104.499ZM86.6559 102.118H87.7823V103.629H86.6559V102.118ZM83.6863 102.118V103.629H82.3295V102.118H83.6863ZM81.5103 103.654H80.4351V102.144H81.5103V103.654ZM82.3295 104.499H83.6863V106.01H82.3295V104.499ZM85.8367 101.299H84.5311V100.019H85.8367V101.299ZM83.6863 101.299H82.3295V100.019H83.6863V101.299ZM80.4351 104.499H81.5103V106.01H80.4351V104.499ZM86.6559 108.109V106.829H87.7823V108.109H86.6559ZM81.5103 100.019V101.299H80.4351V100.019H81.5103ZM80.4351 106.854H81.5103V108.134H80.4351V106.854ZM79.4623 108.954H88.7295V109.184H79.4623V108.954Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M91.8271 110.029H101.939C102.169 110.029 102.349 109.85 102.349 109.619V108.544C102.349 108.314 102.169 108.134 101.939 108.134H101.376V99.6096C101.376 99.3792 101.197 99.2 100.966 99.2H92.7742C92.5438 99.2 92.3646 99.3792 92.3646 99.6096V101.658C92.3646 101.683 92.3646 101.683 92.3646 101.709C92.3646 101.734 92.3646 101.734 92.3646 101.76V106.368C92.3646 106.394 92.3646 106.394 92.3646 106.419C92.3646 106.445 92.3646 106.445 92.3646 106.47V108.109H91.8271C91.5967 108.109 91.4175 108.288 91.4175 108.518V109.568C91.3919 109.824 91.5967 110.029 91.8271 110.029ZM97.2799 108.109V106.829H98.5855V108.109H97.2799ZM95.1039 108.109V106.829H96.4606V108.109H95.1039ZM100.531 103.654H99.4046V102.144H100.531V103.654ZM100.531 106.01H99.4046V104.499H100.531V106.01ZM98.5855 103.654H97.2799V102.144H98.5855V103.654ZM97.2799 106.01V104.499H98.5855V106.01H97.2799ZM96.4606 102.118V103.629H95.1039V102.118H96.4606ZM94.2591 103.654H93.1839V102.144H94.2591V103.654ZM94.2591 104.499V106.01H93.1839V104.499H94.2591ZM95.1039 104.499H96.4606V106.01H95.1039V104.499ZM100.531 101.299H99.4046V100.019H100.531V101.299ZM98.5855 101.299H97.2799V100.019H98.5855V101.299ZM96.4606 101.299H95.1039V100.019H96.4606V101.299ZM99.4302 108.109V106.829H100.557V108.109H99.4302ZM94.2591 100.019V101.299H93.1839V100.019H94.2591ZM94.2591 106.854V108.134H93.1839V106.854H94.2591ZM92.2366 108.954H101.504V109.184H92.2366V108.954Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M66.2526 71.6545H76.3646C76.595 71.6545 76.7743 71.4753 76.7743 71.2449V70.1953C76.7743 69.9649 76.595 69.7857 76.3646 69.7857H75.8271V61.2609C75.8271 61.0305 75.6479 60.8513 75.4175 60.8513H67.2255C66.9951 60.8513 66.8159 61.0305 66.8159 61.2609V63.3089C66.8159 63.3345 66.8159 63.3345 66.8159 63.3601C66.8159 63.3857 66.8159 63.3857 66.8159 63.4113V68.0193C66.8159 68.0449 66.8159 68.0449 66.8159 68.0705C66.8159 68.0961 66.8159 68.0961 66.8159 68.1217V69.7601H66.2783C66.0479 69.7601 65.8686 69.9393 65.8686 70.1697V71.2193C65.843 71.4753 66.0222 71.6545 66.2526 71.6545ZM74.9823 62.9249H73.8559V61.6449H74.9823V62.9249ZM71.7311 69.7601V68.4801H73.0367V69.7601H71.7311ZM69.5551 69.7601V68.4801H70.9119V69.7601H69.5551ZM73.0367 65.3057H71.7311V63.7953H73.0367V65.3057ZM71.7311 67.6609V66.1505H73.0367V67.6609H71.7311ZM73.8815 66.1249H75.0079V67.6353H73.8815V66.1249ZM73.8815 63.7697H75.0079V65.2801H73.8815V63.7697ZM70.8863 63.7697V65.2801H69.5295V63.7697H70.8863ZM68.7103 65.3057H67.6351V63.7953H68.7103V65.3057ZM69.5551 66.1249H70.9119V67.6353H69.5551V66.1249ZM73.0367 62.9249H71.7311V61.6449H73.0367V62.9249ZM70.8863 62.9249H69.5295V61.6449H70.8863V62.9249ZM67.6351 66.1249H68.7103V67.6353H67.6351V66.1249ZM73.8815 69.7601V68.4801H75.0079V69.7601H73.8815ZM68.7103 61.6705V62.9505H67.6351V61.6705H68.7103ZM67.6351 68.4801H68.7103V69.7601H67.6351V68.4801ZM66.6879 70.6049H75.9551V70.8353H66.6879V70.6049Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M79.0527 71.6545H89.1647C89.3951 71.6545 89.5743 71.4753 89.5743 71.2449V70.1953C89.5743 69.9649 89.3951 69.7857 89.1647 69.7857H88.6271V61.2609C88.6271 61.0305 88.4479 60.8513 88.2175 60.8513H80.0255C79.7951 60.8513 79.6159 61.0305 79.6159 61.2609V63.3089C79.6159 63.3345 79.6159 63.3345 79.6159 63.3601C79.6159 63.3857 79.6159 63.3857 79.6159 63.4113V68.0193C79.6159 68.0449 79.6159 68.0449 79.6159 68.0705C79.6159 68.0961 79.6159 68.0961 79.6159 68.1217V69.7601H79.0783C78.8479 69.7601 78.6687 69.9393 78.6687 70.1697V71.2193C78.6431 71.4753 78.8223 71.6545 79.0527 71.6545ZM87.7823 62.9249H86.6559V61.6449H87.7823V62.9249ZM84.5311 69.7601V68.4801H85.8367V69.7601H84.5311ZM82.3295 69.7601V68.4801H83.6863V69.7601H82.3295ZM85.8367 65.3057H84.5311V63.7953H85.8367V65.3057ZM84.5311 67.6609V66.1505H85.8367V67.6609H84.5311ZM86.6559 66.1249H87.7823V67.6353H86.6559V66.1249ZM86.6559 63.7697H87.7823V65.2801H86.6559V63.7697ZM83.6863 63.7697V65.2801H82.3295V63.7697H83.6863ZM81.5103 65.3057H80.4351V63.7953H81.5103V65.3057ZM82.3295 66.1249H83.6863V67.6353H82.3295V66.1249ZM85.8367 62.9249H84.5311V61.6449H85.8367V62.9249ZM83.6863 62.9249H82.3295V61.6449H83.6863V62.9249ZM80.4351 66.1249H81.5103V67.6353H80.4351V66.1249ZM86.6559 69.7601V68.4801H87.7823V69.7601H86.6559ZM81.5103 61.6705V62.9505H80.4351V61.6705H81.5103ZM80.4351 68.4801H81.5103V69.7601H80.4351V68.4801ZM79.4623 70.6049H88.7295V70.8353H79.4623V70.6049Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M91.8271 71.6545H101.939C102.169 71.6545 102.349 71.4753 102.349 71.2449V70.1953C102.349 69.9649 102.169 69.7857 101.939 69.7857H101.376V61.2609C101.376 61.0305 101.197 60.8513 100.966 60.8513H92.7742C92.5438 60.8513 92.3646 61.0305 92.3646 61.2609V63.3089C92.3646 63.3345 92.3646 63.3345 92.3646 63.3601C92.3646 63.3857 92.3646 63.3857 92.3646 63.4113V68.0193C92.3646 68.0449 92.3646 68.0449 92.3646 68.0705C92.3646 68.0961 92.3646 68.0961 92.3646 68.1217V69.7601H91.8271C91.5967 69.7601 91.4175 69.9393 91.4175 70.1697V71.2193C91.3919 71.4753 91.5967 71.6545 91.8271 71.6545ZM97.2799 69.7601V68.4801H98.5855V69.7601H97.2799ZM95.1039 69.7601V68.4801H96.4606V69.7601H95.1039ZM100.531 65.3057H99.4046V63.7953H100.531V65.3057ZM100.531 67.6609H99.4046V66.1505H100.531V67.6609ZM98.5855 65.3057H97.2799V63.7953H98.5855V65.3057ZM97.2799 67.6609V66.1505H98.5855V67.6609H97.2799ZM96.4606 63.7697V65.2801H95.1039V63.7697H96.4606ZM94.2591 65.3057H93.1839V63.7953H94.2591V65.3057ZM94.2591 66.1249V67.6353H93.1839V66.1249H94.2591ZM95.1039 66.1249H96.4606V67.6353H95.1039V66.1249ZM100.531 62.9249H99.4046V61.6449H100.531V62.9249ZM98.5855 62.9249H97.2799V61.6449H98.5855V62.9249ZM96.4606 62.9249H95.1039V61.6449H96.4606V62.9249ZM99.4302 69.7601V68.4801H100.557V69.7601H99.4302ZM94.2591 61.6705V62.9505H93.1839V61.6705H94.2591ZM94.2591 68.4801V69.7601H93.1839V68.4801H94.2591ZM92.2366 70.6049H101.504V70.8353H92.2366V70.6049Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M76.3647 91.1871H75.8271V77.4655C75.8271 77.2351 75.6479 77.0559 75.4175 77.0559H67.2255C66.9951 77.0559 66.8159 77.2351 66.8159 77.4655V91.1871H66.2783C66.0479 91.1871 65.8687 91.3663 65.8687 91.5967V92.6463C65.8687 92.8767 66.0479 93.0559 66.2783 93.0559H76.3903C76.6207 93.0559 76.7999 92.8767 76.7999 92.6463V91.5967C76.7743 91.3663 76.5951 91.1871 76.3647 91.1871ZM75.9551 92.2367H66.6879V92.0063H75.9551V92.2367ZM74.9823 87.5007H67.6351V77.8751H74.9823V87.5007ZM71.7823 91.1871V88.3455H74.9823V91.1871H71.7823ZM67.6351 88.3455H70.9375V91.1871H67.6351V88.3455Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M89.1647 91.1871H88.6271V77.4655C88.6271 77.2351 88.4479 77.0559 88.2175 77.0559H80.0255C79.7951 77.0559 79.6159 77.2351 79.6159 77.4655V91.1871H79.0783C78.8479 91.1871 78.6687 91.3663 78.6687 91.5967V92.6463C78.6687 92.8767 78.8479 93.0559 79.0783 93.0559H89.1903C89.4207 93.0559 89.5999 92.8767 89.5999 92.6463V91.5967C89.5743 91.3663 89.3951 91.1871 89.1647 91.1871ZM88.7295 92.2367H79.4623V92.0063H88.7295V92.2367ZM87.7823 87.5007H80.4351V77.8751H87.7823V87.5007ZM84.5823 91.1871V88.3455H87.7823V91.1871H84.5823ZM80.4351 88.3455H83.7375V91.1871H80.4351V88.3455Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M101.913 91.1871H101.376V77.4655C101.376 77.2351 101.197 77.0559 100.966 77.0559H92.7743C92.5439 77.0559 92.3647 77.2351 92.3647 77.4655V91.1871H91.8271C91.5967 91.1871 91.4175 91.3663 91.4175 91.5967V92.6463C91.4175 92.8767 91.5967 93.0559 91.8271 93.0559H101.939C102.169 93.0559 102.349 92.8767 102.349 92.6463V91.5967C102.349 91.3663 102.144 91.1871 101.913 91.1871ZM101.504 92.2367H92.2367V92.0063H101.504V92.2367ZM97.3311 91.1871V88.3455H100.531V91.1871H97.3311ZM100.531 87.5007H93.1839V77.8751H100.531V87.5007ZM93.1839 88.3455H96.4863V91.1871H93.1839V88.3455Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M73.0368 106.675C72.8064 106.675 72.6272 106.854 72.6272 107.085V108.877C72.6272 109.107 72.8064 109.286 73.0368 109.286C73.2672 109.286 73.4464 109.107 73.4464 108.877V107.085C73.4464 106.854 73.2672 106.675 73.0368 106.675Z",
                fill: "#4195CE"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.7007 77.3633H40.2175V79.9745H42.7007V77.3633Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M31.7696 67.1743H29.2864V69.4271H31.7696V67.1743Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M31.7696 64.0769H29.2864V66.3297H31.7696V64.0769Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M31.6927 77.3633H29.2095V79.9745H31.6927V77.3633Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M31.6927 80.8193H29.2095V83.0721H31.6927V80.8193Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M37.504 101.222H32.512V114.15H37.504V101.222ZM37.1456 108.877C37.1456 109.107 36.9664 109.286 36.736 109.286C36.5056 109.286 36.3264 109.107 36.3264 108.877V107.085C36.3264 106.854 36.5056 106.675 36.736 106.675C36.9664 106.675 37.1456 106.854 37.1456 107.085V108.877Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M38.6047 114.15V100.019H31.4111V114.15H31.6671V100.813C31.6671 100.582 31.8463 100.403 32.0767 100.403H37.9135C38.1439 100.403 38.3231 100.582 38.3231 100.813V114.15H38.6047Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.0208 80.8193H32.5376V83.0721H35.0208V80.8193Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.0208 77.3633H32.5376V79.9745H35.0208V77.3633Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.0975 60.6465H32.6143V63.2577H35.0975V60.6465Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.0208 83.9167H32.5376V86.1696H35.0208V83.9167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.0208 86.9888H32.5376V89.6H35.0208V86.9888Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.0975 64.0769H32.6143V66.3297H35.0975V64.0769Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.0975 67.1743H32.6143V69.4271H35.0975V67.1743Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.7007 83.9167H40.2175V86.1696H42.7007V83.9167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.0975 70.2463H32.6143V72.8575H35.0975V70.2463Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.7007 80.8193H40.2175V83.0721H42.7007V80.8193Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.7007 86.9888H40.2175V89.6H42.7007V86.9888Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.752 60.6465H40.2688V63.2577H42.752V60.6465Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.752 67.1743H40.2688V69.4271H42.752V67.1743Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.752 64.0769H40.2688V66.3297H42.752V64.0769Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.752 70.2463H40.2688V72.8575H42.752V70.2463Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.0286 80.8193H43.5454V83.0721H46.0286V80.8193Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.003 100.019H43.3918V102.502H46.003V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.003 103.347H43.3918V105.83H46.003V103.347Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.0286 77.3633H43.5454V79.9745H46.0286V77.3633Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.0286 83.9167H43.5454V86.1696H46.0286V83.9167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.0799 60.6465H43.5967V63.2577H46.0799V60.6465Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.0286 86.9888H43.5454V89.6H46.0286V86.9888Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M39.9358 44.6719H46.0286C45.8238 43.1615 44.5438 42.0095 42.9822 42.0095C42.163 42.0095 41.395 42.3423 40.8062 42.9055C40.3198 43.3919 40.0382 44.0063 39.9358 44.6719Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.08 45.5168H39.9104V51.0976H46.08V45.5168Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.0799 64.0769H43.5967V66.3297H46.0799V64.0769Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.0799 70.2463H43.5967V72.8575H46.0799V70.2463Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.0799 67.1743H43.5967V69.4271H46.0799V67.1743Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M38.3999 31.0785H47.5647C47.3599 28.7233 45.3887 26.8801 42.9823 26.8801C40.5759 26.8801 38.6047 28.7233 38.3999 31.0785Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M49.1007 100.019H46.8479V102.502H49.1007V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.5552 77.3633H51.072V79.9745H53.5552V77.3633Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M49.1007 103.347H46.8479V105.83H49.1007V103.347Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M52.1984 100.019H49.9456V102.502H52.1984V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M52.1984 103.347H49.9456V105.83H52.1984V103.347Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.5552 80.8193H51.072V83.0721H53.5552V80.8193Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.5552 86.9888H51.072V89.6H53.5552V86.9888Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.5552 83.9167H51.072V86.1696H53.5552V83.9167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.6319 60.6465H51.1487V63.2577H53.6319V60.6465Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.6319 64.0769H51.1487V66.3297H53.6319V64.0769Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.6319 67.1743H51.1487V69.4271H53.6319V67.1743Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.6319 70.2463H51.1487V72.8575H53.6319V70.2463Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M55.6288 100.019H53.0176V102.502H55.6288V100.019Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M55.6288 103.347H53.0176V105.83H55.6288V103.347Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.8831 77.3633H54.3999V79.9745H56.8831V77.3633Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.8831 80.8193H54.3999V83.0721H56.8831V80.8193Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.8831 83.9167H54.3999V86.1696H56.8831V83.9167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.8831 86.9888H54.3999V89.6H56.8831V86.9888Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.96 60.6465H54.4768V63.2577H56.96V60.6465Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.96 64.0769H54.4768V66.3297H56.96V64.0769Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.96 67.1743H54.4768V69.4271H56.96V67.1743Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.96 70.2463H54.4768V72.8575H56.96V70.2463Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M58.4959 54.0161H27.4688V54.9889H58.4959V54.0161Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M27.4688 55.8335V94.3871H58.4959V55.8335H27.4688ZM35.8656 90.0351C35.8656 90.2655 35.6863 90.4447 35.4559 90.4447H28.7999C28.5695 90.4447 28.3903 90.2655 28.3903 90.0351V76.9535C28.3903 76.7231 28.5695 76.5439 28.7999 76.5439H35.4559C35.6863 76.5439 35.8656 76.7231 35.8656 76.9535V90.0351ZM35.9167 73.2927C35.9167 73.5231 35.7375 73.7023 35.5071 73.7023H28.8511C28.6207 73.7023 28.4415 73.5231 28.4415 73.2927V60.2111C28.4415 59.9807 28.6207 59.8015 28.8511 59.8015H35.5071C35.7375 59.8015 35.9167 59.9807 35.9167 60.2111V73.2927ZM46.8735 90.0351C46.8735 90.2655 46.6943 90.4447 46.4639 90.4447H39.8079C39.5775 90.4447 39.3983 90.2655 39.3983 90.0351V76.9535C39.3983 76.7231 39.5775 76.5439 39.8079 76.5439H46.4639C46.6943 76.5439 46.8735 76.7231 46.8735 76.9535V90.0351ZM46.9247 73.2927C46.9247 73.5231 46.7455 73.7023 46.5151 73.7023H39.8591C39.6287 73.7023 39.4495 73.5231 39.4495 73.2927V60.2111C39.4495 59.9807 39.6287 59.8015 39.8591 59.8015H46.5151C46.7455 59.8015 46.9247 59.9807 46.9247 60.2111V73.2927ZM57.7279 90.0351C57.7279 90.2655 57.5487 90.4447 57.3183 90.4447H50.6623C50.4319 90.4447 50.2527 90.2655 50.2527 90.0351V76.9535C50.2527 76.7231 50.4319 76.5439 50.6623 76.5439H57.3183C57.5487 76.5439 57.7279 76.7231 57.7279 76.9535V90.0351ZM57.8047 73.2927C57.8047 73.5231 57.6255 73.7023 57.3951 73.7023H50.7391C50.5087 73.7023 50.3295 73.5231 50.3295 73.2927V60.2111C50.3295 59.9807 50.5087 59.8015 50.7391 59.8015H57.3951C57.6255 59.8015 57.8047 59.9807 57.8047 60.2111V73.2927Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M58.4959 95.2319H27.4688V96.3583H58.4959V95.2319Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M27.4688 97.1777V114.151H30.5663V99.6097C30.5663 99.3793 30.7455 99.2001 30.9759 99.2001H38.9888C39.2192 99.2001 39.3983 99.3793 39.3983 99.6097V114.151H58.4703V97.1777H27.4688ZM56.4736 106.24C56.4736 106.471 56.2943 106.65 56.064 106.65H42.9823C42.7519 106.65 42.5728 106.471 42.5728 106.24V99.5841C42.5728 99.3537 42.7519 99.1745 42.9823 99.1745H56.064C56.2943 99.1745 56.4736 99.3537 56.4736 99.5841V106.24Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M31.6927 83.9167H29.2095V86.1696H31.6927V83.9167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M31.7696 60.6465H29.2864V63.2577H31.7696V60.6465Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M31.7696 70.2463H29.2864V72.8575H31.7696V70.2463Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M31.6927 86.9888H29.2095V89.6H31.6927V86.9888Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M40.9856 36.48C40.9856 37.5808 41.8816 38.4768 42.9824 38.4768C44.0832 38.4768 44.9792 37.5808 44.9792 36.48C44.9792 35.3792 44.0832 34.4832 42.9824 34.4832C41.8816 34.4832 40.9856 35.3792 40.9856 36.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M58.9056 53.1712C53.12 53.1712 48.4096 48.4608 48.4096 42.6752V31.872H50.2528C50.4832 31.872 50.6624 31.6928 50.6624 31.4624C50.6624 31.232 50.4832 31.0528 50.2528 31.0528H48.384C48.1792 28.2368 45.824 26.0352 42.9568 26.0352C40.0896 26.0352 37.76 28.2624 37.5296 31.0528H35.6608C35.4304 31.0528 35.2512 31.232 35.2512 31.4624C35.2512 31.6928 35.4304 31.872 35.6608 31.872H37.504V42.6752C37.504 48.4608 32.7936 53.1712 27.008 53.1712C26.7776 53.1712 26.5984 53.3504 26.5984 53.5808V94.7967V96.768V114.56C26.5984 114.79 26.7776 114.97 27.008 114.97H30.9504H32.0512H37.888H38.9888H58.88C59.1104 114.97 59.2896 114.79 59.2896 114.56V96.768V94.7967V53.5808C59.3408 53.376 59.136 53.1712 58.9056 53.1712ZM32.512 101.222H37.504V114.15H32.512V101.222ZM37.9136 100.403H32.0768C31.8464 100.403 31.6672 100.582 31.6672 100.813V114.15H31.4112V100.019H38.6048V114.15H38.3488V100.813C38.3488 100.582 38.144 100.403 37.9136 100.403ZM39.424 114.15V99.6096C39.424 99.3792 39.2448 99.2 39.0144 99.2H31.0016C30.7712 99.2 30.592 99.3792 30.592 99.6096V114.15H27.4944V97.1776H58.5216V114.15H39.424ZM58.496 54.9888H27.4688V54.016H58.496V54.9888ZM58.496 95.2319V96.3584H27.4688V95.2319H58.496ZM27.4688 94.3872V55.8336H58.496V94.3872H27.4688ZM47.5648 31.0784H38.4C38.6048 28.7232 40.576 26.88 42.9824 26.88C45.3888 26.88 47.36 28.7232 47.5648 31.0784ZM38.3744 42.7008V31.8976H47.5904V42.7008C47.5904 47.4368 50.5088 51.5072 54.656 53.1968H31.3344C35.456 51.4816 38.3744 47.4368 38.3744 42.7008Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.9823 39.2961C44.5439 39.2961 45.7983 38.0161 45.7983 36.4801C45.7983 34.9185 44.5183 33.6641 42.9823 33.6641C41.4207 33.6641 40.1663 34.9441 40.1663 36.4801C40.1663 38.0161 41.4207 39.2961 42.9823 39.2961ZM44.9791 36.4801C44.9791 37.5809 44.0831 38.4769 42.9823 38.4769C41.8815 38.4769 40.9855 37.5809 40.9855 36.4801C40.9855 35.3793 41.8815 34.4833 42.9823 34.4833C44.0831 34.4833 44.9791 35.3793 44.9791 36.4801Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M42.9822 41.1648C41.9326 41.1648 40.9598 41.5744 40.2174 42.3168C39.475 43.0592 39.0654 44.032 39.0654 45.0816V51.5072C39.0654 51.7376 39.2446 51.9168 39.475 51.9168H46.4638C46.6942 51.9168 46.8734 51.7376 46.8734 51.5072V45.0816C46.899 42.9312 45.1326 41.1648 42.9822 41.1648ZM46.0286 44.672H39.9358C40.0382 44.0064 40.3198 43.392 40.8062 42.9056C41.395 42.3168 42.163 42.0096 42.9822 42.0096C44.5438 42.0096 45.8238 43.1616 46.0286 44.672ZM39.9102 45.5168H46.0798V51.0976H39.9102V45.5168Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.4303 76.5439H28.7743C28.5439 76.5439 28.3647 76.7231 28.3647 76.9535V90.0351C28.3647 90.2655 28.5439 90.4447 28.7743 90.4447H35.4303C35.6607 90.4447 35.8399 90.2655 35.8399 90.0351V76.9535C35.8655 76.7231 35.6607 76.5439 35.4303 76.5439ZM35.0207 77.3631V79.9743H32.5375V77.3631H35.0207ZM31.6927 83.9167V86.1695H29.2095V83.9167H31.6927ZM32.5375 83.9167H35.0207V86.1695H32.5375V83.9167ZM32.5375 80.8191H35.0207V83.0719H32.5375V80.8191ZM31.6927 80.8191V83.0719H29.2095V80.8191H31.6927ZM32.5375 86.9887H35.0207V89.5999H32.5375V86.9887ZM31.6927 77.3631V79.9743H29.2095V77.3631H31.6927ZM29.2095 86.9887H31.6927V89.5999H29.2095V86.9887Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.4384 76.5439H39.7824C39.552 76.5439 39.3728 76.7231 39.3728 76.9535V90.0351C39.3728 90.2655 39.552 90.4447 39.7824 90.4447H46.4384C46.6688 90.4447 46.848 90.2655 46.848 90.0351V76.9535C46.8736 76.7231 46.6688 76.5439 46.4384 76.5439ZM40.2176 86.9887H42.7008V89.5999H40.2176V86.9887ZM42.7008 86.1695H40.2176V83.9167H42.7008V86.1695ZM42.7008 83.0719H40.2176V80.8191H42.7008V83.0719ZM42.7008 79.9743H40.2176V77.3631H42.7008V79.9743ZM43.5456 83.9167H46.0288V86.1695H43.5456V83.9167ZM43.5456 83.0719V80.8191H46.0288V83.0719H43.5456ZM46.0288 79.9743H43.5456V77.3631H46.0288V79.9743ZM43.5456 89.5999V86.9887H46.0288V89.5999H43.5456Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M57.3183 76.5439H50.6623C50.4319 76.5439 50.2527 76.7231 50.2527 76.9535V90.0351C50.2527 90.2655 50.4319 90.4447 50.6623 90.4447H57.3183C57.5487 90.4447 57.7279 90.2655 57.7279 90.0351V76.9535C57.7279 76.7231 57.5487 76.5439 57.3183 76.5439ZM56.9087 77.3631V79.9743H54.4255V77.3631H56.9087ZM53.5807 83.9167V86.1695H51.0975V83.9167H53.5807ZM54.3999 83.9167H56.8831V86.1695H54.3999V83.9167ZM54.3999 80.8191H56.8831V83.0719H54.3999V80.8191ZM53.5807 80.8191V83.0719H51.0975V80.8191H53.5807ZM54.3999 86.9887H56.8831V89.5999H54.3999V86.9887ZM53.5807 77.3631V79.9743H51.0975V77.3631H53.5807ZM51.0719 86.9887H53.5551V89.5999H51.0719V86.9887Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M35.507 59.8015H28.851C28.6206 59.8015 28.4414 59.9807 28.4414 60.2111V73.2927C28.4414 73.5231 28.6206 73.7023 28.851 73.7023H35.507C35.7374 73.7023 35.9166 73.5231 35.9166 73.2927V60.2111C35.9166 59.9807 35.7374 59.8015 35.507 59.8015ZM29.2862 72.8575V70.2463H31.7694V72.8575H29.2862ZM32.6142 66.3295V64.0767H35.0974V66.3295H32.6142ZM31.7694 66.3295H29.2862V64.0767H31.7694V66.3295ZM31.7694 67.1743V69.4271H29.2862V67.1743H31.7694ZM32.6142 69.4271V67.1743H35.0974V69.4271H32.6142ZM35.0974 63.2319H32.6142V60.6207H35.0974V63.2319ZM31.7694 60.6463V63.2319H29.2862V60.6207H31.7694V60.6463ZM32.6142 72.8575V70.2463H35.0974V72.8575H32.6142Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M46.5151 59.8015H39.8591C39.6287 59.8015 39.4495 59.9807 39.4495 60.2111V73.2927C39.4495 73.5231 39.6287 73.7023 39.8591 73.7023H46.5151C46.7455 73.7023 46.9247 73.5231 46.9247 73.2927V60.2111C46.9247 59.9807 46.7455 59.8015 46.5151 59.8015ZM46.0799 63.2319H43.5967V60.6207H46.0799V63.2319ZM42.7775 67.1743V69.4271H40.2943V67.1743H42.7775ZM43.5967 67.1743H46.0799V69.4271H43.5967V67.1743ZM43.5967 64.0767H46.0799V66.3295H43.5967V64.0767ZM42.7775 64.0767V66.3295H40.2943V64.0767H42.7775ZM43.5967 70.2463H46.0799V72.8575H43.5967V70.2463ZM42.7775 60.6463V63.2319H40.2943V60.6207H42.7775V60.6463ZM40.2687 70.2463H42.7519V72.8575H40.2687V70.2463Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M57.3696 59.8015H50.7136C50.4832 59.8015 50.304 59.9807 50.304 60.2111V73.2927C50.304 73.5231 50.4832 73.7023 50.7136 73.7023H57.3696C57.6 73.7023 57.7792 73.5231 57.7792 73.2927V60.2111C57.8048 59.9807 57.6 59.8015 57.3696 59.8015ZM51.1488 72.8575V70.2463H53.632V72.8575H51.1488ZM54.4768 66.3295V64.0767H56.96V66.3295H54.4768ZM53.632 66.3295H51.1488V64.0767H53.632V66.3295ZM53.632 67.1743V69.4271H51.1488V67.1743H53.632ZM54.4768 69.4271V67.1743H56.96V69.4271H54.4768ZM56.96 63.2319H54.4768V60.6207H56.96V63.2319ZM53.632 60.6463V63.2319H51.1488V60.6207H53.632V60.6463ZM54.4768 72.8575V70.2463H56.96V72.8575H54.4768Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.064 99.1743H42.9824C42.752 99.1743 42.5728 99.3535 42.5728 99.5839V106.24C42.5728 106.47 42.752 106.65 42.9824 106.65H56.064C56.2944 106.65 56.4736 106.47 56.4736 106.24V99.5839C56.4736 99.3791 56.2944 99.1743 56.064 99.1743ZM55.6288 102.502H53.0176V100.019H55.6288V102.502ZM43.392 103.347H46.0032V105.83H43.392V103.347ZM52.1984 102.502H49.9456V100.019H52.1984V102.502ZM49.1008 102.502H46.848V100.019H49.1008V102.502ZM46.0032 102.502H43.392V100.019H46.0032V102.502ZM46.848 103.347H49.1008V105.83H46.848V103.347ZM49.9456 103.347H52.1984V105.83H49.9456V103.347ZM53.0176 105.83V103.347H55.6288V105.83H53.0176Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M36.7104 106.675C36.48 106.675 36.3008 106.854 36.3008 107.085V108.877C36.3008 109.107 36.48 109.286 36.7104 109.286C36.9408 109.286 37.12 109.107 37.12 108.877V107.085C37.1456 106.854 36.9408 106.675 36.7104 106.675Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M60.8511 80.9985L59.9807 81.8689H63.9743L63.0783 80.9985H60.8511Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M59.9551 82.7136C60.1599 83.6608 60.9791 84.352 61.9775 84.352C62.9759 84.352 63.8207 83.6352 63.9999 82.7136H59.9551Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M62.848 80.1023H61.1072V80.1791H62.848V80.1023Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M54.4766 113.382H53.2734V114.15H58.2142V113.382H57.011H54.4766Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.6015 103.731H54.9119V112.538H56.6015V103.731Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M65.2799 81.9969L63.6927 80.4097V79.6673C63.6927 79.4369 63.5135 79.2577 63.2831 79.2577H62.4127V76.2625C62.4127 75.3153 62.0543 74.4193 61.3887 73.7537C60.7231 73.0881 59.8271 72.7297 58.8799 72.7297C56.9343 72.7297 55.3471 74.3169 55.3471 76.2625V78.5665H54.5279C54.2975 78.5665 54.1183 78.7457 54.1183 78.9761V79.7185C54.1183 79.9489 54.2975 80.1281 54.5279 80.1281H55.3471V102.861H54.5023C54.2719 102.861 54.0927 103.04 54.0927 103.271V112.487H52.8639C52.6335 112.487 52.4543 112.666 52.4543 112.896V114.509C52.4543 114.739 52.6335 114.919 52.8639 114.919H58.6495C58.8799 114.919 59.0591 114.739 59.0591 114.509V112.896C59.0591 112.666 58.8799 112.487 58.6495 112.487H57.4207V103.271C57.4207 103.04 57.2415 102.861 57.0111 102.861H56.1663V80.1281H56.9855C57.2159 80.1281 57.3951 79.9489 57.3951 79.7185V78.9761C57.3951 78.7457 57.2159 78.5665 56.9855 78.5665H56.1663V76.2625C56.1663 74.7777 57.3695 73.5745 58.8543 73.5745C59.5711 73.5745 60.2623 73.8561 60.7487 74.3681C61.2607 74.8801 61.5423 75.5457 61.5423 76.2881V79.2833H60.6719C60.4415 79.2833 60.2623 79.4625 60.2623 79.6929V80.4353L58.6751 82.0225C58.5471 82.1505 58.5215 82.3297 58.5727 82.4833C58.6495 82.6369 58.7775 82.7393 58.9567 82.7393H59.0847C59.2895 84.1473 60.4927 85.2225 61.9519 85.2225C63.4111 85.2225 64.6143 84.1473 64.8191 82.7393H64.9471C65.1263 82.7393 65.2799 82.6369 65.3311 82.4833C65.4335 82.3041 65.3823 82.1249 65.2799 81.9969ZM58.2143 114.151H53.2479V113.383H54.4767H56.9855H58.2143V114.151ZM56.6015 103.731V112.538H54.9119V103.731H56.6015ZM61.9775 84.3521C60.9791 84.3521 60.1343 83.6353 59.9551 82.7137H63.9999C63.7951 83.6609 62.9759 84.3521 61.9775 84.3521ZM59.9807 81.8689L60.8511 80.9985H63.0783L63.9487 81.8689H59.9807ZM62.8479 80.1025V80.1793H61.1071V80.1025H62.8479Z",
                fill: "#7799CC"
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gfYuP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsHouse2", ()=>(0, _iconsHouse2.IconsHouse2));
var _iconsHouse2 = require("./IconsHouse2");

},{"./IconsHouse2":"fLWbS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fLWbS":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsHouse2", ()=>IconsHouse2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsHouse2 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-house2 ${className}`,
        fill: "none",
        height: "128",
        viewBox: "0 0 129 128",
        width: "129",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_99_113)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M126.567 115.123H6.73389C6.63149 115.123 6.55469 114.918 6.55469 114.662C6.55469 114.406 6.63149 114.202 6.73389 114.202H126.593",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M102.759 95.9233H67.4314V96.4609H102.759V95.9233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M102.759 48.9216H67.4314V49.5616H102.759V48.9216Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.814 56.96H99.6875V58.496H100.814V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.814 52.4033H99.6875V53.7089H100.814V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.814 54.5537H99.6875V56.0897H100.814V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.814 59.3665H99.6875V60.6721H100.814V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 104.038H99.6362V105.574H100.763V104.038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 99.4817H99.6362V100.787H100.763V99.4817Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 87.6543H99.6362V89.1903H100.763V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 83.1233H99.6362V84.4289H100.763V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 75.6223H97.5115V78.5151H100.763V75.6223Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 85.248H99.6362V86.784H100.763V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 90.0608H99.6362V91.3664H100.763V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 101.632H99.6362V103.168H100.763V101.632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M100.763 106.445H99.6362V107.75H100.763V106.445Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.8427 59.3665H97.5115V60.6721H98.8427V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.8427 56.96H97.5115V58.496H98.8427V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.8427 54.5537H97.5115V56.0897H98.8427V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.8427 52.4033H97.5115V53.7089H98.8427V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.7914 106.445H97.4602V107.75H98.7914V106.445Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.7914 104.038H97.4602V105.574H98.7914V104.038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.7914 101.632H97.4602V103.168H98.7914V101.632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.7914 99.4817H97.4602V100.787H98.7914V99.4817Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.7914 90.0608H97.4602V91.3664H98.7914V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.7914 87.6543H97.4602V89.1903H98.7914V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.7914 85.248H97.4602V86.784H98.7914V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M98.7914 83.1233H97.4602V84.4289H98.7914V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.641 59.3665H95.2842V60.6721H96.641V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.641 56.96H95.2842V58.496H96.641V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.641 54.5537H95.2842V56.0897H96.641V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.641 52.4033H95.2842V53.7089H96.641V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6156 106.445H95.2332V107.75H96.6156V106.445Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6156 104.038H95.2332V105.574H96.6156V104.038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6156 101.632H95.2332V103.168H96.6156V101.632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6156 99.4817H95.2332V100.787H96.6156V99.4817Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6156 90.0608H95.2332V91.3664H96.6156V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6156 87.6543H95.2332V89.1903H96.6156V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6156 85.248H95.2332V86.784H96.6156V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6156 83.1233H95.2332V84.4289H96.6156V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.4394 59.3665H93.3386V60.6721H94.4394V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.4394 56.96H93.3386V58.496H94.4394V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.4394 54.5537H93.3386V56.0897H94.4394V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.4394 52.4033H93.3386V53.7089H94.4394V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.3884 106.445H93.2876V107.75H94.3884V106.445Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.3884 104.038H93.2876V105.574H94.3884V104.038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.3884 101.632H93.2876V103.168H94.3884V101.632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.3884 99.4817H93.2876V100.787H94.3884V99.4817Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.3884 90.0608H93.2876V91.3664H94.3884V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.3884 87.6543H93.2876V89.1903H94.3884V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.3884 85.248H93.2876V86.784H94.3884V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M94.3884 83.1233H93.2876V84.4289H94.3884V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M96.6412 75.6223H93.2876V78.5151H96.6412V75.6223Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M101.787 61.4912H92.366V61.7216H101.787V61.4912Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M101.735 79.3601H92.3147V79.5905H101.735V79.3601Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M101.735 92.2112H92.3147V92.4416H101.735V92.2112Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M101.735 108.595H92.3147V108.826H101.735V108.595Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M102.759 113.869V97.3057H67.4314V113.869H80.5898V99.0721C80.5898 98.8417 80.769 98.6369 81.025 98.6369H89.1914C89.4218 98.6369 89.6266 98.8161 89.6266 99.0721V113.869H102.759ZM78.6442 109.235C78.6442 109.466 78.465 109.67 78.209 109.67H67.9434C67.713 109.67 67.5082 109.491 67.5082 109.235V108.16C67.5082 107.93 67.6874 107.725 67.9434 107.725H68.481V106.061C68.481 106.035 68.481 106.035 68.481 106.01C68.481 105.984 68.481 105.984 68.481 105.958V101.274C68.481 101.248 68.481 101.248 68.481 101.222C68.481 101.197 68.481 101.197 68.481 101.171V99.0721C68.481 98.8417 68.6602 98.6369 68.9162 98.6369H77.2362C77.4666 98.6369 77.6714 98.8161 77.6714 99.0721V107.725H78.209C78.4394 107.725 78.6442 107.904 78.6442 108.16V109.235ZM91.4698 108.16C91.4698 107.93 91.649 107.725 91.905 107.725H92.4426V106.061C92.4426 106.035 92.4426 106.035 92.4426 106.01C92.4426 105.984 92.4426 105.984 92.4426 105.958V101.274C92.4426 101.248 92.4426 101.248 92.4426 101.222C92.4426 101.197 92.4426 101.197 92.4426 101.171V99.0721C92.4426 98.8417 92.6218 98.6369 92.8778 98.6369H101.198C101.428 98.6369 101.633 98.8161 101.633 99.0721V107.725H102.171C102.401 107.725 102.606 107.904 102.606 108.16V109.235C102.606 109.466 102.427 109.67 102.171 109.67H91.905C91.6746 109.67 91.4698 109.491 91.4698 109.235V108.16Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M102.759 50.4065H67.4314V95.0529H102.759V50.4065ZM78.6442 92.8513C78.6442 93.0817 78.465 93.2865 78.209 93.2865H67.9434C67.713 93.2865 67.5082 93.1073 67.5082 92.8513V91.7761C67.5082 91.5457 67.6874 91.3409 67.9434 91.3409H68.481V89.6769C68.481 89.6513 68.481 89.6513 68.481 89.6257C68.481 89.6001 68.481 89.6001 68.481 89.5745V84.8897C68.481 84.8641 68.481 84.8641 68.481 84.8385C68.481 84.8129 68.481 84.8129 68.481 84.7873V82.6881C68.481 82.4577 68.6602 82.2529 68.9162 82.2529H77.2362C77.4666 82.2529 77.6714 82.4321 77.6714 82.6881V91.3409H78.209C78.4394 91.3409 78.6442 91.5201 78.6442 91.7761V92.8513ZM78.6442 80.0001C78.6442 80.2305 78.465 80.4353 78.209 80.4353H67.9434C67.713 80.4353 67.5082 80.2561 67.5082 80.0001V78.9249C67.5082 78.6945 67.6874 78.4897 67.9434 78.4897H68.481V64.5377C68.481 64.3073 68.6602 64.1025 68.9162 64.1025H77.2362C77.4666 64.1025 77.6714 64.2817 77.6714 64.5377V78.4897H78.209C78.4394 78.4897 78.6442 78.6689 78.6442 78.9249V80.0001ZM78.6954 62.1569C78.6954 62.3873 78.5162 62.5921 78.2602 62.5921H67.9946C67.7642 62.5921 67.5594 62.4129 67.5594 62.1569V61.0817C67.5594 60.8513 67.7386 60.6465 67.9946 60.6465H68.5322V58.9825C68.5322 58.9569 68.5322 58.9569 68.5322 58.9313C68.5322 58.9057 68.5322 58.9057 68.5322 58.8801V54.1953C68.5322 54.1697 68.5322 54.1697 68.5322 54.1441C68.5322 54.1185 68.5322 54.1185 68.5322 54.0929V51.9937C68.5322 51.7633 68.7114 51.5585 68.9674 51.5585H77.2874C77.5178 51.5585 77.7226 51.7377 77.7226 51.9937V60.6465H78.2602C78.4906 60.6465 78.6954 60.8257 78.6954 61.0817V62.1569ZM90.625 92.8513C90.625 93.0817 90.4458 93.2865 90.1898 93.2865H79.9242C79.6938 93.2865 79.489 93.1073 79.489 92.8513V91.7761C79.489 91.5457 79.6682 91.3409 79.9242 91.3409H80.4618V89.6769C80.4618 89.6513 80.4618 89.6513 80.4618 89.6257C80.4618 89.6001 80.4618 89.6001 80.4618 89.5745V84.8897C80.4618 84.8641 80.4618 84.8641 80.4618 84.8385C80.4618 84.8129 80.4618 84.8129 80.4618 84.7873V82.6881C80.4618 82.4577 80.641 82.2529 80.897 82.2529H89.217C89.4474 82.2529 89.6522 82.4321 89.6522 82.6881V91.3409H90.1898C90.4202 91.3409 90.625 91.5201 90.625 91.7761V92.8513ZM90.625 80.0001C90.625 80.2305 90.4458 80.4353 90.1898 80.4353H79.9242C79.6938 80.4353 79.489 80.2561 79.489 80.0001V78.9249C79.489 78.6945 79.6682 78.4897 79.9242 78.4897H80.4618V64.5377C80.4618 64.3073 80.641 64.1025 80.897 64.1025H89.217C89.4474 64.1025 89.6522 64.2817 89.6522 64.5377V78.4897H90.1898C90.4202 78.4897 90.625 78.6689 90.625 78.9249V80.0001ZM90.6762 62.1569C90.6762 62.3873 90.497 62.5921 90.241 62.5921H79.9754C79.745 62.5921 79.5402 62.4129 79.5402 62.1569V61.0817C79.5402 60.8513 79.7194 60.6465 79.9754 60.6465H80.513V58.9569C80.513 58.9313 80.513 58.9313 80.513 58.9057C80.513 58.8801 80.513 58.8801 80.513 58.8545V54.1441C80.513 54.1185 80.513 54.1185 80.513 54.0929C80.513 54.0673 80.513 54.0673 80.513 54.0417V51.9425C80.513 51.7121 80.6922 51.5073 80.9482 51.5073H89.2682C89.4986 51.5073 89.7034 51.6865 89.7034 51.9425V60.5953H90.241C90.4714 60.5953 90.6762 60.7745 90.6762 61.0305V62.1569ZM102.606 92.8513C102.606 93.0817 102.427 93.2865 102.171 93.2865H91.905C91.6746 93.2865 91.4698 93.1073 91.4698 92.8513V91.7761C91.4698 91.5457 91.649 91.3409 91.905 91.3409H92.4426V89.6769C92.4426 89.6513 92.4426 89.6513 92.4426 89.6257C92.4426 89.6001 92.4426 89.6001 92.4426 89.5745V84.8897C92.4426 84.8641 92.4426 84.8641 92.4426 84.8385C92.4426 84.8129 92.4426 84.8129 92.4426 84.7873V82.6881C92.4426 82.4577 92.6218 82.2529 92.8778 82.2529H101.198C101.428 82.2529 101.633 82.4321 101.633 82.6881V91.3409H102.171C102.401 91.3409 102.606 91.5201 102.606 91.7761V92.8513ZM102.606 80.0001C102.606 80.2305 102.427 80.4353 102.171 80.4353H91.905C91.6746 80.4353 91.4698 80.2561 91.4698 80.0001V78.9249C91.4698 78.6945 91.649 78.4897 91.905 78.4897H92.4426V64.5377C92.4426 64.3073 92.6218 64.1025 92.8778 64.1025H101.198C101.428 64.1025 101.633 64.2817 101.633 64.5377V78.4897H102.171C102.401 78.4897 102.606 78.6689 102.606 78.9249V80.0001ZM102.222 62.5921H91.9562C91.7258 62.5921 91.521 62.4129 91.521 62.1569V61.0817C91.521 60.8513 91.7002 60.6465 91.9562 60.6465H92.4938V58.9825C92.4938 58.9569 92.4938 58.9569 92.4938 58.9313C92.4938 58.9057 92.4938 58.9057 92.4938 58.8801V54.1953C92.4938 54.1697 92.4938 54.1697 92.4938 54.1441C92.4938 54.1185 92.4938 54.1185 92.4938 54.0929V51.9937C92.4938 51.7633 92.673 51.5585 92.929 51.5585H101.249C101.479 51.5585 101.684 51.7377 101.684 51.9937V60.6465H102.222C102.452 60.6465 102.657 60.8257 102.657 61.0817V62.1569C102.657 62.3873 102.452 62.5921 102.222 62.5921Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.8332 56.96H87.7068V58.496H88.8332V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.8332 52.4033H87.7068V53.7089H88.8332V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.8332 54.5537H87.7068V56.0897H88.8332V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.8332 59.3665H87.7068V60.6721H88.8332V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.7819 87.6543H87.6555V89.1903H88.7819V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.7819 83.1233H87.6555V84.4289H88.7819V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.782 75.6223H85.5308V78.5151H88.782V75.6223Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.7819 85.248H87.6555V86.784H88.7819V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.7819 90.0608H87.6555V91.3664H88.7819V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M87.6298 100.736H82.5354V113.869H87.6298V100.736ZM87.2458 108.493C87.2458 108.723 87.0666 108.928 86.8106 108.928C86.5802 108.928 86.3754 108.749 86.3754 108.493V106.675C86.3754 106.445 86.5546 106.24 86.8106 106.24C87.041 106.24 87.2458 106.419 87.2458 106.675V108.493Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.862 59.3665H85.5308V60.6721H86.862V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.862 56.96H85.5308V58.496H86.862V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.862 54.5537H85.5308V56.0897H86.862V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.862 52.4033H85.5308V53.7089H86.862V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.8107 90.0608H85.4795V91.3664H86.8107V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.8107 87.6543H85.4795V89.1903H86.8107V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.8107 85.248H85.4795V86.784H86.8107V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.8107 83.1233H85.4795V84.4289H86.8107V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M79.438 34.432H90.7532C90.5228 31.488 88.0652 29.184 85.0956 29.184C82.1004 29.184 79.6428 31.488 79.438 34.432Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M80.385 44.5952H89.7802C89.5754 42.1888 87.5274 40.2944 85.0698 40.2944C82.6122 40.2944 80.5898 42.1888 80.385 44.5952Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6859 59.3665H83.3291V60.6721H84.6859V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6859 56.96H83.3291V58.496H84.6859V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6859 54.5537H83.3291V56.0897H84.6859V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6859 52.4033H83.3291V53.7089H84.6859V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6346 90.0608H83.2778V91.3664H84.6346V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6346 87.6543H83.2778V89.1903H84.6346V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6346 85.248H83.2778V86.784H84.6346V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6346 83.1233H83.2778V84.4289H84.6346V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M82.4843 59.3665H81.3835V60.6721H82.4843V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M82.4843 56.96H81.3835V58.496H82.4843V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M82.4843 54.5537H81.3835V56.0897H82.4843V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M82.4843 52.4033H81.3835V53.7089H82.4843V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M82.4331 90.0608H81.3323V91.3664H82.4331V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M82.4331 87.6543H81.3323V89.1903H82.4331V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M82.4331 85.248H81.3323V86.784H82.4331V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M82.4331 83.1233H81.3323V84.4289H82.4331V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M88.7306 113.869V99.5073H81.4346V113.869H81.6906V100.301C81.6906 100.071 81.8698 99.8657 82.1258 99.8657H88.065C88.2954 99.8657 88.5002 100.045 88.5002 100.301V113.869H88.7306Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M84.6859 75.6223H81.3323V78.5151H84.6859V75.6223Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M89.8314 61.4912H80.4106V61.7216H89.8314V61.4912Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M89.7802 79.3601H80.3594V79.5905H89.7802V79.3601Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M89.7802 92.2112H80.3594V92.4416H89.7802V92.2112Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M90.9324 45.4401H79.2332V45.7473H90.9324V45.4401Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8522 56.96H75.7258V58.496H76.8522V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8522 52.4033H75.7258V53.7089H76.8522V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8522 54.5537H75.7258V56.0897H76.8522V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8522 59.3665H75.7258V60.6721H76.8522V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8012 104.038H75.6748V105.574H76.8012V104.038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8012 99.4817H75.6748V100.787H76.8012V99.4817Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8012 87.6543H75.6748V89.1903H76.8012V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8012 83.1233H75.6748V84.4289H76.8012V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.801 75.6223H73.5498V78.5151H76.801V75.6223Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8012 85.248H75.6748V86.784H76.8012V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8012 90.0608H75.6748V91.3664H76.8012V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8012 101.632H75.6748V103.168H76.8012V101.632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M76.8012 106.445H75.6748V107.75H76.8012V106.445Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.881 59.3665H73.5498V60.6721H74.881V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.881 56.96H73.5498V58.496H74.881V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.881 54.5537H73.5498V56.0897H74.881V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.881 52.4033H73.5498V53.7089H74.881V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.83 106.445H73.4988V107.75H74.83V106.445Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.83 104.038H73.4988V105.574H74.83V104.038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.83 101.632H73.4988V103.168H74.83V101.632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.83 99.4817H73.4988V100.787H74.83V99.4817Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.83 90.0608H73.4988V91.3664H74.83V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.83 87.6543H73.4988V89.1903H74.83V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.83 85.248H73.4988V86.784H74.83V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M74.83 83.1233H73.4988V84.4289H74.83V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.7052 59.3665H71.3484V60.6721H72.7052V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.7052 56.96H71.3484V58.496H72.7052V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.7052 54.5537H71.3484V56.0897H72.7052V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.7052 52.4033H71.3484V53.7089H72.7052V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.6795 106.445H71.2971V107.75H72.6795V106.445Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.6795 104.038H71.2971V105.574H72.6795V104.038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.6795 101.632H71.2971V103.168H72.6795V101.632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.6795 99.4817H71.2971V100.787H72.6795V99.4817Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.6795 90.0608H71.2971V91.3664H72.6795V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.6795 87.6543H71.2971V89.1903H72.6795V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.6795 85.248H71.2971V86.784H72.6795V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.6795 83.1233H71.2971V84.4289H72.6795V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.5034 59.3665H69.4026V60.6721H70.5034V59.3665Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.5034 56.96H69.4026V58.496H70.5034V56.96Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.5034 54.5537H69.4026V56.0897H70.5034V54.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.5034 52.4033H69.4026V53.7089H70.5034V52.4033Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.4524 106.445H69.3516V107.75H70.4524V106.445Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.4524 104.038H69.3516V105.574H70.4524V104.038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.4524 101.632H69.3516V103.168H70.4524V101.632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.4524 99.4817H69.3516V100.787H70.4524V99.4817Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.4524 90.0608H69.3516V91.3664H70.4524V90.0608Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.4524 87.6543H69.3516V89.1903H70.4524V87.6543Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.4524 85.248H69.3516V86.784H70.4524V85.248Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M70.4524 83.1233H69.3516V84.4289H70.4524V83.1233Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M72.7052 75.6223H69.3516V78.5151H72.7052V75.6223Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M77.8507 61.4912H68.4299V61.7216H77.8507V61.4912Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M77.7995 79.3601H68.3787V79.5905H77.7995V79.3601Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M77.7995 92.2112H68.3787V92.4416H77.7995V92.2112Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M77.7995 108.595H68.3787V108.826H77.7995V108.595Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M78.2091 91.3409H77.6715V82.6881C77.6715 82.4577 77.4923 82.2529 77.2363 82.2529H68.9163C68.6859 82.2529 68.4811 82.4321 68.4811 82.6881V84.7873C68.4811 84.8129 68.4811 84.8129 68.4811 84.8385C68.4811 84.8641 68.4811 84.8641 68.4811 84.8897V89.5745C68.4811 89.6001 68.4811 89.6001 68.4811 89.6257C68.4811 89.6513 68.4811 89.6513 68.4811 89.6769V91.3409H67.9435C67.7131 91.3409 67.5083 91.5201 67.5083 91.7761V92.8513C67.5083 93.0817 67.6875 93.2865 67.9435 93.2865H78.2091C78.4395 93.2865 78.6443 93.1073 78.6443 92.8513V91.7761C78.6443 91.5457 78.4651 91.3409 78.2091 91.3409ZM77.7995 92.4417H68.3787V92.2113H77.7995V92.4417ZM73.4987 89.1905V87.6545H74.8299V89.1905H73.4987ZM75.6747 87.6545H76.8011V89.1905H75.6747V87.6545ZM75.6747 85.2481H76.8011V86.7841H75.6747V85.2481ZM74.8299 86.8097H73.4987V85.2737H74.8299V86.8097ZM72.6539 86.8097H71.2715V85.2737H72.6539V86.8097ZM70.4267 86.8097H69.3259V85.2737H70.4267V86.8097ZM71.2971 87.6545H72.6795V89.1905H71.2971V87.6545ZM72.6539 90.0609V91.3665H71.2715V90.0609H72.6539ZM73.4987 90.0609H74.8299V91.3665H73.4987V90.0609ZM69.3515 87.6545H70.4523V89.1905H69.3515V87.6545ZM75.6747 91.3409V90.0353H76.8011V91.3409H75.6747ZM76.8267 84.4033H75.6747V83.0977H76.8011V84.4033H76.8267ZM74.8299 84.4033H73.4987V83.0977H74.8299V84.4033ZM72.6539 84.4033H71.2715V83.0977H72.6539V84.4033ZM70.4267 84.4033H69.3259V83.0977H70.4267V84.4033ZM69.3515 90.0609H70.4523V91.3665H69.3515V90.0609Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M78.2091 107.725H77.6715V99.0719C77.6715 98.8415 77.4923 98.6367 77.2363 98.6367H68.9163C68.6859 98.6367 68.4811 98.8159 68.4811 99.0719V101.171C68.4811 101.197 68.4811 101.197 68.4811 101.222C68.4811 101.248 68.4811 101.248 68.4811 101.274V105.958C68.4811 105.984 68.4811 105.984 68.4811 106.01C68.4811 106.035 68.4811 106.035 68.4811 106.061V107.725H67.9435C67.7131 107.725 67.5083 107.904 67.5083 108.16V109.235C67.5083 109.466 67.6875 109.67 67.9435 109.67H78.2091C78.4395 109.67 78.6443 109.491 78.6443 109.235V108.16C78.6443 107.93 78.4651 107.725 78.2091 107.725ZM77.7995 108.826H68.3787V108.595H77.7995V108.826ZM76.8267 100.787H75.6747V99.4815H76.8011V100.787H76.8267ZM73.4987 107.725V106.419H74.8299V107.725H73.4987ZM71.2971 107.725V106.419H72.6795V107.725H71.2971ZM74.8299 103.194H73.4987V101.658H74.8299V103.194ZM73.4987 105.6V104.064H74.8299V105.6H73.4987ZM75.6747 104.038H76.8011V105.574H75.6747V104.038ZM75.6747 101.632H76.8011V103.168H75.6747V101.632ZM72.6539 101.632V103.168H71.2715V101.632H72.6539ZM70.4267 103.194H69.3259V101.658H70.4267V103.194ZM71.2971 104.038H72.6795V105.574H71.2971V104.038ZM74.8299 100.787H73.4987V99.4815H74.8299V100.787ZM72.6539 100.787H71.2715V99.4815H72.6539V100.787ZM69.3515 104.038H70.4523V105.574H69.3515V104.038ZM75.6747 107.725V106.419H76.8011V107.725H75.6747ZM70.4267 99.4815V100.787H69.3259V99.4815H70.4267ZM69.3515 106.445H70.4523V107.75H69.3515V106.445Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M78.2604 60.6463H77.7228V51.9936C77.7228 51.7632 77.5436 51.5583 77.2876 51.5583H68.9676C68.7372 51.5583 68.5324 51.7376 68.5324 51.9936V54.0928C68.5324 54.1184 68.5324 54.1184 68.5324 54.144C68.5324 54.1696 68.5324 54.1696 68.5324 54.1952V58.88C68.5324 58.9056 68.5324 58.9056 68.5324 58.9312C68.5324 58.9568 68.5324 58.9567 68.5324 58.9823V60.6463H67.9948C67.7644 60.6463 67.5596 60.8256 67.5596 61.0816V62.1568C67.5596 62.3872 67.7388 62.592 67.9948 62.592H78.2604C78.4908 62.592 78.6956 62.4128 78.6956 62.1568V61.0816C78.6956 60.8512 78.5164 60.6463 78.2604 60.6463ZM77.8508 61.7216H68.43V61.4912H77.8508V61.7216ZM72.7052 52.4032V53.7088H71.3484V52.4032H72.7052ZM74.8812 52.4032V53.7088H73.55V52.4032H74.8812ZM76.878 52.4032V53.7088H75.7516V52.4032H76.878ZM74.8812 56.1152H73.55V54.5792H74.8812V56.1152ZM73.55 58.496V56.96H74.8812V58.496H73.55ZM75.726 56.96H76.8524V58.496H75.726V56.96ZM75.726 54.5536H76.8524V56.0896H75.726V54.5536ZM72.7052 54.5536V56.0896H71.3484V54.5536H72.7052ZM70.478 56.1152H69.3772V54.5792H70.478V56.1152ZM71.3484 56.96H72.7052V58.496H71.3484V56.96ZM72.7052 59.3664V60.672H71.3484V59.3664H72.7052ZM73.55 59.3664H74.8812V60.672H73.55V59.3664ZM69.4028 56.96H70.5036V58.496H69.4028V56.96ZM75.726 60.6463V59.3408H76.8524V60.6463H75.726ZM70.478 52.4032V53.7088H69.3772V52.4032H70.478ZM69.4028 59.3664H70.5036V60.672H69.4028V59.3664Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M78.2091 78.4895H77.6715V64.5375C77.6715 64.3071 77.4923 64.1023 77.2363 64.1023H68.9163C68.6859 64.1023 68.4811 64.2815 68.4811 64.5375V78.4895H67.9435C67.7131 78.4895 67.5083 78.6687 67.5083 78.9247V79.9999C67.5083 80.2303 67.6875 80.4351 67.9435 80.4351H78.2091C78.4395 80.4351 78.6443 80.2559 78.6443 79.9999V78.9247C78.6443 78.6943 78.4651 78.4895 78.2091 78.4895ZM77.7995 79.5903H68.3787V79.3599H77.7995V79.5903ZM76.8267 74.7775H69.3515V64.9727H76.8267V74.7775ZM73.5499 78.4895V75.5967H76.8011V78.4895H73.5499ZM69.3515 75.6223H72.7051V78.5151H69.3515V75.6223Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M90.1898 91.3409H89.6522V82.6881C89.6522 82.4577 89.473 82.2529 89.217 82.2529H80.897C80.6666 82.2529 80.4618 82.4321 80.4618 82.6881V84.7873C80.4618 84.8129 80.4618 84.8129 80.4618 84.8385C80.4618 84.8641 80.4618 84.8641 80.4618 84.8897V89.5745C80.4618 89.6001 80.4618 89.6001 80.4618 89.6257C80.4618 89.6513 80.4618 89.6513 80.4618 89.6769V91.3409H79.9242C79.6938 91.3409 79.489 91.5201 79.489 91.7761V92.8513C79.489 93.0817 79.6682 93.2865 79.9242 93.2865H90.1898C90.4202 93.2865 90.625 93.1073 90.625 92.8513V91.7761C90.625 91.5457 90.4202 91.3409 90.1898 91.3409ZM89.7802 92.4417H80.3594V92.2113H89.7802V92.4417ZM85.4794 89.1905V87.6545H86.8106V89.1905H85.4794ZM87.6554 87.6545H88.7818V89.1905H87.6554V87.6545ZM87.6554 85.2481H88.7818V86.7841H87.6554V85.2481ZM86.8106 86.8097H85.4794V85.2737H86.8106V86.8097ZM84.6346 86.8097H83.2778V85.2737H84.6346V86.8097ZM82.4074 86.8097H81.3066V85.2737H82.4074V86.8097ZM83.2778 87.6545H84.6346V89.1905H83.2778V87.6545ZM84.6346 90.0609V91.3665H83.2778V90.0609H84.6346ZM85.4794 90.0609H86.8106V91.3665H85.4794V90.0609ZM81.3322 87.6545H82.433V89.1905H81.3322V87.6545ZM87.6554 91.3409V90.0353H88.7818V91.3409H87.6554ZM88.8074 84.4033H87.681V83.0977H88.8074V84.4033ZM86.8106 84.4033H85.4794V83.0977H86.8106V84.4033ZM84.6346 84.4033H83.2778V83.0977H84.6346V84.4033ZM82.4074 84.4033H81.3066V83.0977H82.4074V84.4033ZM81.3322 90.0609H82.433V91.3665H81.3322V90.0609Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M90.2411 60.6463H89.7035V51.9936C89.7035 51.7632 89.5243 51.5583 89.2683 51.5583H80.9483C80.7179 51.5583 80.5131 51.7376 80.5131 51.9936V54.0928C80.5131 54.1184 80.5131 54.1184 80.5131 54.144C80.5131 54.1696 80.5131 54.1696 80.5131 54.1952V58.88C80.5131 58.9056 80.5131 58.9056 80.5131 58.9312C80.5131 58.9568 80.5131 58.9567 80.5131 58.9823V60.672H79.9755C79.7451 60.672 79.5403 60.8512 79.5403 61.1072V62.1824C79.5403 62.4128 79.7195 62.6176 79.9755 62.6176H90.2411C90.4715 62.6176 90.6763 62.4383 90.6763 62.1824V61.1072C90.6763 60.8512 90.4715 60.6463 90.2411 60.6463ZM89.8315 61.7216H80.4107V61.4912H89.8315V61.7216ZM84.6859 52.4032V53.7088H83.3291V52.4032H84.6859ZM86.8619 52.4032V53.7088H85.5307V52.4032H86.8619ZM88.8331 52.4032V53.7088H87.7067V52.4032H88.8331ZM88.8331 56.1152H87.7067V54.5792H88.8331V56.1152ZM88.8331 58.496H87.7067V56.96H88.8331V58.496ZM86.8619 56.1152H85.5307V54.5792H86.8619V56.1152ZM85.5307 58.496V56.96H86.8619V58.496H85.5307ZM84.6859 54.5536V56.0896H83.3291V54.5536H84.6859ZM82.4587 56.1152H81.3579V54.5792H82.4587V56.1152ZM82.4587 56.96V58.496H81.3579V56.96H82.4587ZM83.3291 56.96H84.6859V58.496H83.3291V56.96ZM84.6859 59.3664V60.672H83.3291V59.3664H84.6859ZM85.5307 59.3664H86.8619V60.672H85.5307V59.3664ZM87.7067 60.6463V59.3408H88.8331V60.6463H87.7067ZM82.4587 52.4032V53.7088H81.3579V52.4032H82.4587ZM82.4587 59.3664V60.672H81.3579V59.3664H82.4587Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M90.1898 78.4895H89.6522V64.5375C89.6522 64.3071 89.473 64.1023 89.217 64.1023H80.897C80.6666 64.1023 80.4618 64.2815 80.4618 64.5375V78.4895H79.9242C79.6938 78.4895 79.489 78.6687 79.489 78.9247V79.9999C79.489 80.2303 79.6682 80.4351 79.9242 80.4351H90.1898C90.4202 80.4351 90.625 80.2559 90.625 79.9999V78.9247C90.625 78.6943 90.4202 78.4895 90.1898 78.4895ZM89.7802 79.5903H80.3594V79.3599H89.7802V79.5903ZM88.8074 74.7775H81.3322V64.9727H88.8074V74.7775ZM85.5306 78.4895V75.5967H88.7818V78.4895H85.5306ZM81.3322 75.6223H84.6858V78.5151H81.3322V75.6223Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M102.171 91.3409H101.633V82.6881C101.633 82.4577 101.454 82.2529 101.198 82.2529H92.878C92.6476 82.2529 92.4428 82.4321 92.4428 82.6881V84.7873C92.4428 84.8129 92.4428 84.8129 92.4428 84.8385C92.4428 84.8641 92.4428 84.8641 92.4428 84.8897V89.5745C92.4428 89.6001 92.4428 89.6001 92.4428 89.6257C92.4428 89.6513 92.4428 89.6513 92.4428 89.6769V91.3409H91.9052C91.6748 91.3409 91.47 91.5201 91.47 91.7761V92.8513C91.47 93.0817 91.6492 93.2865 91.9052 93.2865H102.171C102.401 93.2865 102.606 93.1073 102.606 92.8513V91.7761C102.606 91.5457 102.401 91.3409 102.171 91.3409ZM101.736 92.4417H92.3148V92.2113H101.736V92.4417ZM100.763 86.8097H99.6364V85.2737H100.763V86.8097ZM100.763 89.1905H99.6364V87.6545H100.763V89.1905ZM97.4604 89.1905V87.6545H98.7916V89.1905H97.4604ZM98.7916 86.8097H97.4604V85.2737H98.7916V86.8097ZM96.6156 86.8097H95.2332V85.2737H96.6156V86.8097ZM94.3884 86.8097H93.2876V85.2737H94.3884V86.8097ZM94.3884 87.6545V89.1905H93.2876V87.6545H94.3884ZM95.2332 87.6545H96.6156V89.1905H95.2332V87.6545ZM96.6156 90.0609V91.3665H95.2332V90.0609H96.6156ZM97.4604 90.0609H98.7916V91.3665H97.4604V90.0609ZM99.6364 91.3409V90.0353H100.763V91.3409H99.6364ZM100.763 84.4033H99.6364V83.0977H100.763V84.4033ZM98.7916 84.4033H97.4604V83.0977H98.7916V84.4033ZM96.6156 84.4033H95.2332V83.0977H96.6156V84.4033ZM94.3884 84.4033H93.2876V83.0977H94.3884V84.4033ZM94.3884 90.0609V91.3665H93.2876V90.0609H94.3884Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M91.9052 109.67H102.171C102.401 109.67 102.606 109.491 102.606 109.235V108.16C102.606 107.93 102.427 107.725 102.171 107.725H101.633V99.0719C101.633 98.8415 101.454 98.6367 101.198 98.6367H92.878C92.6476 98.6367 92.4428 98.8159 92.4428 99.0719V101.171C92.4428 101.197 92.4428 101.197 92.4428 101.222C92.4428 101.248 92.4428 101.248 92.4428 101.274V105.958C92.4428 105.984 92.4428 105.984 92.4428 106.01C92.4428 106.035 92.4428 106.035 92.4428 106.061V107.725H91.9052C91.6748 107.725 91.47 107.904 91.47 108.16V109.235C91.47 109.466 91.6748 109.67 91.9052 109.67ZM97.4604 107.725V106.419H98.7916V107.725H97.4604ZM95.2332 107.725V106.419H96.6156V107.725H95.2332ZM100.763 103.194H99.6364V101.658H100.763V103.194ZM100.763 105.6H99.6364V104.064H100.763V105.6ZM98.7916 103.194H97.4604V101.658H98.7916V103.194ZM97.4604 105.6V104.064H98.7916V105.6H97.4604ZM96.6156 101.632V103.168H95.2332V101.632H96.6156ZM94.3884 103.194H93.2876V101.658H94.3884V103.194ZM94.3884 104.038V105.574H93.2876V104.038H94.3884ZM95.2332 104.038H96.6156V105.574H95.2332V104.038ZM100.763 100.787H99.6364V99.4815H100.763V100.787ZM98.7916 100.787H97.4604V99.4815H98.7916V100.787ZM96.6156 100.787H95.2332V99.4815H96.6156V100.787ZM99.6364 107.725V106.419H100.763V107.725H99.6364ZM94.3884 99.4815V100.787H93.2876V99.4815H94.3884ZM94.3884 106.445V107.75H93.2876V106.445H94.3884ZM92.3148 108.595H101.736V108.826H92.3148V108.595Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M102.222 60.6463H101.684V51.9936C101.684 51.7632 101.505 51.5583 101.249 51.5583H92.929C92.6986 51.5583 92.4938 51.7376 92.4938 51.9936V54.0928C92.4938 54.1184 92.4938 54.1184 92.4938 54.144C92.4938 54.1696 92.4938 54.1696 92.4938 54.1952V58.88C92.4938 58.9056 92.4938 58.9056 92.4938 58.9312C92.4938 58.9568 92.4938 58.9567 92.4938 58.9823V60.6463H91.9562C91.7258 60.6463 91.521 60.8256 91.521 61.0816V62.1568C91.521 62.3872 91.7002 62.592 91.9562 62.592H102.222C102.452 62.592 102.657 62.4128 102.657 62.1568V61.0816C102.657 60.8512 102.452 60.6463 102.222 60.6463ZM101.787 61.7216H92.3658V61.4912H101.787V61.7216ZM96.6666 52.4032V53.7088H95.3098V52.4032H96.6666ZM98.8426 52.4032V53.7088H97.5114V52.4032H98.8426ZM100.814 52.4032V53.7088H99.6874V52.4032H100.814ZM100.814 56.1152H99.6874V54.5792H100.814V56.1152ZM100.814 58.496H99.6874V56.96H100.814V58.496ZM98.8426 56.1152H97.5114V54.5792H98.8426V56.1152ZM97.5114 58.496V56.96H98.8426V58.496H97.5114ZM96.6666 54.5536V56.0896H95.3098V54.5536H96.6666ZM95.2842 56.96H96.641V58.496H95.2842V56.96ZM96.6666 59.3664V60.672H95.3098V59.3664H96.6666ZM97.5114 59.3664H98.8426V60.672H97.5114V59.3664ZM94.4394 54.5536V56.0896H93.3386V54.5536H94.4394ZM94.4394 56.96V58.496H93.3386V56.96H94.4394ZM99.6874 60.6463V59.3408H100.814V60.6463H99.6874ZM94.4394 52.4032V53.7088H93.3386V52.4032H94.4394ZM93.3386 59.3664H94.4394V60.672H93.3386V59.3664Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M102.171 78.4895H101.633V64.5375C101.633 64.3071 101.454 64.1023 101.198 64.1023H92.878C92.6476 64.1023 92.4428 64.2815 92.4428 64.5375V78.4895H91.9052C91.6748 78.4895 91.47 78.6687 91.47 78.9247V79.9999C91.47 80.2303 91.6492 80.4351 91.9052 80.4351H102.171C102.401 80.4351 102.606 80.2559 102.606 79.9999V78.9247C102.606 78.6943 102.401 78.4895 102.171 78.4895ZM101.736 79.5903H92.3148V79.3599H101.736V79.5903ZM97.5116 78.4895V75.5967H100.763V78.4895H97.5116ZM100.763 74.7775H93.2876V64.9727H100.763V74.7775ZM93.2876 75.6223H96.6668V78.5151H93.3132V75.6223H93.2876Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M91.3674 44.5952H90.6506C90.4202 41.728 88.0394 39.4496 85.0954 39.4496C82.1514 39.4496 79.7706 41.728 79.5402 44.5952H78.8234C78.593 44.5952 78.3882 44.7744 78.3882 45.0304V46.208C78.3882 46.4384 78.5674 46.6432 78.8234 46.6432H91.393C91.6234 46.6432 91.8282 46.464 91.8282 46.208V45.0304C91.777 44.7744 91.5978 44.5952 91.3674 44.5952ZM90.9322 45.7472H79.233V45.44H90.9322V45.7472ZM89.7802 44.5952H80.385C80.5898 42.1888 82.6378 40.2944 85.0954 40.2944C87.553 40.2944 89.5754 42.1888 89.7802 44.5952Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M86.8363 106.266C86.6059 106.266 86.4011 106.445 86.4011 106.701V108.518C86.4011 108.749 86.5803 108.954 86.8363 108.954C87.0667 108.954 87.2715 108.774 87.2715 108.518V106.701C87.2459 106.445 87.0667 106.266 86.8363 106.266Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M103.169 48.0768C96.7946 48.0768 91.6234 42.9056 91.6234 36.5312V35.3024H93.9786C94.209 35.3024 94.4138 35.1232 94.4138 34.8672C94.4138 34.6368 94.2346 34.432 93.9786 34.432H91.5978C91.3674 31.0272 88.5514 28.3392 85.0954 28.3392C81.6394 28.3392 78.7978 31.0528 78.593 34.432H76.1866C75.9562 34.432 75.7514 34.6112 75.7514 34.8672C75.7514 35.0976 75.9306 35.3024 76.1866 35.3024H78.5418V36.5312C78.5418 42.9056 73.3706 48.0768 66.9962 48.0768C66.7658 48.0768 66.561 48.256 66.561 48.512V95.488V96.8704V114.278C66.561 114.509 66.7402 114.714 66.9962 114.714H80.9994H82.1002H88.0394H89.1402H103.143C103.374 114.714 103.579 114.534 103.579 114.278V96.8704V95.488V48.4864C103.604 48.256 103.399 48.0768 103.169 48.0768ZM82.5354 100.736H87.6298V113.869H82.5354V100.736ZM88.065 99.8656H82.1258C81.8954 99.8656 81.6906 100.045 81.6906 100.301V113.869H81.4346V99.5072H88.7306V113.869H88.4746V100.301C88.4746 100.07 88.2954 99.8656 88.065 99.8656ZM89.1658 98.6368H80.9994C80.769 98.6368 80.5642 98.816 80.5642 99.072V113.869H67.4058V97.3056H102.734V113.869H89.5754V99.072C89.601 98.8416 89.3962 98.6368 89.1658 98.6368ZM67.4314 50.4064H102.759V95.0528H67.4314V50.4064ZM67.4314 95.9232H102.759V96.4608H67.4314V95.9232ZM102.759 48.9216V49.5616H67.4314V48.9216H102.759ZM90.753 34.432H79.4378C79.6682 31.488 82.1002 29.184 85.0954 29.184C88.065 29.184 90.5226 31.488 90.753 34.432ZM79.3866 36.5056V35.2768H90.7786V36.5056C90.7786 41.7536 94.0554 46.2592 98.6634 48.0512H71.5018C76.1098 46.2592 79.3866 41.7536 79.3866 36.5056Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M62.3115 84.6848H18.1003V85.9904H62.3115V84.6848Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M58.3691 32.2816V35.4048V38.528V51.84H62.3115V28.0576C62.3115 26.9568 61.4155 26.0864 60.3403 26.0864C59.2651 26.0864 58.3691 26.9824 58.3691 28.0576V32.2816Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M59.5467 95.488H50.1003V110.054H59.5467V95.488Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M59.4955 63.7439H50.0491V78.3103H59.4955V63.7439Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M60.3402 25.2416C58.7786 25.2416 57.5242 26.5216 57.5242 28.0576V29.7472H43.6234L42.1642 27.6992V24.2432C42.1642 24.1408 42.1386 24.064 42.0874 23.9872L40.2954 21.6064C40.1418 21.4016 39.7834 21.4016 39.6042 21.6064L37.8122 23.9872C37.761 24.064 37.7354 24.1408 37.7354 24.2432V27.6736L36.2506 29.7472H22.8874V28.0576C22.8874 26.496 21.633 25.2416 20.0714 25.2416C18.5098 25.2416 17.2554 26.5216 17.2554 28.0576V52.2496V84.1728C17.2554 84.1728 17.2554 84.1984 17.2554 84.224V86.4C17.2554 86.4 17.2554 86.4256 17.2554 86.4512V114.278C17.2554 114.509 17.4346 114.714 17.6906 114.714H62.7722C63.0026 114.714 63.2074 114.534 63.2074 114.278V86.4256V84.2496V52.2752V28.0832C63.1562 26.5216 61.9018 25.2416 60.3402 25.2416ZM18.1002 28.0832C18.1002 26.9824 18.9962 26.112 20.0714 26.112C21.1722 26.112 22.0426 27.008 22.0426 28.0832V30.208V32.3072V35.4304V38.5536V51.8656H18.1002V28.0832ZM38.5546 24.3968L39.9114 22.5792L41.2682 24.3968V27.4176H38.5546V24.3968ZM57.5242 30.6176V31.872H54.6314C54.401 31.872 54.1962 32.0512 54.1962 32.3072C54.1962 32.5376 54.3754 32.7424 54.6314 32.7424H57.5242V35.0208H54.6314C54.401 35.0208 54.1962 35.2 54.1962 35.456C54.1962 35.6864 54.3754 35.8912 54.6314 35.8912H57.5242V38.1696H54.6314C54.401 38.1696 54.1962 38.3488 54.1962 38.6048C54.1962 38.8352 54.3754 39.04 54.6314 39.04H57.5242V51.9168H53.0442V43.136C53.0442 43.0592 53.0186 42.9568 52.9674 42.88L49.3066 37.76H51.8922C52.1226 37.76 52.3274 37.5808 52.3274 37.3248C52.3274 37.0944 52.1482 36.8896 51.8922 36.8896H48.6922L46.4394 33.7408H49.1018C49.3322 33.7408 49.537 33.5616 49.537 33.3056C49.537 33.0752 49.3578 32.8704 49.1018 32.8704H45.825L44.2122 30.6432H57.5242V30.6176ZM60.3402 26.112C61.441 26.112 62.3114 27.008 62.3114 28.0832V51.8656H58.369V38.5536V35.4304V32.3072V28.0832C58.369 26.9824 59.2394 26.112 60.3402 26.112ZM18.1002 85.9903V84.6592H62.3114V85.9903H18.1002ZM62.3114 80.3072V83.8144H18.1002V80.3072V52.7104H22.4778H27.2394H52.609H57.9338H62.3114V80.3072ZM38.3498 28.2624H41.4986L43.0346 30.4384L48.1546 37.5808L52.1994 43.2384V51.8656H27.6746V43.2384L31.6938 37.632C31.7706 37.5808 31.8218 37.504 31.8474 37.4272L38.3498 28.2624ZM34.0234 32.8448C33.9978 32.8448 33.9978 32.8448 33.9722 32.8448H30.6698C30.4394 32.8448 30.2346 33.024 30.2346 33.28C30.2346 33.5104 30.4138 33.7152 30.6698 33.7152H33.409L31.1562 36.864H28.1098C27.8794 36.864 27.6746 37.0432 27.6746 37.2992C27.6746 37.5296 27.8538 37.7344 28.1098 37.7344H30.5418L26.881 42.8544C26.8298 42.9312 26.8042 43.008 26.8042 43.1104V51.8912H22.8874V39.0144H25.7546C25.985 39.0144 26.1898 38.8352 26.1898 38.5792C26.1898 38.3488 26.0106 38.144 25.7546 38.144H22.8874V35.84H25.7546C25.985 35.84 26.1898 35.6608 26.1898 35.4048C26.1898 35.1744 26.0106 34.9696 25.7546 34.9696H22.8874V32.6912H25.7546C25.985 32.6912 26.1898 32.512 26.1898 32.256C26.1898 32.0256 26.0106 31.8208 25.7546 31.8208H22.8874V30.5664H35.6106L34.0234 32.8448ZM62.3114 112.051V113.869H18.1002V112.051V86.8352H26.2922H40.961H55.5274H62.3114V112.051Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M31.6684 37.6064L27.6492 43.2128V51.84H52.174V43.2128L48.1292 37.5552L43.0092 30.4128L41.4732 28.2368H38.3244L31.7708 37.376C31.7964 37.504 31.7452 37.5552 31.6684 37.6064ZM35.9436 38.5792C35.9436 36.3776 37.7356 34.5856 39.9372 34.5856C42.1388 34.5856 43.9308 36.3776 43.9308 38.5792V48.2304C43.9308 48.4608 43.7516 48.6656 43.4956 48.6656H36.3788C36.1484 48.6656 35.9436 48.4864 35.9436 48.2304V38.5792Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M54.1195 87.7825C51.4315 87.7825 49.2555 89.9585 49.2555 92.6465V95.0529V110.054H48.3339C48.1035 110.054 47.8987 110.234 47.8987 110.49V112.051C47.8987 112.282 48.0779 112.486 48.3339 112.486H61.3387C61.5691 112.486 61.7739 112.307 61.7739 112.051V110.49C61.7739 110.259 61.5947 110.054 61.3387 110.054H60.4171V95.0529V92.6465C60.4171 89.9585 58.2411 87.7825 55.5531 87.7825H54.1195ZM60.9291 111.642H48.7691V110.925H49.6907H60.0075H60.9291V111.642ZM59.5723 110.054H50.1259V95.4881H59.5723V110.054ZM59.5723 94.6433H50.1259V92.6721C50.1259 90.4449 51.9179 88.6529 54.1451 88.6529H55.5531C57.7803 88.6529 59.5723 90.4449 59.5723 92.6721V94.6433Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M49.6906 110.899H48.7434V111.642H60.929V110.899H59.9818H49.6906Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M54.0682 56.0383C51.3802 56.0383 49.2042 58.2143 49.2042 60.9023V63.3087V78.3103H48.2826C48.0522 78.3103 47.8474 78.4895 47.8474 78.7455V80.3071C47.8474 80.5375 48.0266 80.7423 48.2826 80.7423H61.2874C61.5178 80.7423 61.7226 80.5631 61.7226 80.3071V78.7455C61.7226 78.5151 61.5434 78.3103 61.2874 78.3103H60.3658V63.3087V60.9023C60.3658 58.2143 58.1898 56.0383 55.5018 56.0383H54.0682ZM60.8522 79.8975H48.6922V79.1807H49.6138H59.905H60.8266V79.8975H60.8522ZM59.4954 78.3103H50.049V63.7439H59.4954V78.3103ZM59.4954 62.8991H50.049V60.9279C50.049 58.7263 51.841 56.9087 54.0682 56.9087H55.4762C57.6778 56.9087 59.4954 58.7007 59.4954 60.9279V62.8991Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M49.6396 79.1809H48.6924V79.8977H60.8524V79.1809H59.9308H49.6396Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M40.9611 86.8608H26.2923H18.1003V112.077V113.894H62.3115V112.077V86.8608H55.5275H40.9611ZM32.0779 112.486H19.0731C18.8427 112.486 18.6379 112.307 18.6379 112.051V110.49C18.6379 110.259 18.8171 110.054 19.0731 110.054H19.9947V95.0528V92.6464C19.9947 89.9584 22.1707 87.7824 24.8587 87.7824H26.2667C28.9547 87.7824 31.1307 89.9584 31.1307 92.6464V95.0528V110.054H32.0523C32.2827 110.054 32.4875 110.234 32.4875 110.49V112.051C32.5131 112.282 32.3083 112.486 32.0779 112.486ZM46.7723 112.486H33.7675C33.5371 112.486 33.3323 112.307 33.3323 112.051V110.49C33.3323 110.259 33.5115 110.054 33.7675 110.054H34.6891V95.0528V92.6464C34.6891 89.9584 36.8651 87.7824 39.5531 87.7824H40.9611C43.6491 87.7824 45.8251 89.9584 45.8251 92.6464V95.0528V110.054H46.7467C46.9771 110.054 47.1819 110.234 47.1819 110.49V112.051C47.1819 112.282 47.0027 112.486 46.7723 112.486ZM60.4171 92.6464V95.0528V110.054H61.3387C61.5691 110.054 61.7739 110.234 61.7739 110.49V112.051C61.7739 112.282 61.5947 112.486 61.3387 112.486H48.3083C48.0779 112.486 47.8731 112.307 47.8731 112.051V110.49C47.8731 110.259 48.0523 110.054 48.3083 110.054H49.2299V95.0528V92.6464C49.2299 89.9584 51.4059 87.7824 54.0939 87.7824H55.5019C58.2155 87.7824 60.4171 89.9584 60.4171 92.6464Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M44.9803 95.488H35.5339V110.054H44.9803V95.488Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M44.9291 63.7439H35.4827V78.3103H44.9291V63.7439Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M43.0603 38.9888H36.7883V47.7952H43.0603V38.9888Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M43.0348 38.144C42.83 36.608 41.5244 35.4304 39.9372 35.4304C38.35 35.4304 37.0444 36.608 36.8396 38.144H43.0348Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M41.2939 24.3969L39.9371 22.6049L38.5547 24.3969V27.4177H41.2939V24.3969Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M36.3788 48.6401H43.4956C43.726 48.6401 43.9308 48.4609 43.9308 48.2049V38.5537C43.9308 36.3521 42.1388 34.5601 39.9372 34.5601C37.7356 34.5601 35.9436 36.3521 35.9436 38.5537V48.2049C35.9436 48.4609 36.1228 48.6401 36.3788 48.6401ZM39.9372 35.4305C41.5244 35.4305 42.83 36.6081 43.0348 38.1441H36.8396C37.0444 36.6081 38.35 35.4305 39.9372 35.4305ZM43.0604 47.7953H36.7884V38.9889H43.0604V47.7953Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M35.0986 110.899H34.177V111.642H46.337V110.899H45.4154H35.0986Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M35.0476 79.1809H34.126V79.8977H46.286V79.1809H45.3644H35.0476Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M46.7723 110.054H45.8507V95.0529V92.6465C45.8507 89.9585 43.6747 87.7825 40.9867 87.7825H39.5787C36.8907 87.7825 34.7147 89.9585 34.7147 92.6465V95.0529V110.054H33.7931C33.5627 110.054 33.3579 110.234 33.3579 110.49V112.051C33.3579 112.282 33.5371 112.486 33.7931 112.486H46.7979C47.0283 112.486 47.2331 112.307 47.2331 112.051V110.49C47.1819 110.259 47.0027 110.054 46.7723 110.054ZM46.3371 111.642H34.1771V110.925H35.0987H45.3899H46.3115V111.642H46.3371ZM35.5339 92.6465C35.5339 90.4193 37.3259 88.6273 39.5531 88.6273H40.9611C43.1883 88.6273 44.9803 90.4193 44.9803 92.6465V94.6177H35.5339V92.6465ZM35.5339 95.4881H44.9803V110.054H35.5339V95.4881Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M46.721 78.3103H45.7994V63.3087V60.9023C45.7994 58.2143 43.6234 56.0383 40.9354 56.0383H39.5274C36.8394 56.0383 34.6634 58.2143 34.6634 60.9023V63.3087V78.3103H33.6906C33.4602 78.3103 33.2554 78.4895 33.2554 78.7455V80.3071C33.2554 80.5375 33.4346 80.7423 33.6906 80.7423H46.721C46.9514 80.7423 47.1562 80.5631 47.1562 80.3071V78.7455C47.1306 78.5151 46.9514 78.3103 46.721 78.3103ZM46.2858 79.8975H34.1258V79.1807H35.0474H45.3642H46.2858V79.8975ZM35.4826 60.9023C35.4826 58.7007 37.2746 56.8831 39.5018 56.8831H40.9098C43.137 56.8831 44.929 58.6751 44.929 60.9023V62.8735H35.4826V60.9023ZM35.4826 63.7439H44.929V78.3103H35.4826V63.7439Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M30.286 95.488H20.8396V110.054H30.286V95.488Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M30.2347 63.7439H20.7883V78.3103H30.2347V63.7439Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M22.0427 38.5537V35.4305V32.3073V30.2081V28.0833C22.0427 26.9825 21.1467 26.1121 20.0715 26.1121C18.9963 26.1121 18.1003 27.0081 18.1003 28.0833V51.8657H22.0427V38.5537Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M20.4299 110.899H19.4827V111.642H31.6683V110.899H30.7211H20.4299Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M20.3786 79.1809H19.4314V79.8977H31.617V79.1809H30.6698H20.3786Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M32.078 110.054H31.1564V95.0529V92.6465C31.1564 89.9585 28.9804 87.7825 26.2924 87.7825H24.8844C22.1964 87.7825 20.0204 89.9585 20.0204 92.6465V95.0529V110.054H19.0988C18.8684 110.054 18.6636 110.234 18.6636 110.49V112.051C18.6636 112.282 18.8428 112.486 19.0988 112.486H32.1292C32.3596 112.486 32.5644 112.307 32.5644 112.051V110.49C32.5132 110.259 32.3084 110.054 32.078 110.054ZM31.6684 111.642H19.4828V110.925H20.4044H30.7212H31.6428V111.642H31.6684ZM20.8396 92.6465C20.8396 90.4193 22.6316 88.6273 24.8588 88.6273H26.2668C28.494 88.6273 30.286 90.4193 30.286 92.6465V94.6177H20.8396V92.6465ZM20.8396 95.4881H30.286V110.054H20.8396V95.4881Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M32.0267 78.3103H31.1051V63.3087V60.9023C31.1051 58.2143 28.9291 56.0383 26.2411 56.0383H24.8331C22.1451 56.0383 19.9691 58.2143 19.9691 60.9023V63.3087V78.3103H19.0475C18.8171 78.3103 18.6123 78.4895 18.6123 78.7455V80.3071C18.6123 80.5375 18.7915 80.7423 19.0475 80.7423H32.0523C32.2827 80.7423 32.4875 80.5631 32.4875 80.3071V78.7455C32.4619 78.5151 32.2571 78.3103 32.0267 78.3103ZM31.6171 79.8975H19.4315V79.1807H20.3787H30.6699H31.5915V79.8975H31.6171ZM20.7883 60.9023C20.7883 58.7007 22.5803 56.8831 24.8075 56.8831H26.2155C28.4427 56.8831 30.2347 58.6751 30.2347 60.9023V62.8735H20.7883V60.9023ZM20.7883 63.7439H30.2347V78.3103H20.7883V63.7439Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M108.059 99.6865L107.598 97.7665C107.547 97.5873 107.521 97.3825 107.47 97.1777L107.393 96.8449C107.316 96.5377 107.265 96.2305 107.188 95.8977L107.111 95.4881C107.06 95.2321 107.009 94.9761 106.958 94.7201L106.42 92.0321C106.369 91.8017 106.343 91.5713 106.292 91.3409C106.215 90.9825 106.164 90.6241 106.113 90.3169C106.062 89.9841 106.011 89.6769 105.985 89.3953C105.934 88.9345 105.883 88.4737 105.831 87.9873C105.806 87.6289 105.806 87.4497 105.806 87.4497C105.755 85.3249 104.039 83.6353 101.94 83.5841C99.7387 83.5329 97.9211 85.2737 97.8699 87.4497C97.8699 87.4497 97.8699 87.6545 97.8443 87.9873C97.8187 88.4737 97.7675 88.9345 97.6907 89.3953C97.6651 89.6769 97.6139 89.9841 97.5627 90.3169C97.5115 90.6497 97.4603 90.9825 97.3835 91.3665C97.3323 91.5969 97.3067 91.8273 97.2555 92.0833L96.7435 94.7457C96.6923 95.0017 96.6411 95.2577 96.5899 95.5137L96.5131 95.9233C96.4363 96.2561 96.3851 96.5633 96.3083 96.8705L96.2315 97.2033C96.1803 97.4081 96.1291 97.6129 96.1035 97.8177L95.6427 99.7377C95.3867 100.787 95.3867 101.888 95.6427 102.912C96.0779 104.576 97.1019 105.984 98.5867 106.855C99.4827 107.392 100.455 107.674 101.454 107.751V106.24C99.3291 106.035 97.6395 104.218 97.6395 102.016C97.6395 101.786 97.8187 101.581 98.0747 101.581C98.3051 101.581 98.5099 101.76 98.5099 102.016C98.5099 103.731 99.8155 105.165 101.479 105.37V99.7377C99.6107 99.5329 98.1771 97.9457 98.1771 96.0257C98.1771 95.7953 98.3563 95.5905 98.6123 95.5905C98.8427 95.5905 99.0475 95.7697 99.0475 96.0257C99.0475 97.4593 100.123 98.6625 101.505 98.8673V93.2353C100.123 93.0305 99.0475 91.8273 99.0475 90.3681C99.0475 90.1377 99.2267 89.9329 99.4827 89.9329C99.7131 89.9329 99.9179 90.1121 99.9179 90.3681C99.9179 91.3409 100.609 92.1601 101.531 92.3649V87.8849C101.531 87.6545 101.71 87.4497 101.966 87.4497C102.196 87.4497 102.401 87.6289 102.401 87.8849V89.8817C103.323 89.6769 104.014 88.8577 104.014 87.8849C104.014 87.6545 104.193 87.4497 104.449 87.4497C104.679 87.4497 104.884 87.6289 104.884 87.8849C104.884 89.3441 103.809 90.5473 102.427 90.7521V96.3841C103.809 96.1793 104.884 94.9761 104.884 93.5425C104.884 93.3121 105.063 93.1073 105.319 93.1073C105.575 93.1073 105.755 93.2865 105.755 93.5425C105.755 95.4625 104.295 97.0497 102.452 97.2545V102.887C104.116 102.682 105.422 101.248 105.422 99.5329C105.422 99.3025 105.601 99.0977 105.857 99.0977C106.087 99.0977 106.292 99.2769 106.292 99.5329C106.292 101.735 104.628 103.527 102.478 103.757V107.674C102.862 107.648 103.246 107.597 103.63 107.495C106.83 106.624 108.929 103.117 108.059 99.6865Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M108.878 99.4816L108.417 97.5872C108.366 97.408 108.34 97.2032 108.289 96.9984L108.212 96.6656C108.136 96.3584 108.084 96.0512 108.008 95.7184L107.931 95.3088C107.88 95.0528 107.828 94.7968 107.777 94.5408L107.265 91.8528C107.214 91.6224 107.188 91.392 107.137 91.1872C107.086 90.8288 107.009 90.496 106.958 90.1632C106.907 89.8304 106.856 89.5232 106.83 89.2416C106.779 88.8064 106.728 88.3456 106.702 87.8848C106.676 87.5776 106.676 87.3984 106.676 87.3728C106.6 84.7872 104.552 82.7392 101.966 82.6624C101.915 82.6624 101.889 82.6624 101.838 82.6624C99.2268 82.6624 97.0764 84.7616 97.0252 87.3728C97.0252 87.3728 97.0252 87.552 96.9996 87.8848C96.974 88.3456 96.9228 88.8064 96.846 89.2416C96.8204 89.5232 96.7692 89.8304 96.718 90.1632C96.6668 90.496 96.6156 90.8288 96.5388 91.1872C96.4876 91.4176 96.462 91.648 96.4108 91.8784L95.8988 94.5408C95.8476 94.7968 95.7964 95.0528 95.7452 95.3088L95.6428 95.744C95.566 96.0768 95.5148 96.384 95.438 96.6912L95.3612 97.024C95.31 97.2288 95.2844 97.4336 95.2332 97.6128L94.7724 99.5072C94.4652 100.685 94.4652 101.939 94.7724 103.091C95.566 106.24 98.3308 108.365 101.403 108.57V114.33C101.403 114.56 101.582 114.765 101.838 114.765C102.068 114.765 102.273 114.586 102.273 114.33V108.544C102.734 108.518 103.195 108.442 103.63 108.339C105.524 107.853 107.086 106.675 108.084 105.011C109.083 103.322 109.364 101.376 108.878 99.4816ZM102.248 103.757C104.372 103.552 106.062 101.734 106.062 99.5328C106.062 99.3024 105.883 99.0976 105.627 99.0976C105.396 99.0976 105.192 99.2768 105.192 99.5328C105.192 101.248 103.886 102.682 102.222 102.886V97.2544C104.091 97.0496 105.524 95.4624 105.524 93.5424C105.524 93.312 105.345 93.1072 105.089 93.1072C104.833 93.1072 104.654 93.2864 104.654 93.5424C104.654 94.976 103.579 96.1792 102.196 96.384V90.752C103.579 90.5472 104.654 89.344 104.654 87.8848C104.654 87.6544 104.475 87.4496 104.219 87.4496C103.988 87.4496 103.784 87.6288 103.784 87.8848C103.784 88.8576 103.092 89.6768 102.171 89.8816V87.8848C102.171 87.6544 101.992 87.4496 101.736 87.4496C101.505 87.4496 101.3 87.6288 101.3 87.8848V92.3648C100.379 92.16 99.6876 91.3408 99.6876 90.368C99.6876 90.1376 99.5084 89.9328 99.2524 89.9328C99.022 89.9328 98.8172 90.112 98.8172 90.368C98.8172 91.8272 99.8924 93.0304 101.275 93.2352V98.8672C99.8924 98.6624 98.8172 97.4592 98.8172 96.0256C98.8172 95.7952 98.638 95.5904 98.382 95.5904C98.1516 95.5904 97.9468 95.7696 97.9468 96.0256C97.9468 97.9456 99.406 99.5328 101.249 99.7376V105.37C99.5852 105.165 98.2796 103.731 98.2796 102.016C98.2796 101.786 98.1004 101.581 97.8444 101.581C97.614 101.581 97.4092 101.76 97.4092 102.016C97.4092 104.218 99.0732 106.01 101.224 106.24V107.699C100.225 107.622 99.2524 107.341 98.3564 106.803C96.8716 105.933 95.8476 104.525 95.4124 102.861C95.1564 101.837 95.1564 100.736 95.4124 99.6864L95.8732 97.7664C95.9244 97.5872 95.95 97.3824 96.0012 97.152L96.078 96.8192C96.1548 96.512 96.206 96.2048 96.2828 95.872L96.3596 95.4624C96.4108 95.2064 96.462 94.9504 96.5132 94.6944L97.0252 92.032C97.0764 91.8016 97.1276 91.5456 97.1532 91.3152C97.23 90.9568 97.2812 90.5984 97.3324 90.2656C97.3836 89.9328 97.4348 89.6256 97.4604 89.344C97.5116 88.8832 97.5628 88.4224 97.614 87.936C97.6396 87.5776 97.6396 87.3984 97.6396 87.3984C97.6908 85.1968 99.5084 83.4816 101.71 83.5328C103.835 83.584 105.524 85.2992 105.576 87.3984C105.576 87.3984 105.576 87.6032 105.601 87.936C105.627 88.3968 105.678 88.8832 105.755 89.344C105.78 89.6256 105.832 89.9328 105.883 90.2656C105.934 90.5984 105.985 90.9312 106.062 91.2896C106.113 91.52 106.139 91.7504 106.19 91.9808L106.728 94.6688C106.779 94.9248 106.83 95.1808 106.881 95.4368L106.958 95.8464C107.035 96.1792 107.086 96.4864 107.163 96.7936L107.24 97.1264C107.291 97.3312 107.342 97.536 107.368 97.7152L107.828 99.6352C108.699 103.066 106.625 106.573 103.195 107.443C102.811 107.546 102.427 107.597 102.043 107.622V103.757H102.248Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M124.059 80.1279L123.163 81.0239H127.207L126.337 80.1279H124.059Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M127.259 81.8689H123.137C123.342 82.8161 124.187 83.5585 125.185 83.5585C126.209 83.5585 127.054 82.8417 127.259 81.8689Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M126.081 79.2063H124.315V79.2831H126.081V79.2063Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M116.891 113.075H115.662V113.869H120.705V113.075H119.451H116.891Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M119.041 103.271H117.326V112.231H119.041V103.271Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M109.134 81.0239H113.179L112.283 80.1279H110.03L109.134 81.0239Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M113.23 81.8689H109.108C109.313 82.8161 110.158 83.5585 111.156 83.5585C112.18 83.5585 113.025 82.8417 113.23 81.8689Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M112.027 79.2063H110.26V79.2831H112.027V79.2063Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M128.539 81.152L126.926 79.5392V78.7968C126.926 78.5664 126.747 78.3616 126.491 78.3616H125.595V75.3152C125.595 74.3424 125.211 73.4464 124.545 72.7808C123.879 72.0896 122.958 71.7312 122.011 71.7312C120.039 71.7312 118.427 73.344 118.427 75.3152V77.6704H117.915V75.3152C117.915 73.344 116.302 71.7312 114.331 71.7312C113.358 71.7312 112.462 72.1152 111.796 72.7808C111.105 73.4464 110.747 74.368 110.747 75.3152V78.3616H109.851C109.62 78.3616 109.415 78.5408 109.415 78.7968V79.5392L107.803 81.152C107.675 81.28 107.649 81.4592 107.7 81.6128C107.777 81.7664 107.931 81.8688 108.084 81.8688H108.212C108.417 83.3024 109.646 84.4032 111.131 84.4032C112.615 84.4032 113.844 83.3024 114.049 81.8688H114.177C114.356 81.8688 114.51 81.7664 114.561 81.6128C114.638 81.4592 114.587 81.28 114.459 81.152L112.846 79.5392V78.7968C112.846 78.5664 112.667 78.3616 112.411 78.3616H111.515V75.3152C111.515 74.5728 111.796 73.8816 112.308 73.3696C112.82 72.8576 113.511 72.576 114.254 72.576C115.764 72.576 116.993 73.8048 116.993 75.3152V77.6704H116.481C116.251 77.6704 116.046 77.8496 116.046 78.1056V78.8736C116.046 79.104 116.225 79.3088 116.481 79.3088H117.684V102.426H116.891C116.66 102.426 116.455 102.605 116.455 102.861V112.23H115.201C114.971 112.23 114.766 112.41 114.766 112.666V114.304C114.766 114.534 114.945 114.739 115.201 114.739H121.089C121.319 114.739 121.524 114.56 121.524 114.304V112.64C121.524 112.41 121.345 112.205 121.089 112.205H119.835V102.835C119.835 102.605 119.655 102.4 119.399 102.4H118.555V79.2832H119.758C119.988 79.2832 120.193 79.104 120.193 78.848V78.08C120.193 77.8496 120.014 77.6448 119.758 77.6448H119.246V75.2896C119.246 73.7792 120.475 72.5504 121.985 72.5504C122.727 72.5504 123.419 72.832 123.931 73.344C124.443 73.856 124.724 74.5472 124.724 75.2896V78.336H123.828C123.598 78.336 123.393 78.5152 123.393 78.7712V79.5136L121.78 81.1264C121.652 81.2544 121.627 81.4336 121.678 81.5872C121.755 81.7408 121.908 81.8432 122.062 81.8432H122.19C122.395 83.2768 123.623 84.3776 125.108 84.3776C126.593 84.3776 127.822 83.2768 128.027 81.8432H128.155C128.334 81.8432 128.487 81.7408 128.539 81.5872C128.692 81.4592 128.667 81.28 128.539 81.152ZM109.108 81.8688H113.23C113.025 82.816 112.18 83.5584 111.156 83.5584C110.132 83.5584 109.287 82.8416 109.108 81.8688ZM112.052 79.2064V79.2832H110.286V79.2064H112.052ZM113.179 81.024H109.134L110.03 80.128H112.308L113.179 81.024ZM120.705 113.869H115.662V113.075H116.916H119.476H120.731V113.869H120.705ZM119.041 103.27V112.23H117.326V103.27H119.041ZM123.137 81.8688H127.259C127.054 82.816 126.209 83.5584 125.185 83.5584C124.187 83.5584 123.316 82.8416 123.137 81.8688ZM123.163 81.024L124.059 80.128H126.337L127.233 81.024H123.163ZM126.081 79.2064V79.2832H124.315V79.2064H126.081Z",
                        fill: "#7799CC"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M110.747 13.2609C107.931 13.2609 105.371 14.5665 103.681 16.8193C103.604 16.9217 103.502 16.9729 103.374 16.9985C103.246 16.9985 103.143 16.9729 103.041 16.8961C101.787 15.8209 100.199 15.2321 98.561 15.2321C94.7978 15.2321 91.7258 18.3041 91.7258 22.0673C91.7258 23.2705 92.7242 24.2689 93.9274 24.2689H117.3C118.503 24.2689 119.502 23.2705 119.502 22.0673C119.527 17.2033 115.585 13.2609 110.747 13.2609Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M110.747 12.416C107.854 12.416 105.115 13.7216 103.272 15.9488C101.94 14.9248 100.276 14.3616 98.5867 14.3616C94.3371 14.3616 90.9067 17.8176 90.9067 22.0416C90.9067 23.7312 92.2635 25.088 93.9531 25.088H117.326C119.016 25.088 120.372 23.7312 120.372 22.0416C120.372 16.7424 116.046 12.416 110.747 12.416ZM117.326 24.2432H93.9531C92.7499 24.2432 91.7515 23.2448 91.7515 22.0416C91.7515 18.2784 94.8235 15.2064 98.5867 15.2064C100.225 15.2064 101.812 15.7952 103.067 16.8704C103.144 16.9472 103.272 16.9728 103.4 16.9728C103.528 16.9472 103.63 16.896 103.707 16.7936C105.371 14.5664 107.931 13.2608 110.747 13.2608C115.585 13.2608 119.528 17.2032 119.528 22.0416C119.528 23.2704 118.529 24.2432 117.326 24.2432Z",
                        fill: "#7799CC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_99_113",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "128",
                        transform: "translate(0.666748)",
                        width: "128"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fEH0X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsPhone", ()=>(0, _iconsPhone.IconsPhone));
var _iconsPhone = require("./IconsPhone");

},{"./IconsPhone":"cHZ8M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cHZ8M":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsPhone", ()=>IconsPhone);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsPhone = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-phone ${className}`,
        fill: "none",
        height: "128",
        viewBox: "0 0 128 128",
        width: "128",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M83.2486 102.062H44.7517C40.5119 102.062 37.1201 98.5849 37.1201 94.43V29.9858C37.1201 25.746 40.5967 22.3542 44.7517 22.3542H83.2486C87.4883 22.3542 90.8801 25.8308 90.8801 29.9858V94.43C90.8801 98.6697 87.4883 102.062 83.2486 102.062ZM44.7517 25.4069C42.2078 25.4069 40.1727 27.4419 40.1727 29.9858V94.43C40.1727 96.9738 42.2078 99.0089 44.7517 99.0089H83.2486C85.7924 99.0089 87.8275 96.9738 87.8275 94.43V29.9858C87.8275 27.4419 85.7924 25.4069 83.2486 25.4069H44.7517Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.5527 91.2078H46.4476C43.9037 91.2078 41.8687 89.1727 41.8687 86.6288V37.7869C41.8687 35.2431 43.9037 33.208 46.4476 33.208H81.5527C84.0965 33.208 86.1316 35.2431 86.1316 37.7869V86.544C86.1316 89.0879 84.0965 91.2078 81.5527 91.2078ZM46.4476 36.2606C45.5996 36.2606 44.9213 36.939 44.9213 37.7869V86.544C44.9213 87.392 45.5996 88.0703 46.4476 88.0703H81.5527C82.4006 88.0703 83.079 87.392 83.079 86.544V37.7869C83.079 36.939 82.4006 36.2606 81.5527 36.2606H46.4476Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M69.4271 93.7515H58.4885V96.8041H69.4271V93.7515Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M66.3743 71.1962C65.1024 69.9243 62.9825 69.9243 61.6258 71.1962L59.4211 68.9915C61.8802 66.5325 65.9504 66.5325 68.4942 68.9915L66.3743 71.1962Z",
                fill: "#A591D7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M71.3774 66.1933C67.3073 62.1231 60.6933 62.1231 56.6231 66.1933L54.4185 63.9886C59.6757 58.7313 68.24 58.7313 73.4973 63.9886L71.3774 66.1933Z",
                fill: "#A591D7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M51.4505 61.0208L49.2458 58.8162C57.3862 50.6759 70.6142 50.6759 78.7545 58.8162L76.5498 61.0208C69.6814 54.0677 58.3189 54.0677 51.4505 61.0208Z",
                fill: "#A591D7"
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"99oWe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsPlug1", ()=>(0, _iconsPlug1.IconsPlug1));
var _iconsPlug1 = require("./IconsPlug1");

},{"./IconsPlug1":"3F1l7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3F1l7":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsPlug1", ()=>IconsPlug1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsPlug1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-plug-1 ${className}`,
        fill: "none",
        height: "128",
        viewBox: "0 0 129 128",
        width: "129",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M77.128 54.5489V47.3922H73.7882V54.4693H69.7328V47.3922H66.393V54.4693H62.3375V47.3922H58.9977V54.4693H54.9423V47.3922H51.6025V54.5489C49.0579 54.8669 47.1494 57.0139 47.1494 59.5585V70.1346C47.1494 74.8262 50.9663 78.5636 55.5784 78.5636H62.7351V105.6H66.0749V78.5636H73.2316C77.9232 78.5636 81.6606 74.7466 81.6606 70.1346V59.5585C81.6606 56.9344 79.6726 54.7874 77.128 54.5489ZM78.2413 70.1346C78.2413 72.9177 75.9352 75.2238 73.1521 75.2238H55.4194C52.6362 75.2238 50.3302 72.9177 50.3302 70.1346V59.5585C50.3302 58.6043 51.1254 57.8887 52.0001 57.8887H76.4919C77.4461 57.8887 78.1618 58.6838 78.1618 59.5585L78.2413 70.1346Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M89.6126 41.8259C89.6126 35.9415 84.921 31.1704 79.1161 31.0113C76.7305 25.0474 70.9257 20.9919 64.4051 20.9919C57.8846 20.9919 52.0797 25.0474 49.6941 31.0113C43.8892 31.1704 39.1976 35.9415 39.1976 41.7464C34.9036 43.2572 31.9614 47.3127 31.9614 51.9248C31.9614 57.8887 36.8121 62.6598 42.6965 62.6598H47.07V59.4791C47.07 59.3996 47.07 59.3995 47.07 59.32H42.6965C38.641 59.32 35.3012 55.9802 35.3012 51.9248C35.3012 48.426 37.8458 45.3247 41.2651 44.6886C42.1398 44.5295 42.776 43.6548 42.6169 42.7801C42.5374 42.3825 42.5374 42.0644 42.5374 41.7464C42.5374 37.6909 45.8772 34.3511 49.9327 34.3511C50.1712 34.3511 50.4098 34.3511 50.7279 34.4306C51.5231 34.5102 52.3182 34.033 52.5568 33.2379C53.9881 28.0691 58.9183 24.4113 64.3256 24.4113C69.7329 24.4113 74.663 28.0691 76.1739 33.2379C76.4125 34.033 77.1281 34.5102 78.0028 34.4306C78.2414 34.4306 78.4799 34.3511 78.798 34.3511C82.8535 34.3511 86.1933 37.6909 86.1933 41.7464C86.1933 42.0644 86.1933 42.3825 86.1138 42.7801C85.9547 43.6548 86.5909 44.5295 87.4656 44.6886C90.8849 45.4042 93.4295 48.426 93.4295 51.9248C93.4295 55.9802 90.0897 59.32 86.0342 59.32H81.6607C81.6607 59.3995 81.6607 59.3996 81.6607 59.4791V62.6598H86.0342C91.9981 62.6598 96.7693 57.8092 96.7693 51.9248C96.7693 47.3922 93.8271 43.3367 89.6126 41.8259Z",
                fill: "#A591D7"
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jTpBI":[function() {},{}],"d7m2z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsMill", ()=>(0, _iconsMill.IconsMill));
var _iconsMill = require("./IconsMill");

},{"./IconsMill":"OEkJh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"OEkJh":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsMill", ()=>IconsMill);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsMill = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-mill ${className}`,
        fill: "none",
        height: "128",
        viewBox: "0 0 129 128",
        width: "129",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M122.189 115.277H6.6309C6.5285 115.277 6.47729 115.072 6.47729 114.816C6.47729 114.56 6.5541 114.355 6.6309 114.355H122.189",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M98.3301 37.7344L71.9109 64.128L76.4677 68.6848L102.887 42.2912L98.3301 37.7344Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.5314 35.9278L70.1284 62.3457L71.2873 63.5039L97.6903 37.0859L96.5314 35.9278Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M94.0805 105.523L67.6613 79.104L66.0229 80.7424L63.1045 83.6608L64.4613 85.0176L89.4981 110.054L94.0805 105.523Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M69.4795 77.3146L68.3213 78.4736L94.743 104.877L95.9011 103.718L69.4795 77.3146Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M62.9509 69.5043L66.2533 72.8067H70.3237C70.1189 71.5267 69.4021 68.0707 67.3029 65.1523L62.9509 69.5043Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M62.3109 70.144L59.6741 72.7808H64.9477L62.3109 70.144Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M65.2549 90.0864H59.3669V95.9744H65.2549V90.0864Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M59.3669 84.8897H63.0533L62.1573 83.9937C61.9781 83.8145 61.9781 83.5329 62.1573 83.3537L65.2549 80.2561V79.0273H59.3669V84.8897Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M62.3109 68.8641L66.7397 64.4353C65.5109 62.9505 64.0005 61.8497 62.3109 61.1841C60.5957 61.8497 59.1109 62.9249 57.8821 64.4353L62.3109 68.8641Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M66.279 106.778C66.279 104.576 64.4869 102.784 62.2853 102.784C61.2357 102.784 60.2373 103.194 59.4693 103.962C58.7013 104.73 58.2917 105.728 58.2917 106.778V111.847C58.3173 111.898 58.343 111.975 58.343 112.051C58.343 112.128 58.3173 112.179 58.2917 112.256V114.381H66.2533V106.778H66.279Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M58.3685 72.7809L61.6709 69.4785L57.3189 65.1265C55.2197 68.0449 54.5029 71.5009 54.2981 72.7809H58.3685Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.9605 59.8786L61.4917 55.3218L35.0981 28.9282L30.5413 33.485L56.9605 59.8786Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M56.3204 60.5186L29.9012 34.125L28.7236 35.277L55.1428 61.6962L56.3204 60.5186Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M53.345 75.5085L26.9346 101.919L28.0931 103.077L54.5035 76.667L53.345 75.5085Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M48.1343 70.3044L21.7239 96.7148L26.2855 101.276L52.696 74.866L48.1343 70.3044Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M58.9061 89.165C58.6501 89.165 58.4453 89.3698 58.4453 89.6258V94.4642H54.7589C54.5029 94.4642 54.2981 94.669 54.2981 94.925C54.2981 95.181 54.5029 95.3858 54.7589 95.3858H58.4453V96.4354C58.4453 96.6914 58.6501 96.8962 58.9061 96.8962H65.7157C65.9717 96.8962 66.1765 96.6914 66.1765 96.4354V89.6258C66.1765 89.3698 65.9717 89.165 65.7157 89.165H58.9061ZM65.2549 95.9746H59.3669V90.0866H65.2549V95.9746Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M68.2245 100.352H72.3717C72.6277 100.352 72.8325 100.147 72.8325 99.8915C72.8325 99.6355 72.6277 99.4307 72.3717 99.4307H68.2245C67.9685 99.4307 67.7637 99.6355 67.7637 99.8915C67.7637 100.147 67.9685 100.352 68.2245 100.352Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M70.9636 64.4608L76.1604 69.6576C76.2372 69.7344 76.3652 69.7856 76.4932 69.7856C76.6212 69.7856 76.7236 69.7344 76.826 69.6576L103.885 42.5984C104.064 42.4192 104.064 42.1376 103.885 41.9584L98.6884 36.7616L96.8708 34.944C96.6916 34.7648 96.41 34.7648 96.2308 34.944L69.146 62.0032L67.3796 63.7696C65.9972 62.1312 64.3588 60.9536 62.4644 60.2624C62.362 60.2368 62.2596 60.2368 62.1572 60.2624C60.2628 60.9536 58.5988 62.1568 57.242 63.7696L55.8084 62.336L62.49 55.6544C62.6692 55.4752 62.6692 55.1936 62.49 55.0144L35.4052 27.9552C35.226 27.776 34.9444 27.776 34.7652 27.9552L27.7508 34.9696C27.5716 35.1488 27.5716 35.4304 27.7508 35.6096L54.81 62.6688L56.6532 64.512C53.8884 68.3008 53.3508 72.832 53.3252 73.1904L53.1716 74.0608L48.4612 69.3248C48.282 69.1456 48.0004 69.1456 47.8212 69.3248L20.762 96.384C20.6852 96.4608 20.634 96.5888 20.634 96.7168C20.634 96.8448 20.6852 96.9472 20.762 97.0496L27.7764 104.064C27.8532 104.141 27.9812 104.192 28.1092 104.192C28.2372 104.192 28.3396 104.141 28.442 104.064L52.0196 80.4864L45.6964 114.765C45.6708 114.893 45.6964 115.046 45.7988 115.149C45.8756 115.251 46.0036 115.302 46.1572 115.302H78.5412C78.6692 115.302 78.7972 115.251 78.8996 115.149C78.9764 115.046 79.0276 114.918 79.002 114.765L75.8532 97.6384L89.2676 111.053C89.3444 111.13 89.4724 111.181 89.6004 111.181C89.7284 111.181 89.8308 111.13 89.9332 111.053L95.13 105.856L96.9476 104.038C97.1268 103.859 97.1268 103.578 96.9476 103.398L72.4484 78.8992L71.3988 73.1904C71.3476 72.8064 70.8356 68.2752 68.0708 64.512L69.5812 63.0016L70.9636 64.4608ZM71.9108 64.128L98.33 37.7088L102.887 42.2656L76.4676 68.6848L71.9108 64.128ZM71.2708 63.488L70.1188 62.336L96.538 35.9168L97.69 37.0688L71.2708 63.488ZM55.1428 76.0064L53.9396 74.8032L54.1444 73.6768H57.4468L55.1428 76.0064ZM48.154 70.2976L52.7108 74.8544L26.2916 101.274L21.7348 96.7168L48.154 70.2976ZM62.3108 61.1584C64.026 61.824 65.5108 62.9248 66.7396 64.4096L62.3108 68.864L57.882 64.4352C59.1108 62.9248 60.5956 61.824 62.3108 61.1584ZM62.3108 70.144L64.9476 72.7808H59.6484L62.3108 70.144ZM61.6708 69.504L58.3684 72.8064H54.298C54.5028 71.5264 55.2196 68.096 57.3188 65.152L61.6708 69.504ZM53.3508 75.4944L54.5028 76.6464L28.0836 103.066L26.9316 101.914L53.3508 75.4944ZM66.2532 72.7808L62.9508 69.4784L67.3028 65.1264C69.402 68.0448 70.1188 71.5008 70.3236 72.7808H66.2532ZM61.4916 55.3216L56.9348 59.8784L30.5412 33.4848L35.098 28.928L61.4916 55.3216ZM29.9012 34.1248L56.3204 60.544L55.1684 61.7216L28.7236 35.2768L29.9012 34.1248ZM58.3172 112.23C58.3428 112.179 58.3684 112.102 58.3684 112.026C58.3684 111.949 58.3428 111.898 58.3172 111.821V106.752C58.3172 105.702 58.7268 104.704 59.4948 103.936C60.2372 103.194 61.2356 102.758 62.3108 102.758C64.5124 102.758 66.3044 104.55 66.3044 106.752V114.355H58.3428V112.23H58.3172ZM77.9524 114.381H67.2004V107.622H70.8868C71.1428 107.622 71.3476 107.418 71.3476 107.162C71.3476 106.906 71.1428 106.701 70.8868 106.701H67.2004C67.1492 104.038 64.9732 101.888 62.3108 101.888C61.0052 101.888 59.7764 102.4 58.8548 103.322C57.9332 104.243 57.4212 105.472 57.4212 106.778V111.59H53.786C53.53 111.59 53.3252 111.795 53.3252 112.051C53.3252 112.307 53.53 112.512 53.786 112.512H57.4212V114.381H46.6692L48.6148 103.782H52.378C52.634 103.782 52.8388 103.578 52.8388 103.322C52.8388 103.066 52.634 102.861 52.378 102.861H48.7684L51.738 86.6816H55.5268C55.7828 86.6816 55.9876 86.4768 55.9876 86.2208C55.9876 85.9648 55.7828 85.76 55.5268 85.76H51.9172L53.0948 79.3088L55.45 76.9536L56.0132 76.3904C56.09 76.4416 56.1668 76.4672 56.2436 76.4672H60.3908C60.6468 76.4672 60.8516 76.2624 60.8516 76.0064C60.8516 75.7504 60.6468 75.5456 60.3908 75.5456H56.858L58.7524 73.6512H65.8692L68.8388 76.6208L67.354 78.1056L66.1764 79.2832V78.4896C66.1764 78.2336 65.9716 78.0288 65.7156 78.0288H58.906C58.65 78.0288 58.4452 78.2336 58.4452 78.4896V85.2992C58.4452 85.5552 58.65 85.76 58.906 85.76H63.9748L74.65 96.4352L77.9524 114.381ZM65.2548 80.2304L62.1572 83.328C61.978 83.5072 61.978 83.7888 62.1572 83.968L63.0532 84.864H59.3412V78.976H65.2292V80.2304H65.2548ZM64.4868 85.0176L63.13 83.6608L66.0484 80.7424L67.6868 79.104L94.106 105.523L89.5236 110.08L64.4868 85.0176ZM94.7204 104.883L68.3012 78.464L69.4532 77.312L95.8724 103.731L94.7204 104.883ZM69.786 76.3392L67.1492 73.7024H70.4516L71.194 77.7728L69.786 76.3392Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M37.7604 89.4721C37.7604 89.4465 37.786 89.4209 37.786 89.3953C38.4772 88.4225 38.8356 87.2705 38.8356 86.0673C38.8356 82.8673 36.25 80.2817 33.05 80.2817C29.85 80.2817 27.2644 82.8673 27.2644 86.0673C27.2644 86.9889 27.4948 87.8849 27.9044 88.7041C28.0324 88.8065 28.1604 88.9089 28.2884 89.0369L30.4644 89.1649C29.21 88.7553 28.314 87.6033 28.314 86.2209C28.314 85.9649 28.5188 85.7601 28.7748 85.7601C29.0308 85.7601 29.2356 85.9649 29.2356 86.2209C29.2356 87.2705 29.978 88.1409 30.9764 88.3457V86.0673C30.9764 85.8113 31.1812 85.6065 31.4372 85.6065C31.6932 85.6065 31.898 85.8113 31.898 86.0673V89.2417L33.7156 89.3441C34.33 88.7809 34.7396 87.9617 34.7396 87.0657C34.7396 86.8097 34.9444 86.6049 35.2004 86.6049C35.4564 86.6049 35.6612 86.8097 35.6612 87.0657C35.6612 87.9361 35.3796 88.7553 34.8932 89.4209L37.4276 89.5745C37.4788 89.5745 37.6068 89.5233 37.7604 89.4721Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M39.6037 90.1377C37.7861 90.1377 36.1733 90.9825 35.0981 92.2881C35.0725 92.3649 35.0213 92.4417 34.9445 92.4929C34.2277 93.4657 33.8181 94.6433 33.8181 95.9233C33.8181 98.5601 35.5845 100.787 38.0165 101.478C38.0677 101.248 38.0933 100.992 38.0933 100.736V97.6385C36.6085 97.4081 35.4565 96.1281 35.4565 94.5921C35.4565 94.3361 35.6613 94.1313 35.9173 94.1313C36.1733 94.1313 36.3781 94.3361 36.3781 94.5921C36.3781 95.6417 37.1205 96.5121 38.1189 96.7169V95.8977C38.1189 95.6417 38.3237 95.4369 38.5797 95.4369C38.8357 95.4369 39.0405 95.6417 39.0405 95.8977V99.4561C40.5253 99.2257 41.6773 97.9457 41.6773 96.4097C41.6773 96.1537 41.8821 95.9489 42.1381 95.9489C42.3941 95.9489 42.5989 96.1537 42.5989 96.4097C42.5989 98.4577 41.0373 100.147 39.0661 100.378V100.736C39.0661 101.043 39.0405 101.35 38.9893 101.658C39.2197 101.683 39.4501 101.709 39.7061 101.709C42.9061 101.709 45.4917 99.1233 45.4917 95.9233C45.3893 92.7233 42.8037 90.1377 39.6037 90.1377Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M39.6037 89.2161C39.3733 89.2161 39.1685 89.2161 38.9381 89.2417C39.4501 88.2689 39.7317 87.1937 39.7317 86.0929C39.7317 82.4065 36.7365 79.3857 33.0245 79.3857C29.3381 79.3857 26.3173 82.3809 26.3173 86.0929C26.3173 86.7073 26.4197 87.3217 26.5733 87.9361C25.5237 87.4241 24.3461 87.1169 23.0917 87.1169C18.7909 87.1169 15.2837 90.6241 15.2837 94.9249C15.2837 99.2257 18.7909 102.733 23.0917 102.733C23.3989 102.733 23.6805 102.707 23.9877 102.682C24.0901 106.445 27.1365 109.491 30.8997 109.568V114.842C30.8997 115.098 31.1045 115.303 31.3605 115.303C31.6165 115.303 31.8213 115.098 31.8213 114.842V105.907H33.8181C36.0197 105.907 37.8885 104.525 38.6309 102.554C38.9381 102.605 39.2709 102.631 39.5781 102.631C43.2645 102.631 46.2853 99.6353 46.2853 95.9233C46.3109 92.2113 43.2901 89.2161 39.6037 89.2161ZM39.6037 101.709C39.3733 101.709 39.1173 101.683 38.8869 101.658C38.9381 101.351 38.9637 101.043 38.9637 100.736V100.378C40.9605 100.147 42.4965 98.4577 42.4965 96.4097C42.4965 96.1537 42.2917 95.9489 42.0357 95.9489C41.7797 95.9489 41.5749 96.1537 41.5749 96.4097C41.5749 97.9457 40.4229 99.2257 38.9381 99.4561V95.8977C38.9381 95.6417 38.7333 95.4369 38.4773 95.4369C38.2213 95.4369 38.0165 95.6417 38.0165 95.8977V96.7169C37.0181 96.5121 36.2757 95.6417 36.2757 94.5921C36.2757 94.3361 36.0709 94.1313 35.8149 94.1313C35.5589 94.1313 35.3541 94.3361 35.3541 94.5921C35.3541 96.1537 36.5061 97.4337 37.9909 97.6385V100.736C37.9909 100.992 37.9653 101.223 37.9141 101.479C35.5077 100.787 33.7157 98.5601 33.7157 95.9233C33.7157 94.6433 34.1509 93.4657 34.8421 92.4929C34.9189 92.4417 34.9701 92.3649 34.9957 92.2881C36.0709 90.9825 37.6837 90.1377 39.5013 90.1377C42.7013 90.1377 45.2869 92.7233 45.2869 95.9233C45.3893 99.1233 42.8037 101.709 39.6037 101.709ZM31.8469 91.0849C33.0501 91.0081 34.1253 90.3937 34.8165 89.4721C35.3029 88.8065 35.5845 87.9873 35.5845 87.1169C35.5845 86.8609 35.3797 86.6561 35.1237 86.6561C34.8677 86.6561 34.6629 86.8609 34.6629 87.1169C34.6629 88.0129 34.2789 88.8321 33.6389 89.3953C33.1525 89.8305 32.5125 90.1377 31.8213 90.1889V89.2929V86.1185C31.8213 85.8625 31.6165 85.6577 31.3605 85.6577C31.1045 85.6577 30.8997 85.8625 30.8997 86.1185V88.3969C29.9013 88.1921 29.1589 87.3217 29.1589 86.2721C29.1589 86.0161 28.9541 85.8113 28.6981 85.8113C28.4421 85.8113 28.2373 86.0161 28.2373 86.2721C28.2373 87.6545 29.1333 88.8321 30.3877 89.2161C30.5413 89.2673 30.6949 89.2929 30.8741 89.3185V91.5201C30.4901 91.3665 30.1317 91.1873 29.7733 90.9569C29.3637 90.2657 28.8261 89.6257 28.2117 89.0881C28.0837 88.9857 27.9557 88.8577 27.8277 88.7553C27.4181 87.9361 27.1877 87.0401 27.1877 86.1185C27.1877 82.9185 29.7733 80.3329 32.9733 80.3329C36.1733 80.3329 38.7589 82.9185 38.7589 86.1185C38.7589 87.3217 38.4005 88.4737 37.7093 89.4465C37.6837 89.4721 37.6837 89.4977 37.6837 89.5233C37.5301 89.5745 37.4021 89.6001 37.2741 89.6513C36.0965 90.0609 35.0981 90.8033 34.3301 91.7505C33.8949 91.8529 33.4341 91.9297 32.9733 91.9297C32.5637 91.9297 32.1797 91.8785 31.7701 91.8017V91.0849H31.8469ZM30.9253 94.6177C30.8997 93.7985 30.7461 93.0049 30.4645 92.2625C30.6181 92.3137 30.7717 92.3905 30.9253 92.4417V94.6177ZM30.0549 94.9249C30.0549 98.1249 27.8789 100.787 24.9349 101.581V98.1505C26.4197 97.9201 27.5717 96.6401 27.5717 95.1041C27.5717 94.8481 27.3669 94.6433 27.1109 94.6433C26.8549 94.6433 26.6501 94.8481 26.6501 95.1041C26.6501 96.1537 25.9077 97.0241 24.9093 97.2289V96.3329C24.9093 96.0769 24.7045 95.8721 24.4485 95.8721C24.1925 95.8721 23.9877 96.0769 23.9877 96.3329V99.7633C22.0933 99.6353 20.6085 98.0737 20.6085 96.1537C20.6085 95.8977 20.4037 95.6929 20.1477 95.6929C19.8917 95.6929 19.6869 95.8977 19.6869 96.1537C19.6869 98.5601 21.5813 100.557 23.9877 100.659V101.76C23.7061 101.786 23.3989 101.811 23.0917 101.811C19.2773 101.811 16.1797 98.7137 16.1797 94.8993C16.1797 91.0849 19.2773 87.9873 23.0917 87.9873C26.9317 88.0129 30.0549 91.1105 30.0549 94.9249ZM24.9349 102.528C28.2885 101.735 30.8229 98.7905 30.9509 95.2065V108.647C27.6229 108.57 24.9349 105.856 24.9349 102.528ZM33.8437 104.986H31.8469V92.6977C32.2309 92.7745 32.6405 92.8001 33.0501 92.8001C33.2805 92.8001 33.4853 92.7745 33.7157 92.7745C33.2037 93.7217 32.9221 94.7969 32.9221 95.9233C32.9221 98.9697 34.9701 101.555 37.7861 102.349C37.1205 103.885 35.6101 104.986 33.8437 104.986Z",
                fill: "#7799CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M16.231 94.9251C16.231 98.7395 19.3286 101.837 23.143 101.837C23.4502 101.837 23.7318 101.812 24.039 101.786V100.685C21.6582 100.557 19.7382 98.5859 19.7382 96.1795C19.7382 95.9235 19.943 95.7187 20.199 95.7187C20.455 95.7187 20.6598 95.9235 20.6598 96.1795C20.6598 98.0995 22.1702 99.6611 24.039 99.7891V96.3587C24.039 96.1027 24.2438 95.8979 24.4998 95.8979C24.7558 95.8979 24.9606 96.1027 24.9606 96.3587V97.2547C25.959 97.0499 26.7014 96.1795 26.7014 95.1299C26.7014 94.8739 26.9062 94.6691 27.1622 94.6691C27.4182 94.6691 27.623 94.8739 27.623 95.1299C27.623 96.6915 26.471 97.9715 24.9862 98.1763V101.607C27.9302 100.813 30.1062 98.1251 30.1062 94.9507C30.1062 91.1363 27.0086 88.0387 23.1942 88.0387C19.3286 88.0131 16.231 91.1107 16.231 94.9251Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M104.295 93.6447C104.346 93.6447 104.397 93.5935 104.397 93.5423C104.397 93.4911 104.346 93.4399 104.295 93.4399H99.8404C99.7892 93.4399 99.738 93.4911 99.738 93.5423C99.738 93.5935 99.7892 93.6447 99.8404 93.6447H104.295Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.9716 15.4111C80.4868 15.4111 79.0532 15.9487 77.9268 16.9215C77.8244 16.9983 77.6964 17.0495 77.5684 17.0239C77.4404 16.9983 77.338 16.9471 77.2612 16.8447C75.7508 14.7967 73.3956 13.6191 70.8612 13.6191C66.458 13.6191 62.874 17.2031 62.874 21.6063C62.874 22.6815 63.7444 23.5519 64.8196 23.5519H86.2212C87.2964 23.5519 88.1668 22.6815 88.1668 21.6063C88.1668 18.1759 85.3764 15.4111 81.9716 15.4111Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M81.9716 14.4898C80.4356 14.4898 78.9252 15.0018 77.6964 15.9234C76.0068 13.901 73.498 12.6978 70.8612 12.6978C65.9716 12.6978 61.978 16.6914 61.978 21.581C61.978 23.1682 63.258 24.4482 64.8452 24.4482H86.2468C87.834 24.4482 89.114 23.1682 89.114 21.581C89.0628 17.6898 85.8884 14.4898 81.9716 14.4898ZM86.2212 23.5522H64.8196C63.7444 23.5522 62.874 22.6818 62.874 21.6066C62.874 17.2034 66.458 13.6194 70.8612 13.6194C73.4212 13.6194 75.7508 14.797 77.2612 16.845C77.338 16.9474 77.4404 17.0242 77.5684 17.0242C77.6964 17.0498 77.8244 16.9986 77.9268 16.9218C79.0532 15.949 80.4868 15.4114 81.9716 15.4114C85.3764 15.4114 88.1668 18.2018 88.1668 21.6066C88.1668 22.6818 87.2964 23.5522 86.2212 23.5522Z",
                fill: "#7799CC"
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kLtSv":[function(require,module,exports) {
module.exports = require("68ef7a37a0fd5483").getBundleURL("4oMEl") + "worker.2a57633e.png";

},{"68ef7a37a0fd5483":"c7Tr5"}],"3jo39":[function(require,module,exports) {
module.exports = require("d67b1398310c7e65").getBundleURL("4oMEl") + "placeholder.512da104.png";

},{"d67b1398310c7e65":"c7Tr5"}],"h7MUz":[function(require,module,exports) {
module.exports = require("fbf8fb7dc6dba474").getBundleURL("4oMEl") + "trailbluvideo.34f4d9e4.mp4";

},{"fbf8fb7dc6dba474":"c7Tr5"}],"1gu8p":[function(require,module,exports) {
module.exports = require("ddc21e0019886ac8").getBundleURL("4oMEl") + "coloredFibaBanka.7fb2db4a.png";

},{"ddc21e0019886ac8":"c7Tr5"}],"7ZdGm":[function(require,module,exports) {
module.exports = require("1759957ad9c257de").getBundleURL("4oMEl") + "coloredAktifBank.e775bc59.png";

},{"1759957ad9c257de":"c7Tr5"}],"4MzbP":[function(require,module,exports) {
module.exports = require("b5cffd45a1175938").getBundleURL("4oMEl") + "osigoLogo.92b5039a.png";

},{"b5cffd45a1175938":"c7Tr5"}],"dAahR":[function(require,module,exports) {
module.exports = require("4837c40a4ee5128a").getBundleURL("4oMEl") + "imeceLogo.b0b331fc.png";

},{"4837c40a4ee5128a":"c7Tr5"}],"3EslU":[function(require,module,exports) {
module.exports = require("c3b70cd067f127f7").getBundleURL("4oMEl") + "turkiyesigorta.8352a9cd.png";

},{"c3b70cd067f127f7":"c7Tr5"}],"iJWO5":[function(require,module,exports) {
module.exports = require("964805c95c81cb60").getBundleURL("4oMEl") + "mobile-web-app-testing.633577fe.svg";

},{"964805c95c81cb60":"c7Tr5"}],"dCDK5":[function(require,module,exports) {
module.exports = require("36394830da5d79a").getBundleURL("4oMEl") + "data-driven-testing.2b1a8bb7.svg";

},{"36394830da5d79a":"c7Tr5"}],"g0h4V":[function(require,module,exports) {
module.exports = require("67d60902553101b4").getBundleURL("4oMEl") + "visual-testing.d059f405.svg";

},{"67d60902553101b4":"c7Tr5"}],"lb6qu":[function(require,module,exports) {
module.exports = require("4665a0fbdd6a0b7a").getBundleURL("4oMEl") + "frame-17-1.cda09989.svg";

},{"4665a0fbdd6a0b7a":"c7Tr5"}],"7LFsY":[function(require,module,exports) {
module.exports = require("3c25060ee93849d5").getBundleURL("4oMEl") + "frame-17.f0731216.svg";

},{"3c25060ee93849d5":"c7Tr5"}],"j0rW0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoPng = require("../../assets/Logo.png");
var _logoPngDefault = parcelHelpers.interopDefault(_logoPng);
var _menuIconPng = require("../../assets/menuIcon.png");
var _menuIconPngDefault = parcelHelpers.interopDefault(_menuIconPng);
var _button = require("../Button/Button");
var _styleCss = require("./style.css");
var _reactRouterDom = require("react-router-dom");
var _reactScroll = require("react-scroll");
const Header = ()=>{
    const [menuVisible, setMenuVisible] = (0, _react.useState)(false);
    const toggleMenu = ()=>{
        setMenuVisible(!menuVisible);
    };
    const handleMenuItemClick = ()=>{
        setMenuVisible(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "HEADER",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "HEADER-CONTENT",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "/",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: (0, _logoPngDefault.default),
                        className: "tb",
                        alt: "Trailblu Logo"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "menu-icon",
                            src: (0, _menuIconPngDefault.default),
                            alt: "Trailblu Menu Icon",
                            style: {
                                width: "40px",
                                height: "auto",
                                cursor: "pointer"
                            },
                            onClick: toggleMenu
                        }),
                        menuVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "menu-dropdown",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                className: "menu-list",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "/blog",
                                            onClick: handleMenuItemClick,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                className: "design-component-instance-node-small",
                                                stateProp: "normal",
                                                style: "text",
                                                text: "Blog",
                                                type: "regular"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "/documentation",
                                            onClick: handleMenuItemClick,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                className: "design-component-instance-node-small",
                                                stateProp: "normal",
                                                style: "text",
                                                text: "Documentation",
                                                type: "regular"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://web.trailblu.com/login",
                                            onClick: handleMenuItemClick,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                className: "design-component-instance-node-small",
                                                stateProp: "normal",
                                                style: "text",
                                                text: "Log in",
                                                type: "regular"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "/request-a-demo",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                className: "button-2-small",
                                                stateProp: "normal",
                                                style: "solid",
                                                text: "Try for Free",
                                                type: "cta"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "/blog",
                            onClick: handleMenuItemClick,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "design-component-instance-node-large",
                                stateProp: "normal",
                                style: "text",
                                text: "Blog",
                                type: "regular"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "/documentation",
                            onClick: handleMenuItemClick,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "design-component-instance-node-large",
                                stateProp: "normal",
                                style: "text",
                                text: "Documentation",
                                type: "regular"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://web.trailblu.com/login",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "design-component-instance-node-large",
                                stateProp: "normal",
                                style: "text",
                                text: "Log in",
                                type: "regular"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "/request-a-demo",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "button-2-large",
                                stateProp: "normal",
                                style: "solid",
                                text: "Try for Free",
                                type: "cta"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = Header;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../assets/Logo.png":"22Rfz","../../assets/menuIcon.png":"9u5xF","../Button/Button":"jAaxT","./style.css":"jQowP","react-router-dom":"l6ORY","react-scroll":"dXHyb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"22Rfz":[function(require,module,exports) {
module.exports = require("6149b74e6a4e743").getBundleURL("4oMEl") + "Logo.d59ea1f7.png";

},{"6149b74e6a4e743":"c7Tr5"}],"9u5xF":[function(require,module,exports) {
module.exports = require("51ddb1d337690959").getBundleURL("4oMEl") + "menuIcon.fb1f72dc.png";

},{"51ddb1d337690959":"c7Tr5"}],"jQowP":[function() {},{}],"dXHyb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;
var _Link = require("38580495ff8c469");
var _Link2 = _interopRequireDefault(_Link);
var _Button = require("b951e2c8cc4f4951");
var _Button2 = _interopRequireDefault(_Button);
var _Element = require("1c7a1a5378d3222a");
var _Element2 = _interopRequireDefault(_Element);
var _scroller = require("c66a13f88b64a06e");
var _scroller2 = _interopRequireDefault(_scroller);
var _scrollEvents = require("c7ab12265b733b81");
var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
var _scrollSpy = require("9a976dc95b346ec9");
var _scrollSpy2 = _interopRequireDefault(_scrollSpy);
var _animateScroll = require("87c52f00cb7c8b12");
var _animateScroll2 = _interopRequireDefault(_animateScroll);
var _scrollLink = require("7ffe93662d8c693e");
var _scrollLink2 = _interopRequireDefault(_scrollLink);
var _scrollElement = require("7901e79c6f94853a");
var _scrollElement2 = _interopRequireDefault(_scrollElement);
var _Helpers = require("3b8d20f97964b509");
var _Helpers2 = _interopRequireDefault(_Helpers);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = {
    Link: _Link2.default,
    Button: _Button2.default,
    Element: _Element2.default,
    scroller: _scroller2.default,
    Events: _scrollEvents2.default,
    scrollSpy: _scrollSpy2.default,
    animateScroll: _animateScroll2.default,
    ScrollLink: _scrollLink2.default,
    ScrollElement: _scrollElement2.default,
    Helpers: _Helpers2.default
};

},{"38580495ff8c469":"8DQ32","b951e2c8cc4f4951":"biJYd","1c7a1a5378d3222a":"8OX8o","c66a13f88b64a06e":"013jD","c7ab12265b733b81":"f1RZP","9a976dc95b346ec9":"fAI1L","87c52f00cb7c8b12":"braoi","7ffe93662d8c693e":"fN0Wv","7901e79c6f94853a":"xV3eL","3b8d20f97964b509":"4Ba4H"}],"8DQ32":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("8a64b4ca04c41da8");
var _react2 = _interopRequireDefault(_react);
var _scrollLink = require("d8bcf590fbdcc262");
var _scrollLink2 = _interopRequireDefault(_scrollLink);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var LinkElement = function(_React$Component) {
    _inherits(LinkElement, _React$Component);
    function LinkElement() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, LinkElement);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.render = function() {
            return _react2.default.createElement("a", _this.props, _this.props.children);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    return LinkElement;
}(_react2.default.Component);
exports.default = (0, _scrollLink2.default)(LinkElement);

},{"8a64b4ca04c41da8":"6uln9","d8bcf590fbdcc262":"fN0Wv"}],"fN0Wv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("bc981e3f5a0c50a5");
var _react2 = _interopRequireDefault(_react);
var _scrollSpy = require("538f636feac93d82");
var _scrollSpy2 = _interopRequireDefault(_scrollSpy);
var _scroller = require("7b6e26f23c7cf77d");
var _scroller2 = _interopRequireDefault(_scroller);
var _propTypes = require("5c6c0289d4bc0021");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _scrollHash = require("3fbd2cfed8d4bb6a");
var _scrollHash2 = _interopRequireDefault(_scrollHash);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var protoTypes = {
    to: _propTypes2.default.string.isRequired,
    containerId: _propTypes2.default.string,
    container: _propTypes2.default.object,
    activeClass: _propTypes2.default.string,
    activeStyle: _propTypes2.default.object,
    spy: _propTypes2.default.bool,
    horizontal: _propTypes2.default.bool,
    smooth: _propTypes2.default.oneOfType([
        _propTypes2.default.bool,
        _propTypes2.default.string
    ]),
    offset: _propTypes2.default.number,
    delay: _propTypes2.default.number,
    isDynamic: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    duration: _propTypes2.default.oneOfType([
        _propTypes2.default.number,
        _propTypes2.default.func
    ]),
    absolute: _propTypes2.default.bool,
    onSetActive: _propTypes2.default.func,
    onSetInactive: _propTypes2.default.func,
    ignoreCancelEvents: _propTypes2.default.bool,
    hashSpy: _propTypes2.default.bool,
    saveHashHistory: _propTypes2.default.bool,
    spyThrottle: _propTypes2.default.number
};
exports.default = function(Component, customScroller) {
    var scroller = customScroller || _scroller2.default;
    var Link = function(_React$PureComponent) {
        _inherits(Link, _React$PureComponent);
        function Link(props) {
            _classCallCheck(this, Link);
            var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
            _initialiseProps.call(_this);
            _this.state = {
                active: false
            };
            return _this;
        }
        _createClass(Link, [
            {
                key: "getScrollSpyContainer",
                value: function getScrollSpyContainer() {
                    var containerId = this.props.containerId;
                    var container = this.props.container;
                    if (containerId && !container) return document.getElementById(containerId);
                    if (container && container.nodeType) return container;
                    return document;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.props.spy || this.props.hashSpy) {
                        var scrollSpyContainer = this.getScrollSpyContainer();
                        if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
                        if (this.props.hashSpy) {
                            if (!_scrollHash2.default.isMounted()) _scrollHash2.default.mount(scroller);
                            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
                        }
                        _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);
                        this.setState({
                            container: scrollSpyContainer
                        });
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
                }
            },
            {
                key: "render",
                value: function render() {
                    var className = "";
                    if (this.state && this.state.active) className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                    else className = this.props.className;
                    var style = {};
                    if (this.state && this.state.active) style = _extends({}, this.props.style, this.props.activeStyle);
                    else style = _extends({}, this.props.style);
                    var props = _extends({}, this.props);
                    for(var prop in protoTypes)if (props.hasOwnProperty(prop)) delete props[prop];
                    props.className = className;
                    props.style = style;
                    props.onClick = this.handleClick;
                    return _react2.default.createElement(Component, props);
                }
            }
        ]);
        return Link;
    }(_react2.default.PureComponent);
    var _initialiseProps = function _initialiseProps() {
        var _this2 = this;
        this.scrollTo = function(to, props) {
            scroller.scrollTo(to, _extends({}, _this2.state, props));
        };
        this.handleClick = function(event) {
            /*
       * give the posibility to override onClick
       */ if (_this2.props.onClick) _this2.props.onClick(event);
            /*
       * dont bubble the navigation
       */ if (event.stopPropagation) event.stopPropagation();
            if (event.preventDefault) event.preventDefault();
            /*
       * do the magic!
       */ _this2.scrollTo(_this2.props.to, _this2.props);
        };
        this.spyHandler = function(x, y) {
            var scrollSpyContainer = _this2.getScrollSpyContainer();
            if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) return;
            var horizontal = _this2.props.horizontal;
            var to = _this2.props.to;
            var element = null;
            var isInside = void 0;
            var isOutside = void 0;
            if (horizontal) {
                var elemLeftBound = 0;
                var elemRightBound = 0;
                var containerLeft = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerLeft = containerCords.left;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var cords = element.getBoundingClientRect();
                    elemLeftBound = cords.left - containerLeft + x;
                    elemRightBound = elemLeftBound + cords.width;
                }
                var offsetX = x - _this2.props.offset;
                isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
                isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
            } else {
                var elemTopBound = 0;
                var elemBottomBound = 0;
                var containerTop = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var _containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerTop = _containerCords.top;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var _cords = element.getBoundingClientRect();
                    elemTopBound = _cords.top - containerTop + y;
                    elemBottomBound = elemTopBound + _cords.height;
                }
                var offsetY = y - _this2.props.offset;
                isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
                isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
            }
            var activeLink = scroller.getActiveLink();
            if (isOutside) {
                if (to === activeLink) scroller.setActiveLink(void 0);
                if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
                    var _props$saveHashHistor = _this2.props.saveHashHistory, saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;
                    _scrollHash2.default.changeHash("", saveHashHistory);
                }
                if (_this2.props.spy && _this2.state.active) {
                    _this2.setState({
                        active: false
                    });
                    _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
                }
            }
            if (isInside && (activeLink !== to || _this2.state.active === false)) {
                scroller.setActiveLink(to);
                var _props$saveHashHistor2 = _this2.props.saveHashHistory, _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;
                _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);
                if (_this2.props.spy) {
                    _this2.setState({
                        active: true
                    });
                    _this2.props.onSetActive && _this2.props.onSetActive(to, element);
                }
            }
        };
    };
    Link.propTypes = protoTypes;
    Link.defaultProps = {
        offset: 0
    };
    return Link;
};

},{"bc981e3f5a0c50a5":"6uln9","538f636feac93d82":"fAI1L","7b6e26f23c7cf77d":"013jD","5c6c0289d4bc0021":"6FKs7","3fbd2cfed8d4bb6a":"26Ex6"}],"fAI1L":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _lodash = require("e23cd3a4eafb9980");
var _lodash2 = _interopRequireDefault(_lodash);
var _passiveEventListeners = require("4b1c095f54f04b90");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
    var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
    return (0, _lodash2.default)(eventHandler, throttleAmount);
};
var scrollSpy = {
    spyCallbacks: [],
    spySetState: [],
    scrollSpyContainers: [],
    mount: function mount(scrollSpyContainer, throttle) {
        if (scrollSpyContainer) {
            var eventHandler = eventThrottler(function(event) {
                scrollSpy.scrollHandler(scrollSpyContainer);
            }, throttle);
            scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
            (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, "scroll", eventHandler);
        }
    },
    isMounted: function isMounted(scrollSpyContainer) {
        return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
    },
    currentPositionX: function currentPositionX(scrollSpyContainer) {
        if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageYOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
        } else return scrollSpyContainer.scrollLeft;
    },
    currentPositionY: function currentPositionY(scrollSpyContainer) {
        if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageXOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
        } else return scrollSpyContainer.scrollTop;
    },
    scrollHandler: function scrollHandler(scrollSpyContainer) {
        var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
        callbacks.forEach(function(c) {
            return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
        });
    },
    addStateHandler: function addStateHandler(handler) {
        scrollSpy.spySetState.push(handler);
    },
    addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
        var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];
        if (!container.spyCallbacks) container.spyCallbacks = [];
        container.spyCallbacks.push(handler);
        handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    },
    updateStates: function updateStates() {
        scrollSpy.spySetState.forEach(function(s) {
            return s();
        });
    },
    unmount: function unmount(stateHandler, spyHandler) {
        scrollSpy.scrollSpyContainers.forEach(function(c) {
            return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
        });
        if (scrollSpy.spySetState && scrollSpy.spySetState.length && scrollSpy.spySetState.indexOf(stateHandler) > -1) scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
        document.removeEventListener("scroll", scrollSpy.scrollHandler);
    },
    update: function update() {
        return scrollSpy.scrollSpyContainers.forEach(function(c) {
            return scrollSpy.scrollHandler(c);
        });
    }
};
exports.default = scrollSpy;

},{"e23cd3a4eafb9980":"11Vy1","4b1c095f54f04b90":"2f3OO"}],"11Vy1":[function(require,module,exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    if (isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace(reTrim, "");
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = throttle;

},{}],"2f3OO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */ var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
    var listenerName = listener.name;
    if (!listenerName) {
        listenerName = eventName;
        console.warn("Listener must be a named function.");
    }
    if (!attachedListeners.has(eventName)) attachedListeners.set(eventName, new Set());
    var listeners = attachedListeners.get(eventName);
    if (listeners.has(listenerName)) return;
    var supportsPassiveOption = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function get() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("test", null, opts);
        } catch (e) {}
        return supportsPassiveOption;
    }();
    target.addEventListener(eventName, listener, supportsPassiveOption ? {
        passive: true
    } : false);
    listeners.add(listenerName);
};
var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
    target.removeEventListener(eventName, listener);
    attachedListeners.get(eventName).delete(listener.name || eventName);
};
var attachedListeners = new Map();

},{}],"013jD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _utils = require("ffb60f8465a16056");
var _utils2 = _interopRequireDefault(_utils);
var _animateScroll = require("be6cb14e66cb5035");
var _animateScroll2 = _interopRequireDefault(_animateScroll);
var _scrollEvents = require("722f3b680fb3baca");
var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var __mapped = {};
var __activeLink = void 0;
exports.default = {
    unmount: function unmount() {
        __mapped = {};
    },
    register: function register(name, element) {
        __mapped[name] = element;
    },
    unregister: function unregister(name) {
        delete __mapped[name];
    },
    get: function get(name) {
        return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
    },
    setActiveLink: function setActiveLink(link) {
        return __activeLink = link;
    },
    getActiveLink: function getActiveLink() {
        return __activeLink;
    },
    scrollTo: function scrollTo(to, props) {
        var target = this.get(to);
        if (!target) {
            console.warn("target Element not found");
            return;
        }
        props = _extends({}, props, {
            absolute: false
        });
        var containerId = props.containerId;
        var container = props.container;
        var containerElement = void 0;
        if (containerId) containerElement = document.getElementById(containerId);
        else if (container && container.nodeType) containerElement = container;
        else containerElement = document;
        props.absolute = true;
        var horizontal = props.horizontal;
        var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);
        /*
     * if animate is not provided just scroll into the view
     */ if (!props.smooth) {
            if (_scrollEvents2.default.registered["begin"]) _scrollEvents2.default.registered["begin"](to, target);
            if (containerElement === document) {
                if (props.horizontal) window.scrollTo(scrollOffset, 0);
                else window.scrollTo(0, scrollOffset);
            } else containerElement.scrollTop = scrollOffset;
            if (_scrollEvents2.default.registered["end"]) _scrollEvents2.default.registered["end"](to, target);
            return;
        }
        /*
     * Animate scrolling
     */ _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
    }
};

},{"ffb60f8465a16056":"axGuX","be6cb14e66cb5035":"braoi","722f3b680fb3baca":"f1RZP"}],"axGuX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
    var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
    var hashToUpdate = hashVal ? "#" + hashVal : "";
    var curLoc = window && window.location;
    var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
    historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};
var getHash = function getHash() {
    return window.location.hash.replace(/^#/, "");
};
var filterElementInContainer = function filterElementInContainer(container) {
    return function(element) {
        return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
    };
};
var isPositioned = function isPositioned(element) {
    return getComputedStyle(element).position !== "static";
};
var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
    var offsetTop = element.offsetTop;
    var currentOffsetParent = element.offsetParent;
    while(currentOffsetParent && !predicate(currentOffsetParent)){
        offsetTop += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    return {
        offsetTop: offsetTop,
        offsetParent: currentOffsetParent
    };
};
var scrollOffset = function scrollOffset(c, t, horizontal) {
    if (horizontal) return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
    else {
        if (c === document) return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
        // The offsetParent of an element, according to MDN, is its nearest positioned
        // (an element whose position is anything other than static) ancestor. The offsetTop
        // of an element is taken with respect to its offsetParent which may not neccessarily
        // be its parentElement except the parent itself is positioned.
        // So if containerElement is positioned, then it must be an offsetParent somewhere
        // If it happens that targetElement is a descendant of the containerElement, and there
        // is not intermediate positioned element between the two of them, i.e.
        // targetElement"s offsetParent is the same as the containerElement, then the
        // distance between the two will be the offsetTop of the targetElement.
        // If, on the other hand, there are intermediate positioned elements between the
        // two entities, the distance between the targetElement and the containerElement
        // will be the accumulation of the offsetTop of the element and that of its
        // subsequent offsetParent until the containerElement is reached, since it
        // will also be an offsetParent at some point due to the fact that it is positioned.
        // If the containerElement is not positioned, then it can"t be an offsetParent,
        // which means that the offsetTop of the targetElement would not be with respect to it.
        // However, if the two of them happen to have the same offsetParent, then
        // the distance between them will be the difference between their offsetTop
        // since they are both taken with respect to the same entity.
        // The last resort would be to accumulate their offsetTop until a common
        // offsetParent is reached (usually the document) and taking the difference
        // between the accumulated offsetTops
        if (isPositioned(c)) {
            if (t.offsetParent !== c) {
                var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
                    return e === c || e === document;
                };
                var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument), offsetTop = _getElementOffsetInfo.offsetTop, offsetParent = _getElementOffsetInfo.offsetParent;
                if (offsetParent !== c) throw new Error("Seems containerElement is not an ancestor of the Element");
                return offsetTop;
            }
            return t.offsetTop;
        }
        if (t.offsetParent === c.offsetParent) return t.offsetTop - c.offsetTop;
        var isDocument = function isDocument(e) {
            return e === document;
        };
        return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
    }
};
exports.default = {
    updateHash: updateHash,
    getHash: getHash,
    filterElementInContainer: filterElementInContainer,
    scrollOffset: scrollOffset
};

},{}],"braoi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _utils = require("d7560461a72326d3");
var _utils2 = _interopRequireDefault(_utils);
var _smooth = require("6a253c36956bd8bc");
var _smooth2 = _interopRequireDefault(_smooth);
var _cancelEvents = require("a36225ec02b7a554");
var _cancelEvents2 = _interopRequireDefault(_cancelEvents);
var _scrollEvents = require("1fda2410c947d412");
var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * Gets the easing type from the smooth prop within options.
 */ var getAnimationType = function getAnimationType(options) {
    return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */ var functionWrapper = function functionWrapper(value) {
    return typeof value === "function" ? value : function() {
        return value;
    };
};
/*
 * Wraps window properties to allow server side rendering
 */ var currentWindowProperties = function currentWindowProperties() {
    if (typeof window !== "undefined") return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
};
/*
 * Helper function to never extend 60fps on the webpage.
 */ var requestAnimationFrameHelper = function() {
    return currentWindowProperties() || function(callback, element, delay) {
        window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
    };
}();
var makeData = function makeData() {
    return {
        currentPosition: 0,
        startPosition: 0,
        targetPosition: 0,
        progress: 0,
        duration: 0,
        cancel: false,
        target: null,
        containerElement: null,
        to: null,
        start: null,
        delta: null,
        percent: null,
        delayTimeout: null
    };
};
var currentPositionX = function currentPositionX(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollLeft;
    else {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    }
};
var currentPositionY = function currentPositionY(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollTop;
    else {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    }
};
var scrollContainerWidth = function scrollContainerWidth(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollWidth - containerElement.offsetWidth;
    else {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
    }
};
var scrollContainerHeight = function scrollContainerHeight(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollHeight - containerElement.offsetHeight;
    else {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    }
};
var animateScroll = function animateScroll(easing, options, timestamp) {
    var data = options.data;
    // Cancel on specific events
    if (!options.ignoreCancelEvents && data.cancel) {
        if (_scrollEvents2.default.registered["end"]) _scrollEvents2.default.registered["end"](data.to, data.target, data.currentPositionY);
        return;
    }
    data.delta = Math.round(data.targetPosition - data.startPosition);
    if (data.start === null) data.start = timestamp;
    data.progress = timestamp - data.start;
    data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);
    data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);
    if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
        if (options.horizontal) data.containerElement.scrollLeft = data.currentPosition;
        else data.containerElement.scrollTop = data.currentPosition;
    } else if (options.horizontal) window.scrollTo(data.currentPosition, 0);
    else window.scrollTo(0, data.currentPosition);
    if (data.percent < 1) {
        var easedAnimate = animateScroll.bind(null, easing, options);
        requestAnimationFrameHelper.call(window, easedAnimate);
        return;
    }
    if (_scrollEvents2.default.registered["end"]) _scrollEvents2.default.registered["end"](data.to, data.target, data.currentPosition);
};
var setContainer = function setContainer(options) {
    options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};
var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
    options.data = options.data || makeData();
    window.clearTimeout(options.data.delayTimeout);
    var setCancel = function setCancel() {
        options.data.cancel = true;
    };
    _cancelEvents2.default.subscribe(setCancel);
    setContainer(options);
    options.data.start = null;
    options.data.cancel = false;
    options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
    options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;
    if (options.data.startPosition === options.data.targetPosition) {
        if (_scrollEvents2.default.registered["end"]) _scrollEvents2.default.registered["end"](options.data.to, options.data.target, options.data.currentPosition);
        return;
    }
    options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);
    options.data.duration = functionWrapper(options.duration)(options.data.delta);
    options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
    options.data.to = to;
    options.data.target = target;
    var easing = getAnimationType(options);
    var easedAnimate = animateScroll.bind(null, easing, options);
    if (options && options.delay > 0) {
        options.data.delayTimeout = window.setTimeout(function() {
            if (_scrollEvents2.default.registered["begin"]) _scrollEvents2.default.registered["begin"](options.data.to, options.data.target);
            requestAnimationFrameHelper.call(window, easedAnimate);
        }, options.delay);
        return;
    }
    if (_scrollEvents2.default.registered["begin"]) _scrollEvents2.default.registered["begin"](options.data.to, options.data.target);
    requestAnimationFrameHelper.call(window, easedAnimate);
};
var proceedOptions = function proceedOptions(options) {
    options = _extends({}, options);
    options.data = options.data || makeData();
    options.absolute = true;
    return options;
};
var scrollToTop = function scrollToTop(options) {
    animateTopScroll(0, proceedOptions(options));
};
var scrollTo = function scrollTo(toPosition, options) {
    animateTopScroll(toPosition, proceedOptions(options));
};
var scrollToBottom = function scrollToBottom(options) {
    options = proceedOptions(options);
    setContainer(options);
    animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};
var scrollMore = function scrollMore(toPosition, options) {
    options = proceedOptions(options);
    setContainer(options);
    var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
    animateTopScroll(toPosition + currentPosition, options);
};
exports.default = {
    animateTopScroll: animateTopScroll,
    getAnimationType: getAnimationType,
    scrollToTop: scrollToTop,
    scrollToBottom: scrollToBottom,
    scrollTo: scrollTo,
    scrollMore: scrollMore
};

},{"d7560461a72326d3":"axGuX","6a253c36956bd8bc":"8qrRa","a36225ec02b7a554":"6D4MS","1fda2410c947d412":"f1RZP"}],"8qrRa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */ defaultEasing: function defaultEasing(x) {
        if (x < 0.5) return Math.pow(x * 2, 2) / 2;
        return 1 - Math.pow((1 - x) * 2, 2) / 2;
    },
    /*
   * https://gist.github.com/gre/1650294
   */ // no easing, no acceleration
    linear: function linear(x) {
        return x;
    },
    // accelerating from zero velocity
    easeInQuad: function easeInQuad(x) {
        return x * x;
    },
    // decelerating to zero velocity
    easeOutQuad: function easeOutQuad(x) {
        return x * (2 - x);
    },
    // acceleration until halfway, then deceleration
    easeInOutQuad: function easeInOutQuad(x) {
        return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
    },
    // accelerating from zero velocity 
    easeInCubic: function easeInCubic(x) {
        return x * x * x;
    },
    // decelerating to zero velocity π
    easeOutCubic: function easeOutCubic(x) {
        return --x * x * x + 1;
    },
    // acceleration until halfway, then deceleration 
    easeInOutCubic: function easeInOutCubic(x) {
        return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
    },
    // accelerating from zero velocity 
    easeInQuart: function easeInQuart(x) {
        return x * x * x * x;
    },
    // decelerating to zero velocity 
    easeOutQuart: function easeOutQuart(x) {
        return 1 - --x * x * x * x;
    },
    // acceleration until halfway, then deceleration
    easeInOutQuart: function easeInOutQuart(x) {
        return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
    },
    // accelerating from zero velocity
    easeInQuint: function easeInQuint(x) {
        return x * x * x * x * x;
    },
    // decelerating to zero velocity
    easeOutQuint: function easeOutQuint(x) {
        return 1 + --x * x * x * x * x;
    },
    // acceleration until halfway, then deceleration 
    easeInOutQuint: function easeInOutQuint(x) {
        return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
    }
};

},{}],"6D4MS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _passiveEventListeners = require("fc400580db1a5f53");
var events = [
    "mousedown",
    "mousewheel",
    "touchmove",
    "keydown"
];
exports.default = {
    subscribe: function subscribe(cancelEvent) {
        return typeof document !== "undefined" && events.forEach(function(event) {
            return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
        });
    }
};

},{"fc400580db1a5f53":"2f3OO"}],"f1RZP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var Events = {
    registered: {},
    scrollEvent: {
        register: function register(evtName, callback) {
            Events.registered[evtName] = callback;
        },
        remove: function remove(evtName) {
            Events.registered[evtName] = null;
        }
    }
};
exports.default = Events;

},{}],"26Ex6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _passiveEventListeners = require("7beb828a4a93d88");
var _utils = require("e4bb8e4ec292c8bb");
var _utils2 = _interopRequireDefault(_utils);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var scrollHash = {
    mountFlag: false,
    initialized: false,
    scroller: null,
    containers: {},
    mount: function mount(scroller) {
        this.scroller = scroller;
        this.handleHashChange = this.handleHashChange.bind(this);
        window.addEventListener("hashchange", this.handleHashChange);
        this.initStateFromHash();
        this.mountFlag = true;
    },
    mapContainer: function mapContainer(to, container) {
        this.containers[to] = container;
    },
    isMounted: function isMounted() {
        return this.mountFlag;
    },
    isInitialized: function isInitialized() {
        return this.initialized;
    },
    initStateFromHash: function initStateFromHash() {
        var _this = this;
        var hash = this.getHash();
        if (hash) window.setTimeout(function() {
            _this.scrollTo(hash, true);
            _this.initialized = true;
        }, 10);
        else this.initialized = true;
    },
    scrollTo: function scrollTo(to, isInit) {
        var scroller = this.scroller;
        var element = scroller.get(to);
        if (element && (isInit || to !== scroller.getActiveLink())) {
            var container = this.containers[to] || document;
            scroller.scrollTo(to, {
                container: container
            });
        }
    },
    getHash: function getHash() {
        return _utils2.default.getHash();
    },
    changeHash: function changeHash(to, saveHashHistory) {
        if (this.isInitialized() && _utils2.default.getHash() !== to) _utils2.default.updateHash(to, saveHashHistory);
    },
    handleHashChange: function handleHashChange() {
        this.scrollTo(this.getHash());
    },
    unmount: function unmount() {
        this.scroller = null;
        this.containers = null;
        window.removeEventListener("hashchange", this.handleHashChange);
    }
};
exports.default = scrollHash;

},{"7beb828a4a93d88":"2f3OO","e4bb8e4ec292c8bb":"axGuX"}],"biJYd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("55802ee72fe2e337");
var _react2 = _interopRequireDefault(_react);
var _scrollLink = require("781c5cde30679faa");
var _scrollLink2 = _interopRequireDefault(_scrollLink);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ButtonElement = function(_React$Component) {
    _inherits(ButtonElement, _React$Component);
    function ButtonElement() {
        _classCallCheck(this, ButtonElement);
        return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
    }
    _createClass(ButtonElement, [
        {
            key: "render",
            value: function render() {
                return _react2.default.createElement("button", this.props, this.props.children);
            }
        }
    ]);
    return ButtonElement;
}(_react2.default.Component);
exports.default = (0, _scrollLink2.default)(ButtonElement);

},{"55802ee72fe2e337":"6uln9","781c5cde30679faa":"fN0Wv"}],"8OX8o":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("e536cc8b73656c95");
var _react2 = _interopRequireDefault(_react);
var _scrollElement = require("8b0e7539de992d2c");
var _scrollElement2 = _interopRequireDefault(_scrollElement);
var _propTypes = require("acc02e77696c83c3");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ElementWrapper = function(_React$Component) {
    _inherits(ElementWrapper, _React$Component);
    function ElementWrapper() {
        _classCallCheck(this, ElementWrapper);
        return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
    }
    _createClass(ElementWrapper, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // Remove `parentBindings` and `name` from props
                var newProps = _extends({}, this.props);
                delete newProps.name;
                if (newProps.parentBindings) delete newProps.parentBindings;
                return _react2.default.createElement("div", _extends({}, newProps, {
                    ref: function ref(el) {
                        _this2.props.parentBindings.domNode = el;
                    }
                }), this.props.children);
            }
        }
    ]);
    return ElementWrapper;
}(_react2.default.Component);
ElementWrapper.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
};
exports.default = (0, _scrollElement2.default)(ElementWrapper);

},{"e536cc8b73656c95":"6uln9","8b0e7539de992d2c":"xV3eL","acc02e77696c83c3":"6FKs7"}],"xV3eL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("760153a166ff83b7");
var _react2 = _interopRequireDefault(_react);
var _reactDom = require("e4b5bf24f01a075d");
var _reactDom2 = _interopRequireDefault(_reactDom);
var _scroller = require("ce5692ed9ea631c8");
var _scroller2 = _interopRequireDefault(_scroller);
var _propTypes = require("2395b84592c539ce");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
exports.default = function(Component) {
    var Element = function(_React$Component) {
        _inherits(Element, _React$Component);
        function Element(props) {
            _classCallCheck(this, Element);
            var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
            _this.childBindings = {
                domNode: null
            };
            return _this;
        }
        _createClass(Element, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (typeof window === "undefined") return false;
                    this.registerElems(this.props.name);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.name !== prevProps.name) this.registerElems(this.props.name);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (typeof window === "undefined") return false;
                    _scroller2.default.unregister(this.props.name);
                }
            },
            {
                key: "registerElems",
                value: function registerElems(name) {
                    _scroller2.default.register(name, this.childBindings.domNode);
                }
            },
            {
                key: "render",
                value: function render() {
                    return _react2.default.createElement(Component, _extends({}, this.props, {
                        parentBindings: this.childBindings
                    }));
                }
            }
        ]);
        return Element;
    }(_react2.default.Component);
    Element.propTypes = {
        name: _propTypes2.default.string,
        id: _propTypes2.default.string
    };
    return Element;
};

},{"760153a166ff83b7":"6uln9","e4b5bf24f01a075d":"b8T3j","ce5692ed9ea631c8":"013jD","2395b84592c539ce":"6FKs7"}],"4Ba4H":[function(require,module,exports) {
"use strict";
/* DEPRECATED */ var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var React = require("27fd02529ac47b82");
var ReactDOM = require("3117bbb6b711d7e5");
var utils = require("cd03f1ae200afdd6");
var scrollSpy = require("2d399b4b573011ca");
var defaultScroller = require("378d0cca2a518cd2");
var PropTypes = require("728c6c9d575c68c8");
var scrollHash = require("ea55ecbd1db40fd7");
var protoTypes = {
    to: PropTypes.string.isRequired,
    containerId: PropTypes.string,
    container: PropTypes.object,
    activeClass: PropTypes.string,
    spy: PropTypes.bool,
    smooth: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
    ]),
    offset: PropTypes.number,
    delay: PropTypes.number,
    isDynamic: PropTypes.bool,
    onClick: PropTypes.func,
    duration: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.func
    ]),
    absolute: PropTypes.bool,
    onSetActive: PropTypes.func,
    onSetInactive: PropTypes.func,
    ignoreCancelEvents: PropTypes.bool,
    hashSpy: PropTypes.bool,
    spyThrottle: PropTypes.number
};
var Helpers = {
    Scroll: function Scroll(Component, customScroller) {
        console.warn("Helpers.Scroll is deprecated since v1.7.0");
        var scroller = customScroller || defaultScroller;
        var Scroll = function(_React$Component) {
            _inherits(Scroll, _React$Component);
            function Scroll(props) {
                _classCallCheck(this, Scroll);
                var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));
                _initialiseProps.call(_this);
                _this.state = {
                    active: false
                };
                return _this;
            }
            _createClass(Scroll, [
                {
                    key: "getScrollSpyContainer",
                    value: function getScrollSpyContainer() {
                        var containerId = this.props.containerId;
                        var container = this.props.container;
                        if (containerId) return document.getElementById(containerId);
                        if (container && container.nodeType) return container;
                        return document;
                    }
                },
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        if (this.props.spy || this.props.hashSpy) {
                            var scrollSpyContainer = this.getScrollSpyContainer();
                            if (!scrollSpy.isMounted(scrollSpyContainer)) scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
                            if (this.props.hashSpy) {
                                if (!scrollHash.isMounted()) scrollHash.mount(scroller);
                                scrollHash.mapContainer(this.props.to, scrollSpyContainer);
                            }
                            if (this.props.spy) scrollSpy.addStateHandler(this.stateHandler);
                            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);
                            this.setState({
                                container: scrollSpyContainer
                            });
                        }
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        scrollSpy.unmount(this.stateHandler, this.spyHandler);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var className = "";
                        if (this.state && this.state.active) className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                        else className = this.props.className;
                        var props = _extends({}, this.props);
                        for(var prop in protoTypes)if (props.hasOwnProperty(prop)) delete props[prop];
                        props.className = className;
                        props.onClick = this.handleClick;
                        return React.createElement(Component, props);
                    }
                }
            ]);
            return Scroll;
        }(React.Component);
        var _initialiseProps = function _initialiseProps() {
            var _this2 = this;
            this.scrollTo = function(to, props) {
                scroller.scrollTo(to, _extends({}, _this2.state, props));
            };
            this.handleClick = function(event) {
                /*
         * give the posibility to override onClick
         */ if (_this2.props.onClick) _this2.props.onClick(event);
                /*
         * dont bubble the navigation
         */ if (event.stopPropagation) event.stopPropagation();
                if (event.preventDefault) event.preventDefault();
                /*
         * do the magic!
         */ _this2.scrollTo(_this2.props.to, _this2.props);
            };
            this.stateHandler = function() {
                if (scroller.getActiveLink() !== _this2.props.to) {
                    if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) _this2.props.onSetInactive();
                    _this2.setState({
                        active: false
                    });
                }
            };
            this.spyHandler = function(y) {
                var scrollSpyContainer = _this2.getScrollSpyContainer();
                if (scrollHash.isMounted() && !scrollHash.isInitialized()) return;
                var to = _this2.props.to;
                var element = null;
                var elemTopBound = 0;
                var elemBottomBound = 0;
                var containerTop = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerTop = containerCords.top;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var cords = element.getBoundingClientRect();
                    elemTopBound = cords.top - containerTop + y;
                    elemBottomBound = elemTopBound + cords.height;
                }
                var offsetY = y - _this2.props.offset;
                var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
                var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
                var activeLink = scroller.getActiveLink();
                if (isOutside) {
                    if (to === activeLink) scroller.setActiveLink(void 0);
                    if (_this2.props.hashSpy && scrollHash.getHash() === to) scrollHash.changeHash();
                    if (_this2.props.spy && _this2.state.active) {
                        _this2.setState({
                            active: false
                        });
                        _this2.props.onSetInactive && _this2.props.onSetInactive();
                    }
                    return scrollSpy.updateStates();
                }
                if (isInside && activeLink !== to) {
                    scroller.setActiveLink(to);
                    _this2.props.hashSpy && scrollHash.changeHash(to);
                    if (_this2.props.spy) {
                        _this2.setState({
                            active: true
                        });
                        _this2.props.onSetActive && _this2.props.onSetActive(to);
                    }
                    return scrollSpy.updateStates();
                }
            };
        };
        Scroll.propTypes = protoTypes;
        Scroll.defaultProps = {
            offset: 0
        };
        return Scroll;
    },
    Element: function Element(Component) {
        console.warn("Helpers.Element is deprecated since v1.7.0");
        var Element = function(_React$Component2) {
            _inherits(Element, _React$Component2);
            function Element(props) {
                _classCallCheck(this, Element);
                var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
                _this3.childBindings = {
                    domNode: null
                };
                return _this3;
            }
            _createClass(Element, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        if (typeof window === "undefined") return false;
                        this.registerElems(this.props.name);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate(prevProps) {
                        if (this.props.name !== prevProps.name) this.registerElems(this.props.name);
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        if (typeof window === "undefined") return false;
                        defaultScroller.unregister(this.props.name);
                    }
                },
                {
                    key: "registerElems",
                    value: function registerElems(name) {
                        defaultScroller.register(name, this.childBindings.domNode);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        return React.createElement(Component, _extends({}, this.props, {
                            parentBindings: this.childBindings
                        }));
                    }
                }
            ]);
            return Element;
        }(React.Component);
        Element.propTypes = {
            name: PropTypes.string,
            id: PropTypes.string
        };
        return Element;
    }
};
module.exports = Helpers;

},{"27fd02529ac47b82":"6uln9","3117bbb6b711d7e5":"b8T3j","cd03f1ae200afdd6":"axGuX","2d399b4b573011ca":"fAI1L","378d0cca2a518cd2":"013jD","728c6c9d575c68c8":"6FKs7","ea55ecbd1db40fd7":"26Ex6"}],"2Br4S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _footerPng = require("../../assets/footer.png");
var _footerPngDefault = parcelHelpers.interopDefault(_footerPng);
var _capterraSvg = require("../../assets/capterra.svg");
var _capterraSvgDefault = parcelHelpers.interopDefault(_capterraSvg);
var _getAppPng = require("../../assets/getApp.png");
var _getAppPngDefault = parcelHelpers.interopDefault(_getAppPng);
var _reactRouterDom = require("react-router-dom");
var _styleCss = require("./style.css");
const Footer = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-29",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "footer",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: (0, _footerPngDefault.default),
                    className: "tb-1-1",
                    color: "#B4C6E7",
                    fill: "white",
                    alt: "Trailblu Footer Icon"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "text-wrapper-15",
                    children: [
                        "Copyright \xa9 ",
                        new Date().getFullYear(),
                        " TRAILBLU, Inc. All rights reserved"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-30",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-31",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper-16",
                                    children: "Resources"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/blog",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-17",
                                        children: "Blog"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/documentation",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-17",
                                        children: "Documentation"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-31",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper-compare",
                                    children: "Compare Us"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/alternatives",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-17",
                                        children: "Alternatives"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-31",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper-16",
                                    children: "Follow us"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        gap: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://twitter.com/trailblu",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "1.5em",
                                                viewBox: "0 0 512 512",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                    fill: "#ffffff",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://www.linkedin.com/company/trailblu/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "1.5em",
                                                viewBox: "0 0 448 512",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                    fill: "#ffffff",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "comment-bottom",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "capterra",
                            target: "_blank",
                            href: "https://www.capterra.com/p/10014205/TRAILBLU/#reviews",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _capterraSvgDefault.default),
                                alt: "Trailblu Capterra",
                                style: {
                                    borderRadius: "5%",
                                    display: "flex",
                                    width: "100%"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "getapp",
                            target: "_blank",
                            href: "https://www.getapp.com/it-management-software/a/trailblu/reviews/",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "getapp-img",
                                src: (0, _getAppPngDefault.default),
                                alt: "Trailblu GetApp"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = Footer;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../assets/footer.png":"jGetB","../../assets/capterra.svg":"5a5l8","../../assets/getApp.png":"jVwXD","react-router-dom":"l6ORY","./style.css":"a42kI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jGetB":[function(require,module,exports) {
module.exports = require("39ab7f2867765b29").getBundleURL("4oMEl") + "footer.37a846b1.png";

},{"39ab7f2867765b29":"c7Tr5"}],"5a5l8":[function(require,module,exports) {
module.exports = require("c07d7b18d901518b").getBundleURL("4oMEl") + "capterra.7a47a480.svg";

},{"c07d7b18d901518b":"c7Tr5"}],"jVwXD":[function(require,module,exports) {
module.exports = require("85c040457a40e57d").getBundleURL("4oMEl") + "getApp.8409d752.png";

},{"85c040457a40e57d":"c7Tr5"}],"a42kI":[function() {},{}],"1rplF":[function(require,module,exports) {
module.exports = require("188a464eb5d261dd").getBundleURL("4oMEl") + "TrailbluIntro.da3a49e6.png";

},{"188a464eb5d261dd":"c7Tr5"}],"3Iv0m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alternatives", ()=>Alternatives);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("../../components/Header/Header"); // Import your Header component
var _headerDefault = parcelHelpers.interopDefault(_header);
var _styleCss = require("./style.css"); // Import your CSS file for Blog styling
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _button = require("../../components/Button");
var _reactHelmetAsync = require("react-helmet-async");
var _trailbluIntroPng = require("../../assets/TrailbluIntro.png");
var _trailbluIntroPngDefault = parcelHelpers.interopDefault(_trailbluIntroPng);
const Alternatives = ()=>{
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main-3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                        children: "Trailblu vs Competitors: A Test Automation Showdown"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "description",
                        content: "Explore Trailblu's direct comparisons with leading test automation tools. Discover the benefits of Trailblu's innovative products. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "keywords",
                        content: "test automation tools, Trailblu alternatives, Appium, TestCraft, Katalon, Preflight, Cypress, Browserstack, TestProject, Functionize, Reflect, Testim.io, Selenium, Mabl, Ghost Inspector, LambdaTest, compare tools"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Explore Alternatives to Trailblu: Test Automation Tools Comparison"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:description",
                        content: "Discover various test automation tools as alternatives to Trailblu. Compare features, capabilities, and functionalities of Appium, TestCraft, Katalon, Preflight, Cypress, Browserstack, TestProject, Functionize, Reflect, Testim.io, Selenium, Mabl, Ghost Inspector, LambdaTest, and more."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image",
                        content: (0, _trailbluIntroPngDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: "TRAILBLU Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:card",
                        content: " summary_large_image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@trailblu"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:title",
                        content: "Explore Alternatives to Trailblu: Test Automation Tools Comparison"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:description",
                        content: "Discover various test automation tools as alternatives to Trailblu. Compare features, capabilities, and functionalities of Appium, TestCraft, Katalon, Preflight, Cypress, Browserstack, TestProject, Functionize, Reflect, Testim.io, Selenium, Mabl, Ghost Inspector, LambdaTest, and more."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image",
                        content: (0, _trailbluIntroPngDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image:alt",
                        content: "TRAILBLU Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.trailblu.com/alternatives"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hero-section-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "bottom"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                            className: "h1-class-alter",
                            children: [
                                "Uncovering",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "primary-color",
                                    children: " TRAILBLU:"
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "h1-class-alter",
                            children: "A Comprehensive Evaluation Against Competitors"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "center-bottom",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "h3-class-3",
                                children: "Explore Trailblu's Direct Comparison Against Leading Test Automation Tools"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "alternatives-section",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "altenatives",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "alternative-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "alternatives/trailblu-vs-Appium",
                                    className: "alternative-link",
                                    children: "Trailblu vs Appium"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Katalon",
                                    className: "alternative-link",
                                    children: "Trailblu vs Katalon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Preflight",
                                    className: "alternative-link",
                                    children: "Trailblu vs Preflight"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Cypress",
                                    className: "alternative-link",
                                    children: "Trailblu vs Cypress"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "alternative",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Selenium",
                                    className: "alternative-link",
                                    children: "Trailblu vs Selenium"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Functionize",
                                    className: "alternative-link",
                                    children: "Trailblu vs Functionize"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Reflect",
                                    className: "alternative-link",
                                    children: "Trailblu vs Reflect"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Testim.io",
                                    className: "alternative-link",
                                    children: "Trailblu vs Testim.io"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "alternative-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Mabl",
                                    className: "alternative-link",
                                    children: "Trailblu vs Mabl"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Ghost-Inspector",
                                    className: "alternative-link",
                                    children: "Trailblu vs Ghost Inspector"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-LambdaTest",
                                    className: "alternative-link",
                                    children: "Trailblu vs LambdaTest"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/alternatives/trailblu-vs-Sauce-Labs",
                                    className: "alternative-link",
                                    children: "Trailblu vs Sauce Labs"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "comparison-bottom-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bottom-text-part",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "bottom-text-header",
                                children: "Looking for a comprehensive testing solution that simplifies your test runs?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                className: "bottom-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "primary-color-2",
                                        children: " Trailblu"
                                    }),
                                    " provides a comprehensive platform designed for seamless test execution, simplifying the process across diverse testing needs. With its user-friendly interface and robust capabilities,",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "primary-color-2",
                                        children: " Trailblu"
                                    }),
                                    " ensures efficient and hassle-free test execution for various applications and scenarios."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "button-part",
                        href: "/request-a-demo",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            className: "design-component-instance-node-2",
                            stateProp: "normal",
                            style: "solid",
                            text: "Request a demo",
                            type: "regular"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = Alternatives;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Header/Header":"j0rW0","./style.css":"jw3nY","../../components/Footer/Footer":"2Br4S","../../components/Button":"d3NfG","react-helmet-async":"5Z9jX","../../assets/TrailbluIntro.png":"1rplF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jw3nY":[function() {},{}],"jpLAL":[function(require,module,exports) {
// src/screens/ArcadePage.jsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("../../components/Header/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _subscription = require("../../components/Subscription/Subscription");
var _subscriptionDefault = parcelHelpers.interopDefault(_subscription);
var _reactHelmetAsync = require("react-helmet-async");
var _iframeEmbed = require("../../components/IframeEmbed"); // Reusable iframe component
var _iframeEmbedDefault = parcelHelpers.interopDefault(_iframeEmbed);
var _styleCss = require("./style.css"); // Optional: For custom styling
const DocumentationPage = ()=>{
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                        children: "Trailblu Product Demos"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "description",
                        content: "Explore Trailblu's product demos and see our solutions in action."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "arcade-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iframeEmbedDefault.default), {
                    src: "https://app.arcade.software/share/collections/s17dWoHYUvlvEb0rsQT0?embed&show_copy_link=true&force_no_header=true",
                    title: "Trailblu Product Demos",
                    className: "arcade-collection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscriptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = DocumentationPage;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Header/Header":"j0rW0","../../components/Footer/Footer":"2Br4S","../../components/Subscription/Subscription":"8mH2y","react-helmet-async":"5Z9jX","../../components/IframeEmbed":"jmpXi","./style.css":"80P9Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8mH2y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("../../components/Button");
var _styleCss = require("./style.css");
const Subscription = ()=>{
    const [email, setEmail] = (0, _react.useState)("");
    const [subscribed, setSubscribed] = (0, _react.useState)(false);
    const handleEmailChange = (event)=>{
        setEmail(event.target.value);
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        // Add your subscription handling logic here using 'email' state
        console.log("Subscribed with email:", email);
        // Reset the email field after submission
        setEmail("");
        setSubscribed(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "bottom-section",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "h1-class-3",
                children: "Discover What's New in Testing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "paragraph-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "h2-class-2",
                children: "Subscribe now for Trailblu's AI app testing updates."
            }),
            !subscribed ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "form-style",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "email",
                        placeholder: "Business Email",
                        value: email,
                        onChange: handleEmailChange,
                        className: "form-input-style",
                        required: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        className: "subscribe-button",
                        stateProp: "normal",
                        style: "solid",
                        text: "Subscribe",
                        type: "regular",
                        id: "subscribeButton"
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "thank-you-message",
                children: "Thank you for subscribing!"
            })
        ]
    });
};
exports.default = Subscription;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Button":"d3NfG","./style.css":"4HyZI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4HyZI":[function() {},{}],"jmpXi":[function(require,module,exports) {
// src/components/IframeEmbed.jsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _iframeEmbedCss = require("./IframeEmbed.css"); // Optional: For custom styling
const IframeEmbed = ({ src, title, className })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "iframe-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
            src: src,
            title: title,
            className: className,
            frameBorder: "0",
            loading: "lazy",
            allowFullScreen: true,
            sandbox: "allow-scripts allow-same-origin allow-top-navigation-by-user-activation allow-popups",
            allow: "clipboard-write"
        })
    });
IframeEmbed.propTypes = {
    src: (0, _propTypesDefault.default).string.isRequired,
    title: (0, _propTypesDefault.default).string.isRequired,
    className: (0, _propTypesDefault.default).string
};
IframeEmbed.defaultProps = {
    className: ""
};
exports.default = IframeEmbed;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","prop-types":"6FKs7","./IframeEmbed.css":"fAk4G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAk4G":[function() {},{}],"80P9Y":[function() {},{}],"EuFTd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComparisonPage", ()=>ComparisonPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _header = require("../../components/Header/Header"); // Import your Header component
var _headerDefault = parcelHelpers.interopDefault(_header);
var _styleCss = require("./style.css"); // Import your CSS file for Blog styling
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _button = require("../../components/Button");
var _comparisonTable = require("../../components/ComparisonTable/ComparisonTable");
var _iconsCloudLaptop = require("../../icons/IconsCloudLaptop");
var _iconsPhone = require("../../icons/IconsPhone");
var _iconsPlug1 = require("../../icons/IconsPlug1");
var _reactHelmetAsync = require("react-helmet-async");
var _trailbluIntroPng = require("../../assets/TrailbluIntro.png");
var _trailbluIntroPngDefault = parcelHelpers.interopDefault(_trailbluIntroPng);
const ComparisonPage = ()=>{
    const metaInfo = {
        Appium: {
            metaTitle: "Trailblu vs Appium: Comprehensive Test Automation Comparison",
            metaDescription: "Compare Trailblu and Appium for mobile and web app testing. Explore features like parallel tests, no-code testing, AI-powered self-healing, and more."
        },
        Selenium: {
            metaTitle: "Trailblu vs Selenium: Comprehensive Test Automation Comparison",
            metaDescription: "Compare Trailblu and Selenium for web app testing. Analyze features such as no-code testing, AI-powered self-healing, visual testing, data-driven testing, and more."
        },
        Katalon: {
            metaTitle: "Trailblu vs Katalon: Comprehensive Test Automation Tools Comparison",
            metaDescription: "Compare Trailblu and Katalon for web and mobile app testing. Analyze features including AI-powered self-healing, organization management, test scheduling, and Slack/email notifications."
        },
        Preflight: {
            metaTitle: "Trailblu vs Preflight: Thorough Test Automation Platform Comparison",
            metaDescription: "Evaluate Trailblu against Preflight for comprehensive web and mobile app testing. Assess features including live manual app testing, visual testing, data-driven testing, and more."
        },
        Mabl: {
            metaTitle: "Trailblu vs Mabl: Detailed Test Automation Comparison",
            metaDescription: "Compare Trailblu and Mabl for web and mobile app testing. Evaluate features such as AI-powered self-healing, visual testing, test scheduling, and Slack/email notifications."
        },
        Functionize: {
            metaTitle: "Trailblu vs Functionize: Comprehensive Test Automation Tool Comparison",
            metaDescription: "Assess Trailblu and Functionize for web and mobile app testing. Compare features like AI-powered self-healing, data-driven testing, test scheduling, CI/CD integrations, and Slack/email notifications."
        },
        "Ghost Inspector": {
            metaTitle: "Trailblu vs Ghost Inspector: Thorough Test Automation Comparison",
            metaDescription: "Compare Trailblu and Ghost Inspector for web and mobile app testing. Examine features including visual testing, data-driven testing, organization management, and more."
        },
        Reflect: {
            metaTitle: "Trailblu vs Reflect: Comprehensive Test Automation Platform Comparison",
            metaDescription: "Compare Trailblu and Reflect for web and mobile app testing. Explore features including live manual app testing, organization management, visual testing, and more."
        },
        LambdaTest: {
            metaTitle: "Trailblu vs LambdaTest: Comprehensive Test Automation Comparison",
            metaDescription: "Compare Trailblu and LambdaTest for web and mobile app testing. Evaluate features such as AI-powered self-healing, live manual app testing, test scheduling, and Slack/email notifications."
        },
        Cypress: {
            metaTitle: "Trailblu vs Cypress: Detailed Web Testing Tools Comparison",
            metaDescription: "Examine Trailblu and Cypress for web app testing. Compare parallel test capabilities, AI-powered self-healing, data-driven testing, CI/CD integrations, and Slack/email notification features."
        },
        "Testim.io": {
            metaTitle: "Trailblu vs Testim.io: Comprehensive Test Automation Comparison",
            metaDescription: "Compare Trailblu and Testim.io for web and mobile app testing. Evaluate features such as AI-powered self-healing, live manual app testing, test scheduling, and Slack/email notifications."
        },
        "Sauce Labs": {
            metaTitle: "Trailblu vs Saucelab: Comprehensive Test Automation Platforms Comparison",
            metaDescription: "Compare Trailblu and Saucelab for comprehensive web and mobile app testing. Analyze parallel tests, no-code testing, visual testing, organization management, and more."
        }
    };
    const getComparisonData = (formattedCompanyName)=>{
        switch(formattedCompanyName){
            case "Appium":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "Detailed Reports",
                        otherCompany: "No",
                        trailblu: "yes"
                    }
                ];
            case "Selenium":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "Yes, limited",
                        trailblu: "Yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "no",
                        trailblu: "yes, inbuilt support"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Support via integrations",
                        trailblu: "yes, inbuilt support"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Detailed Reports",
                        otherCompany: "no",
                        trailblu: "yes, inbuilt support"
                    }
                ];
            case "Katalon":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "Yes, limited",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    }
                ];
            case "Preflight":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    }
                ];
            case "Mabl":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "yes, limited",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Visual Testing with Custom Settings",
                        otherCompany: "No",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    }
                ];
            case "Functionize":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "yes, limited",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "yes, for simple workflows",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    }
                ];
            case "Ghost Inspector":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Customer Support",
                        otherCompany: "no",
                        trailblu: "yes"
                    }
                ];
            case "Reflect":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "yes, limited",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Customer Support",
                        otherCompany: "yes",
                        trailblu: "yes"
                    }
                ];
            case "LambdaTest":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Customer Support",
                        otherCompany: "yes",
                        trailblu: "yes"
                    }
                ];
            case "Cypress":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Customer Support",
                        otherCompany: "no",
                        trailblu: "yes"
                    }
                ];
            case "Testim.io":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "yes, limited",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "yes, limited",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Customer Support",
                        otherCompany: "yes",
                        trailblu: "yes"
                    }
                ];
            case "Sauce Labs":
                return [
                    {
                        feature: "Web App Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Mobile App Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered No-Code Testing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Self-Healing",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Manual App Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "AI-Powered Visual Testing",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Data-Driven Testing",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Organization Management",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Test Scheduling",
                        otherCompany: "no",
                        trailblu: "yes"
                    },
                    {
                        feature: "CI/CD integrations",
                        otherCompany: "Yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Slack/Email notification",
                        otherCompany: "yes",
                        trailblu: "yes"
                    },
                    {
                        feature: "Live Customer Support",
                        otherCompany: "no",
                        trailblu: "yes"
                    }
                ];
            default:
                return [];
        }
    };
    const { companyName } = (0, _reactRouterDom.useParams)();
    const formattedCompanyName = companyName.split("-") // Split the string by "-"
    .slice(2) // Get the part after "trailblu-vs-"
    .join(" "); // Join using empty space to get "Ghost Inspector"
    const allowedCompanies = [
        "Appium",
        "Katalon",
        "Preflight",
        "Cypress",
        "Functionize",
        "Reflect",
        "Testim.io",
        "Selenium",
        "Mabl",
        "Ghost Inspector",
        "LambdaTest",
        "Sauce Labs"
    ];
    if (!allowedCompanies.includes(formattedCompanyName)) // If not allowed, navigate to a specific error page or display an error message
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: "/error",
        replace: true
    });
    const comparisonData = getComparisonData(formattedCompanyName);
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    const { metaTitle, metaDescription } = metaInfo[formattedCompanyName];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main-3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("title", {
                        children: [
                            "The Best ",
                            formattedCompanyName,
                            " Alternative | TRAILBLU"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "description",
                        content: `Explore Trailblu, the ultimate ${formattedCompanyName} alternative, offering a powerful platform for seamless automated end-to-end AI-Based software testing.`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image",
                        content: (0, _trailbluIntroPngDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: "TRAILBLU Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:card",
                        content: " summary_large_image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@trailblu"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image",
                        content: (0, _trailbluIntroPngDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image:alt",
                        content: "TRAILBLU Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:url",
                        content: `https://www.trailblu.com/alternatives/${companyName}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hero-section-comp",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "bottom"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "company-name-comp",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "h1-class-comp",
                                    children: "Choose the Best:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                    className: "h1-class-comp",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "primary-color",
                                            children: " TRAILBLU - "
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                    className: "h1-class-comp",
                                    children: [
                                        "The Ultimate ",
                                        formattedCompanyName,
                                        " Alternative"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "center-bottom",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "h3-class-2",
                                            children: "TRAILBLU offers a powerful software platform for effortless automated end-to-end testing of Web and Mobile Applications, simplifying test creation and execution to ensure flawless functionality across various digital landscapes."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "/",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                className: "design-component-instance-node-2",
                                                stateProp: "normal",
                                                style: "solid",
                                                text: "Learn More",
                                                type: "regular"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTable.ComparisonTable), {
                company: formattedCompanyName,
                comparisonList: comparisonData
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "frame-feature",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "feature",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "feature-top",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsCloudLaptop.IconsCloudLaptop), {
                                        className: "feature-icon"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "feature-header",
                                        children: "AI-Powered No-Code Testing"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "feature-text",
                                children: "Forget about tedious, time-consuming test writing. With No-Code Testing, you can quickly write tests and get fast insights."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "feature",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "feature-top",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsPhone.IconsPhone), {
                                        className: "feature-icon"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "feature-header",
                                        children: "AI-Powered Visual Testing"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "feature-text",
                                children: "Harness the power of AI to transform your visual quality assurance. Our tool provides comprehensive coverage, intuitive insights, and smart detection of even the most subtle visual issues."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "feature",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "feature-top",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsPlug1.IconsPlug1), {
                                        className: "feature-icon"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "feature-header",
                                        children: "AI-Powered Self-Healing"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "feature-text",
                                children: "With TRAILBLU's AI-powered self-healing, you can get more from your existing tests by automatically identifying and fixing flaky tests."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "comparison-bottom",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bottom-text-part",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "bottom-text-header",
                                children: "Looking for a comprehensive testing solution that simplifies your test runs?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "bottom-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "primary-color-2",
                                        children: " Trailblu"
                                    }),
                                    " provides a comprehensive platform designed for seamless test execution, simplifying the process across diverse testing needs. With its user-friendly interface and robust capabilities,",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "primary-color-2",
                                        children: " Trailblu"
                                    }),
                                    " ensures efficient and hassle-free test execution for various applications and scenarios."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "button-part",
                        href: "/request-a-demo",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            className: "design-component-instance-node-2",
                            stateProp: "normal",
                            style: "solid",
                            text: "Request a demo",
                            type: "regular"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = ComparisonPage;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../../components/Header/Header":"j0rW0","./style.css":"6y1PN","../../components/Footer/Footer":"2Br4S","../../components/Button":"d3NfG","../../components/ComparisonTable/ComparisonTable":"8g1Fs","../../icons/IconsCloudLaptop":"5ghaX","../../icons/IconsPhone":"fEH0X","../../icons/IconsPlug1":"99oWe","react-helmet-async":"5Z9jX","../../assets/TrailbluIntro.png":"1rplF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6y1PN":[function() {},{}],"8g1Fs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComparisonTable", ()=>ComparisonTable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const ComparisonTable = (props)=>{
    const { company, comparisonList } = props;
    const renderContent = (value)=>{
        if (value?.toLowerCase() === "yes") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "tick",
            children: "\u2713"
        });
        else if (value?.toLowerCase() === "no") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "cross",
            children: "\u2717"
        });
        else return value;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "comparison-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "table-header",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "table-title",
                    children: [
                        "Feature Comparison: Trailblu vs ",
                        company
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "table-header-feature",
                        children: "Features"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "pinkish-color-feature",
                        children: company
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "greenish-color-feature",
                        children: "Trailblu"
                    })
                ]
            }),
            comparisonList.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "table-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: item.feature
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pinkish-color",
                            children: renderContent(item.otherCompany?.toLowerCase())
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "greenish-color",
                            children: renderContent(item.trailblu?.toLowerCase())
                        })
                    ]
                }, index))
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./style.css":"5dzdO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5dzdO":[function() {},{}],"cZ0YM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Blog", ()=>Blog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("../../components/Header/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _styleCss = require("./style.css"); // Import your CSS file for Blog styling
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _button = require("../../components/Button");
var _subscription = require("../../components/Subscription/Subscription");
var _subscriptionDefault = parcelHelpers.interopDefault(_subscription);
var _blogCard = require("../../components/BlogCard/BlogCard");
var _reactHelmetAsync = require("react-helmet-async");
var _trailbluIntroPng = require("../../assets/TrailbluIntro.png");
var _trailbluIntroPngDefault = parcelHelpers.interopDefault(_trailbluIntroPng);
var _blogData = require("../../blogData");
const Blog = ()=>{
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    const firstPost = (0, _blogData.blogPosts)[0];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                        children: "Blogs, Articles, and News | TRAILBLU"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "description",
                        content: "Stay ahead in testing with TRAILBLU. Explore No-Code AI-based testing insights for mobile and web applications."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:title",
                        content: "TRAILBLU Blog: AI-Driven No-Code Testing Insights"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:description",
                        content: "Dive into the world of AI-driven no-code testing with TRAILBLU's blog. Discover expert insights, trends, and innovations revolutionizing testing practices. Stay ahead with our in-depth articles."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image",
                        content: (0, _trailbluIntroPngDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: "TRAILBLU Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@trailblu"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:title",
                        content: "TRAILBLU Blog: AI-Driven No-Code Testing Insights"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:description",
                        content: "Dive into the world of AI-driven no-code testing with TRAILBLU's blog. Discover expert insights, trends, and innovations revolutionizing testing practices. Stay ahead with our in-depth articles."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image",
                        content: (0, _trailbluIntroPngDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image:alt",
                        content: "TRAILBLU Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:type",
                        content: "articles"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.trailblu.com/blog"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bottom"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "company-name",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                            className: "h1-class",
                            children: [
                                "The",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "primary-color",
                                    children: " Trailblu "
                                }),
                                "Blog"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "middle-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "h2-class",
                        children: "No-Code, AI-Powered Testing For Your Mobile and Web Applications"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "h3-class",
                        children: [
                            "Discover the future of app testing with",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "primary-color-2",
                                children: " Trailblu"
                            }),
                            "'s AI-driven solution\u2014seamless, code-free, and impeccably accurate."
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "/",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            className: "design-component-instance-node-2",
                            stateProp: "normal",
                            style: "solid",
                            text: "Learn More",
                            type: "regular"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "news-section",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "news",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                        href: `/blog/${(0, _blogData.createSlug)(firstPost.title)}`,
                        className: "news-items",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "news-image-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "news-image",
                                    src: firstPost.blogImage,
                                    alt: firstPost.title
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "news-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "news-date",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                children: firstPost.date
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "divider"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "read-time",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: firstPost.readTime
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "min-read-txt",
                                                        children: "min read"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "news-content",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "news-title",
                                                children: firstPost.title
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "news-desc",
                                                children: firstPost.metaDescription
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "news-bottom",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "author-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "author-img",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "image",
                                                            src: firstPost.authorImageUrl,
                                                            alt: "Trailblu Profile Image"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "author-name",
                                                        children: firstPost.author
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "tag",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: firstPost.tag
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    maxWidth: "1280px",
                    alignSelf: "center"
                },
                className: "divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "section-blog",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column-container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column-wrap",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "article-columns",
                            role: "list",
                            children: (0, _blogData.blogPosts).slice(1).map((post, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column",
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blogCard.BlogCard), {
                                        link: `/blog/${(0, _blogData.createSlug)(post.title)}`,
                                        imgsrc: post.blogImage,
                                        date: post.date,
                                        readTime: post.readTime,
                                        title: post.title,
                                        profileImg: post.authorImageUrl,
                                        authorName: post.author,
                                        tag: post.tag
                                    })
                                }, index))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscriptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = Blog;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Header/Header":"j0rW0","./style.css":"8kGEx","../../components/Footer/Footer":"2Br4S","../../components/Button":"d3NfG","../../components/Subscription/Subscription":"8mH2y","../../components/BlogCard/BlogCard":"c5OEz","react-helmet-async":"5Z9jX","../../assets/TrailbluIntro.png":"1rplF","../../blogData":"xrdVS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kGEx":[function() {},{}],"c5OEz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlogCard", ()=>BlogCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _styleCss = require("./style.css");
const BlogCard = ({ link, imgsrc, date, readTime, title, profileImg, authorName, tag })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "article-item",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: link,
            style: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "article-contents",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "article-img-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "article-img",
                            src: imgsrc,
                            alt: "Trailblu Article Image"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "card-content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "date",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: date
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "divider"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "read-time",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: readTime
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "min-read-txt",
                                                children: "min read"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "title",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "title-text",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-bottom",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "author-2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "tag",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: tag
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","./style.css":"lDmSk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lDmSk":[function() {},{}],"xrdVS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSlug", ()=>createSlug);
parcelHelpers.export(exports, "blogPosts", ()=>blogPosts);
var _profileJpg = require("./assets/profile.jpg");
var _profileJpgDefault = parcelHelpers.interopDefault(_profileJpg);
var _visualTestingPng = require("./assets/visualTesting.png");
var _visualTestingPngDefault = parcelHelpers.interopDefault(_visualTestingPng);
var _generativeAIPng = require("./assets/generativeAI.png");
var _generativeAIPngDefault = parcelHelpers.interopDefault(_generativeAIPng);
var _qatarEventPng = require("./assets/qatar_event.png");
var _qatarEventPngDefault = parcelHelpers.interopDefault(_qatarEventPng);
var _p21Png = require("./assets/p21.png");
var _p21PngDefault = parcelHelpers.interopDefault(_p21Png);
var _flutterTestingPng = require("./assets/flutterTesting.png");
var _flutterTestingPngDefault = parcelHelpers.interopDefault(_flutterTestingPng);
var _p31Png = require("./assets/p31.png");
var _p31PngDefault = parcelHelpers.interopDefault(_p31Png);
var _revolutionizetestingAI1Png = require("./assets/revolutionizetestingAI1.png");
var _revolutionizetestingAI1PngDefault = parcelHelpers.interopDefault(_revolutionizetestingAI1Png);
var _codelessAutomatedPng = require("./assets/codelessAutomated.png");
var _codelessAutomatedPngDefault = parcelHelpers.interopDefault(_codelessAutomatedPng);
var _continuousTesting2Png = require("./assets/ContinuousTesting2.png");
var _continuousTesting2PngDefault = parcelHelpers.interopDefault(_continuousTesting2Png);
var _regressionTesting1Png = require("./assets/RegressionTesting1.png");
var _regressionTesting1PngDefault = parcelHelpers.interopDefault(_regressionTesting1Png);
/* Added Missing Image Imports */ var _scalingSoftwareTestingAIPng = require("./assets/scalingSoftwareTestingAI.png");
var _scalingSoftwareTestingAIPngDefault = parcelHelpers.interopDefault(_scalingSoftwareTestingAIPng);
var _endToEndTestingPng = require("./assets/endToEndTesting.png");
var _endToEndTestingPngDefault = parcelHelpers.interopDefault(_endToEndTestingPng);
var _crossDeviceTestingPng = require("./assets/crossDeviceTesting.png");
var _crossDeviceTestingPngDefault = parcelHelpers.interopDefault(_crossDeviceTestingPng);
var _profitCenterTestingPng = require("./assets/profitCenterTesting.png");
var _profitCenterTestingPngDefault = parcelHelpers.interopDefault(_profitCenterTestingPng);
var _seleniumPlaywrightTestingPng = require("./assets/seleniumPlaywrightTesting.png");
var _seleniumPlaywrightTestingPngDefault = parcelHelpers.interopDefault(_seleniumPlaywrightTestingPng);
var _deviceFarmPng = require("./assets/deviceFarm.png");
var _deviceFarmPngDefault = parcelHelpers.interopDefault(_deviceFarmPng);
var _testAutomationPng = require("./assets/testAutomation.png");
var _testAutomationPngDefault = parcelHelpers.interopDefault(_testAutomationPng);
var _validationVerificationPng = require("./assets/validationVerification.png");
var _validationVerificationPngDefault = parcelHelpers.interopDefault(_validationVerificationPng);
/* Existing Content Imports */ var _codelessAutomatedMd = require("./Blogs/CodelessAutomated.md");
var _codelessAutomatedMdDefault = parcelHelpers.interopDefault(_codelessAutomatedMd);
var _qatarEventMd = require("./Blogs/QatarEvent.md");
var _qatarEventMdDefault = parcelHelpers.interopDefault(_qatarEventMd);
var _howToMasterMd = require("./Blogs/HowToMaster.md");
var _howToMasterMdDefault = parcelHelpers.interopDefault(_howToMasterMd);
var _trailbluIntroducesMd = require("./Blogs/TrailbluIntroduces.md");
var _trailbluIntroducesMdDefault = parcelHelpers.interopDefault(_trailbluIntroducesMd);
var _aipoweredSelfHealingMd = require("./Blogs/AIPoweredSelfHealing.md");
var _aipoweredSelfHealingMdDefault = parcelHelpers.interopDefault(_aipoweredSelfHealingMd);
var _generativeAIMd = require("./Blogs/GenerativeAI.md");
var _generativeAIMdDefault = parcelHelpers.interopDefault(_generativeAIMd);
var _flutterTestingMd = require("./Blogs/FlutterTesting.md");
var _flutterTestingMdDefault = parcelHelpers.interopDefault(_flutterTestingMd);
var _revolutinizeTestingAIMd = require("./Blogs/RevolutinizeTestingAI.md");
var _revolutinizeTestingAIMdDefault = parcelHelpers.interopDefault(_revolutinizeTestingAIMd);
var _revolutinizeTestingAI2Md = require("./Blogs/RevolutinizeTestingAI2.md");
var _revolutinizeTestingAI2MdDefault = parcelHelpers.interopDefault(_revolutinizeTestingAI2Md);
var _continuousTestingMd = require("./Blogs/ContinuousTesting.md");
var _continuousTestingMdDefault = parcelHelpers.interopDefault(_continuousTestingMd);
var _regressionTestingMd = require("./Blogs/RegressionTesting.md");
var _regressionTestingMdDefault = parcelHelpers.interopDefault(_regressionTestingMd);
/* Added Missing Content Imports */ var _scalingSoftwareTestingAIMd = require("./Blogs/ScalingSoftwareTestingAI.md");
var _scalingSoftwareTestingAIMdDefault = parcelHelpers.interopDefault(_scalingSoftwareTestingAIMd);
var _endToEndTestingMd = require("./Blogs/EndToEndTesting.md");
var _endToEndTestingMdDefault = parcelHelpers.interopDefault(_endToEndTestingMd);
var _crossDeviceTestingMd = require("./Blogs/CrossDeviceTesting.md");
var _crossDeviceTestingMdDefault = parcelHelpers.interopDefault(_crossDeviceTestingMd);
var _visualTestingContentMd = require("./Blogs/VisualTestingContent.md");
var _visualTestingContentMdDefault = parcelHelpers.interopDefault(_visualTestingContentMd);
var _profitCenterTestingMd = require("./Blogs/ProfitCenterTesting.md");
var _profitCenterTestingMdDefault = parcelHelpers.interopDefault(_profitCenterTestingMd);
var _selfHealingContentMd = require("./Blogs/SelfHealingContent.md");
var _selfHealingContentMdDefault = parcelHelpers.interopDefault(_selfHealingContentMd);
var _seleniumPlaywrightContentMd = require("./Blogs/SeleniumPlaywrightContent.md");
var _seleniumPlaywrightContentMdDefault = parcelHelpers.interopDefault(_seleniumPlaywrightContentMd);
var _deviceFarmContentMd = require("./Blogs/DeviceFarmContent.md");
var _deviceFarmContentMdDefault = parcelHelpers.interopDefault(_deviceFarmContentMd);
var _testAutomationContentMd = require("./Blogs/TestAutomationContent.md");
var _testAutomationContentMdDefault = parcelHelpers.interopDefault(_testAutomationContentMd);
var _validationVerificationContentMd = require("./Blogs/ValidationVerificationContent.md");
var _validationVerificationContentMdDefault = parcelHelpers.interopDefault(_validationVerificationContentMd);
const createSlug = (title)=>{
    return title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
};
const ScalingAIContent = (0, _scalingSoftwareTestingAIMdDefault.default).replace("{{IMAGE_SRC}}", (0, _scalingSoftwareTestingAIPngDefault.default));
const blogPosts = [
    {
        label: "Navigating Software Testing: Validation vs. Verification",
        tag: "Software Testing",
        blogImage: (0, _validationVerificationPngDefault.default),
        title: "Navigating Software Testing: Validation vs. Verification",
        metaTitle: "Validation vs Verification in Software Testing: Key Differences Explained",
        metaDescription: "Learn the key differences between validation and verification in software testing. Understand why both processes are essential for delivering high-quality software and how Trailblu ensures quality through automated testing.",
        author: "Trailblu",
        date: "Nov 25, 2024",
        readTime: "3",
        content: (0, _validationVerificationContentMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Scaling Software Testing with AI",
        tag: "Artificial Intelligence",
        blogImage: (0, _scalingSoftwareTestingAIPngDefault.default),
        title: "Scaling Software Testing with AI: Revolutionizing Efficiency and Flexibility",
        metaTitle: "AI-Driven Software Testing: Scale Efficiently with AI Solutions",
        metaDescription: "Discover how AI-powered testing methodologies enable scalable, flexible, and efficient testing practices for modern software applications. Learn how Trailblu leads the way in AI-driven testing.",
        author: "Trailblu",
        date: "Nov 23, 2024",
        readTime: "5",
        //content: processedContent,
        content: (0, _scalingSoftwareTestingAIMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "End-to-End Testing",
        tag: "Quality Assurance",
        blogImage: (0, _endToEndTestingPngDefault.default),
        title: "What is End-to-End Testing?",
        metaTitle: "End-to-End Testing: Ensure Seamless Application Performance Across Workflows",
        metaDescription: "Discover the importance of End-to-End Testing for verifying complete application flows and ensuring seamless user experience. Learn strategies, benefits, and how Trailblu empowers effective E2E Testing.",
        author: "Trailblu",
        date: "Nov 11, 2024",
        readTime: "4",
        content: (0, _endToEndTestingMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Cross Device Testing",
        tag: "Cross Platform Solutions",
        blogImage: (0, _crossDeviceTestingPngDefault.default),
        title: "The Ultimate Guide to Cross Device Testing",
        metaTitle: "Cross Device Testing: Ensure Seamless User Experiences Across Platforms",
        metaDescription: "Learn how to perform effective cross device testing to ensure your web and mobile applications work flawlessly across all devices. Discover strategies, challenges, and tools like Trailblu for seamless testing.",
        author: "Trailblu",
        date: "Nov 4, 2024",
        readTime: "7",
        content: (0, _crossDeviceTestingMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Visual Testing",
        tag: "Visual Testing Solutions",
        blogImage: (0, _visualTestingPngDefault.default),
        title: "Visual Testing Challenges: A Trailblu Solution",
        metaTitle: "Visual Testing Challenges and Trailblu's AI-Powered Solution",
        metaDescription: "Discover how Trailblu tackles visual testing challenges with AI-driven solutions, ensuring cross-browser consistency, handling dynamic content, and reducing false positives.",
        author: "Trailblu",
        date: "Oct 28, 2024",
        readTime: "7",
        content: (0, _visualTestingContentMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Software Testing",
        tag: "Software Testing",
        blogImage: (0, _profitCenterTestingPngDefault.default),
        title: "Why Software Testing Should Be Considered a 'Profit Center'",
        metaTitle: "Software Testing Profit Center | Trailblu",
        metaDescription: "Learn how software testing can drive profitability by enhancing quality, accelerating time-to-market, and reducing costs through automation. Discover key industry insights and future trends.",
        author: "Trailblu",
        date: "Oct 24, 2024",
        readTime: "6",
        content: (0, _profitCenterTestingMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Self-Healing Test Automation",
        tag: "Self-Healing Testing",
        blogImage: (0, _p31PngDefault.default),
        title: "Understanding Self-Healing for Test Automation",
        metaTitle: "Self-Healing in Test Automation: AI-Powered Efficiency with Trailblu",
        metaDescription: "Explore the benefits of self-healing test automation and how Trailblu's AI-powered solutions improve test stability, reduce maintenance, and accelerate time-to-market.",
        author: "Trailblu",
        date: "Oct 21, 2024",
        readTime: "8",
        content: (0, _selfHealingContentMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Testing Tools",
        tag: "Selenium and Playwright",
        blogImage: (0, _seleniumPlaywrightTestingPngDefault.default),
        title: "Unlocking the Power of Selenium and Playwright with Trailblu",
        metaTitle: "Enhance Web Testing with Trailblu, Selenium, and Playwright",
        metaDescription: "Explore how Trailblu\u2019s AI-powered test automation enhances Selenium and Playwright for efficient, scalable, and no-code web testing solutions.",
        author: "Trailblu",
        date: "Oct 7, 2024",
        readTime: "6",
        content: (0, _seleniumPlaywrightContentMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Cross-Platform Testing",
        tag: "Cross-Platform Testing",
        blogImage: (0, _deviceFarmPngDefault.default),
        title: "Maximize Your Testing Strategy with Trailblu\u2019s Real Mobile Device Farm and Browser Farms",
        metaTitle: "Optimize Testing with Trailblu\u2019s Device and Browser Farms",
        metaDescription: "Discover how Trailblu\u2019s Real Device and Browser Farms enhance testing accuracy, cross-platform compatibility, and reduce time-to-market for your applications.",
        author: "Trailblu",
        date: "Oct 3, 2024",
        readTime: "7",
        content: (0, _deviceFarmContentMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Test Automation Importance",
        tag: "Test Automation Benefits",
        blogImage: (0, _testAutomationPngDefault.default),
        title: "What is Test Automation and Why Does it Matter?",
        metaTitle: "Why Test Automation Matters | Trailblu",
        metaDescription: "Discover the importance of test automation in modern software development. Learn how automated testing enhances quality, reduces time-to-market, and improves efficiency.",
        author: "Trailblu",
        date: "Sep 30, 2024",
        readTime: "6",
        content: (0, _testAutomationContentMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Testing Tools",
        tag: "Testing Tools",
        blogImage: (0, _revolutionizetestingAI1PngDefault.default),
        title: "Revolutionizing Software Testing with AI: Expanding the Horizons (Part 2)",
        metaTitle: "Software Testing with AI | Trailblu",
        metaDescription: "Discover how AI is transforming software testing, from performance and security testing to continuous testing and predictive analytics. Explore real-world examples and future trends in AI-augmented testing.",
        author: "Trailblu",
        date: "Sep 23, 2024",
        readTime: "5",
        content: (0, _revolutinizeTestingAI2MdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "DevOps",
        tag: "DevOps",
        blogImage: (0, _regressionTesting1PngDefault.default),
        title: "Regression Testing",
        metaTitle: "Regression Testing | Trailblu",
        metaDescription: "Discover why Regression Testing is crucial for enabling early bug detection, improved collaboration, and seamless code deployment with Trailblu's expert solutions.",
        author: "Trailblu",
        date: "Sep 3, 2024",
        readTime: "5",
        content: (0, _regressionTestingMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "DevOps",
        tag: "DevOps",
        blogImage: (0, _continuousTesting2PngDefault.default),
        title: "Why Continuous Testing is a Must-Have for Every Developer",
        metaTitle: "Why Continuous Testing is Essential for Every Developer | Trailblu",
        metaDescription: "Discover why Continuous Testing is crucial for developers to maintain speed and quality in software development. Learn how it enables early bug detection, improved collaboration, and seamless code deployment with Trailblu's expert solutions.",
        author: "Trailblu",
        date: "Aug 13, 2024",
        readTime: "5",
        content: (0, _continuousTestingMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Testing Tools",
        tag: "Testing Tools",
        blogImage: (0, _revolutionizetestingAI1PngDefault.default),
        title: "Revolutionizing Software Testing with AI: 6 Key Benefits for Your Business (Part 1)",
        metaTitle: "Software Testing with AI | Trailblu",
        metaDescription: "Discover how AI is transforming software testing, boosting efficiency, accuracy, and coverage. Explore 6 key benefits of AI-augmented testing in this insightful blog post.",
        author: "Trailblu",
        date: "July 30, 2024",
        readTime: "5",
        content: (0, _revolutinizeTestingAIMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Testing Tools",
        tag: "Testing Tools",
        blogImage: (0, _generativeAIPngDefault.default),
        title: "Unveiling the Future of Software Testing with Generative AI at Trailblu",
        metaTitle: "Generative AI in Software Testing | Trailblu",
        metaDescription: "Explore Generative AI\u2019s role in software testing and test automation. Read about important use cases and Trailblu\u2019s innovative approach!",
        author: "Trailblu",
        date: "January 29, 2024",
        readTime: "5",
        content: (0, _generativeAIMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Event",
        tag: "Event",
        blogImage: (0, _qatarEventPngDefault.default),
        title: "Web Summit Qatar: Trailblu's Insight into Future Tech",
        metaTitle: "Trailblu's Exciting Venture at Web Summit Qatar 2024: Unveiling Tech Innovations",
        metaDescription: "Join Trailblu at the Web Summit Qatar 2024 for industry insights and influential speakers. Explore our booth for tech innovations, partnerships, and key takeaways.",
        author: "Trailblu",
        date: "February 2, 2024",
        readTime: "3",
        content: (0, _qatarEventMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Testing Tools",
        tag: "Testing Tools",
        blogImage: (0, _flutterTestingPngDefault.default),
        title: "Testing the Uncharted Territory of Flutter Apps",
        metaTitle: "Flutter Testing: Trailblu's Solution for Seamless Automation",
        metaDescription: "Elevate your Flutter app testing with Trailblu's innovative automation solution. Request a demo for a glimpse into the future of Flutter testing.",
        author: "Trailblu",
        date: "January 11, 2024",
        readTime: "3",
        content: (0, _flutterTestingMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Visual Testing",
        tag: "Visual Testing",
        blogImage: (0, _visualTestingPngDefault.default),
        title: "Flawless UI Every Time: Introducing Trailblu's Visual Testing Revolution",
        metaTitle: "Visual Testing Feature for Superior UI Consistency | TRAILBLU",
        metaDescription: "Trailblu's Visual Testing feature is designed to enhance UI consistency across platforms. Automated, efficient, and precise \u2013 perfect for developers and designers.",
        author: "Trailblu",
        date: "November 25, 2023",
        readTime: "3",
        content: (0, _trailbluIntroducesMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Codeless Automation",
        tag: "Codeless Automation",
        blogImage: (0, _p21PngDefault.default),
        title: "Codeless Testing Best Practices: A Complete Guide to Mastery",
        metaTitle: "How to Master Codeless Test Automation | TRAILBLU",
        metaDescription: "Learn essential Trailblu tips for achieving effective and reliable tests, covering topics like test coverage, data quality, collaboration, and more.",
        author: "Trailblu",
        date: "April 5, 2023",
        readTime: "5",
        content: (0, _howToMasterMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Test Automation",
        tag: "Test Automation",
        blogImage: (0, _p31PngDefault.default),
        title: "AI-Powered Self-Healing: Tackling Test Flakiness Head-On",
        metaTitle: "AI-Powered Self-Healing for Test Flakiness | TRAILBLU",
        metaDescription: "Discover the impact of flaky locators and how AI-powered self-healing techniques revolutionize automated testing.",
        author: "Trailblu",
        date: "December 26, 2022",
        readTime: "6",
        content: (0, _aipoweredSelfHealingMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    },
    {
        label: "Testing Tools",
        tag: "Testing Tools",
        blogImage: (0, _codelessAutomatedPngDefault.default),
        title: "Effortless Testing: The Future of Codeless Automation",
        metaTitle: "The Rise of Codeless Automation | TRAILBLU",
        metaDescription: "Streamline your testing process without coding, saving time and effort. Explore the simplicity of Trailblu for efficient mobile and web application testing.",
        author: "Trailblu",
        date: "December 5, 2022",
        readTime: "4",
        content: (0, _codelessAutomatedMdDefault.default),
        authorImageUrl: (0, _profileJpgDefault.default)
    }
];

},{"./assets/profile.jpg":"7SIy0","./assets/visualTesting.png":"hvZkZ","./assets/generativeAI.png":"ePeP0","./assets/qatar_event.png":"e5Kno","./assets/p21.png":"aVZSv","./assets/flutterTesting.png":"4D9lc","./assets/p31.png":"68zWL","./assets/revolutionizetestingAI1.png":"aekCl","./assets/codelessAutomated.png":"1yYsc","./assets/ContinuousTesting2.png":"6Ytnd","./assets/RegressionTesting1.png":"kmWQV","./assets/scalingSoftwareTestingAI.png":"8P2dz","./assets/endToEndTesting.png":"bE3D0","./assets/crossDeviceTesting.png":"dQWLf","./assets/profitCenterTesting.png":"7q1MD","./assets/seleniumPlaywrightTesting.png":"cs4yD","./assets/deviceFarm.png":"gofbs","./assets/testAutomation.png":"ihDTG","./assets/validationVerification.png":"eNsyq","./Blogs/CodelessAutomated.md":"3ji2H","./Blogs/QatarEvent.md":"4sQL6","./Blogs/HowToMaster.md":"k6eaO","./Blogs/TrailbluIntroduces.md":"1wbSI","./Blogs/AIPoweredSelfHealing.md":"5cGNR","./Blogs/GenerativeAI.md":"cNG86","./Blogs/FlutterTesting.md":"eO4qE","./Blogs/RevolutinizeTestingAI.md":"hSNPd","./Blogs/RevolutinizeTestingAI2.md":"avRll","./Blogs/ContinuousTesting.md":"eADgc","./Blogs/RegressionTesting.md":"hM4y8","./Blogs/ScalingSoftwareTestingAI.md":"2pnea","./Blogs/EndToEndTesting.md":"b2UXn","./Blogs/CrossDeviceTesting.md":"hFmfV","./Blogs/VisualTestingContent.md":"2OI2z","./Blogs/ProfitCenterTesting.md":"27Ho3","./Blogs/SelfHealingContent.md":"dw1NB","./Blogs/SeleniumPlaywrightContent.md":"bkM7i","./Blogs/DeviceFarmContent.md":"7RyRb","./Blogs/TestAutomationContent.md":"jzn7b","./Blogs/ValidationVerificationContent.md":"eyLg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7SIy0":[function(require,module,exports) {
module.exports = require("35d862fa06edf68f").getBundleURL("4oMEl") + "profile.39da575e.jpg";

},{"35d862fa06edf68f":"c7Tr5"}],"hvZkZ":[function(require,module,exports) {
module.exports = require("e8a1c7853f1235ea").getBundleURL("4oMEl") + "visualTesting.b8854283.png";

},{"e8a1c7853f1235ea":"c7Tr5"}],"ePeP0":[function(require,module,exports) {
module.exports = require("baec3421de479f02").getBundleURL("4oMEl") + "generativeAI.d26a072a.png";

},{"baec3421de479f02":"c7Tr5"}],"e5Kno":[function(require,module,exports) {
module.exports = require("2a79b2cd6559ba8").getBundleURL("4oMEl") + "qatar_event.3f6c769a.png";

},{"2a79b2cd6559ba8":"c7Tr5"}],"aVZSv":[function(require,module,exports) {
module.exports = require("e7ba202a38f89bc7").getBundleURL("4oMEl") + "p21.2fae429a.png";

},{"e7ba202a38f89bc7":"c7Tr5"}],"4D9lc":[function(require,module,exports) {
module.exports = require("c6c3e7f348961286").getBundleURL("4oMEl") + "flutterTesting.681fa9ee.png";

},{"c6c3e7f348961286":"c7Tr5"}],"68zWL":[function(require,module,exports) {
module.exports = require("753892f73ed6072").getBundleURL("4oMEl") + "p31.f76b6ba5.png";

},{"753892f73ed6072":"c7Tr5"}],"aekCl":[function(require,module,exports) {
module.exports = require("438e27d029c3238d").getBundleURL("4oMEl") + "revolutionizetestingAI1.66f9e73c.png";

},{"438e27d029c3238d":"c7Tr5"}],"1yYsc":[function(require,module,exports) {
module.exports = require("6aec1fec7d6222b").getBundleURL("4oMEl") + "codelessAutomated.1be6be62.png";

},{"6aec1fec7d6222b":"c7Tr5"}],"6Ytnd":[function(require,module,exports) {
module.exports = require("7806ffcbb108cc28").getBundleURL("4oMEl") + "ContinuousTesting2.b7b703d0.png";

},{"7806ffcbb108cc28":"c7Tr5"}],"kmWQV":[function(require,module,exports) {
module.exports = require("3ec3651e1c3ff903").getBundleURL("4oMEl") + "RegressionTesting1.1da52bb4.png";

},{"3ec3651e1c3ff903":"c7Tr5"}],"8P2dz":[function(require,module,exports) {
module.exports = require("91b7960678027735").getBundleURL("4oMEl") + "scalingSoftwareTestingAI.4aba1723.png";

},{"91b7960678027735":"c7Tr5"}],"bE3D0":[function(require,module,exports) {
module.exports = require("d27446c28aa0b4ef").getBundleURL("4oMEl") + "endToEndTesting.d91249bc.png";

},{"d27446c28aa0b4ef":"c7Tr5"}],"dQWLf":[function(require,module,exports) {
module.exports = require("e41c46084245b5d").getBundleURL("4oMEl") + "crossDeviceTesting.0a9daeae.png";

},{"e41c46084245b5d":"c7Tr5"}],"7q1MD":[function(require,module,exports) {
module.exports = require("df57bd639bc55f1b").getBundleURL("4oMEl") + "profitCenterTesting.3683948c.png";

},{"df57bd639bc55f1b":"c7Tr5"}],"cs4yD":[function(require,module,exports) {
module.exports = require("ca4fd1108b08de64").getBundleURL("4oMEl") + "seleniumPlaywrightTesting.6cda924c.png";

},{"ca4fd1108b08de64":"c7Tr5"}],"gofbs":[function(require,module,exports) {
module.exports = require("778b2526e2e264d5").getBundleURL("4oMEl") + "deviceFarm.b2b9133f.png";

},{"778b2526e2e264d5":"c7Tr5"}],"ihDTG":[function(require,module,exports) {
module.exports = require("3426f3e3b397652d").getBundleURL("4oMEl") + "testAutomation.f03e5450.png";

},{"3426f3e3b397652d":"c7Tr5"}],"eNsyq":[function(require,module,exports) {
module.exports = require("f90a84762928428d").getBundleURL("4oMEl") + "validationVerification.8750bbdc.png";

},{"f90a84762928428d":"c7Tr5"}],"3ji2H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = 'When you hear the word \u2018testing\u2019 or \u2018quality assurance\u2019, as a non-technical individual, maybe the first thing that comes to your mind is a group of people sitting at their desks and looking preoccupied \nwith their screens trying to click everywhere on a new web/mobile application to see if something goes wrong. Well, you are not far from the truth, this type of testing is called Manual Testing.\n\n<p align="center">\n  <img src="/codelessAutomated.png" alt="Let the codeless automated testing tool take the edge off and focus on your product" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n\nManual testing is an integral part of software development and can be a difficult task to master. It requires patience and a keen eye for details to ensure that all defects in the application are identified \nand addressed. Manual testing is a time-consuming, expensive, and tedious process, where testers have to perform the test manually over and over, and it is almost impossible to repeat the exact same test again. \nHowever, more modern ways have been invented and applied for quite some time. Depending on machines instead of humans to do the testing provides another type of testing called Automated Testing.\n\n\nAutomated testing is a form of software testing that uses specialized tools to automatically execute tests and report results. This might ring a bell and remind you of every time you sign up for something the page \nasks you if you are a robot :). Automated testing is used to increase test coverage and reduce the time and cost associated with manual testing. Automated testing can be used for a variety of testing types, \nsuch as unit, integration, and regression tests. It can also be used to test the functionality of a wide range of applications, from enterprise web applications to mobile applications. Automated testing is an \nessential part of the software development process, and it can help ensure the quality and reliability of an application. By automating tests, developers can quickly identify and fix any issues that may arise \nduring the development process. Comparing automated testing to manual testing can sure sound a lot intriguing and exciting, where we benefit from using machines to do the testing, on contrary to manual testing \nwhich depends solely on humans. After all, machines don\u2019t get bored, sick, or tired of doing the same exact job every single day. However, as glamorous as automated testing can look, it has a huge drawback!\n\n<br>\n\n<p align="center">\n  <img src="/P2.png" alt="Manuel Testing! How is it going for you?"  style="border-radius: 10px; max-width: 100%;" />\n</p>\n<p align="center" style="margin-bottom: 20px;">\n  <em>Automated tests coding is a daunting and high-maintenance job</em>\n</p>\n\n<br>\n\nAutomated testing can be tricky to get right, as it requires careful planning and execution, in addition to a great deal of technical knowledge and highly advanced skill sets. Automated testing could save \nmore time than manual testing does, but it still consumes more time that the development team may not have available with the accelerated production and agile development methodology. As a business owner, \nyou might think twice before asking your QA team to adopt an automated testing approach, even though it has all of the amazing advantages that were mentioned above. You might think to yourself, What if there \nwas a way to benefit from automated testing without having to invest time, effort and money into coding those test scripts? Codeless Automated Testing is the answer you are looking for.\n\n<br>\n\n<p align="center">\n  <img src="/P3.png" alt="Let the codeless automated testing tool take the edge off and focus on your product"  style="border-radius: 10px; max-width: 100%;" />\n</p>\n<p align="center" style="margin-bottom: 20px;  font-style:italic;">\n <em>Let the codeless automated testing tool take the edge off and focus on your product</em>\n</p>\n\n<br>\n\nCodeless (AKA no-code) automated testing is a revolutionary way to perform automated testing without having to write a single line of code. Codeless automated testing has come to relieve testers \nand QA engineers from spending too much time and effort on creating automated tests, not to mention maintaining these tests after every application change. It provides the users with an intuitive, easy-to-use \ninterface where they just have to test their product with a few clicks. Codeless automated testing also offers the ability to test across multiple platforms, including mobile, web, and desktop, and provides \nyou with the results in just a few minutes. You get the experience of manual testing wrapped in automated tests that you can replay anytime and check results. With codeless automated testing you can run these \nrecorded tests on a regular basis, create schedules, check the test logs, screenshots and videos that the tool provides and then you can create reports on how the application is doing under different scenarios. \nIt is also highly scalable, allowing you to add more tests to your existing framework as the application evolves. And since it does not require any coding skills, it is also much faster to develop and deploy. \nYou finally feel that your time is valued and your efforts are in the right place.\n\n<br>\n\nAs you are feeling obligated to open up the search engine and start looking at tens of testing tools, you will feel lost between so many choices. The most important thing is to identify \nyour business needs and your budget. Many codeless automated solutions offer a lot of options that you might not need but have to pay for because it comes with the package. You need to take your time \nto figure out which solution is best for your business to adopt without breaking the bank. One of the great choices you might find tailored to your needs is Trailblu. <a href="https://www.trailblu.com/">Trailblu</a> is a codeless automated \ntesting tool that provides you with mobile and web application testing features, where you can record your tests and run them on cross-platform browsers and multiple different devices. Whether your business \nis big or just starting up, you will find that \nTrailblu is a good choice with its user-friendly interface and active customer support service.\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4sQL6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/qatar.png" alt="Qatar Event"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<br><br>\n\nAt Trailblu, we\'re thrilled to announce our enthusiastic participation in the highly anticipated Web Summit Qatar, scheduled to take place from February 26 to 29, 2024, at the Doha Exhibition and Convention Center (DECC).\n<br><br>\nAs honoured participants in the Alpha Startup Program, we are gearing up for an immersive journey at this premier technology event, which is expected to attract a dynamic audience of over 7,500 individuals and boast an impressive history with 32,000+ startups. The Web Summit Qatar promises to be a pivotal moment in the tech calendar, providing an exceptional platform for collaborative exploration, innovation, and industry insights.\n<br><br>\nOur dedicated team is eager to engage with the brightest minds in the industry, aiming to delve into the latest trends and establish meaningful connections that transcend the ordinary. As we eagerly embrace this summit\'s various opportunities, we are enthusiastic about networking with fellow visionaries, gaining invaluable insights from influential speakers and actively participating in enlightening educational panel discussions and workshops.\n<br><br>\nKeep a keen eye on our communications channels for real-time updates, captivating stories, and behind-the-scenes glimpses of our exciting journey at the Web Summit Qatar. Make sure to mark your calendars to visit our booth, where we will be showcasing not just our technological contributions but also the potential partnerships and key takeaways we are set to glean from this thrilling event. We extend a warm invitation to you to be an integral part of our experience, immersing yourself in the innovation and trailblazing spirit that defines Trailblu!\n<br><br>\n\n<p align="center">\n<a target="_blank" style= "text-decoration:none;" href="https://qatar.websummit.com/">\n  <img src="/qatar_event2.png" alt="Qatar Event"   style="border-radius: 10px; max-width: 100%;" />\n  </a>\n</p>\n\n<br><br>\nSeize the opportunity to be a part of this transformative experience! Secure your tickets now and join us in collectively shaping the future of technology at the Web Summit Qatar! Your presence is not just requested; it\'s an essential component in the collaborative narrative of growth and innovation that Trailblu is set to unfold. Visit Web Summit Qatar\u2019s webpage more information: <a target="_blank" style= "text-decoration:none;" href="https://qatar.websummit.com/">Web Summit Qatar, Doha | February 26-29, 2024</a> \n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6eaO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/P21.png" alt="Let the codeless automated testing tool take the edge off and focus on your product"  style="border-radius: 10px; max-width: 100%;" />\n</p>\n\nAs businesses continue to embrace a digital-first approach, automated testing is becoming increasingly important to ensure the quality and reliability of products. More explicitly, \ncodeless automated tests are the way to go as a great solution to test applications quickly and easily. We discussed before the perks and benefits of codeless (low-code) automated testing, It allows\ntesters to quickly and efficiently test the application/product and catch bugs before they reach the end-users. However, that\u2019s not always the case! When codeless automated testing is not done the right way, \nit could show shortcomings in accuracy and test coverage. As we emphasize that codeless automated testing is the right thing to do, that\u2019s not enough to show how amazing it is\u2026 \nbecause doing the right thing alone is not enough, doing it RIGHT is the key to your testing and quality assurance success.\n\n\nLet\u2019s say you are on your first steps at this codeless automated testing experience; to be able to get the most out of it with as little fuss as possible, we offer you some perspective points and practical \ntips on how to masteryour codeless automated tests regardless of your technical background. Before starting your journey, first you need to finish the following checklist:\n\n\n1. **Goals and motivation awareness:** \n   Understand the purpose of your automated tests. Before you begin, make sure you understand why you\u2019re running the tests and what you\u2019re trying to achieve. This will help you create tests that are more effective and efficient.\n\n2. **Prioritize Testing:** \n   The first step in improving automated tests is to prioritize testing. Automated testing should be integrated into the development process from the beginning. This ensures that bugs are caught early in the development cycle, saving time and resources in the long run. By prioritizing testing, you can also ensure that your testing process is robust and thorough.\n\n3. **Choose the Right Tools:** \n   Choosing the right codeless automated testing tools is crucial for improving your testing process. There are many testing tools available, each with its own strengths and weaknesses. It is important to choose a tool that is suitable for your application and team. Factors to consider when choosing a testing tool include cost, ease of use, support, and the ability to integrate with other tools in your development stack.\n\n4. **Write Testable Code:** \n   Writing testable code is an important step in improving automated testing. Testable code is code that is easy to test, with clear inputs and outputs. By writing testable code, you can ensure that your automated tests are effective and efficient. Some tips for writing testable code include using meaningful variable names, keeping functions small and focused, and making sure to include unique properties for your application elements as much as possible.\n\n5. **Continuous Integration:** \n   Continuous integration is the process of automatically building, testing, and deploying code changes. By integrating automated testing into your continuous integration process, you can catch bugs and issues early on in the development cycle. This ensures that your code is always working as expected, and reduces the risk of bugs being introduced into production.\n\n   <br>\n\n<p align="center">\n  <img src="./P22.png" alt="Codeless Automation"   style="border-radius: 10px; max-width: 100%;"/>\n</p>\n\n   <br>\n\nTest recording phase, using the codeless automated testing tool that you chose, can be easy and enjoyable, but often misleading if the tester did not make the most out of it, and the results of replaying those hastily recorded tests will show undesirable outcomes. However, by following the practical tips below, you can improve your tests and make sure to get the best results you like to achieve.\n\n   <br>\n   \n1. **Test Coverage:** \n   Ensure that you have comprehensive test coverage that covers all possible scenarios and edge cases. You can start by converting the manual test scenarios to automated ones and find other hidden spots that can be covered by the tools you adopted for test automation.\n\n2. **Test Data:** \n   Make sure that your test data is robust and representative of real-world scenarios. Use test data generators to create a wide range of test data that will help identify bugs and issues.\n\n3. **Collaboration:** \n   Collaborate with developers, testers, and other stakeholders to ensure that automated tests are developed and executed effectively. Regular communication and collaboration will help identify issues and improve the overall quality of your automated tests.\n\n4. **Verification:** \n   Make sure to add assertion steps throughout your test steps as checkup points to assure the test is going in the right direction and showing the right outcomes.\n\n5. **Monitoring:** \n   Keep an eye on test results, as it is an important part of improving automated testing. Regularly review test results to identify patterns and trends. This can help you identify areas of your code that may require further testing or optimization. It is also important to review test results after making code changes, to ensure that your changes have not introduced new bugs or issues.\n\n6. **Self-Healing:** \n   Make the best out of the self-healing feature that you can get from the codeless testing tool that you chose before. Self-healing feature will provide you with the ability to overcome and eliminate flaky locators.\n\n7. **Maintenance:** \n   Regularly maintain and update your automated tests to ensure that they continue to be effective. Refactor and optimize tests as necessary to keep up with changes in the application or technology stack.\n\n<br>\n\nIn conclusion, codeless automated testing can be a valuable tool for software development teams by taking the time to understand the available options, as well as implementing the necessary steps to ensure your tests are effective and reliable.\n\n<br>\n\nHere, at Trailblu, we understand the importance of mastering automated tests, and we have the perfect solution for you. Our codeless automated testing platform helps you quickly and easily create, execute, and manage automated tests with minimal effort. Our platform is designed to help anyone, regardless of their technical background, to improve their automated tests. With Trailblu, you can easily create automated tests with no coding required. We also provide detailed test results, so you can quickly identify and fix any issues. Our platform also allows you to easily integrate automated tests with your existing development and deployment pipelines. At Trailblu, we believe that codeless automated tests should be easy to use and provide accurate results. With our platform, you can quickly and easily improve your automated tests and ensure the quality of your products.\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1wbSI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = "<p align=\"center\">\n  <img src=\"/visualTesting.png\" alt=\"visual testing\" width=\"454px\"  style=\"border-radius: 10px; max-width: 100%;\"/>\n</p>\n\n<br>\n\nIn an era where digital interface plays a pivotal role in user experience, Trailblu is proud to announce the launch of its latest feature: Automated Visual Testing. This revolutionary tool is set to transform the way developers and designers ensure the visual consistency and functionality of websites and applications.\n\n<br>\n\nVisual testing, often overlooked, is crucial in detecting nuanced issues that traditional testing methods miss. Trailblu's Visual Testing tool automates this process, comparing screenshots against predefined expectations, highlighting discrepancies in layout, text alignment, and more. It's not just about functionality; it's about ensuring the UI looks and behaves exactly as intended.\n\n<br>\n\nOur tool's baseline setting feature allows for a seamless comparison of current and desired UI states, making it easier to identify errors early in the development cycle. This not only saves time but also ensures a consistent experience across various platforms and devices. Trailblu's Visual Testing is more than a tool; it's a commitment to flawless user experiences.\n\n<br>\n\nBy integrating Trailblu's Visual Testing into your development process, you're not just building an application or website; you're crafting an impeccable digital experience for your users. Embrace the future of testing with Trailblu.\n\n<br>\n\n# Advanced Features and Benefits \n\nTrailblu's Visual Testing tool is equipped with advanced features that cater to the dynamic needs of modern web development. With its intuitive interface, developers can effortlessly configure the tool to match specific testing requirements. This includes setting up custom thresholds for error detection, allowing for finer control over what constitutes a visual discrepancy.\n\n<br>\n\nMoreover, the tool's AI-driven comparison engine is designed to intelligently ignore minor, non-critical differences that often occur due to dynamic content. This means more accurate results and fewer false positives, enabling teams to focus on genuine visual issues.\n\n<br>\n\n## Collaborative Testing & Reporting \n\nTrailblu understands the importance of collaboration in today's development environments. Our visual testing tool supports team collaboration by allowing multiple users to view and comment on test results. This feature ensures that everyone involved in the project, from developers to designers to QA analysts, can contribute to the visual quality of the product.\n\n<br>\n\nAdditionally, our comprehensive reporting system provides detailed insights into each test. Users can access historical test data, making it easy to track progress and improvements over time. These reports can be customized and shared with stakeholders, ensuring transparency and alignment across the team.\n\n<br>\n\n## A Commitment to Quality & User Experience: \n\nAt Trailblu, we believe in empowering developers and designers with tools that not only enhance productivity but also contribute to a superior end-user experience. With the Visual Testing feature, we are taking a significant step towards helping our clients deliver visually perfect applications and websites. We are excited to see how our tool will be used to create digital experiences that delight users worldwide.\n\n<br>\n\n\n**To explore how Trailblu's Visual Testing can elevate your project's visual quality, visit us at <a href= \"https://www.trailblu.com/\">www.trailblu.com</a>. Join us in shaping a visually impeccable digital future.**\n";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cGNR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/selfHealing.png" alt="AI-Powered Self-Healing in Test Automation"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n<!-- <p align="center" style="margin-bottom: 20px;">\n  <em>AI-Powered Self-Healing in Test Automation</em>\n</p>\n<br> -->\n\nTest automation, whether it is code-based or codeless, has become a popular way to increase efficiency and reduce costs in software development. One of the most common applications of test automation is automated regression testing, which is performed to verify that changes or updates to a software application or system have not negatively impacted its existing functionality. It involves rerunning previously passed test cases to ensure that the application is still working as intended after the changes have been made.\n\nNaturally, as the development cycle never stops, any new version/release of a web or mobile application will carry changes to its Graphical User Interface (GUI) or/and its underlying logic such as the element\u2019s location or identifying properties. Unfortunately, when a new version of the application is released, the previously written automated tests can be rendered inaccurate. This is also known as test flakiness. This means that test cases or scripts maintenance is required to ensure that tests remain up-to-date and accurate, and this additional effort can be costly. This is especially true when testing an application with frequent releases. So, the dilemma of spending time and effort is back again to the front page. Even though codeless automated testing saves up so much time and effort on creating the test scripts, now remains the daunting task of maintaining each test and fixing failing steps after every new release.\n\nWhat makes the test scripts fail almost after every new release is mainly the flaky locators. Flaky locators refer to elements on a webpage or application that are difficult to locate or interact with consistently due to issues with the way they are identified. This can lead to test failures or unpredictable behavior when trying to perform actions on these elements. If you are not an experienced testing engineer, you might first wonder: What is a locator?\n\n\nIn automated testing, a locator is an element in the user interface (UI) that is used to identify and interact with elements in the application under test. Locators are used by testing frameworks and tools to locate specific UI elements in order to perform actions on them, such as clicking a button or entering text into a field. There are several types of locators that can be used in automated testing, including:\n\n\n1. **ID:** An ID is a unique identifier for a UI element. ID locators are typically the most reliable type of locator, as they are usually unique and do not usually change.\n\n2. **Name:** The name of a UI element is the value of its \u201Cname\u201D attribute. Name locators are often used for form elements, such as input fields and buttons.\n\n3. **Class:** The class of a UI element is the value of its \u201Cclass\u201D attribute. Class locators can be used to locate multiple elements that share the same class.\n\n4. **Tag name:** The tag name of an element is the type of HTML tag that it is, such as \u201Cdiv\u201D or \u201Cp\u201D. Tag name locators can be used to locate multiple elements of the same type.\n\n5. **CSS selector:** A CSS selector is a string that uses the syntax of the Cascading Style Sheets (CSS) language to select elements in the UI. CSS selectors can be used to locate elements based on their attributes, such as their ID, class, or tag name.\n\n6. **XPath:** XPath is a language used to navigate and select elements in an XML document, such as an HTML page. XPath locators can be used to locate elements based on their position in the document hierarchy or their attributes.\n\nLocators are an important part of automated testing, as they are used to identify and interact with specific elements in the UI. However, it is important to choose the right type of locator for the job, as different types of locators have different levels of reliability and may be more or less suitable depending on the context. Whether the page layout, the text within the element, or one of the element\u2019s attributes is updated or deleted, a robust locator must be able to find the element anyway, but when the test fails to locate an element, then the locator is rendered inaccurate and flaky.\n\n\nFortunately, there is a way to address these issues when they happen in real-time: Self-Healing. With the advent of Artificial Intelligence (AI), self-healing is becoming a reality. This means that the software can detect when a locator or test is failing and automatically adjust itself to repair the issue. The AI system can be trained to identify and fix/replace flaky locators that fail due to changes in the application under test. In codeless automated testing, the AI-powered self-healing technique requires the system to train a model for generating appropriate locators that uniquely identify each element being interacted with. With a collection of locators and attributes, it becomes easier to find a better and more robust locator to replace the flaky one. This approach can be used to improve the reliability and correctness of automated tests, as it allows them to adapt to the application\u2019s visual or/and logical changes and recover from broken locators without the need for manual intervention.\n\n\nThis technology is already being used in production and has been proven to be extremely effective. The use of AI in self-healing is an exciting development in automation testing. It can free up a lot of resources and time spent troubleshooting and repairing failing tests. It also helps ensure that application development teams are producing the best possible results. But how does self-healing find the right locator to identify the required element?\n\n\nThere are many proposed methods and algorithms for Self-Healing in the test automation field. To name a few, one method uses Genetic Algorithms[1] to find the lost element among all UI elements on the page. Depending on previously collected attributes of every UI element, this method finds all elements from the page that exactly match the lost element in only one attribute (such as ID, Name, Class, \u2026 etc). By comparing and doing some calculations on the similarity of the collected elements with the old element\u2019s attributes, the fittest elements are chosen while the rest are deleted in each iteration until the right element is found or a stopping criteria is met. Another algorithm[2] does not only depend on the element\u2019s attributes, but it also takes into consideration the element\u2019s position, text within, and image. When the regression test fails after a new release, the self-healing algorithm first calculates the similarities for each property, between the old element and a candidate, and then integrates them into one similarity. By sorting the candidate elements into ranks, which are based on their similarity score, the highest ranked element is the most likely to be the old element.\n\n\nAnother popular and widely used self-healing algorithm[3] is a modified version of the Longest Common Subsequence algorithm, which takes into account the weight of various attributes such as tag, id, class, value, and others. The purpose of this modification is to identify the longest sub-sequence that is common to all sequences in a set of sequences. With this approach, if an element on the web page changes its position in the DOM or receives a new id, the self-healing algorithm will be able to detect the change and generate a new locator for it.\n\n\nOverall, AI-powered self-healing is a powerful tool for improving the reliability of the testing process by automatically addressing problems as they arise, reducing the risk of errors and improving the overall quality of the testing process. By automating the process of identifying and fixing flaky locators, self-healing algorithms can help to minimize the cost of the testing process and free up human resources to focus on more important tasks.\n\n\n***\n\n<p style="margin-top: 30px; font-style: italic;" >\n[1] Eladawy, Hadeel Mohamed, Amr E. Mohamed, and Sameh A. Salem. \u201CA new algorithm for repairing web-locators using optimization techniques.\u201D 2018 13th International Conference on Computer Engineering and Systems (ICCES). IEEE, 2018.</p>\n\n\n\n_[2] Kirinuki, Hiroyuki, Haruto Tanno, and Katsuyuki Natsukawa. \u201CCOLOR: correct locator recommender for broken test scripts using various clues in web application.\u201D 2019 IEEE 26th International Conference on Software Analysis, Evolution and Reengineering (SANER). IEEE, 2019._\n\n\n<a target="_blank" href="https://healenium.io">_[3] https://healenium.io/_<a>';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cNG86":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/GenerativeAI.png" alt="Generative AI in Software Testing blog banner" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<br>\n\n\nSoftware, crafted meticulously by developers, is susceptible to errors with consequences that vary in financial and moral impact based on the software\'s domain and purpose. For instance, game developers may face decreased user retention and revenue. At the same time, NASA\'s Challenger space shuttle software errors resulted in significant financial losses and, tragically, and most importantly, loss of lives.\n\n<br>\n\nSoftware testing is the crucial mechanism for assessing whether software fulfils its intended functions accurately. Despite its importance, various testing branches are often overlooked by developers due to challenges in application, cost, time, and technical skills, leading to substantial damages.\n\n<br><br>\n\n# The Pre-Generative AI Era: A Missing Link in Software Testing\n\n\nIn the era before Generative AI, software testing faced an inherent paradox. While technological advancements propelled application development to new heights, the methods for ensuring the reliability and robustness of software struggled to keep pace. \n\n<br>\n\nManual test case creation was labor-intensive and time-consuming, often resulting in incomplete coverage and an ongoing battle with evolving applications. The need for a solution to bridge this gap between innovation and testing efficiency was more apparent than ever. With test automation emerging years ago, things started picking up for QA engineers. \n\n<br>\n\nTest automation overcame the drawbacks of manual testing and provided better coverage, fewer errors and less time consumption. As the test automation solution started racing in the market by providing many features such as low-code/no-code testing and visual testing, it was only a matter of time before someone started to think: How can we improve test automation? Better yet, it\u2019s easier! \n\n<br><br>\n\n# Generative AI: Revolutionizing Software Testing\n\n<p align="center">\n  <img src="/GenerativeAI2.png" alt="Generative AI in Software Testing blog banner" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<br>\n\nGenerative AI is a subset of artificial intelligence (AI) that concentrates on autonomously creating new, original content. Unlike traditional AI systems that rely on predefined rules, Generative AI utilizes advanced machine learning models, such as neural networks, to learn patterns from existing data and generate novel outputs. This technology has wide-ranging applications, from generating realistic text and images to creating innovative solutions in various domains. \n\n<br>\n\nIn the context of software testing, Generative AI becomes a transformative force. By leveraging its ability to generate diverse and complex test scenarios, it significantly reduces the burden of manual effort while enhancing test coverage. What sets Generative AI apart is its ability to create tests; it\'s the transformative impact it brings to the entire testing life cycle. \n\n\n### How Generative AI Works \n\nGenerative AI operates as a creative powerhouse, employing advanced machine learning models to comprehend patterns and structures within data. At its core, this technology learns from existing information and dynamically generates new content, whether text, images, or other forms, mirroring the patterns it has discerned. \n\n<br>\n\nThe process involves remarkable sophistication, allowing Generative AI to go beyond rule-based systems. Its vast applications span various domains, from content creation and artistic endeavours to generating meaningful test scenarios. This isn\'t just a leap forward; it\'s a paradigm shift in how we approach software testing.\n\n### Use Cases of Generative AI\nThe applications of Generative AI are boundless, spanning from expediting the testing process to amplifying test coverage and extending its influence across diverse domains. Large Language Models (LLMs) emerge as integral components within this dynamic landscape, exemplified by GPT. \n\n<br>\n\nThese LLMs serve as keystones in the universe of Generative AI, showcasing remarkable proficiency in comprehending and generating human-like language. Their sophisticated neural networks contribute to coherent and contextually relevant text and play a pivotal role in advancing Generative AI applications. \n\nA wealth of libraries is available for developers venturing into the world of Generative AI, encompassing proprietary technology like <a target="_blank" href="https://platform.openai.com/docs/models/overview">OpenAI\'s GPT series</a>, particularly GPT-3, and open-source frameworks such as <a target="_blank" href="https://ai.meta.com/llama/">Llama</a>, <a target="_blank" href="https://huggingface.co/bigscience/bloom">Bloom</a>, and <a target="_blank" href="https://mistral.ai/">Mistral</a>. With their comprehensive toolsets, these libraries offer invaluable resources for seamlessly integrating Generative AI into diverse projects.\n\n<br><br>\n\n# Software Testing: Trailblu\'s Integration of Generative AI\n\n<p align="center">\n  <img src="/GenerativeAI3.png" alt="Generative AI in Software Testing blog banner" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<br>\nTesting teams and QA engineers have already started exploiting Generative AI in testing with scenario creation, where scenarios assist them in writing testing scripts. However, a question arises: How can Generative AI help in test automation, specifically, in a no-code testing solution? \n\n<br>\n\nEnter Trailblu, an innovator at the forefront of software testing, harnessing the potential of Generative AI to redefine how we test applications. At Trailblu, we\'ve transformed Generative AI into a user-friendly, powerful toolset that empowers users to create tests effortlessly. Not only does Trailblu take the edge out of writing tedious testing scripts by providing a no-code testing solution, it also provides cutting edge AI-based tools to assist the user during test recording and replaying. \n\n<br>\n\nTrailblu blends Generative AI with test automation for mobile and web applications, revolutionizing the UI testing process by integrating LLMs into the test creation step. In addition, Trailblu offers self-healing capabilities based on AI technologies to change regression test maintenance from a daunting, time-consuming task to a hassle-free one.  This innovation accelerates and simplifies test writing for application developers, saves time and cost, and enhances the user experience.  \n\n### Key Take Aways\n\n-   Software testing faces application, cost, time, and technical skill constraints. \n-	Test automation has emerged as a solution, providing benefits like better coverage, fewer errors, and increased time efficiency. \n-	Generative AI revolutionizes testing by autonomously creating diverse scenarios, reducing manual effort. \n-	Trailblu pioneers Generative AI integration into testing with a user-friendly, no-code solution, blending it seamlessly with test automation and offering unique features like AI-generated test steps in addition to self-healing capabilities for simplified regression test maintenance.\n\n\nIn summary, AI-powered software solutions are here to change the direction of the future. Trailblu offers tangible and quick solutions for challenges industries may face with software testing. Want to know more about Trailblu\u2019s innovative solutions? Contact our team of experts and <a href="https://www.trailblu.com/request-a-demo">request a demo</a> now! \n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eO4qE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/FlutterTesting.png" alt="Flutter Tester" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<br>\n\n# Flutter Testing\n\nMobile app development has always presented unique challenges, and the rise of Flutter has been no exception. Flutter, an open-source UI software development toolkit created by Google, has become famous for its capacity to provide the tools and gadgets to create visually striking and high-performance cross-platform applications. \n\n<br>\n\nWith a single codebase, Flutter apps empowers developers to design applications that seamlessly run on Android and iOS platforms, significantly reducing development time and effort. Designing with Flutter is a gratifying experience as it provides a rich set of customisable widgets, enabling the creation of aesthetically pleasing user interfaces. \n\n<br>\n\nFurthermore, the simplicity of design encompasses visual appeal and functionality, courtesy of Flutter\'s hot reload feature. This functionality enables real-time code modifications without requiring a complete app restart. However, as developers bask in the simplicity of Flutter\'s design, a distinct challenge looms beneath the surface\u2014the intricate world of testing, particularly under automated frame works. \n\n<br>\n\nData from <a target="_blank" href="https://insights.stackoverflow.com/trends?tags=flutter">Stack Overflow</a> reveals a significant and steady increase in interest in Flutter beginning in 2018, indicating its growing importance in the developer community. This upward trajectory underscores Flutter\'s rising dominance and the tech community\'s need to ensure these applications are of the highest quality.\n\n\n<br>\n\n# Design Simplicity, Testing Complexity\n\nThe allure of Flutter resides in its design simplicity. The comprehensive widget library and the instant feedback loop provided by the hot reload feature make designing visually appealing user interfaces seamless. \n\n<br>\n\n\n<p align="center">\n  <img src="/flutterTesting2.png" alt="Flutter App Testing"  style="border-radius: 10px; max-width: 100%; width: 468px;" />\n</p>\n\n<br>\n\nYet, as developers revel in this design elegance, the transition to the realm of automated testing reveals a striking paradox. The simplicity that makes designing with Flutter apps a joy becomes a source of complexity when subjected to the rigour of test automation. \n\n\n<br>\n\n# Challenges and Solutions: Flutter Test Automation\n\nNavigating the testing landscape for Flutter apps presents various challenges, ranging from the complexities of element identification to maintaining cross-platform consistency and adapting to the dynamic nature of Flutter applications. \n\n<br>\n\nEven though Flutter offers its own <a target="_blank" href="https://docs.flutter.dev/testing/overview">automated testing capabilities</a> (such as Unit Testing, Widget Testing, and Integration Testing), these automated tests necessitate using source code. They must be carefully designed, written, and technically maintained regularly. Automated testing by Flutter requires the developers to have a good deal of coding skills and a significant amount of time and effort to keep these test scripts valid and up to date. \n\n<br>\n\nThis time-consuming test scripting emphasizes a need for robust test automation solutions to comprehensively address Flutter\'s multifaceted challenges. The industry has yet to witness a single platform seamlessly integrating with Flutter\'s uniqueness, catering to the demand for a comprehensive test automation framework.\n\n\n<br>\n\n# Trailblu\'s Flutter Testing\n\nTrailblu pioneered to fill a gap in response to this pressing need. As the first to recognize and address this void, Trailblu offered developers a reliable and efficient solution to the challenges of Flutter testing. This unprecedented initiative is poised to reshape the landscape, providing a transformative testing experience for Flutter applications previously unparalleled in the industry.\n\n<br>\n\nSuccessfully addressing Flutter\'s dynamic UI, we are thrilled to unveil a groundbreaking feature\u2014an embodiment of our commitment to innovation in testing. This feature is a testament to our belief that testing Flutter apps should not be daunting. Instead, it should be an empowering experience for DevOps and testing engineers. \n\n<br>\n\n\n\n<p align="center">\n  <img src="/flutterTesting3.png" alt="Trailblu Flutter Testing Request a Demo"  style="border-radius: 10px; max-width: 100%; width: 468px;" />\n</p>\n\n<br>\n\n\n**Trailblu\'s platform is designed for agility and ease of use, which extends to our support for Flutter applications.** With Trailblu, integrating test automation into your Flutter app development process is straightforward and hassle-free. Our advanced AI-driven tools provide a level of testing thoroughness that other methods can\'t match, all while being incredibly user-friendly.\n\n<br>\n\nAre you ready to elevate the quality of your Flutter apps and accelerate your development cycle with test automation? Discover how Trailblu can transform your Flutter automation testing process. \n\n<br>\n\n**Request a demo now and confidently step into the future of Flutter app testing.**\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hSNPd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/revolutionizetestingAI1.png" alt="Revolutionizing Software Testing with AI: 6 Key Benefits (Part 1) blog banner" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<br>\n\nIn today\'s fast-paced software development landscape, ensuring the quality of applications is more critical than ever. As applications become increasingly complex, traditional testing methods often struggle to keep up with the demands of rapid development cycles. This is where AI-augmented testing comes in. By leveraging artificial intelligence, software testing can be significantly enhanced, leading to improved efficiency, accuracy, and test coverage.\n\n<br>\n\nThis blog post is the first in a series that will explore the key areas where AI can revolutionize software testing. In this part, we will focus on six key benefits:\n\n<br> \n\n## 1. Test Planning and Test Prioritization\n\nAI can optimize test planning by identifying the most critical areas of an application that need testing. By analyzing historical data, user behavior, and code complexity, AI algorithms can pinpoint high-risk areas and prioritize tests accordingly. This ensures that testing efforts are focused on the parts of the application that are most likely to have defects, improving efficiency and effectiveness.\n\n<br>\n\n## 2. Test Creation\n\nCreating test cases can be a time-consuming and error-prone process. AI can help by automatically generating test cases from requirements, user stories, and existing test suites. This automation not only saves time but also ensures comprehensive coverage by considering all critical paths and potential scenarios.\n\n<br>\n\n## 3. Test Maintenance\n\n<p align="center">\n  <img src="/revolutionizetestingAI2.png" alt="Revolutionizing Software Testing with AI: 6 Key Benefits (Part 1) blog banner" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\nMaintaining test cases is one of the most challenging aspects of UI testing, especially as applications evolve. Changes in the UI, such as element IDs or structure, can cause tests to fail even if the application is functioning correctly. AI-powered self-healing mechanisms can address this issue by dynamically updating and adapting test scripts when UI changes occur. For instance, if an element\'s identifier changes, the AI can recognize the element based on other attributes and update the test script accordingly. This reduces the maintenance burden and ensures that tests remain robust against UI changes. Additionally, self-healing can help identify and fix flaky tests, which are tests that pass and fail inconsistently without changes in the code.\n\n<br>\n\n## 4. Test Data Generation\n\nGenerating diverse and representative test data is crucial for comprehensive testing. AI can assist in this area by creating synthetic data, which is artificially created rather than obtained from real-world observations. This data can be generated using various methods, including statistically rigorous sampling from real data, semantic approaches, and Generative Adversarial Networks (GANs). Alternatively, data can be created by simulating scenarios where models and processes interact to produce entirely new datasets of events. By leveraging AI for test data generation, software engineering teams can ensure that testing covers a wide range of possible scenarios, improving test coverage and robustness.\n\n<br>\n\n## 5. Visual Testing\n\nVisual testing uses AI to evaluate the visible output of an application and compare it against the expected results. Unlike traditional testing methods that rely on specific assertions, visual testing mimics what a human tester would see when things don\'t "look right." For example, it can detect issues such as text not rendering properly or elements being partly offscreen. Visual testing is particularly relevant for testing non-standard user interfaces, such as those not confined to web, mobile, or desktop applications.\n\n<br>\n\n## 6. Test and Defect Analysis\n\nAI can significantly impact test and defect analysis in the following ways:\n- **Automatic Defect Classification**: AI can triage defects early and improve accuracy in future defect classification using self-learning algorithms and intelligent classification techniques.\n- **Defect Prediction**: By leveraging machine learning (ML) and natural language processing (NLP) techniques to detect patterns in historical quality assurance (QA) data, AI can identify gaps in quality and defect targets, minimize redundancy, and enhance the effectiveness and efficiency of testing processes.\n\n<br>\n\n## Conclusion\n\nAs applications become more complex, the role of AI in software testing will become even more critical. By leveraging AI in the six key areas discussed above, software engineering teams can ensure faster, more accurate, and more efficient testing processes, ultimately leading to higher-quality software.\n\n<br>\n\nIn the next part of this blog series, we will explore additional benefits of AI-augmented testing and discuss future trends in this rapidly evolving field. Stay tuned for more insights on how AI is revolutionizing software testing!\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avRll":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/revolutionizetestingAI1.png" alt="Revolutionizing Software Testing with AI: (Part 2) blog banner" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<br>\n\nIn the first part of this series, we explored six key ways AI is transforming software testing, bringing efficiency, accuracy, and broader coverage to the forefront. As we delve deeper, it becomes evident that AI\'s impact extends even further, permeating various testing domains and practices.\n\n<br>\n\n## 7. Performance Testing\n\nAI can significantly enhance performance testing by identifying bottlenecks and predicting potential issues before they impact users. By analyzing performance metrics and historical data, AI algorithms can pinpoint areas where the application might struggle under heavy load or specific usage patterns. This proactive approach allows developers to optimize performance and prevent costly downtime.\n\n<br>\n\n## 8. Security Testing\n\nSecurity vulnerabilities can have severe consequences. AI can bolster security testing by identifying vulnerabilities and potential attack vectors that might be missed by traditional methods. Machine learning algorithms can analyze code and network traffic to detect anomalies and patterns indicative of security risks, helping to fortify the application against potential threats.\n\n<br>\n\n## 9. Continuous Testing\n\nIn the era of continuous integration and continuous deployment (CI/CD), AI plays a crucial role in enabling continuous testing. By seamlessly integrating with CI/CD pipelines, AI can trigger automated tests whenever code changes are committed. Moreover, AI can intelligently select the most relevant tests based on the nature of the changes, ensuring rapid feedback without compromising thoroughness.\n\n<br>\n\n## 10. Regression Testing\n\nRegression testing is essential to ensure that new code changes don\'t inadvertently break existing functionality. AI can optimize this process by identifying the minimum set of test cases needed to validate the changes effectively. By analyzing code dependencies and historical test data, AI algorithms can pinpoint the most relevant tests, saving time and resources while maintaining confidence in the application\'s stability.\n\n<br>\n\n## 11. User Behavior Analysis\n\nUnderstanding how users interact with an application is invaluable for testing. AI can analyze user behavior data to identify patterns, preferences, and pain points. This information can guide testing efforts toward the most critical user flows and functionalities, ensuring that the application meets user expectations and delivers a seamless experience.\n\n<br>\n\n## 12. Predictive Analytics for Testing\n\nAI can leverage predictive analytics to forecast potential defects and testing outcomes. By analyzing historical testing data, code metrics, and other relevant factors, AI algorithms can identify areas of the application that are more likely to harbor defects. This predictive capability allows teams to allocate testing resources more effectively, focusing on areas with higher risk and preventing defects from reaching production.\n\n<br>\n\n## Conclusion\n\nThe integration of AI into software testing is not merely an enhancement; it\'s a paradigm shift. By extending AI\'s capabilities beyond the foundational benefits explored in Part 1, we unlock new dimensions of testing efficiency, effectiveness, and proactivity. As AI continues to evolve, its impact on software testing will only deepen, leading to higher quality applications, faster release cycles, and greater user satisfaction.\n\n<br>\n\nIn future installments of this series, we\'ll delve into specific AI-powered testing tools and techniques, showcasing real-world examples of how AI is reshaping the testing landscape across industries. Stay tuned as we continue to explore the exciting frontiers of AI-augmented software testing!\n\n\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eADgc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/ContinuousTesting1.png" alt="Why Continuous Testing is a Must-Have for Every Developer blog banner" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\nIn the dynamic world of software development, speed and quality are the two critical factors that determine the success of any application. Developers are under constant pressure to deliver new features, updates, and fixes faster than ever before. However, this need for speed can often lead to compromises in quality if proper testing practices are not in place. This is where Continuous Testing becomes a game-changer.\n\n\n## What is Continuous Testing?\n\nContinuous Testing is a process where automated tests are integrated into the development pipeline, allowing for constant feedback on the quality of the code. Unlike traditional testing methods that occur at the end of the development cycle, Continuous Testing happens at every stage, ensuring that issues are detected and resolved as they arise.\n\n\n## The Benefits of Continuous Testing for Developers\n\n- Increased Speed Without Compromising Quality: One of the biggest challenges developers face is the trade-off between speed and quality. Continuous Testing eliminates this dilemma by allowing developers to write and deploy code faster while maintaining high quality standards. Automated tests run continuously, providing immediate feedback, and allowing developers to fix issues on the fly.\n\n\n\n- Early Bug Detection and Resolution: Bugs are inevitable, but the sooner they are detected, the less impact they have on the project. Continuous Testing enables early bug detection, reducing the risk of critical issues reaching production. This not only saves time but also reduces costs associated with fixing bugs in later stages of development.\n\n\n\n- Enhanced Confidence in Code Deployment: Continuous Testing gives developers the confidence to deploy code more frequently. Knowing that the code has been thoroughly tested throughout the development process reduces the fear of introducing new bugs and ensures that the application remains stable and reliable.\n\n\n- Improved Collaboration Across Teams: Continuous Testing fosters a collaborative environment between developers, testers, and operations teams. By integrating testing into the development pipeline, everyone is on the same page, which leads to faster and more efficient software delivery.\n\n\n\n## The Role of Continuous Testing in DevOps\n\n<p align="center">\n  <img src="/ContinuousTesting2.png" alt="Why Continuous Testing is a Must-Have for Every Developer blog banner" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\nDevOps is all about breaking down silos and enabling seamless collaboration across different teams. Continuous Testing is a key component of the DevOps culture as it ensures that quality is built into every step of the development process. This continuous feedback loop helps teams deliver better software faster, meeting the ever-growing demands of users.\n\n\n## How Trailblu Can Help\n\nAt Trailblu, we understand the importance of Continuous Testing in modern software development. Our solutions are designed to help developers integrate testing into their workflow seamlessly, ensuring that quality and speed go hand-in-hand. Whether you are just starting your DevOps journey or looking to optimize your existing processes, Trailblu offers the tools and expertise to make Continuous Testing an integral part of your development strategy.\n\nContinuous Testing is no longer an optional practice for developers\u2014it\u2019s a necessity. In a world where software needs to be delivered faster and more reliably than ever before, Continuous Testing ensures that quality is never compromised. By embracing Continuous Testing, developers can not only meet the demands of today\u2019s fast-paced development cycles but also set the stage for long-term success.\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hM4y8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/RegressionTesting1.png" alt="Regression Testing" style="border-radius: 10px; max-width: 80%;" />\n</p>\n\n<br>\nWith each new feature or update, there\'s an increased risk of introducing bugs or errors, making regression testing a critical practice. But what exactly is regression testing, and why is it so crucial?\n\n<br>\n\n## Understanding Regression Testing\n\nRegression testing is the process of re-running functional and non-functional tests to ensure that recent code changes have not negatively impacted the existing functionality of the software. It\u2019s used to detect unexpected issues that may arise after updates, bug fixes, or new feature implementations. Essentially, regression testing helps to confirm that the application still performs as expected and that no new bugs have been introduced during development.\n\n<br>\n\n## Benefits of Automated Regression Testing\n\nAs applications grow in complexity, the number of test cases required for thorough regression testing increases, often making manual testing impractical. Automated regression testing offers a more efficient, accurate, and scalable solution to address these challenges:\n\n<br>\n\n\u25CF	**Efficiency & Speed**: Automated regression testing significantly reduces the time required to execute tests, enabling your team to focus on innovation rather than repetitive tasks.\n<br>\n\n\u25CF	**Accuracy & Consistency**: Automation eliminates human error, ensuring tests are executed with precision every time, leading to more reliable results.\n<br>\n\n\u25CF	**Cost-Effectiveness**: Although there is an initial investment in setting up automated tests, the long-term savings are substantial. Catching issues early in the development cycle reduces the need for extensive bug fixes, saving both time and money.\n<br>\n\n\u25CF	**Scalability**: Automated regression testing easily scales to cover a wide range of test cases, ensuring comprehensive testing as your application grows.\n<br>\n\n\u25CF	**CI/CD Integration**: Automated regression testing is crucial in a continuous integration/continuous delivery (CI/CD) environment, ensuring that new code changes don\u2019t introduce regressions and allowing for faster, more reliable releases.\n<br>\n\n\u25CF	**Reduced Manual Effort**: By automating regression tests, your testing team can focus on more complex and exploratory testing tasks, enhancing productivity and fostering innovation.\n\n<br>\n\n## When Is Regression Testing Complete?\n\nKnowing when to stop regression testing is essential to avoid unnecessary delays in the development cycle. Generally, regression testing is considered complete when:\nAll critical and high-priority test cases have passed.\nNo new bugs have been detected during multiple test cycles.\nThe code changes have been tested across different environments and platforms.\nThe test coverage meets or exceeds the predefined threshold set by your team.\nHowever, it\'s important to recognize that regression testing is a continuous process, especially in an Agile or DevOps environment. New code changes often require re-testing to ensure stability.\n\n<br>\n\n## Challenges and Limitations of Regression Testing\n\n\nDespite its importance, regression testing is not without its challenges. Some of the key limitations include:\n<br>\n<br>\n\n\u25CF	**High Initial Setup Cost**: Implementing automated regression testing requires an upfront investment in tools, infrastructure, and training.\n<br>\n\n\u25CF	**Maintenance Overhead**: Automated tests need regular updates as the application evolves, which can become resource-intensive.\n<br>\n\n\u25CF	**False Positives/Negatives**: Poorly designed test cases can lead to false results, either missing defects or flagging non-existent issues.\n<br>\n\n\u25CF	**Complexity in Test Management**: As the number of automated tests grows, managing and organizing them can become increasingly complex.\n\n<br>\n\n## Trailblu: Your Solution for Advanced Regression Testing\n\nAt Trailblu, we recognize the complexities involved in maintaining software quality. That\u2019s why we offer a suite of advanced features designed to streamline and enhance your regression testing process:\n<br>\n<br>\n\n\u25CF	**Generative AI-Powered Test Creation**: Our platform leverages generative AI to automatically create comprehensive test cases tailored to your application\u2019s unique needs. This significantly reduces the time and effort required to develop test scripts while ensuring high coverage and accuracy.\n<br>\n\n\u25CF	**AI-Powered No-Code Testing**: Trailblu\u2019s no-code testing solution allows teams without extensive coding knowledge to create and execute automated tests easily. This democratizes the testing process, enabling broader participation across your team.\n<br>\n\n\u25CF	**AI-Powered Visual Testing**: Visual testing ensures that your application\u2019s user interface remains consistent across different devices and browsers. Trailblu\u2019s AI-driven visual testing automatically detects and flags UI discrepancies, helping you maintain a seamless user experience.\n<br>\n\n\u25CF	**AI-Powered Self-Healing**: One of the biggest challenges in automated testing is maintaining test scripts as the application evolves. Trailblu\u2019s self-healing feature automatically adjusts and repairs test cases when UI elements change, reducing the need for manual updates and ensuring ongoing reliability.\n\n<br>\n\nBy incorporating these advanced features, Trailblu enables you to achieve a more efficient, accurate, and scalable regression testing process, ultimately delivering a superior product to your users.\n\n<br>\n\n## Conclusion\n\nIn today\u2019s competitive software landscape, automated regression testing is no longer a luxury but a necessity. By leveraging Trailblu\u2019s cutting-edge tools and technologies, you can ensure your applications are stable, reliable, and ready to meet the demands of modern users.\nReady to take your regression testing to the next level?\n\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pnea":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/scalingSoftwareTestingAI.png" alt="Scaling Software Testing with AI: Revolutionizing Efficiency and Flexibilit"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n\nAs development speeds accelerate and digital products grow more complex, scalable AI-driven testing methodologies offer companies a pathway to meet expanding demands without compromising quality or agility.\n\n### Why Is Scaling Testing Crucial Today?\n\nThe rise of agile methodologies, combined with AI-powered development tools, has enabled faster coding and shorter release cycles. As developers produce more code than ever, testing teams are often overwhelmed by the increased workload. Manual testing approaches can no longer keep up, creating the need for adaptable, AI-enhanced testing frameworks. With AI-driven scalability, businesses can now validate vast amounts of code in reduced timelines, keeping development and testing cycles synchronized and agile.\n\n### Leveraging AI for Autonomous Testing\n\nAI can now simulate a range of testing processes that once demanded significant manual effort. From generating test scripts to validating user flows across various devices, AI enhances both the pace and depth of testing. One breakthrough is AI\u2019s ability to interpret user instructions in natural language, making test automation more accessible to non-developers. This capability allows product managers and designers to communicate their testing needs in plain English, which the AI then translates into executable scripts. The result is a faster, frictionless testing pipeline that can scale on demand.\n\n\n### Expanding Test Automation with Generative AI\n\nGenerative AI introduces a new paradigm, allowing for the creation and execution of complex testing scenarios. Once given a user journey or feature outline, the AI autonomously generates code and executes it within continuous integration/continuous delivery (CI/CD) pipelines. Automated monitoring and intelligent adjustments further allow AI systems to address testing issues proactively. This ensures that applications perform as expected without the delays typically associated with human intervention, all while reducing error rates in the testing process.\n\n\n### Bridging the Talent Gap with AI Test Engineers\n\nAs the need for test automation continues to outpace the availability of skilled engineers, AI test engineers have become essential for maintaining testing quality and coverage. These AI engineers can execute a vast number of test cases across multilingual platforms and varying screen sizes, supporting consistent user experience globally. From mobile apps to multilingual websites, AI test engineers adapt scenarios for each unique environment, enabling seamless, accurate, and expansive testing without straining human resources.\n\n\n### Multi-Platform and Multilingual Capabilities\n\nModern applications need to perform well across different devices, screen sizes, and languages to meet global standards. AI testing solutions support diverse environments without requiring human intervention. Whether it\'s a banking app in multiple languages or an e-commerce site handling multiple currency formats, AI-driven testing ensures that each platform and language receives the attention it deserves, aligning with global performance expectations.\n\n\n### Adaptive Testing and Automated Issue Resolution\n\nAI-driven testing solutions are capable of adaptive testing\u2014recognizing and adjusting to changes in the application in real-time. When issues arise, AI can autonomously attempt a recovery, reporting only critical failures for human review. This not only reduces the time to identify and fix bugs but also ensures that testing operations remain fluid and responsive, regardless of scale.\n\n\n### Embracing Flexibility in Testing\n\nOne of the most compelling advantages of AI in testing is its flexibility. As applications evolve, AI testing systems can adapt to new updates and features without human intervention, making it easy to maintain continuous testing coverage. This flexibility empowers companies to:\n\n- Adapt to Rapid Changes: AI enables quick adaptation to new features, keeping testing aligned with ongoing development.\n- Provide Consistent Coverage Across Platforms: Applications are tested across diverse devices and operating systems to ensure reliable performance.\n- Optimize Resource Allocation: AI test engineers can be deployed instantly and at scale, allowing resources to focus on higher-priority tasks.\n- Enhance Global User Experience: Multilingual and multiplatform testing guarantees a seamless user experience regardless of locale or device type.\n\n\n### Shifting the Role of Test Engineers\nAs AI systems handle more routine testing tasks, the role of test engineers is evolving toward managing AI outputs and focusing on strategic oversight. This shift allows test engineers to engage in higher-level decision-making, such as monitoring test coverage and refining AI processes, thereby adding value to the testing framework. Additionally, companies must establish transparent practices around AI-driven processes to ensure accuracy, accountability, and ethical testing standards.\n\n\n### Looking Ahead: The Future of Scalable AI Testing\n\nAs AI becomes more entrenched in software testing, companies have the opportunity to fully transform their testing processes, preparing for future complexities in digital environments. The flexibility, speed, and scale of AI testing solutions are reshaping quality assurance practices and enhancing software reliability. Moving forward, businesses can leverage AI to not only match the rapid pace of development but also to lead innovation within their testing frameworks, ensuring a consistently high-quality experience for users worldwide.\n\nIn an age where efficiency and scalability define success, AI-driven testing methodologies provide a sustainable solution for companies aiming to lead in an increasingly digital world. By integrating these technologies today, organizations are setting a foundation for resilient, adaptive testing that will support future growth and innovation.\n\n\n### Why Trailblu is Leading the Charge\n\nTrailblu stands at the forefront of this AI testing revolution, offering a comprehensive suite of AI-powered testing solutions that empower teams to achieve seamless scalability. From multilingual and multiplatform capabilities to real-time adaptive testing, Trailblu\u2019s advanced automation tools simplify complex testing processes, all while maintaining exceptional quality and speed. Trailblu\u2019s commitment to innovation ensures that your software stays reliable and robust, even as demands grow and timelines shrink. Choosing Trailblu means choosing a partner dedicated to excellence in AI-driven testing, helping your business thrive in today\u2019s fast-paced digital landscape.\n\n\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b2UXn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/endToEndTesting.png" alt="What is End-to-End Testing"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n\nIn a digital-first world, where applications power business and connect customers, ensuring software reliability is crucial. End-to-End (E2E) Testing is a pivotal practice that helps guarantee a seamless experience across complex applications, ensuring all components work together flawlessly. This type of testing is particularly valuable when different systems, APIs, and third-party integrations need to function harmoniously. But what exactly is End-to-End Testing, and why is it a cornerstone of software quality?\n\n### Defining End-to-End Testing\n\nEnd-to-End Testing is a testing methodology focused on verifying the entire application flow, from start to finish, to confirm that each segment of an application works as expected. Unlike unit or integration testing, which focuses on specific modules or interactions, E2E Testing simulates real-world scenarios to evaluate complete workflows, user behavior, and system dependencies. This process provides an overarching view of how your application performs, ensuring that each element operates cohesively under real user conditions.\n\n### Why is End-to-End Testing Essential?\n\nAs applications grow in complexity, the risk of isolated issues affecting the overall user experience increases. E2E Testing minimizes these risks by:\n\n- Ensuring User Experience Consistency: By validating the application from a user perspective, E2E Testing helps deliver a seamless user experience across all interactions.\n\n- Enhancing Reliability: This testing process identifies breakpoints across different environments, configurations, or systems, ensuring greater dependability.\n\n- Reducing Future Maintenance: Detecting bugs early in the application lifecycle saves time and resources, reducing future maintenance needs and speeding up releases.\n\n### Key End-to-End Testing Strategies\n\nImplementing an effective E2E Testing strategy involves adopting techniques that closely resemble real-world use cases. Here are some of the essential strategies:\n\n- Real-World Scenario Testing: Identify critical user flows, such as logging in, making transactions, or navigating dashboards, to understand and verify primary user paths.\n\n- Automated vs. Manual E2E Testing: Automated E2E Testing accelerates execution time for repetitive tests, while manual E2E Testing ensures nuanced, one-off cases are covered.\n\n- Data-Driven Testing: Simulate real-world scenarios by using varied datasets to see how the application handles diverse data types and edge cases.\n\n- Continuous Testing Integration: Integrating E2E Testing with CI/CD pipelines helps detect issues as soon as new code is pushed, promoting continuous improvement and high software quality.\n\n### How Trailblu Empowers End-to-End Testing\n\nTrailblu provides a robust platform that enables efficient, scalable E2E Testing. Here\u2019s how Trailblu stands out:\n\n- Cross-Platform Testing: Trailblu\u2019s platform supports web, mobile, and API testing, ensuring consistent performance across diverse platforms and devices.\n\n- Real-Device Cloud: Testing on real devices allows Trailblu users to replicate true user conditions, identifying and resolving device-specific issues.\n\n- Parallel Execution: Execute tests across multiple devices simultaneously, saving time and providing comprehensive coverage.\n\n### Benefits of Effective End-to-End Testing with Trailblu\n\n- Increased Test Coverage: E2E Testing ensures complete coverage of critical user flows, minimizing the chance of missed bugs.\n\n- User-Centric Quality Assurance: By testing through the lens of the end user, Trailblu provides tools to simulate real environments, improving user satisfaction.\n\n- Efficient Development Lifecycle: Early detection of bugs reduces back-and-forth in development, accelerating time-to-market.\n\n### End-to-End Testing Challenges and How to Overcome Them\n\nE2E Testing can be resource-intensive, especially in complex environments with multiple third-party integrations. Key challenges include:\n\n- Test Environment Complexity: Maintaining a test environment that mirrors production can be costly. Using cloud-based testing solutions, like those provided by Trailblu, can alleviate this burden by offering access to diverse environments.\n\n- Test Data Management: Managing different datasets across workflows is challenging but necessary. Trailblu\u2019s data-driven testing capabilities streamline data handling, making tests more comprehensive.\n\n### Conclusion\n\nEnd-to-End Testing is more than just a quality check\u2014it\u2019s a strategic approach to delivering robust, user-focused applications. As applications evolve, E2E Testing ensures that every component functions seamlessly, enhancing user experience and reducing operational risks. With Trailblu\'s platform, you gain the tools to conduct reliable, efficient, and scalable End-to-End Testing, ensuring your applications meet the high expectations of today\u2019s users.\n\nStart your journey towards flawless application performance with Trailblu\'s End-to-End Testing solutions today.\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hFmfV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/crossDeviceTesting.png" alt="The Ultimate Guide to Cross Device Testing"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n\nWhether your users are on a smartphone, tablet, or desktop, they expect a seamless experience. Testing across devices ensures that your web and mobile applications perform flawlessly, no matter the platform. But how can you ensure effective Cross Device Testing? Let\'s dive in.\n\n### What is Cross Device Testing?\n\nCross Device Testing is the process of verifying that your website or application works as intended across a wide range of devices. This includes different screen sizes, operating systems, browsers, and hardware capabilities. Essentially, it\'s about ensuring that your app is functional, user-friendly, and visually consistent on any device a user might use.\n\n### Why is Cross Device Testing Necessary?\n\nWith the diversity of devices available today, from high-end smartphones to budget tablets, ensuring compatibility is critical. Cross Device Testing helps:\n- Improve user experience (UX) across all platforms.\n- Identify performance issues specific to certain devices.\n- Ensure design consistency and responsiveness.\n- Boost brand reputation by providing a seamless experience, regardless of the user\u2019s device.\n\nFailing to test your application on various devices can lead to poor performance, compatibility issues, and even loss of business.\n\n### What Are the Cross Device Testing Strategies?\n\nTo get the most out of Cross Device Testing, it\u2019s important to adopt specific strategies, such as:\n\n- Real Device Testing: Using actual devices for accurate results, especially when testing hardware features like cameras or GPS.\n- Emulators and Simulators: Useful for quick tests, but they might not reflect real-world conditions perfectly.\n- Parallel Testing: Running tests simultaneously on multiple devices to save time.\n- Cloud-Based Testing: Testing on virtual devices in the cloud for scalability and flexibility (like Trailblu offers).\n\n### What Are the Issues to Identify in Cross Device Testing?\n\nDuring Cross Device Testing, you\'ll want to identify:\n\n- Layout and Design Issues: Some elements may not render correctly across devices with different resolutions.\n- Performance Discrepancies: A smooth app on one device may lag on another.\n- Touch and Gesture Sensitivity: What works on a touchscreen may not work on a desktop.\n-Browser Compatibility: Different browsers may interpret code differently, leading to unexpected behavior.\n\n### Key Considerations for Cross Device Testing\n\nBefore you begin Cross Device Testing, keep these considerations in mind:\n\n- Device Prioritization: Focus on the most popular devices your target audience uses.\n- Testing Frequency: Make Cross Device Testing a continuous process, especially after updates or new releases.\n- Network Conditions: Test under different network environments like 3G, 4G, and Wi-Fi to ensure performance across varying speeds.\n\n### What Are the Benefits of Cross Device Testing?\n\nHere\u2019s why Cross Device Testing is a game changer:\n\n- Enhanced User Experience: A smoother, consistent UX increases user retention and satisfaction.\n- Wider Reach: Ensures that your app or website works perfectly across all platforms and devices, expanding your audience.\n- Early Detection of Issues: Catch bugs or issues before they become user complaints.\n- Competitive Advantage: An app that works well on all devices stands out in a crowded market.\n\n### What Are the Challenges of Cross Device Testing?\n\nDespite its importance, Cross Device Testing comes with challenges:\n\n- Device Fragmentation: The sheer number of devices, OS versions, and browsers can be overwhelming.\n- Cost and Resources: Maintaining a lab with all these devices can be costly.\n- Time-Consuming: Testing on multiple devices takes time, especially if done manually.\n  \nThis is where solutions like Trailblu come in.\n\n### How to Achieve Cross Device Testing?\n\nAchieving effective Cross Device Testing requires the right tools, strategies, and planning. Here\u2019s a step-by-step guide:\n\n- Identify the Devices: Focus on devices that are most popular with your users.\n- Automate Where Possible: Use automation tools to run repetitive tests.\n- Use Real Devices and Simulators: A blend of real devices and simulators gives you accurate results while staying cost-effective.\n- Leverage Parallel Testing: Speed up the process by running tests simultaneously.\n\n### How to Choose What Devices to Test On?\n\nYou don\u2019t need to test on every device under the sun\u2014prioritize based on:\n\n- User Demographics: Which devices your users commonly use.\n- Market Share: Focus on the devices with the largest market share in your region.\n- OS Versions: Ensure compatibility with both older and newer operating systems.\n  \n### How to Conduct Effective Cross Device Testing?\n\nTo make your Cross Device Testing process efficient:\n\n- Define Your Scope: Decide which devices, OS, and browsers you\u2019ll test on.\n- Run Tests in Parallel: Save time by running tests simultaneously on multiple devices.\n- Monitor Results Closely: Track your test results to catch errors early.\n\n### Tools for Cross-Device Testing\n\nWhen it comes to Cross-Device Testing, Trailblu stands out by offering a seamless experience with its Real Mobile Device Farm and Browser Farm, enabling parallel execution on real devices across multiple platforms. Whether you\'re testing for web, mobile, or APIs, Trailblu\u2019s cloud-based solutions ensure your applications work flawlessly on any device. \n\n- Testsigma: This AI-powered tool specializes in no-code test automation. It enables testers to automate and execute cross-device tests on web, mobile, and desktop applications, as well as APIs. Testsigma integrates with the device cloud of your choice, allowing flexible, scalable testing across multiple browsers and devices.\n\n- LambdaTest: A versatile platform for testing web and mobile apps on real devices, browsers, and platforms. LambdaTest supports both manual and automated testing and integrates well with popular frameworks for seamless testing workflows.\n\n- Sauce Labs: Sauce Labs provides cloud-based testing for a wide range of browsers and devices. Supporting both desktop and mobile testing, it integrates with CI/CD pipelines, making it ideal for automating tests in fast-paced development environments.\n\n- BrowserStack: One of the most widely-used cloud-based testing platforms, BrowserStack offers access to over 3,000 real devices and browsers. It supports both manual and automated testing, ensuring your website or app functions perfectly across different environments.\n\n### How to Perform Cross Device Testing Using Trailblu: A Step-by-Step Guide\n\nTrailblu makes Cross Device Testing a breeze by offering a powerful combination of real devices, virtual machines, and cloud-based testing environments. Here\'s how you can perform Cross Device Testing using Trailblu:\n\n- Step 1: Select Your Devices\nLog into Trailblu and access the Real Mobile Device Farm or Browser Farm. Select the devices and browsers you want to test on.\n\n- Step 2: Set Up Your Test Cases\nLoad your automated or manual test scripts into Trailblu\u2019s platform. You can integrate it with your existing testing framework or create new test cases directly in the system.\n\n- Step 3: Run Parallel Tests\nUtilize Parallel Execution to test across multiple devices simultaneously. This saves time and provides instant feedback on device-specific issues.\n\n- Step 4: Analyze Results\nOnce your tests are complete, review detailed reports. Trailblu provides visual logs, screenshots, and videos for comprehensive results, making it easy to spot layout issues or functional bugs.\n\n- Step 5: Optimize and Retest\nBased on your findings, make the necessary adjustments to your app or site. Retest to confirm that issues have been resolved.\n\n### Conclusion\n\nCross Device Testing is crucial in today\u2019s multi-device landscape. It ensures your app or website performs seamlessly across all platforms, leading to enhanced user experience, broader reach, and a competitive edge. While challenges exist, tools like Trailblu make the process easier, faster, and more efficient by offering cloud-based, parallel testing on real devices. Start optimizing your app for all devices today, and ensure your users enjoy a flawless experience, no matter how they access your platform.\n\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2OI2z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/visualTesting.png" alt="Visual Testing Challenges: A Trailblu Solution"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<!-- Visual Testing Challenges: A Trailblu Solution -->\n\nImagine your web application displaying flawlessly on one device but breaking apart on another\u2014an inconsistency that could cost you users and tarnish your brand\u2019s reputation. Visual issues are among the hardest to catch manually, and in today\u2019s digital world, user expectations are higher than ever. Ensuring that every pixel is perfectly in place across all browsers and devices has become a monumental task for developers and testers alike. But where manual efforts fall short, intelligent automation steps in. This is where Trailblu\'s innovative solution excels, tackling the most pressing visual testing challenges with precision and efficiency.\n\n### Common Visual Testing Challenges\n\n- Cross-Browser and Cross-Device Inconsistencies: According to research, as much as 52% of users access the web from multiple devices, meaning ensuring consistent visual quality across different browsers and devices is critical. These inconsistencies can result in reduced user engagement and potential revenue loss, especially for e-commerce platforms. Browser rendering differences can lead to mismatches in fonts, layouts, and colors, creating usability challenges for developers and testers.\n\n- Dynamic Content Testing: Many websites today have dynamic content (e.g., real-time updates, personalized dashboards). Approximately 30% of tests fail due to changes in dynamic content, and dynamic UI updates can make it difficult to predict or capture consistent visual representations. The complexity increases with the need to test across various screen sizes, further multiplying the test cases\u200B.\n\n- False Positives and Negatives: False positives are a significant issue in automated visual testing. On average, some teams report that 20-30% of flagged issues are false positives due to minor, non-impactful changes in pixels. This wastes time for QA teams, who need to manually verify whether the changes are important or not\u200B. Conversely, false negatives\u2014where small but important visual defects go unnoticed\u2014can affect user experience and result in costly post-release fixes.\n\n- High Maintenance Efforts: The effort required to maintain visual tests can be staggering, especially as UI components change frequently. Large teams report spending up to 25% of their testing time updating baselines for visual tests. This can slow down the CI/CD pipeline and increase testing times by 20-30%, particularly when working with large-scale applications that undergo frequent UI updates\u200B.\n\nThese challenges, combined with the rise in the complexity of modern web applications, highlight the importance of using automated solutions to streamline visual testing efforts. By addressing these issues, teams can improve the consistency, reliability, and efficiency of their testing processes, leading to better user experiences.\n\n### How Trailblu Addresses These Challenges?\n\nAt Trailblu, we recognize these visual testing pain points and have designed a robust, AI-powered solution that automates the process while ensuring precision and scalability.\n\n1. AI-Driven Visual Regression Testing: \n   Trailblu employs AI to detect even the most subtle visual differences between releases. Our AI algorithms go beyond mere pixel comparisons, focusing on the actual user experience. This reduces false positives, ensuring that only meaningful changes are flagged, saving testers time and reducing frustration.\n\n2. Seamless Cross-Browser and Device Testing: \n   With Trailblu, testers can automate the process of checking visual consistency across multiple browsers and devices. Our platform integrates with leading browsers and mobile devices, ensuring that your application renders perfectly, no matter the environment.\n\n3. Dynamic Content Handling: \n   Our solution is tailored to handle dynamic content efficiently. Trailblu\u2019s visual testing framework allows testers to define expected behaviors for dynamic elements, reducing the risk of missing any visual discrepancies in content that changes frequently.\n\n4. Smart Baseline Management: \n   One of the standout features of Trailblu\u2019s visual testing solution is its smart baseline management. Our system automatically updates baselines when needed, reducing manual effort while maintaining visual consistency. This is especially useful for teams working on fast-paced development cycles where UI changes are frequent.\n\n5. Scalability and Parallel Execution: \n   For large teams or enterprises, Trailblu offers parallel execution of visual tests, ensuring rapid feedback across all environments. This enables teams to scale their visual testing efforts without compromising on speed or accuracy.\n\n### Conclusion\n\nVisual testing is no longer an optional part of the quality assurance process\u2014it\u2019s a necessity. The challenges associated with maintaining visual integrity across browsers and devices are real, but with Trailblu\u2019s innovative solution, these challenges become manageable. By automating visual regression testing, reducing false positives, and supporting dynamic content, Trailblu empowers development teams to deliver visually flawless applications faster and more efficiently.\n\nEmbrace the future of visual testing with Trailblu. Transform your UI testing into a seamless, automated process and ensure your application delivers a pixel-perfect experience every time.\n\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"27Ho3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/profitCenterTesting.png" alt="Why Software Testing Should Be Considered a \'Profit Center\'"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n\n\nTraditionally, software testing has been perceived as a necessary but non-revenue-generating expense. However, in the rapidly evolving digital landscape, this perspective is shifting. Software testing can now be leveraged as a profit center, driving substantial value and contributing directly to a company\'s bottom line. This transformation is fueled by advancements in automation, AI-driven testing, and strategic integration within business processes.\n\n## The Strategic Value of Software Testing\n\n### Enhancing Product Quality and Customer Satisfaction\n\nHigh-quality software is paramount to customer satisfaction and retention. Effective testing ensures that products are free from defects, perform reliably, and meet user expectations. This reduces the likelihood of costly post-release fixes and enhances the overall user experience, leading to higher customer loyalty and repeat business.\n\n### Accelerating Time to Market\nIn today\u2019s fast-paced market, speed is a critical competitive advantage. Automated testing tools like TRAILBLU enable organizations to streamline their QA processes, significantly reducing the time required to test and deploy software. By integrating testing into Continuous Integration/Continuous Deployment (CI/CD) pipelines, businesses can release updates and new features more rapidly, staying ahead of competitors and responding swiftly to market demands.\n\n## Financial Benefits of Viewing Testing as a Profit Center\n\n###\xa0Cost Efficiency through Automation\nManual testing is time-consuming and resource-intensive. Automated testing with TRAILBLU reduces the reliance on highly skilled QA professionals with programming expertise, lowering labor costs. Automation also minimizes human error, ensuring more accurate and reliable testing outcomes. This leads to significant cost savings and allows for the reallocation of resources to more strategic projects.\n\n### Revenue Generation from Improved Product Quality\nDefect-free software enhances user satisfaction, reducing churn rates and increasing customer lifetime value. High-quality products are more likely to receive positive reviews and referrals, driving organic growth and new customer acquisition. Additionally, robust testing practices can shorten the sales cycle by providing potential customers with confidence in the product\u2019s reliability and performance.\n\n## Market Trends Supporting Software Testing as a Profit Center\n\n### Growth of the Software Testing Market\n\nThe global software testing market is experiencing robust growth, projected to exceed $97.3 billion by 2032. This expansion is driven by the increasing adoption of automated testing tools, the rise of AI-driven testing solutions, and the growing complexity of software systems. Businesses are investing heavily in advanced testing frameworks to ensure the reliability and security of their applications.\n\n### Adoption of Agile and DevOps Practices\nAgile and DevOps methodologies emphasize continuous testing and integration, making software testing an integral part of the development lifecycle. This shift towards continuous testing ensures that issues are identified and resolved promptly, maintaining high standards of software quality and accelerating delivery timelines.\n\n### Technological Advancements in Testing\nInnovations such as AI-driven testing, machine learning, and continuous integration are revolutionizing the software testing landscape. These technologies enhance the accuracy and efficiency of defect detection, enabling organizations to deliver higher-quality software at a faster pace. As a result, testing is becoming a strategic asset that directly contributes to business growth and profitability.\n\n### Gartner\u2019s Insights\nAccording to Gartner\u2019s 2023 report, by 2026, 50% of enterprise applications will separate support from subscription fees to create additional revenue stream. This highlights the growing trend of monetizing support and testing functions as part of broader business strategies, reinforcing the notion of testing as a profit center.\n\n### GMI\u2019s Market Analysis\nThe software testing market, projected to exceed $97.3 billion by 2032, underscores the critical role of testing in driving business growth. Key trends such as the adoption of AI-driven testing, continuous integration, and agile DevOps practices are propelling the market forward, making software testing an essential component of modern business strategies.\n\n\n## Conclusion\n\nNilay Kose, Test and Quality Manager at Fibabanka, shares her experience with TRAILBLU:\n\u201CFor our mobile app testing, we used to employ QAs with programming skills. Now, our QAs no longer need to know programming. With TRAILBLU, we can automate all our tests and get our product to market faster.\u201D\nThis testimonial exemplifies how automated testing tools can transform QA processes, leading to increased efficiency and faster time to market\u2014key indicators of a profit center.\n\nTransforming software testing from a cost center to a profit center is not just a strategic advantage\u2014it\u2019s a necessity in today\u2019s competitive market. By leveraging advanced automation tools like TRAILBLU, businesses can enhance product quality, accelerate time to market, and drive revenue growth. Embracing this shift enables organizations to not only reduce costs but also generate additional revenue streams, positioning software testing as a vital component of their overall business strategy.\nFor businesses looking to stay ahead, investing in robust software testing solutions is a strategic move that promises substantial returns. Embrace the potential of software testing as a profit center and unlock new avenues for growth and success.\n\n---\nReferences:\n- Gartner Predicts 2023: Gartner Report on Application Security Testing https://info.checkmarx.com/gartner-mq-2023 \n\n- GMI Insights: Software Testing Market Analysis \nhttps://www.gminsights.com/industry-analysis/software-testing-market \n\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dw1NB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/selfHealing.png" alt="AI-Powered Self-Healing in Test Automation"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n<!-- Understanding Self-Healing for Test Automation -->\n\nSelf-healing for test automation is a groundbreaking feature designed to minimize the disruption caused by dynamic changes in applications during automated testing. In traditional test automation, even the slightest change in the application (such as renaming a button or changing its location) can cause test scripts to fail, leading to delays in testing and the need for manual intervention. Self-healing systems proactively adjust the test scripts to accommodate these changes, allowing the tests to continue running without interruption.\n\nIn essence, self-healing involves automated test scripts that can detect, adapt to, and recover from changes in the application environment. This significantly reduces the maintenance burden on QA teams, increases test coverage, and ensures more stable and reliable results.\n\n### How Does Self-Healing Work?\n\nSelf-healing mechanisms rely on artificial intelligence (AI) and machine learning (ML) to detect changes in the application under test (AUT). Here\'s how it works:\n\n1. Element Identification: During the test, the system identifies the elements (buttons, fields, icons) involved in the application interface. Traditionally, this identification is based on attributes like IDs, XPath, or CSS selectors.\n   \n2. Dynamic Adaptation: If an element in the application changes, such as its ID or location, the self-healing mechanism dynamically adapts by re-evaluating alternative properties or patterns to locate the element again. It could use fallback strategies such as matching by text, tag name, or even visual recognition.\n\n3. Learning & Recovery: Over time, the system \u201Clearns\u201D from recurring changes and improves its ability to anticipate them, becoming more resilient to common modifications in the user interface. This ensures that tests can recover and continue without manual intervention.\n\nBy allowing tests to self-correct in real-time, self-healing mechanisms drastically reduce the need for manual updates to test scripts, making test automation a lot more resilient to changes and thus more efficient.\n\n### Example Scenario of Self-Healing in Action\n\nLet\u2019s consider an e-commerce web application that regularly updates its UI. Imagine your automated test script is validating the checkout process, and it specifically locates the \u201CSubmit Order\u201D button by its ID attribute. One day, the development team changes the button\'s ID during a UI redesign.\n\nWithout self-healing, the test would fail because the script couldn\u2019t find the "Submit Order" button. However, with self-healing enabled, the system recognizes that while the button ID has changed, its properties like text label ("Submit Order") and position in the UI remain consistent. The self-healing system dynamically adjusts the test script to find the button based on alternative attributes, allowing the test to proceed without breaking.\n\n### The Importance of Self-Healing for Test Automation\n\nIn the constantly evolving world of software development, applications are frequently updated with new features, bug fixes, or interface changes. These frequent updates can break automated tests, causing significant delays in product delivery as the QA team spends time diagnosing and fixing broken tests. Self-healing automation helps address this challenge by ensuring that tests are automatically maintained and updated, even as the application changes.\n\nKey reasons why self-healing is essential:\n\n- Reduces Test Maintenance: Traditional test automation requires significant time for maintaining scripts. Self-healing reduces this burden, freeing up testers to focus on more strategic tasks.\n\n- Increases Stability: By allowing tests to automatically adapt to changes, self-healing increases the stability of test suites and reduces the risk of false positives or failed tests due to minor application updates.\n\n- Increased Test Coverage: Tests can be run more frequently, providing continuous feedback.\n\n- Higher Reliability: Test results become more accurate as false failures are minimized.\n\n- Lower Cost: Reduced time spent on test maintenance means lower overall costs for test automation efforts.\n\n- Accelerates Time-to-Market: With less time spent on maintaining tests, teams can run automated tests more frequently, speeding up the feedback loop and helping teams release products faster.\n\nWhen discussing the advantages of self-healing in test automation, several statistics highlight its significance, particularly in improving efficiency and reducing costs. According to a report from Cigniti Technologies, maintenance accounts for up to 80% of the cost of traditional test automation efforts, as scripts need constant updates due to frequent UI changes. AI-driven self-healing can drastically reduce this maintenance burden by automatically adapting test scripts to changes, eliminating the need for manual intervention. As a result, it saves significant time and money, leading to faster software releases and improved ROI. \n\nFurthermore, the global software testing market is expected to grow significantly from USD 47.9 billion in 2023 to USD 66.0 billion by 2030, with a CAGR of 4.7%. This steady growth is being driven by factors like the increasing importance of quality assurance in digital transformation, the adoption of Agile and DevOps methodologies, and the advancements in automation, AI, and cloud-based testing solutions\u200B.\nKey drivers include the rise of continuous testing, enhanced test automation capabilities, and the growing demand for mobile and performance testing. Additionally, the shift towards cloud-based testing infrastructure has provided more flexibility and scalability, making it a popular choice for enterprises across industries\u200B.\n\nAdditionally, a self-healing approach enhances productivity by minimizing manual repair efforts and ensuring more stable and reliable test outcomes. This is particularly important in agile development environments, where maintaining the pace of continuous deployment without manual intervention is critical. By reducing manual maintenance time from several hours to virtually no time at all, businesses can significantly accelerate their development and testing cycles.\n\n### Trailblu\'s Approach to Self-Healing in Test Automation\n\nAt Trailblu, we specialize in AI-powered, no-code test automation that includes self-healing capabilities. Our platform empowers teams by not only simplifying the test creation process but also by ensuring that tests are resilient to changes in the application under test. With AI-driven self-healing, our system identifies when elements in the application have changed and automatically adapts, minimizing disruption and allowing your testing to continue smoothly.\n\nThis feature allows teams to focus on critical testing activities rather than spending valuable time troubleshooting broken tests. Our solution ensures high test stability and accelerates the testing process, enabling quicker feedback loops and faster product releases.\n\nBy integrating cutting-edge AI and self-healing mechanisms, Trailblu is at the forefront of test automation, reducing the manual burden for testers and increasing test suite resilience. Let us help you take your automation strategy to the next level.\n\n***\n\n- QASOURCE: https://blog.qasource.com/a-complete-guide-to-self-healing-test-automation \n\n- Cigniti: https://www.cigniti.com/blog/ai-for-seamless-software-testing-self-healing-revolution/ \n\n- Exactitiude Consultancy: \nhttps://exactitudeconsultancy.com/tr/reports/35404/software-testing-market/ \n\n- Software Testing - Global Strategic Business Report:\nhttps://www.researchandmarkets.com/report/software-testing\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bkM7i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/seleniumPlaywrightTesting.png" alt="Unlocking the Power of Selenium and Playwright"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n\n<!-- Unlocking the Power of Selenium and Playwright -->\n\n### Why Choose Selenium and Playwright for Web Testing?\n\nSelenium has long been the go-to tool in the world of web automation. Its flexibility and wide-ranging support for programming languages like Python, Java, and C# make it a versatile choice for developers and testers alike. Selenium allows you to automate repetitive tasks, thereby reducing the likelihood of human error and freeing up valuable time for your team to focus on more complex challenges.\n\nPlaywright, a newer entrant, is quickly gaining popularity for its cutting-edge capabilities. Unlike Selenium, Playwright supports fast and reliable testing across multiple browser contexts, including mobile, out of the box. This makes it an excellent choice for businesses that need to ensure their applications deliver a consistent user experience across different devices. Both tools are highly adaptable and can be easily integrated into your existing development workflow.\n\n\n### The Drawbacks of Selenium and Playwright\n\n- While Selenium and Playwright are powerful tools for web testing, they do come with certain limitations. One of the main challenges is the complexity involved in setting up and maintaining test environments, particularly when dealing with multiple browsers and platforms. This can lead to significant overhead in terms of time and resources. \n\n- Additionally, both tools require a considerable amount of coding expertise, which can limit their accessibility for teams without strong programming backgrounds. \n\n- The maintenance of test scripts as applications evolve can also be cumbersome, with frequent updates needed to keep tests accurate and relevant. Moreover, despite their capabilities, these tools can sometimes struggle with handling flaky tests and ensuring consistent performance across all testing scenarios.\n\nThis is where Trailblu comes in: Generative AI-Powered Test Automation.\n\nTrailblu enhances your testing strategy by allowing you to leverage the benefits of Selenium and Playwright without the associated drawbacks. By automating the creation and execution of test cases, Trailblu helps teams overcome the limitations of traditional manual scripting, enabling faster and more comprehensive testing.\n\n### Here\u2019s How Trailblu Makes A Difference:\n\n- Generative AI-Powered Test Creation: Trailblu automatically generates test cases tailored to your application\u2019s specific requirements, eliminating the need for manual scripting and ensuring broad coverage.\n- AI-Powered No-Code Testing: Our platform allows teams to create and manage tests without needing extensive coding expertise, making advanced automation accessible to a wider audience.\n- AI-Powered Visual Testing: Trailblu ensures that your application\'s UI remains consistent across different devices and browsers by automatically detecting and highlighting UI discrepancies.\n- AI-Powered Self-Healing: As your application evolves, so too must your tests. Trailblu\u2019s self-healing feature automatically updates and repairs test cases when UI elements change, reducing the burden of maintenance and ensuring your tests remain reliable.\n\nBy integrating Trailblu with Selenium and Playwright, you gain the combined benefits of flexibility, scalability, and cutting-edge AI-driven automation. This combination not only improves the efficiency and accuracy of your web testing process but also ensures that your applications meet the highest standards of quality.\n\n### Conclusion: A New Era of Web Testing\n\nDelivering a flawless user experience is essential in today\u2019s competitive digital landscape. With the combined power of Selenium, Playwright, and Trailblu\u2019s AI-Powered Test Automation, you can streamline your web testing process, reduce the risk of errors, and ensure your applications perform seamlessly across all platforms.\nReady to elevate your web testing strategy? Discover how Trailblu can help you achieve superior results with minimal effort.\n\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7RyRb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/deviceFarm.png" alt="Device and Browser Farm Testing" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n### What is a Real Device Farm?\n\nA Device Farm is a cloud-based testing environment that allows developers and testers to run their applications on a wide range of real mobile devices. Unlike emulators or simulators, which mimic device behaviors, a Device Farm provides access to actual hardware, ensuring that testing results reflect real-world user experiences. This approach is crucial for identifying device-specific issues that might not surface during simulated tests, ultimately leading to higher-quality applications.\n\n### How Does a Device Farm Work?\n\nTrailblu\u2019s Device Farm operates by providing remote access to a vast array of mobile devices, spanning various manufacturers, models, operating systems, and screen sizes. Testers can select the specific devices they want to test on and execute automated tests directly on those devices. The testing environment replicates the conditions that end-users will encounter, allowing for comprehensive testing scenarios that include different network conditions, battery states, and device settings.\n\n\n\n### Benefits of Using a Device Farm\n\n- Real-World Accuracy: Testing on real devices ensures that your application performs as expected across all hardware configurations, reducing the likelihood of unexpected issues post-launch.\n\n- Broader Coverage: Gain access to a wide range of devices, including both popular and niche models, ensuring comprehensive testing and higher reliability.\n\n- Faster Time-to-Market: By quickly identifying and fixing issues early in the development process, you can accelerate your application\u2019s release cycle without compromising quality.\n\n- Cost Efficiency: Accessing a variety of devices through a cloud-based farm eliminates the need for purchasing and maintaining a large inventory of physical devices, reducing overhead costs.\n\n### What is a Browser Farm?\n\nA Browser Farm is a testing environment that allows developers and testers to run their web applications across multiple browsers and browser versions. This is essential for ensuring that a web application delivers a consistent user experience regardless of the browser or operating system a user might be using.\n\n### How Does a Browser Farm Work?\n\nTrailblu\u2019s Browser Farm provides remote access to a diverse range of browsers, including different versions of popular browsers like Chrome, Firefox, Safari, and Edge. Testers can run automated tests across these browsers to identify compatibility issues, visual inconsistencies, or performance bottlenecks. This setup ensures that your web application functions correctly across all browser environments, which is crucial for maintaining a positive user experience.\n\n### Benefits of Using a Browser Farm\n\n- Cross-Browser Compatibility: Ensure that your web application works seamlessly on all major browsers, reducing the risk of user frustration and abandonment.\n\n- Consistent User Experience: A Browser Farm helps maintain a uniform look and feel across different browsers, which is key to user satisfaction and brand trust.\n\n- Scalable Testing: As your application evolves, a Browser Farm allows you to scale your testing efforts easily, accommodating new browser versions and updates without disrupting your workflow.\n\n- Efficient Issue Resolution: By identifying browser-specific issues early, your team can address potential problems before they impact end-users, leading to smoother deployments and fewer post-launch issues.\n\n### Conclusion\n\nTrailblu\u2019s Real Device Farm and Browser Farm are essential tools for businesses aiming to deliver high-quality applications that meet user expectations. By leveraging these advanced testing environments, you can ensure that your applications perform optimally across all devices and browsers, enhancing user satisfaction and driving business success.\n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jzn7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/testAutomation.png" alt="What is Test Automation and Why Does it Matter?"   style="border-radius: 10px; max-width: 100%;" />\n</p>\n\n\nIn the rapidly evolving landscape of software development, test automation has become a cornerstone for ensuring the quality and reliability of digital products. As businesses race to deliver software faster and more efficiently, the demand for robust testing methods has never been greater. But what exactly is test automation, and why is it so critical?\n\n### Understanding Test Automation\n\nTest automation refers to the use of specialized tools to execute tests on software applications automatically. This approach contrasts with traditional manual testing, where human testers manually execute test cases\u2014a process that can be both time-consuming and prone to error. Automated testing, however, enables quicker, more consistent results, making it an essential practice for modern QA teams.\nAt its core, test automation is about efficiency and accuracy. By automating repetitive tasks, companies can free up valuable resources, reduce human error, and achieve higher test coverage. This is particularly important as software applications become more complex and need to function seamlessly across various platforms and devices.\n\n### The Advantages of Test Automation\n\nOne of the significant advantages of test automation is its ability to handle complex testing scenarios that would be nearly impossible to manage manually. Automated tests can be run repeatedly at any time of day, providing immediate feedback to developers and allowing for faster iterations. This continuous feedback loop is essential for Agile and DevOps practices, where quick turnarounds are crucial.\nMoreover, test automation is a key driver in reducing time-to-market. In today\u2019s competitive environment, the ability to release high-quality software quickly can make or break a business. Automated testing enables companies to accelerate their development cycles without compromising on quality. By automating repetitive and complex testing tasks, businesses can ensure that their software is robust, reliable, and ready to meet the demands of modern users.\n\nAccording to a 2023 Gartner report, 60% of organizations automate software testing primarily to enhance product quality, with 58% citing the need to accelerate deployment speed as a key factor. Other notable reasons for adopting automated testing include improving departmental agility (41%), supporting CI/CD processes (36%), and reducing the workload on QA teams (29%). \n\n### Challenges in Traditional Test Automation\n\nDespite its benefits, traditional test automation is not without its challenges. Maintenance can become a significant issue, especially as applications evolve and new features are added. Automation scripts often require regular updates, which can be both time-consuming and resource-intensive. Additionally, traditional test automation typically requires developer expertise, making it difficult for teams with limited technical resources to implement effectively.\n\n### Trailblu\u2019s Innovative Approach\n\nThis is where Trailblu steps in. At Trailblu, we are revolutionizing test automation with our generative AI-powered, no-code platform. Our solution addresses the common challenges of traditional test automation by reducing maintenance efforts and simplifying the creation of automation scripts. With Trailblu, businesses can automate end-to-end testing processes with ease, even without extensive programming knowledge.\n\nOur platform also incorporates advanced features such as AI-powered visual testing and self-healing capabilities, ensuring that tests remain reliable and accurate over time. These innovations not only reduce the need for manual intervention but also enhance the overall quality of the software.\n\n### Why Test Automation Matters\n\nIn conclusion, test automation is no longer just a trend\u2014it\u2019s a necessity for any business aiming to stay competitive in today\u2019s digital world. As software applications become more complex and user expectations continue to rise, the importance of reliable and efficient testing methods cannot be overstated.\n\nBy adopting advanced test automation tools like those offered by Trailblu, companies can ensure their software meets the highest standards of quality and performance. Whether you\u2019re looking to reduce time-to-market, improve test coverage, or simply enhance the reliability of your software, test automation is the key to achieving your goals.\n\nReady to transform your testing process? https://www.trailblu.com/request-a-demo \nhttps://www.gartner.com/peer-community/oneminuteinsights/automated-software-testing-adoption-trends-7d6 \n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eyLg4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '<p align="center">\n  <img src="/validationVerification.png" alt="Navigating Software Testing: Validation vs. Verification" style="border-radius: 10px; max-width: 100%;" />\n</p>\n\nIn the software development lifecycle, understanding the distinction between validation and verification is crucial for ensuring high-quality products. While these terms are often used interchangeably, they play distinct roles in the development process. Misunderstanding or neglecting either can lead to costly errors and delays. In this article, we\u2019ll break down the differences and explain why both processes are essential to delivering successful software.\n\n### What is Verification?\n\nVerification is the process of evaluating work products to ensure they meet specified requirements and design standards. It answers the question: Are we building the product correctly?\nDuring the verification phase, the focus is on reviewing elements such as code, architecture, and documentation to confirm that the software is being developed according to predefined specifications. Verification primarily involves static testing methods, such as:\n\n- Code Reviews\n- Inspections\n- Walkthroughs\n\nVerification is typically carried out early in the development cycle and continues throughout the project. This early intervention helps identify issues before they evolve into larger problems. Research by the IEEE suggests that addressing defects early during verification can reduce project costs by up to 30%.\n\n### What is Validation?\n\nValidation, on the other hand, addresses a different question: Are we building the right product?\nValidation ensures that the finished software meets the needs and expectations of end users. It involves dynamic testing processes such as functional, non-functional, and user-focused testing. Key validation methods include:\n\n- Functional Testing\n- User Acceptance Testing (UAT)\n- Performance Testing\n\nWhile verification checks whether the product is being built according to design specifications, validation confirms that the software fulfills its intended purpose. According to Gartner, 56% of failed software projects are attributed to poor validation and misalignment with user requirements, highlighting the importance of this phase.\n\n###\xa0Why Both Are Essential?\n\nBoth verification and validation are integral to delivering a functional, reliable product that meets user expectations. Neglecting either process can lead to serious setbacks:\n\n- Skipping Verification: Without proper verification, issues in the code or design may remain undetected, leading to expensive fixes later in the project.\n- Neglecting Validation: Failing to validate the product risks releasing software that doesn\u2019t meet user needs, leading to poor user satisfaction and potential project failure.\n\nIndustry experts recommend a balanced approach. Capers Jones, a leading researcher in software quality, asserts that projects that incorporate both effective verification and validation can improve overall product quality by up to 45%, while significantly reducing defect-related costs.\n\n### The Trailblu Approach to Software Testing\n\nAt Trailblu, we integrate both validation and verification throughout the software development lifecycle. Our advanced automated testing solutions ensure that your software is:\n- Built right through early defect detection during verification.\n- Aligned with user expectations through comprehensive validation.\n- Delivered quickly and efficiently with scalable automated testing.\n\nBy combining cutting-edge AI tools with human expertise, we offer a seamless testing framework that helps businesses reduce risks, enhance quality, and streamline their development processes.\n\n## Conclusion\n\nNavigating the software testing landscape requires a clear understanding of both validation and verification. By incorporating both processes at the appropriate stages, you can minimize costs, enhance product quality, and ensure that the software not only meets design specifications but also satisfies user needs.\n\nAt Trailblu, we provide the tools and expertise to optimize both aspects of testing, enabling your team to deliver high-quality, reliable software on time. Begin your journey toward flawless software testing with us today!\n\n \n\n';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gHXHB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpecificBlog", ()=>SpecificBlog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("../../components/Header/Header"); // Import your Header component
var _headerDefault = parcelHelpers.interopDefault(_header);
var _styleCss = require("./style.css"); // Import your CSS file for Blog styling
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _subscription = require("../../components/Subscription/Subscription");
var _subscriptionDefault = parcelHelpers.interopDefault(_subscription);
var _trailbluIntroPng = require("../../assets/TrailbluIntro.png");
var _trailbluIntroPngDefault = parcelHelpers.interopDefault(_trailbluIntroPng);
var _reactHelmetAsync = require("react-helmet-async");
var _marked = require("marked");
var _p31Png = require("../../assets/p31.png");
var _p31PngDefault = parcelHelpers.interopDefault(_p31Png);
var _p3Png = require("../../assets/p3.png");
var _p3PngDefault = parcelHelpers.interopDefault(_p3Png);
var _p2Png = require("../../assets/p2.png");
var _p2PngDefault = parcelHelpers.interopDefault(_p2Png);
var _p21Png = require("../../assets/p21.png");
var _p21PngDefault = parcelHelpers.interopDefault(_p21Png);
var _p22Png = require("../../assets/p22.png");
var _p22PngDefault = parcelHelpers.interopDefault(_p22Png);
var _codelessAutomatedPng = require("../../assets/codelessAutomated.png");
var _codelessAutomatedPngDefault = parcelHelpers.interopDefault(_codelessAutomatedPng);
var _visualTestingPng = require("../../assets/visualTesting.png");
var _visualTestingPngDefault = parcelHelpers.interopDefault(_visualTestingPng);
var _flutterTestingPng = require("../../assets/flutterTesting.png");
var _flutterTestingPngDefault = parcelHelpers.interopDefault(_flutterTestingPng);
var _flutterTesting2Png = require("../../assets/flutterTesting2.png");
var _flutterTesting2PngDefault = parcelHelpers.interopDefault(_flutterTesting2Png);
var _flutterTesting3Png = require("../../assets/flutterTesting3.png");
var _flutterTesting3PngDefault = parcelHelpers.interopDefault(_flutterTesting3Png);
var _generativeAIPng = require("../../assets/generativeAI.png");
var _generativeAIPngDefault = parcelHelpers.interopDefault(_generativeAIPng);
var _generativeAI2Png = require("../../assets/generativeAI2.png");
var _generativeAI2PngDefault = parcelHelpers.interopDefault(_generativeAI2Png);
var _generativeAI3Png = require("../../assets/generativeAI3.png");
var _generativeAI3PngDefault = parcelHelpers.interopDefault(_generativeAI3Png);
var _qatarPng = require("../../assets/qatar.png");
var _qatarPngDefault = parcelHelpers.interopDefault(_qatarPng);
var _qatarEvent2Png = require("../../assets/qatar_event2.png");
var _qatarEvent2PngDefault = parcelHelpers.interopDefault(_qatarEvent2Png);
var _revolutionizetestingAI1Png = require("../../assets/revolutionizetestingAI1.png");
var _revolutionizetestingAI1PngDefault = parcelHelpers.interopDefault(_revolutionizetestingAI1Png);
var _revolutionizetestingAI2Png = require("../../assets/revolutionizetestingAI2.png");
var _revolutionizetestingAI2PngDefault = parcelHelpers.interopDefault(_revolutionizetestingAI2Png);
var _continuousTesting1Png = require("../../assets/ContinuousTesting1.png");
var _continuousTesting1PngDefault = parcelHelpers.interopDefault(_continuousTesting1Png);
var _continuousTesting2Png = require("../../assets/ContinuousTesting2.png");
var _continuousTesting2PngDefault = parcelHelpers.interopDefault(_continuousTesting2Png);
var _regressionTesting1Png = require("../../assets/RegressionTesting1.png");
var _regressionTesting1PngDefault = parcelHelpers.interopDefault(_regressionTesting1Png);
var _scalingSoftwareTestingAIPng = require("../../assets/scalingSoftwareTestingAI.png");
var _scalingSoftwareTestingAIPngDefault = parcelHelpers.interopDefault(_scalingSoftwareTestingAIPng);
var _endToEndTestingPng = require("../../assets/endToEndTesting.png");
var _endToEndTestingPngDefault = parcelHelpers.interopDefault(_endToEndTestingPng);
var _crossDeviceTestingPng = require("../../assets/crossDeviceTesting.png");
var _crossDeviceTestingPngDefault = parcelHelpers.interopDefault(_crossDeviceTestingPng);
var _profitCenterTestingPng = require("../../assets/profitCenterTesting.png");
var _profitCenterTestingPngDefault = parcelHelpers.interopDefault(_profitCenterTestingPng);
var _seleniumPlaywrightTestingPng = require("../../assets/seleniumPlaywrightTesting.png");
var _seleniumPlaywrightTestingPngDefault = parcelHelpers.interopDefault(_seleniumPlaywrightTestingPng);
var _deviceFarmPng = require("../../assets/deviceFarm.png");
var _deviceFarmPngDefault = parcelHelpers.interopDefault(_deviceFarmPng);
var _testAutomationPng = require("../../assets/testAutomation.png");
var _testAutomationPngDefault = parcelHelpers.interopDefault(_testAutomationPng);
var _validationVerificationPng = require("../../assets/validationVerification.png");
var _validationVerificationPngDefault = parcelHelpers.interopDefault(_validationVerificationPng);
const SpecificBlog = ({ label, blogImage, title, metaDescription, metaTitle, authorName, date, readTime, content, authorImageUrl })=>{
    const replaceImages = (markdown)=>{
        return markdown.replace("/selfHealing.png", (0, _p31PngDefault.default)).replace("/codelessAutomated.png", (0, _codelessAutomatedPngDefault.default)).replace("/P2.png", (0, _p2PngDefault.default)).replace("/P3.png", (0, _p3PngDefault.default)).replace("/P21.png", (0, _p21PngDefault.default)).replace("./P22.png", (0, _p22PngDefault.default)).replace("/visualTesting.png", (0, _visualTestingPngDefault.default)).replace("/FlutterTesting.png", (0, _flutterTestingPngDefault.default)).replace("/flutterTesting2.png", (0, _flutterTesting2PngDefault.default)).replace("/flutterTesting3.png", (0, _flutterTesting3PngDefault.default)).replace("/GenerativeAI.png", (0, _generativeAIPngDefault.default)).replace("/GenerativeAI2.png", (0, _generativeAI2PngDefault.default)).replace("/GenerativeAI3.png", (0, _generativeAI3PngDefault.default)).replace("/revolutionizetestingAI1.png", (0, _revolutionizetestingAI1PngDefault.default)).replace("/revolutionizetestingAI2.png", (0, _revolutionizetestingAI2PngDefault.default)).replace("/ContinuousTesting1.png", (0, _continuousTesting1PngDefault.default)).replace("/ContinuousTesting2.png", (0, _continuousTesting2PngDefault.default)).replace("/RegressionTesting1.png", (0, _regressionTesting1PngDefault.default)).replace("/qatar.png", (0, _qatarPngDefault.default)).replace("/qatar_event2.png", (0, _qatarEvent2PngDefault.default)).replace("/scalingSoftwareTestingAI.png", (0, _scalingSoftwareTestingAIPngDefault.default)).replace("/endToEndTesting.png", (0, _endToEndTestingPngDefault.default)).replace("/crossDeviceTesting.png", (0, _crossDeviceTestingPngDefault.default)).replace("/profitCenterTesting.png", (0, _profitCenterTestingPngDefault.default)).replace("/seleniumPlaywrightTesting.png", (0, _seleniumPlaywrightTestingPngDefault.default)).replace("/deviceFarm.png", (0, _deviceFarmPngDefault.default)).replace("/validationVerification.png", (0, _validationVerificationPngDefault.default)).replace("/testAutomation.png", (0, _testAutomationPngDefault.default));
    };
    const replacedImagesContent = replaceImages(content);
    const markedToHtml = (0, _marked.marked).parse(replacedImagesContent);
    const [markdownContent, setMarkdownContent] = (0, _react.useState)("");
    const createSlug = (title)=>{
        return title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
    };
    (0, _react.useEffect)(()=>{
        setMarkdownContent(content);
    }, []);
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image",
                        content: blogImage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: "TRAILBLU Blog Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:card",
                        content: " summary_large_image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@trailblu"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image",
                        content: blogImage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image:alt",
                        content: "TRAILBLU Blog Image"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:url",
                        content: `https://www.trailblu.com/blog/${createSlug(title)}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Trailblu Blog"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        property: "og:image:height",
                        content: "600"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hero-section-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "section-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "starter-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "label-2",
                                children: label
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "middle-starter",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "h1-class-2",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "author"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "divider-section-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "date-read-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: date
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "date-divider"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "read-time",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: readTime
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "min-read-txt",
                                                    children: "min read"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "content-section",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "content-container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "content",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: markedToHtml
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscriptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = SpecificBlog;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Header/Header":"j0rW0","./style.css":"jVCv7","../../components/Footer/Footer":"2Br4S","../../components/Subscription/Subscription":"8mH2y","../../assets/TrailbluIntro.png":"1rplF","react-helmet-async":"5Z9jX","marked":"61TfJ","../../assets/p31.png":"68zWL","../../assets/p3.png":"8bwsE","../../assets/p2.png":"4zcHQ","../../assets/p21.png":"aVZSv","../../assets/p22.png":"e6V9t","../../assets/codelessAutomated.png":"1yYsc","../../assets/visualTesting.png":"hvZkZ","../../assets/flutterTesting.png":"4D9lc","../../assets/flutterTesting2.png":"c1d98","../../assets/flutterTesting3.png":"k1cPI","../../assets/generativeAI.png":"ePeP0","../../assets/generativeAI2.png":"5VAvG","../../assets/generativeAI3.png":"ZakbA","../../assets/qatar.png":"cGUbm","../../assets/qatar_event2.png":"kM02K","../../assets/revolutionizetestingAI1.png":"aekCl","../../assets/revolutionizetestingAI2.png":"dPGkp","../../assets/ContinuousTesting1.png":"hycqj","../../assets/ContinuousTesting2.png":"6Ytnd","../../assets/RegressionTesting1.png":"kmWQV","../../assets/scalingSoftwareTestingAI.png":"8P2dz","../../assets/endToEndTesting.png":"bE3D0","../../assets/crossDeviceTesting.png":"dQWLf","../../assets/profitCenterTesting.png":"7q1MD","../../assets/seleniumPlaywrightTesting.png":"cs4yD","../../assets/deviceFarm.png":"gofbs","../../assets/testAutomation.png":"ihDTG","../../assets/validationVerification.png":"eNsyq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVCv7":[function() {},{}],"61TfJ":[function(require,module,exports) {
/**
 * marked v10.0.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ /**
 * Gets the original marked default options.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hooks", ()=>_Hooks);
parcelHelpers.export(exports, "Lexer", ()=>_Lexer);
parcelHelpers.export(exports, "Marked", ()=>Marked);
parcelHelpers.export(exports, "Parser", ()=>_Parser);
parcelHelpers.export(exports, "Renderer", ()=>_Renderer);
parcelHelpers.export(exports, "TextRenderer", ()=>_TextRenderer);
parcelHelpers.export(exports, "Tokenizer", ()=>_Tokenizer);
parcelHelpers.export(exports, "defaults", ()=>_defaults);
parcelHelpers.export(exports, "getDefaults", ()=>_getDefaults);
parcelHelpers.export(exports, "lexer", ()=>lexer);
parcelHelpers.export(exports, "marked", ()=>marked);
parcelHelpers.export(exports, "options", ()=>options);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "parseInline", ()=>parseInline);
parcelHelpers.export(exports, "parser", ()=>parser);
parcelHelpers.export(exports, "setOptions", ()=>setOptions);
parcelHelpers.export(exports, "use", ()=>use);
parcelHelpers.export(exports, "walkTokens", ()=>walkTokens);
function _getDefaults() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
let _defaults = _getDefaults();
function changeDefaults(newDefaults) {
    _defaults = newDefaults;
}
/**
 * Helpers
 */ const escapeTest = /[&<>"']/;
const escapeReplace = new RegExp(escapeTest.source, "g");
const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
const escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
const getEscapeReplacement = (ch)=>escapeReplacements[ch];
function escape(html, encode) {
    if (encode) {
        if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
    } else {
        if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
    }
    return html;
}
const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, (_, n)=>{
        n = n.toLowerCase();
        if (n === "colon") return ":";
        if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
        return "";
    });
}
const caret = /(^|[^\[])\^/g;
function edit(regex, opt) {
    regex = typeof regex === "string" ? regex : regex.source;
    opt = opt || "";
    const obj = {
        replace: (name, val)=>{
            val = typeof val === "object" && "source" in val ? val.source : val;
            val = val.replace(caret, "$1");
            regex = regex.replace(name, val);
            return obj;
        },
        getRegex: ()=>{
            return new RegExp(regex, opt);
        }
    };
    return obj;
}
function cleanUrl(href) {
    try {
        href = encodeURI(href).replace(/%25/g, "%");
    } catch (e) {
        return null;
    }
    return href;
}
const noopTest = {
    exec: ()=>null
};
function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    const row = tableRow.replace(/\|/g, (match, offset, str)=>{
        let escaped = false;
        let curr = offset;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) // odd number of slashes means | is escaped
        // so we leave it alone
        return "|";
        else // add space before unescaped |
        return " |";
    }), cells = row.split(/ \|/);
    let i = 0;
    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
    }
    for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace(/\\\|/g, "|");
    return cells;
}
/**
 * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
 * /c*$/ is vulnerable to REDOS.
 *
 * @param str
 * @param c
 * @param invert Remove suffix of non-c chars instead. Default falsey.
 */ function rtrim(str, c, invert) {
    const l = str.length;
    if (l === 0) return "";
    // Length of suffix matching the invert condition.
    let suffLen = 0;
    // Step left until we fail to match the invert condition.
    while(suffLen < l){
        const currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    let level = 0;
    for(let i = 0; i < str.length; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    return -1;
}
function outputLink(cap, link, raw, lexer) {
    const href = link.href;
    const title = link.title ? escape(link.title) : null;
    const text = cap[1].replace(/\\([\[\]])/g, "$1");
    if (cap[0].charAt(0) !== "!") {
        lexer.state.inLink = true;
        const token = {
            type: "link",
            raw,
            href,
            title,
            text,
            tokens: lexer.inlineTokens(text)
        };
        lexer.state.inLink = false;
        return token;
    }
    return {
        type: "image",
        raw,
        href,
        title,
        text: escape(text)
    };
}
function indentCodeCompensation(raw, text) {
    const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) return text;
    const indentToCode = matchIndentToCode[1];
    return text.split("\n").map((node)=>{
        const matchIndentInNode = node.match(/^\s+/);
        if (matchIndentInNode === null) return node;
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
/**
 * Tokenizer
 */ class _Tokenizer {
    options;
    // TODO: Fix this rules type
    rules;
    lexer;
    constructor(options){
        this.options = options || _defaults;
    }
    space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) return {
            type: "space",
            raw: cap[0]
        };
    }
    code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
            const text = cap[0].replace(/^ {1,4}/gm, "");
            return {
                type: "code",
                raw: cap[0],
                codeBlockStyle: "indented",
                text: !this.options.pedantic ? rtrim(text, "\n") : text
            };
        }
    }
    fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
            const raw = cap[0];
            const text = indentCodeCompensation(raw, cap[3] || "");
            return {
                type: "code",
                raw,
                lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, "$1") : cap[2],
                text
            };
        }
    }
    heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
            let text = cap[2].trim();
            // remove trailing #s
            if (/#$/.test(text)) {
                const trimmed = rtrim(text, "#");
                if (this.options.pedantic) text = trimmed.trim();
                else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                text = trimmed.trim();
            }
            return {
                type: "heading",
                raw: cap[0],
                depth: cap[1].length,
                text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) return {
            type: "hr",
            raw: cap[0]
        };
    }
    blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
            const text = rtrim(cap[0].replace(/^ *>[ \t]?/gm, ""), "\n");
            const top = this.lexer.state.top;
            this.lexer.state.top = true;
            const tokens = this.lexer.blockTokens(text);
            this.lexer.state.top = top;
            return {
                type: "blockquote",
                raw: cap[0],
                tokens,
                text
            };
        }
    }
    list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list = {
                type: "list",
                raw: "",
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : "",
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
            // Get next list item
            const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
            let raw = "";
            let itemContents = "";
            let endsWithBlankLine = false;
            // Check if current bullet point can start a new List Item
            while(src){
                let endEarly = false;
                if (!(cap = itemRegex.exec(src))) break;
                if (this.rules.block.hr.test(src)) break;
                raw = cap[0];
                src = src.substring(raw.length);
                let line = cap[2].split("\n", 1)[0].replace(/^\t+/, (t)=>" ".repeat(3 * t.length));
                let nextLine = src.split("\n", 1)[0];
                let indent = 0;
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimStart();
                } else {
                    indent = cap[2].search(/[^ ]/); // Find first non-space char
                    indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                let blankLine = false;
                if (!line && /^ *$/.test(nextLine)) {
                    raw += nextLine + "\n";
                    src = src.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                    const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                    const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                    const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                    // Check if following lines should be included in List Item
                    while(src){
                        const rawLine = src.split("\n", 1)[0];
                        nextLine = rawLine;
                        // Re-align to follow commonmark nesting rules
                        if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                        // End list item if found code fences
                        if (fencesBeginRegex.test(nextLine)) break;
                        // End list item if found start of new heading
                        if (headingBeginRegex.test(nextLine)) break;
                        // End list item if found start of new bullet
                        if (nextBulletRegex.test(nextLine)) break;
                        // Horizontal rule found
                        if (hrRegex.test(src)) break;
                        if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) itemContents += "\n" + nextLine.slice(indent);
                        else {
                            // not enough indentation
                            if (blankLine) break;
                            // paragraph continuation unless last line was a different block level element
                            if (line.search(/[^ ]/) >= 4) break;
                            if (fencesBeginRegex.test(line)) break;
                            if (headingBeginRegex.test(line)) break;
                            if (hrRegex.test(line)) break;
                            itemContents += "\n" + nextLine;
                        }
                        if (!blankLine && !nextLine.trim()) blankLine = true;
                        raw += rawLine + "\n";
                        src = src.substring(rawLine.length + 1);
                        line = nextLine.slice(indent);
                    }
                }
                if (!list.loose) {
                    // If the previous item ended with a blank line, the list is loose
                    if (endsWithBlankLine) list.loose = true;
                    else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                }
                let istask = null;
                let ischecked;
                // Check for task list items
                if (this.options.gfm) {
                    istask = /^\[[ xX]\] /.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== "[ ] ";
                        itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                    }
                }
                list.items.push({
                    type: "list_item",
                    raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents,
                    tokens: []
                });
                list.raw += raw;
            }
            // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
            list.items[list.items.length - 1].raw = raw.trimEnd();
            list.items[list.items.length - 1].text = itemContents.trimEnd();
            list.raw = list.raw.trimEnd();
            // Item child tokens handled here at end because we needed to have the final item to trim it first
            for(let i = 0; i < list.items.length; i++){
                this.lexer.state.top = false;
                list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                if (!list.loose) {
                    // Check if list should be loose
                    const spacers = list.items[i].tokens.filter((t)=>t.type === "space");
                    const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>/\n.*\n/.test(t.raw));
                    list.loose = hasMultipleLineBreaks;
                }
            }
            // Set all items to loose if list is loose
            if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
            return list;
        }
    }
    html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
            const token = {
                type: "html",
                block: true,
                raw: cap[0],
                pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                text: cap[0]
            };
            return token;
        }
    }
    def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
            const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
            const href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "";
            const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, "$1") : cap[3];
            return {
                type: "def",
                tag,
                raw: cap[0],
                href,
                title
            };
        }
    }
    table(src) {
        const cap = this.rules.block.table.exec(src);
        if (cap) {
            if (!/[:|]/.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
            return;
            const item = {
                type: "table",
                raw: cap[0],
                header: splitCells(cap[1]).map((c)=>{
                    return {
                        text: c,
                        tokens: []
                    };
                }),
                align: cap[2].replace(/^\||\| *$/g, "").split("|"),
                rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : []
            };
            if (item.header.length === item.align.length) {
                let l = item.align.length;
                let i, j, k, row;
                for(i = 0; i < l; i++){
                    const align = item.align[i];
                    if (align) {
                        if (/^ *-+: *$/.test(align)) item.align[i] = "right";
                        else if (/^ *:-+: *$/.test(align)) item.align[i] = "center";
                        else if (/^ *:-+ *$/.test(align)) item.align[i] = "left";
                        else item.align[i] = null;
                    }
                }
                l = item.rows.length;
                for(i = 0; i < l; i++)item.rows[i] = splitCells(item.rows[i], item.header.length).map((c)=>{
                    return {
                        text: c,
                        tokens: []
                    };
                });
                // parse child tokens inside headers and cells
                // header child tokens
                l = item.header.length;
                for(j = 0; j < l; j++)item.header[j].tokens = this.lexer.inline(item.header[j].text);
                // cell child tokens
                l = item.rows.length;
                for(j = 0; j < l; j++){
                    row = item.rows[j];
                    for(k = 0; k < row.length; k++)row[k].tokens = this.lexer.inline(row[k].text);
                }
                return item;
            }
        }
    }
    lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) return {
            type: "heading",
            raw: cap[0],
            depth: cap[2].charAt(0) === "=" ? 1 : 2,
            text: cap[1],
            tokens: this.lexer.inline(cap[1])
        };
    }
    paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
            const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
            return {
                type: "paragraph",
                raw: cap[0],
                text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) return {
            type: "text",
            raw: cap[0],
            text: cap[0],
            tokens: this.lexer.inline(cap[0])
        };
    }
    escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) return {
            type: "escape",
            raw: cap[0],
            text: escape(cap[1])
        };
    }
    tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
            if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
            else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
            if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
            else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
            return {
                type: "html",
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: false,
                text: cap[0]
            };
        }
    }
    link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                // commonmark requires matching angle brackets
                if (!/>$/.test(trimmedUrl)) return;
                // ending angle bracket cannot be escaped
                const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
            } else {
                // find closing parenthesis
                const lastParenIndex = findClosingBracket(cap[2], "()");
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = "";
                }
            }
            let href = cap[2];
            let title = "";
            if (this.options.pedantic) {
                // split pedantic href and title
                const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                if (link) {
                    href = link[1];
                    title = link[3];
                }
            } else title = cap[3] ? cap[3].slice(1, -1) : "";
            href = href.trim();
            if (/^</.test(href)) {
                if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                href = href.slice(1);
                else href = href.slice(1, -1);
            }
            return outputLink(cap, {
                href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
                title: title ? title.replace(this.rules.inline._escapes, "$1") : title
            }, cap[0], this.lexer);
        }
    }
    reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
            let link = (cap[2] || cap[1]).replace(/\s+/g, " ");
            link = links[link.toLowerCase()];
            if (!link) {
                const text = cap[0].charAt(0);
                return {
                    type: "text",
                    raw: text,
                    text
                };
            }
            return outputLink(cap, link, cap[0], this.lexer);
        }
    }
    emStrong(src, maskedSrc, prevChar = "") {
        let match = this.rules.inline.emStrong.lDelim.exec(src);
        if (!match) return;
        // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
        if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
        const nextChar = match[1] || match[2] || "";
        if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
            // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
            const lLength = [
                ...match[0]
            ].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
            endReg.lastIndex = 0;
            // Clip maskedSrc to same section of string as src (move to lexer?)
            maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
            while((match = endReg.exec(maskedSrc)) != null){
                rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                if (!rDelim) continue; // skip single * in __abc*abc__
                rLength = [
                    ...rDelim
                ].length;
                if (match[3] || match[4]) {
                    delimTotal += rLength;
                    continue;
                } else if (match[5] || match[6]) {
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue; // CommonMark Emphasis Rules 9-10
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                // Remove extra characters. *a*** -> *a*
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                // char length can be >1 for unicode characters;
                const lastCharLength = [
                    ...match[0]
                ][0].length;
                const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                // Create `em` if smallest delimiter has odd char count. *a***
                if (Math.min(lLength, rLength) % 2) {
                    const text = raw.slice(1, -1);
                    return {
                        type: "em",
                        raw,
                        text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
                // Create 'strong' if smallest delimiter has even char count. **a***
                const text = raw.slice(2, -2);
                return {
                    type: "strong",
                    raw,
                    text,
                    tokens: this.lexer.inlineTokens(text)
                };
            }
        }
    }
    codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
            let text = cap[2].replace(/\n/g, " ");
            const hasNonSpaceChars = /[^ ]/.test(text);
            const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
            text = escape(text, true);
            return {
                type: "codespan",
                raw: cap[0],
                text
            };
        }
    }
    br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) return {
            type: "br",
            raw: cap[0]
        };
    }
    del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) return {
            type: "del",
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2])
        };
    }
    autolink(src) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
            let text, href;
            if (cap[2] === "@") {
                text = escape(cap[1]);
                href = "mailto:" + text;
            } else {
                text = escape(cap[1]);
                href = text;
            }
            return {
                type: "link",
                raw: cap[0],
                text,
                href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text
                    }
                ]
            };
        }
    }
    url(src) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
            let text, href;
            if (cap[2] === "@") {
                text = escape(cap[0]);
                href = "mailto:" + text;
            } else {
                // do extended autolink path validation
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                }while (prevCapZero !== cap[0]);
                text = escape(cap[0]);
                if (cap[1] === "www.") href = "http://" + cap[0];
                else href = cap[0];
            }
            return {
                type: "link",
                raw: cap[0],
                text,
                href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text
                    }
                ]
            };
        }
    }
    inlineText(src) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
            let text;
            if (this.lexer.state.inRawBlock) text = cap[0];
            else text = escape(cap[0]);
            return {
                type: "text",
                raw: cap[0],
                text
            };
        }
    }
}
/**
 * Block-Level Grammar
 */ // Not all rules are defined in the object literal
// @ts-expect-error
const block = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
    def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: noopTest,
    lheading: /^(?!bull )((?:.|\n(?!\s*?\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
};
block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block.def = edit(block.def).replace("label", block._label).replace("title", block._title).getRegex();
block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
block.listItemStart = edit(/^( *)(bull) */).replace("bull", block.bullet).getRegex();
block.list = edit(block.list).replace(/bull/g, block.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block.def.source + ")").getRegex();
block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
block.html = edit(block.html, "i").replace("comment", block._comment).replace("tag", block._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
block.lheading = edit(block.lheading).replace(/bull/g, block.bullet) // lists can interrupt
.getRegex();
block.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
.replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
.replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
.getRegex();
block.blockquote = edit(block.blockquote).replace("paragraph", block.paragraph).getRegex();
/**
 * Normal Block Grammar
 */ block.normal = {
    ...block
};
/**
 * GFM Block Grammar
 */ block.gfm = {
    ...block.normal,
    table: "^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
};
block.gfm.table = edit(block.gfm.table).replace("hr", block.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
.replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // tables can be interrupted by type (6) html blocks
.getRegex();
block.gfm.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
.replace("table", block.gfm.table) // interrupt paragraphs with table
.replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
.replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
.getRegex();
/**
 * Pedantic grammar (original John Gruber's loose markdown specification)
 */ block.pedantic = {
    ...block.normal,
    html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(block.normal._paragraph).replace("hr", block.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
};
/**
 * Inline-Level Grammar
 */ // Not all rules are defined in the object literal
// @ts-expect-error
const inline = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: "reflink|nolink(?!\\()",
    emStrong: {
        lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
        //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
        //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
        rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
        rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/ // ^- Not allowed for _
    },
    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^((?![*_])[\spunctuation])/
};
// list of unicode punctuation marks, plus any missing characters from CommonMark spec
inline._punctuation = "\\p{P}$+<=>`^|~";
inline.punctuation = edit(inline.punctuation, "u").replace(/punctuation/g, inline._punctuation).getRegex();
// sequences em should skip over [title](link), `code`, <html>
inline.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
inline.anyPunctuation = /\\[punct]/g;
inline._escapes = /\\([punct])/g;
inline._comment = edit(block._comment).replace("(?:-->|$)", "-->").getRegex();
inline.emStrong.lDelim = edit(inline.emStrong.lDelim, "u").replace(/punct/g, inline._punctuation).getRegex();
inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, "gu").replace(/punct/g, inline._punctuation).getRegex();
inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, "gu").replace(/punct/g, inline._punctuation).getRegex();
inline.anyPunctuation = edit(inline.anyPunctuation, "gu").replace(/punct/g, inline._punctuation).getRegex();
inline._escapes = edit(inline._escapes, "gu").replace(/punct/g, inline._punctuation).getRegex();
inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline.autolink = edit(inline.autolink).replace("scheme", inline._scheme).replace("email", inline._email).getRegex();
inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
inline.tag = edit(inline.tag).replace("comment", inline._comment).replace("attribute", inline._attribute).getRegex();
inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
inline.link = edit(inline.link).replace("label", inline._label).replace("href", inline._href).replace("title", inline._title).getRegex();
inline.reflink = edit(inline.reflink).replace("label", inline._label).replace("ref", block._label).getRegex();
inline.nolink = edit(inline.nolink).replace("ref", block._label).getRegex();
inline.reflinkSearch = edit(inline.reflinkSearch, "g").replace("reflink", inline.reflink).replace("nolink", inline.nolink).getRegex();
/**
 * Normal Inline Grammar
 */ inline.normal = {
    ...inline
};
/**
 * Pedantic Inline Grammar
 */ inline.pedantic = {
    ...inline.normal,
    strong: {
        start: /^__|\*\*/,
        middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        endAst: /\*\*(?!\*)/g,
        endUnd: /__(?!_)/g
    },
    em: {
        start: /^_|\*/,
        middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
        endAst: /\*(?!\*)/g,
        endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline._label).getRegex()
};
/**
 * GFM Inline Grammar
 */ inline.gfm = {
    ...inline.normal,
    escape: edit(inline.escape).replace("])", "~|])").getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
inline.gfm.url = edit(inline.gfm.url, "i").replace("email", inline.gfm._extended_email).getRegex();
/**
 * GFM + Line Breaks Inline Grammar
 */ inline.breaks = {
    ...inline.gfm,
    br: edit(inline.br).replace("{2,}", "*").getRegex(),
    text: edit(inline.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
/**
 * Block Lexer
 */ class _Lexer {
    tokens;
    options;
    state;
    tokenizer;
    inlineQueue;
    constructor(options){
        // TokenList cannot be created in one go
        // @ts-expect-error
        this.tokens = [];
        this.tokens.links = Object.create(null);
        this.options = options || _defaults;
        this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            block: block.normal,
            inline: inline.normal
        };
        if (this.options.pedantic) {
            rules.block = block.pedantic;
            rules.inline = inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = block.gfm;
            if (this.options.breaks) rules.inline = inline.breaks;
            else rules.inline = inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    /**
     * Expose Rules
     */ static get rules() {
        return {
            block,
            inline
        };
    }
    /**
     * Static Lex Method
     */ static lex(src, options) {
        const lexer = new _Lexer(options);
        return lexer.lex(src);
    }
    /**
     * Static Lex Inline Method
     */ static lexInline(src, options) {
        const lexer = new _Lexer(options);
        return lexer.inlineTokens(src);
    }
    /**
     * Preprocessing
     */ lex(src) {
        src = src.replace(/\r\n|\r/g, "\n");
        this.blockTokens(src, this.tokens);
        let next;
        while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
        return this.tokens;
    }
    blockTokens(src, tokens = []) {
        if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
        else src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs)=>{
            return leading + "    ".repeat(tabs.length);
        });
        let token;
        let lastToken;
        let cutSrc;
        let lastParagraphClipped;
        while(src){
            if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            // newline
            if (token = this.tokenizer.space(src)) {
                src = src.substring(token.raw.length);
                if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                // so move it there so that we don't get unnecessary paragraph tags
                tokens[tokens.length - 1].raw += "\n";
                else tokens.push(token);
                continue;
            }
            // code
            if (token = this.tokenizer.code(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                // An indented code block cannot interrupt a paragraph.
                if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            // fences
            if (token = this.tokenizer.fences(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // heading
            if (token = this.tokenizer.heading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // hr
            if (token = this.tokenizer.hr(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // blockquote
            if (token = this.tokenizer.blockquote(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // list
            if (token = this.tokenizer.list(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // html
            if (token = this.tokenizer.html(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // def
            if (token = this.tokenizer.def(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.raw;
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                    href: token.href,
                    title: token.title
                };
                continue;
            }
            // table (gfm)
            if (token = this.tokenizer.table(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // lheading
            if (token = this.tokenizer.lheading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // top-level paragraph
            // prevent paragraph consuming extensions by clipping 'src' to extension start
            cutSrc = src;
            if (this.options.extensions && this.options.extensions.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                lastToken = tokens[tokens.length - 1];
                if (lastParagraphClipped && lastToken.type === "paragraph") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token);
                lastParagraphClipped = cutSrc.length !== src.length;
                src = src.substring(token.raw.length);
                continue;
            }
            // text
            if (token = this.tokenizer.text(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && lastToken.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src, tokens = []) {
        this.inlineQueue.push({
            src,
            tokens
        });
        return tokens;
    }
    /**
     * Lexing/Compiling
     */ inlineTokens(src, tokens = []) {
        let token, lastToken, cutSrc;
        // String with links masked to avoid interference with em and strong
        let maskedSrc = src;
        let match;
        let keepPrevChar, prevChar;
        // Mask out reflinks
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
        }
        // Mask out other blocks
        while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        // Mask out escaped characters
        while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        while(src){
            if (!keepPrevChar) prevChar = "";
            keepPrevChar = false;
            // extensions
            if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            // escape
            if (token = this.tokenizer.escape(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // tag
            if (token = this.tokenizer.tag(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && token.type === "text" && lastToken.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            // link
            if (token = this.tokenizer.link(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // reflink, nolink
            if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && token.type === "text" && lastToken.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            // em & strong
            if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // code
            if (token = this.tokenizer.codespan(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // br
            if (token = this.tokenizer.br(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // del (gfm)
            if (token = this.tokenizer.del(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // autolink
            if (token = this.tokenizer.autolink(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // url (gfm)
            if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // text
            // prevent inlineText consuming extensions by clipping 'src' to extension start
            cutSrc = src;
            if (this.options.extensions && this.options.extensions.startInline) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (token = this.tokenizer.inlineText(cutSrc)) {
                src = src.substring(token.raw.length);
                if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                keepPrevChar = true;
                lastToken = tokens[tokens.length - 1];
                if (lastToken && lastToken.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        return tokens;
    }
}
/**
 * Renderer
 */ class _Renderer {
    options;
    constructor(options){
        this.options = options || _defaults;
    }
    code(code, infostring, escaped) {
        const lang = (infostring || "").match(/^\S*/)?.[0];
        code = code.replace(/\n$/, "") + "\n";
        if (!lang) return "<pre><code>" + (escaped ? code : escape(code, true)) + "</code></pre>\n";
        return '<pre><code class="language-' + escape(lang) + '">' + (escaped ? code : escape(code, true)) + "</code></pre>\n";
    }
    blockquote(quote) {
        return `<blockquote>\n${quote}</blockquote>\n`;
    }
    html(html, block) {
        return html;
    }
    heading(text, level, raw) {
        // ignore IDs
        return `<h${level}>${text}</h${level}>\n`;
    }
    hr() {
        return "<hr>\n";
    }
    list(body, ordered, start) {
        const type = ordered ? "ol" : "ul";
        const startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
        return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
    }
    listitem(text, task, checked) {
        return `<li>${text}</li>\n`;
    }
    checkbox(checked) {
        return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
    }
    paragraph(text) {
        return `<p>${text}</p>\n`;
    }
    table(header, body) {
        if (body) body = `<tbody>${body}</tbody>`;
        return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
    }
    tablerow(content) {
        return `<tr>\n${content}</tr>\n`;
    }
    tablecell(content, flags) {
        const type = flags.header ? "th" : "td";
        const tag = flags.align ? `<${type} align="${flags.align}">` : `<${type}>`;
        return tag + content + `</${type}>\n`;
    }
    /**
     * span level renderer
     */ strong(text) {
        return `<strong>${text}</strong>`;
    }
    em(text) {
        return `<em>${text}</em>`;
    }
    codespan(text) {
        return `<code>${text}</code>`;
    }
    br() {
        return "<br>";
    }
    del(text) {
        return `<del>${text}</del>`;
    }
    link(href, title, text) {
        const cleanHref = cleanUrl(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = '<a href="' + href + '"';
        if (title) out += ' title="' + title + '"';
        out += ">" + text + "</a>";
        return out;
    }
    image(href, title, text) {
        const cleanHref = cleanUrl(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = `<img src="${href}" alt="${text}"`;
        if (title) out += ` title="${title}"`;
        out += ">";
        return out;
    }
    text(text) {
        return text;
    }
}
/**
 * TextRenderer
 * returns only the textual part of the token
 */ class _TextRenderer {
    // no need for block level renderers
    strong(text) {
        return text;
    }
    em(text) {
        return text;
    }
    codespan(text) {
        return text;
    }
    del(text) {
        return text;
    }
    html(text) {
        return text;
    }
    text(text) {
        return text;
    }
    link(href, title, text) {
        return "" + text;
    }
    image(href, title, text) {
        return "" + text;
    }
    br() {
        return "";
    }
}
/**
 * Parsing & Compiling
 */ class _Parser {
    options;
    renderer;
    textRenderer;
    constructor(options){
        this.options = options || _defaults;
        this.options.renderer = this.options.renderer || new _Renderer();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.textRenderer = new _TextRenderer();
    }
    /**
     * Static Parse Method
     */ static parse(tokens, options) {
        const parser = new _Parser(options);
        return parser.parse(tokens);
    }
    /**
     * Static Parse Inline Method
     */ static parseInline(tokens, options) {
        const parser = new _Parser(options);
        return parser.parseInline(tokens);
    }
    /**
     * Parse Loop
     */ parse(tokens, top = true) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            // Run any renderer extensions
            if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                const genericToken = token;
                const ret = this.options.extensions.renderers[genericToken.type].call({
                    parser: this
                }, genericToken);
                if (ret !== false || ![
                    "space",
                    "hr",
                    "heading",
                    "code",
                    "table",
                    "blockquote",
                    "list",
                    "html",
                    "paragraph",
                    "text"
                ].includes(genericToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            switch(token.type){
                case "space":
                    continue;
                case "hr":
                    out += this.renderer.hr();
                    continue;
                case "heading":
                    {
                        const headingToken = token;
                        out += this.renderer.heading(this.parseInline(headingToken.tokens), headingToken.depth, unescape(this.parseInline(headingToken.tokens, this.textRenderer)));
                        continue;
                    }
                case "code":
                    {
                        const codeToken = token;
                        out += this.renderer.code(codeToken.text, codeToken.lang, !!codeToken.escaped);
                        continue;
                    }
                case "table":
                    {
                        const tableToken = token;
                        let header = "";
                        // header
                        let cell = "";
                        for(let j = 0; j < tableToken.header.length; j++)cell += this.renderer.tablecell(this.parseInline(tableToken.header[j].tokens), {
                            header: true,
                            align: tableToken.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        let body = "";
                        for(let j = 0; j < tableToken.rows.length; j++){
                            const row = tableToken.rows[j];
                            cell = "";
                            for(let k = 0; k < row.length; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                header: false,
                                align: tableToken.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    }
                case "blockquote":
                    {
                        const blockquoteToken = token;
                        const body = this.parse(blockquoteToken.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    }
                case "list":
                    {
                        const listToken = token;
                        const ordered = listToken.ordered;
                        const start = listToken.start;
                        const loose = listToken.loose;
                        let body = "";
                        for(let j = 0; j < listToken.items.length; j++){
                            const item = listToken.items[j];
                            const checked = item.checked;
                            const task = item.task;
                            let itemBody = "";
                            if (item.task) {
                                const checkbox = this.renderer.checkbox(!!checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                                        item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: "text",
                                        text: checkbox + " "
                                    });
                                } else itemBody += checkbox + " ";
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, !!checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    }
                case "html":
                    {
                        const htmlToken = token;
                        out += this.renderer.html(htmlToken.text, htmlToken.block);
                        continue;
                    }
                case "paragraph":
                    {
                        const paragraphToken = token;
                        out += this.renderer.paragraph(this.parseInline(paragraphToken.tokens));
                        continue;
                    }
                case "text":
                    {
                        let textToken = token;
                        let body = textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text;
                        while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                            textToken = tokens[++i];
                            body += "\n" + (textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
    /**
     * Parse Inline Tokens
     */ parseInline(tokens, renderer) {
        renderer = renderer || this.renderer;
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            // Run any renderer extensions
            if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                const ret = this.options.extensions.renderers[token.type].call({
                    parser: this
                }, token);
                if (ret !== false || ![
                    "escape",
                    "html",
                    "link",
                    "image",
                    "strong",
                    "em",
                    "codespan",
                    "br",
                    "del",
                    "text"
                ].includes(token.type)) {
                    out += ret || "";
                    continue;
                }
            }
            switch(token.type){
                case "escape":
                    {
                        const escapeToken = token;
                        out += renderer.text(escapeToken.text);
                        break;
                    }
                case "html":
                    {
                        const tagToken = token;
                        out += renderer.html(tagToken.text);
                        break;
                    }
                case "link":
                    {
                        const linkToken = token;
                        out += renderer.link(linkToken.href, linkToken.title, this.parseInline(linkToken.tokens, renderer));
                        break;
                    }
                case "image":
                    {
                        const imageToken = token;
                        out += renderer.image(imageToken.href, imageToken.title, imageToken.text);
                        break;
                    }
                case "strong":
                    {
                        const strongToken = token;
                        out += renderer.strong(this.parseInline(strongToken.tokens, renderer));
                        break;
                    }
                case "em":
                    {
                        const emToken = token;
                        out += renderer.em(this.parseInline(emToken.tokens, renderer));
                        break;
                    }
                case "codespan":
                    {
                        const codespanToken = token;
                        out += renderer.codespan(codespanToken.text);
                        break;
                    }
                case "br":
                    out += renderer.br();
                    break;
                case "del":
                    {
                        const delToken = token;
                        out += renderer.del(this.parseInline(delToken.tokens, renderer));
                        break;
                    }
                case "text":
                    {
                        const textToken = token;
                        out += renderer.text(textToken.text);
                        break;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
}
class _Hooks {
    options;
    constructor(options){
        this.options = options || _defaults;
    }
    static passThroughHooks = new Set([
        "preprocess",
        "postprocess"
    ]);
    /**
     * Process markdown before marked
     */ preprocess(markdown) {
        return markdown;
    }
    /**
     * Process HTML after marked is finished
     */ postprocess(html) {
        return html;
    }
}
class Marked {
    defaults = _getDefaults();
    options = this.setOptions;
    parse = this.#parseMarkdown(_Lexer.lex, _Parser.parse);
    parseInline = this.#parseMarkdown(_Lexer.lexInline, _Parser.parseInline);
    Parser = _Parser;
    Renderer = _Renderer;
    TextRenderer = _TextRenderer;
    Lexer = _Lexer;
    Tokenizer = _Tokenizer;
    Hooks = _Hooks;
    constructor(...args){
        this.use(...args);
    }
    /**
     * Run callback for every token
     */ walkTokens(tokens, callback) {
        let values = [];
        for (const token of tokens){
            values = values.concat(callback.call(this, token));
            switch(token.type){
                case "table":
                    {
                        const tableToken = token;
                        for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                        for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                        break;
                    }
                case "list":
                    {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                default:
                    {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                            values = values.concat(this.walkTokens(genericToken[childTokens], callback));
                        });
                        else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                    }
            }
        }
        return values;
    }
    use(...args) {
        const extensions = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        args.forEach((pack)=>{
            // copy options to new object
            const opts = {
                ...pack
            };
            // set async to true if it was set to true before
            opts.async = this.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach((ext)=>{
                    if (!ext.name) throw new Error("extension name required");
                    if ("renderer" in ext) {
                        const prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function(...args) {
                            let ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if ("tokenizer" in ext) {
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        const extLevel = extensions[ext.level];
                        if (extLevel) extLevel.unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) {
                const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                for(const prop in pack.renderer){
                    const rendererFunc = pack.renderer[prop];
                    const rendererKey = prop;
                    const prevRenderer = renderer[rendererKey];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[rendererKey] = (...args)=>{
                        let ret = rendererFunc.apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret || "";
                    };
                }
                opts.renderer = renderer;
            }
            if (pack.tokenizer) {
                const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                for(const prop in pack.tokenizer){
                    const tokenizerFunc = pack.tokenizer[prop];
                    const tokenizerKey = prop;
                    const prevTokenizer = tokenizer[tokenizerKey];
                    // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[tokenizerKey] = (...args)=>{
                        let ret = tokenizerFunc.apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                }
                opts.tokenizer = tokenizer;
            }
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) {
                const hooks = this.defaults.hooks || new _Hooks();
                for(const prop in pack.hooks){
                    const hooksFunc = pack.hooks[prop];
                    const hooksKey = prop;
                    const prevHook = hooks[hooksKey];
                    if (_Hooks.passThroughHooks.has(prop)) hooks[hooksKey] = (arg)=>{
                        if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                            return prevHook.call(hooks, ret);
                        });
                        const ret = hooksFunc.call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[hooksKey] = (...args)=>{
                        let ret = hooksFunc.apply(hooks, args);
                        if (ret === false) ret = prevHook.apply(hooks, args);
                        return ret;
                    };
                }
                opts.hooks = hooks;
            }
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                const walkTokens = this.defaults.walkTokens;
                const packWalktokens = pack.walkTokens;
                opts.walkTokens = function(token) {
                    let values = [];
                    values.push(packWalktokens.call(this, token));
                    if (walkTokens) values = values.concat(walkTokens.call(this, token));
                    return values;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...opts
            };
        });
        return this;
    }
    setOptions(opt) {
        this.defaults = {
            ...this.defaults,
            ...opt
        };
        return this;
    }
    lexer(src, options) {
        return _Lexer.lex(src, options ?? this.defaults);
    }
    parser(tokens, options) {
        return _Parser.parse(tokens, options ?? this.defaults);
    }
    #parseMarkdown(lexer, parser) {
        return (src, options)=>{
            const origOpt = {
                ...options
            };
            const opt = {
                ...this.defaults,
                ...origOpt
            };
            // Show warning if an extension set async to true but the parse was called with async: false
            if (this.defaults.async === true && origOpt.async === false) {
                if (!opt.silent) console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored.");
                opt.async = true;
            }
            const throwError = this.#onError(!!opt.silent, !!opt.async);
            // throw error in case of non string input
            if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
            if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
            if (opt.hooks) opt.hooks.options = opt;
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                const tokens = lexer(src, opt);
                if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                let html = parser(tokens, opt);
                if (opt.hooks) html = opt.hooks.postprocess(html);
                return html;
            } catch (e) {
                return throwError(e);
            }
        };
    }
    #onError(silent, async) {
        return (e)=>{
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (silent) {
                const msg = "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
                if (async) return Promise.resolve(msg);
                return msg;
            }
            if (async) return Promise.reject(e);
            throw e;
        };
    }
}
const markedInstance = new Marked();
function marked(src, opt) {
    return markedInstance.parse(src, opt);
}
/**
 * Sets the default options.
 *
 * @param options Hash of options
 */ marked.options = marked.setOptions = function(options) {
    markedInstance.setOptions(options);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
/**
 * Gets the original marked default options.
 */ marked.getDefaults = _getDefaults;
marked.defaults = _defaults;
/**
 * Use Extension
 */ marked.use = function(...args) {
    markedInstance.use(...args);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
/**
 * Run callback for every token
 */ marked.walkTokens = function(tokens, callback) {
    return markedInstance.walkTokens(tokens, callback);
};
/**
 * Compiles markdown to HTML without enclosing `p` tag.
 *
 * @param src String of markdown source to be compiled
 * @param options Hash of options
 * @return String of compiled HTML
 */ marked.parseInline = markedInstance.parseInline;
/**
 * Expose
 */ marked.Parser = _Parser;
marked.parser = _Parser.parse;
marked.Renderer = _Renderer;
marked.TextRenderer = _TextRenderer;
marked.Lexer = _Lexer;
marked.lexer = _Lexer.lex;
marked.Tokenizer = _Tokenizer;
marked.Hooks = _Hooks;
marked.parse = marked;
const options = marked.options;
const setOptions = marked.setOptions;
const use = marked.use;
const walkTokens = marked.walkTokens;
const parseInline = marked.parseInline;
const parse = marked;
const parser = _Parser.parse;
const lexer = _Lexer.lex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8bwsE":[function(require,module,exports) {
module.exports = require("b23018f4cde9261d").getBundleURL("4oMEl") + "p3.6cbcf2e9.png";

},{"b23018f4cde9261d":"c7Tr5"}],"4zcHQ":[function(require,module,exports) {
module.exports = require("56e4a606892772a6").getBundleURL("4oMEl") + "p2.52b2dcd2.png";

},{"56e4a606892772a6":"c7Tr5"}],"e6V9t":[function(require,module,exports) {
module.exports = require("582c839db8e40b31").getBundleURL("4oMEl") + "p22.9e5f4266.png";

},{"582c839db8e40b31":"c7Tr5"}],"c1d98":[function(require,module,exports) {
module.exports = require("5576395de4d3a947").getBundleURL("4oMEl") + "flutterTesting2.b736b2e4.png";

},{"5576395de4d3a947":"c7Tr5"}],"k1cPI":[function(require,module,exports) {
module.exports = require("7e796726ecaf6379").getBundleURL("4oMEl") + "flutterTesting3.ad603ff4.png";

},{"7e796726ecaf6379":"c7Tr5"}],"5VAvG":[function(require,module,exports) {
module.exports = require("f343af0f1ae4c6d4").getBundleURL("4oMEl") + "generativeAI2.13235141.png";

},{"f343af0f1ae4c6d4":"c7Tr5"}],"ZakbA":[function(require,module,exports) {
module.exports = require("f3542d0c5e4125ba").getBundleURL("4oMEl") + "generativeAI3.b568445d.png";

},{"f3542d0c5e4125ba":"c7Tr5"}],"cGUbm":[function(require,module,exports) {
module.exports = require("8cfb45215977448d").getBundleURL("4oMEl") + "qatar.31be1fe7.png";

},{"8cfb45215977448d":"c7Tr5"}],"kM02K":[function(require,module,exports) {
module.exports = require("f064d8add35c0b83").getBundleURL("4oMEl") + "qatar_event2.7bc86066.png";

},{"f064d8add35c0b83":"c7Tr5"}],"dPGkp":[function(require,module,exports) {
module.exports = require("4def5caf463d0c4e").getBundleURL("4oMEl") + "revolutionizetestingAI2.e31dd0c4.png";

},{"4def5caf463d0c4e":"c7Tr5"}],"hycqj":[function(require,module,exports) {
module.exports = require("c5060d6a84677fd0").getBundleURL("4oMEl") + "ContinuousTesting1.fdf53e31.png";

},{"c5060d6a84677fd0":"c7Tr5"}],"2N59i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _header = require("../../components/Header/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _reactHelmetAsync = require("react-helmet-async");
var _button = require("../../components/Button");
var _iconsMill = require("../../icons/IconsMill");
var _iconsHouse1 = require("../../icons/IconsHouse1");
var _iconsHouse2 = require("../../icons/IconsHouse2");
var _iconsPlug1 = require("../../icons/IconsPlug1");
var _iconsCloudLaptop = require("../../icons/IconsCloudLaptop");
var _iconsPhone = require("../../icons/IconsPhone");
var _mobileWebAppTestingSvg = require("../../assets/mobile-web-app-testing.svg");
var _mobileWebAppTestingSvgDefault = parcelHelpers.interopDefault(_mobileWebAppTestingSvg);
var _workerPng = require("../../assets/worker.png");
var _workerPngDefault = parcelHelpers.interopDefault(_workerPng);
var _trailbluNoCodeTestingGif = require("../../assets/TrailbluNoCodeTesting.gif");
var _trailbluNoCodeTestingGifDefault = parcelHelpers.interopDefault(_trailbluNoCodeTestingGif);
var _trailbluSelfHealingGif = require("../../assets/TrailbluSelfHealing.gif");
var _trailbluSelfHealingGifDefault = parcelHelpers.interopDefault(_trailbluSelfHealingGif);
var _trailbluVisualTestingGif = require("../../assets/TrailbluVisualTesting.gif");
var _trailbluVisualTestingGifDefault = parcelHelpers.interopDefault(_trailbluVisualTestingGif);
var _trailbluGenAIGif = require("../../assets/TrailbluGenAI.gif");
var _trailbluGenAIGifDefault = parcelHelpers.interopDefault(_trailbluGenAIGif);
var _styleCss = require("./style.css");
var _killerFeatureGenAIPng = require("../../assets/killerFeatureGenAI.png");
var _killerFeatureGenAIPngDefault = parcelHelpers.interopDefault(_killerFeatureGenAIPng);
var _killerFeatureNoCodePng = require("../../assets/killerFeatureNoCode.png");
var _killerFeatureNoCodePngDefault = parcelHelpers.interopDefault(_killerFeatureNoCodePng);
var _killerFeatureSelfHealingPng = require("../../assets/killerFeatureSelfHealing.png");
var _killerFeatureSelfHealingPngDefault = parcelHelpers.interopDefault(_killerFeatureSelfHealingPng);
var _killerFeatureVisualTestingPng = require("../../assets/killerFeatureVisualTesting.png");
var _killerFeatureVisualTestingPngDefault = parcelHelpers.interopDefault(_killerFeatureVisualTestingPng);
var _1WriteSvg = require("../../assets/noCodeFeatureIcons/1write.svg");
var _1WriteSvgDefault = parcelHelpers.interopDefault(_1WriteSvg);
var _2GroupOfPeopleSvg = require("../../assets/noCodeFeatureIcons/2groupOfPeople.svg");
var _2GroupOfPeopleSvgDefault = parcelHelpers.interopDefault(_2GroupOfPeopleSvg);
var _3RocketLaunchingSvg = require("../../assets/noCodeFeatureIcons/3RocketLaunching.svg");
var _3RocketLaunchingSvgDefault = parcelHelpers.interopDefault(_3RocketLaunchingSvg);
var _4FixedSettingSvg = require("../../assets/noCodeFeatureIcons/4FixedSetting.svg");
var _4FixedSettingSvgDefault = parcelHelpers.interopDefault(_4FixedSettingSvg);
var _1PuzzlePieceSvg = require("../../assets/genAiFeatureIcons/1puzzle-piece.svg");
var _1PuzzlePieceSvgDefault = parcelHelpers.interopDefault(_1PuzzlePieceSvg);
var _2StopwatchSvg = require("../../assets/genAiFeatureIcons/2stopwatch.svg");
var _2StopwatchSvgDefault = parcelHelpers.interopDefault(_2StopwatchSvg);
var _3ShieldSvg = require("../../assets/genAiFeatureIcons/3shield.svg");
var _3ShieldSvgDefault = parcelHelpers.interopDefault(_3ShieldSvg);
var _4DangerSvg = require("../../assets/genAiFeatureIcons/4danger.svg");
var _4DangerSvgDefault = parcelHelpers.interopDefault(_4DangerSvg);
var _5TransparencySvg = require("../../assets/genAiFeatureIcons/5transparency.svg");
var _5TransparencySvgDefault = parcelHelpers.interopDefault(_5TransparencySvg);
var _6QualitySvg = require("../../assets/genAiFeatureIcons/6quality.svg");
var _6QualitySvgDefault = parcelHelpers.interopDefault(_6QualitySvg);
var _1MagnifyingGlassSvg = require("../../assets/visualTestingFeatureIcons/1magnifying-glass.svg");
var _1MagnifyingGlassSvgDefault = parcelHelpers.interopDefault(_1MagnifyingGlassSvg);
var _2TargetSvg = require("../../assets/visualTestingFeatureIcons/2target.svg");
var _2TargetSvgDefault = parcelHelpers.interopDefault(_2TargetSvg);
var _3ResponsiveSvg = require("../../assets/visualTestingFeatureIcons/3responsive.svg");
var _3ResponsiveSvgDefault = parcelHelpers.interopDefault(_3ResponsiveSvg);
var _4ScreenshotSvg = require("../../assets/visualTestingFeatureIcons/4screenshot.svg");
var _4ScreenshotSvgDefault = parcelHelpers.interopDefault(_4ScreenshotSvg);
var _5AnalyzingSvg = require("../../assets/visualTestingFeatureIcons/5analyzing.svg");
var _5AnalyzingSvgDefault = parcelHelpers.interopDefault(_5AnalyzingSvg);
var _1GuaranteeSvg = require("../../assets/selfHealingFeatureIcons/1guarantee.svg");
var _1GuaranteeSvgDefault = parcelHelpers.interopDefault(_1GuaranteeSvg);
var _2AutomaticSvg = require("../../assets/selfHealingFeatureIcons/2automatic.svg");
var _2AutomaticSvgDefault = parcelHelpers.interopDefault(_2AutomaticSvg);
var _3ShieldUpdateSvg = require("../../assets/selfHealingFeatureIcons/3shield-update.svg");
var _3ShieldUpdateSvgDefault = parcelHelpers.interopDefault(_3ShieldUpdateSvg);
var _4IncreasingBarSvg = require("../../assets/selfHealingFeatureIcons/4increasing-bar.svg");
var _4IncreasingBarSvgDefault = parcelHelpers.interopDefault(_4IncreasingBarSvg);
var _5DecreasingBarSvg = require("../../assets/selfHealingFeatureIcons/5decreasing-bar.svg");
var _5DecreasingBarSvgDefault = parcelHelpers.interopDefault(_5DecreasingBarSvg);
const Feature = ()=>{
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    const { featureName } = (0, _reactRouterDom.useParams)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const formattedFeatureName = featureName ? featureName.split("-").join(" ") // Split the string by "-" and join using space
     : "";
    console.log(formattedFeatureName);
    const getFeatureData = (formattedFeatureName)=>{
        switch(formattedFeatureName){
            case "ai powered no code test automation":
                return {
                    metaTitle: "Enhance Testing with AI-Powered No-Code Solution | TRAILBLU",
                    metaDescription: "Elevate your testing with Trailblu's AI-Powered No-Code Test Automation. Effortlessly create and manage tests, ensuring reliability and top-quality software.",
                    heroBannerTitle: "AI-Powered,",
                    heroBannerTitle2: "No-Code,",
                    heroBannerTitle3: "Test Automation",
                    rightImg: (0, _trailbluNoCodeTestingGifDefault.default),
                    platformOverview: "Tired of tedious testing? Trailblu's AI-Powered solution revolutionizes the game, making testing effortless for developers. No more coding hassles, just quick tests, detailed results, and seamless integration. Elevate your testing game with Trailblu!",
                    cta1: "Choose Trailblu and experience the peak of AI-Powered testing solutions, transforming your testing processes with unmatched precision!",
                    H2: "Challenges Addressed by No-Code Test Automation",
                    H2Content: [
                        {
                            title: "Simplifying Test Script Creation",
                            content: "No-Code Test Automation eliminates the complexities of coding, making test script creation straightforward and user-friendly, even for complex applications like web, mobile, or virtual environments.",
                            imageUrl: (0, _1WriteSvgDefault.default)
                        },
                        {
                            title: "Opening Testing to Non-Developers",
                            content: "With No-Code solutions, deep programming knowledge is no longer a prerequisite, making test creation accessible to people of all skill levels. This inclusivity fosters a collaborative, agile workflow.",
                            imageUrl: (0, _2GroupOfPeopleSvgDefault.default)
                        },
                        {
                            title: "Accelerating Test Development",
                            content: "No-Code Test Automation speeds up the test creation process, removing the bottlenecks of complex coding and lengthy integrations. This efficiency helps in achieving quicker deployment and faster time-to-market, focusing on testing outcomes rather than repetitive tasks.",
                            imageUrl: (0, _3RocketLaunchingSvgDefault.default)
                        },
                        {
                            title: "Reducing Maintenance Hassles",
                            content: "Trailblu\u2019s platform simplifies test maintenance, minimizing the need for constant updates. It leverages AI for reusable test components, automatically adapting to changes, which ensures tests remain current with minimal manual intervention.",
                            imageUrl: (0, _4FixedSettingSvgDefault.default)
                        }
                    ],
                    killerFeatureTitle: "No-Code Test Automation for Effortless and Reliable Results",
                    killerFeatureImage: (0, _killerFeatureNoCodePngDefault.default),
                    killerFeatureContent: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            maxWidth: "1024px",
                            textAlign: "justify"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    marginTop: "40px"
                                },
                                className: "killer-content",
                                children: "The game-changing AI-Powered No-Code Test Automation, liberates users from the complexities of coding, making automated testing accessible to everyone, regardless of their technical background."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "killer-content",
                                style: {
                                    fontWeight: "650",
                                    marginBottom: "25px",
                                    marginTop: "32px",
                                    fontSize: "24px",
                                    color: "#3a3a3a"
                                },
                                children: "How does Trailblu No-Code AI-Powered Test Automation Help your Business?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "killer-content",
                                children: "This unique capability empowers users to effortlessly create, execute, and manage automated tests, ensuring a quick and user-friendly testing experience. With detailed test results, seamless integration into existing pipelines, and a self-healing feature, Trailblu's No-Code Test Automation not only simplifies the testing process but also enhances reliability, making it an indispensable tool for ensuring the quality and efficiency of software products."
                            })
                        ]
                    })
                };
            case "ai powered visual testing":
                return {
                    metaTitle: "AI-Powered Visual Testing | TRAILBLU",
                    metaDescription: "Explore the future of testing with Trailblu's transformative AI-Powered Visual Testing. Address consistency challenges, launch errors, and collaboration gaps easily. ",
                    heroBannerTitle: "AI-Powered",
                    heroBannerTitle2: "Visual Testing",
                    rightImg: (0, _trailbluVisualTestingGifDefault.default),
                    platformOverview: "In a digital-centric era, Trailblu proudly unveils its groundbreaking feature: Automated Visual Testing. This revolutionary tool is poised to redefine how developers and designers ensure the visual consistency and functionality of websites and applications.",
                    cta1: "Shape a visually flawless digital future with Trailblu. Explore our AI-Powered solutions for exceptional testing experiences.",
                    H2: "Trailblu's Visual Mastery: Elevating UI with Innovation",
                    H2Content: [
                        {
                            title: "Extensive Visual Assurance",
                            content: "Trailblu\u2019s Visual Testing ensures complete visual coverage of your UI. Experience advanced detection and grouping of visual changes across web and mobile applications, enhancing consistency and user experience.",
                            imageUrl: (0, _1MagnifyingGlassSvgDefault.default)
                        },
                        {
                            title: "Precision Testing: Reducing False Positives",
                            content: "Trailblu\u2019s AI Visual Engine accurately spots crucial visual changes and minimizes false positives, focusing on key elements that impact users while ignoring what's not important.",
                            imageUrl: (0, _2TargetSvgDefault.default)
                        },
                        {
                            title: "Adaptive Responsive Testing",
                            content: "Trust your UI's adaptability on any device with Trailblu\u2019s responsive testing. Assure excellence in user interfaces at every screen dimension, ensuring a universally seamless experience.",
                            imageUrl: (0, _3ResponsiveSvgDefault.default)
                        },
                        {
                            title: " Advanced Snapshot Technology",
                            content: "Utilize Trailblu\u2019s groundbreaking snapshot technology to achieve more accurate visual tests. It expertly handles dynamic content like animations and custom typography, delivering dependable, consistent results.",
                            imageUrl: (0, _4ScreenshotSvgDefault.default)
                        },
                        {
                            title: "Refined Visual Analysis Strategy",
                            content: "Trailblu changes how you check visual updates. Its easy-to-use tools and smart analysis make the review faster and simpler, helping you make quick and smart choices.",
                            imageUrl: (0, _5AnalyzingSvgDefault.default)
                        }
                    ],
                    killerFeatureTitle: "Trailblu's AI-Powered Visual Testing \u2013",
                    killerFeatureTitle2: "A Gateway to Flawless UI",
                    killerFeatureImage: (0, _killerFeatureVisualTestingPngDefault.default),
                    killerFeatureContent: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            marginTop: "40px",
                            textAlign: "justify",
                            maxWidth: "1024px"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "killer-content",
                                children: "Trailblu's AI-Powered Visual Testing is a groundbreaking innovation reshaping the landscape of UI quality assurance. This advanced tool doesn't just identify visual discrepancies; it offers a comprehensive analysis that ensures every aspect of your UI is pixel-perfect. By seamlessly integrating into your development workflow, it provides invaluable insights into the visual fidelity of your applications."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "killer-content",
                                style: {
                                    fontWeight: "650",
                                    marginBottom: "25px",
                                    marginTop: "32px",
                                    fontSize: "24px",
                                    color: "#3a3a3a"
                                },
                                children: "How does Trailblu AI-Powered Visual Testing Help your Business?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "killer-content",
                                children: "Trailblu\u2019s AI-Driven visual testing revolutionizes the way you approach UI consistency and quality. Its intelligent algorithms analyze every detail, from color consistency to layout precision, reducing the manual effort needed for visual checks. This leads to a significant reduction in time and resources spent on quality assurance, making your testing process more efficient and cost-effective."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "killer-content",
                                children: "With Trailblu's AI-Powered Visual Testing, you're not just adopting a tool; you're embracing a new standard of excellence in UI design. Enter a new era of visual perfection with Trailblu and set a benchmark in digital aesthetics."
                            })
                        ]
                    })
                };
            case "ai powered self healing":
                return {
                    metaTitle: "Revolutionizing Testing with AI-Powered Self-Healing | TRAILBLU",
                    metaDescription: "Experience seamless automated testing with Trailblu's AI-Powered Self-Healing. Proactively tackle challenges like locator flakiness and reduce manual intervention.",
                    heroBannerTitle: "AI-Powered",
                    heroBannerTitle2: "Self-Healing",
                    rightImg: (0, _trailbluSelfHealingGifDefault.default),
                    platformOverview: "Trailblu's AI-Powered Self-Healing transforms automated testing by using artificial intelligence to tackle challenges from dynamic application changes. This innovative tool proactively addresses issues like locator flakiness, ensuring test reliability without constant manual intervention.",
                    cta1: "Explore the power of AI-Powered Self-Healing for a seamless and efficient testing process.",
                    H2: "Challenges Addressed by Self-Healing",
                    H2Content: [
                        {
                            title: "Locator Stability",
                            content: "Our system expertly identifies and resolves issues with unstable locators, guaranteeing stable and consistent automated tests.",
                            imageUrl: (0, _1GuaranteeSvgDefault.default)
                        },
                        {
                            title: "Reduced Manual Maintenance",
                            content: "Automatically modifies test scripts in response to updates in the application's layout, text, or other elements, ensuring fluid adaptation without manual effort.",
                            imageUrl: (0, _2AutomaticSvgDefault.default)
                        },
                        {
                            title: "Reliable Test Performance",
                            content: "Enhances test reliability by continuously syncing with ongoing application updates, improving accuracy and reliability.",
                            imageUrl: (0, _3ShieldUpdateSvgDefault.default)
                        },
                        {
                            title: "Increased Testing Efficiency",
                            content: "Streamlines the testing process by autonomously handling issues related to locator changes, allowing testing teams to focus on higher-value tasks.",
                            imageUrl: (0, _4IncreasingBarSvgDefault.default)
                        },
                        {
                            title: "Minimized Test Failures",
                            content: "The self-healing feature significantly lowers the chances of test failures from UI updates, keeping tests current and maintaining steady project progress.",
                            imageUrl: (0, _5DecreasingBarSvgDefault.default)
                        }
                    ],
                    killerFeatureTitle: "A Healing Hand in Testing:",
                    killerFeatureTitle2: "Trailblu's AI-Powered Solution",
                    killerFeatureImage: (0, _killerFeatureSelfHealingPngDefault.default),
                    killerFeatureContent: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            marginTop: "40px",
                            textAlign: "justify",
                            maxWidth: "1024px"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    marginBottom: "20px"
                                },
                                className: "killer-content",
                                children: "AI-Powered Self-Healing is a revolutionary solution that proactively identifies and adjusts to failing locators, ensuring the accuracy and reliability of automated tests. This game-changing feature not only saves valuable time and resources but also streamlines the testing process for increased efficiency."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                style: {
                                    fontWeight: "650",
                                    marginBottom: "25px",
                                    marginTop: "32px",
                                    fontSize: "24px",
                                    color: "#3a3a3a"
                                },
                                className: "killer-content",
                                children: "How does Trailblu\u2019s AI-Powered Self-Healing Help your Business?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "killer-content",
                                children: "Trailblu's AI-driven self-healing algorithm intelligently detects and repairs flaky locators, significantly reducing the need for manual intervention. This not only enhances the reliability of automated tests but also contributes to a more cost-effective and streamlined testing process."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "killer-content",
                                children: "Beyond being a tool, it's a commitment to flawless testing experiences, empowering development teams to focus on critical tasks. Embrace the future of automated testing with Trailblu's AI-Powered Self-Healing."
                            })
                        ]
                    })
                };
            case "generative ai powered test creation":
                return {
                    metaTitle: "Generative AI-Powered Test Creation | TRAILBLU",
                    metaDescription: "Elevate your testing with Trailblu's AI-Powered No-Code Testing. Effortlessly create and manage tests, ensuring reliability and top-quality software.",
                    heroBannerTitle: "Generative",
                    heroBannerTitle2: "AI-Powered",
                    heroBannerTitle3: "Test Creation",
                    rightImg: (0, _trailbluGenAIGifDefault.default),
                    platformOverview: "In the forefront of innovation, Trailblu introduces a revolutionary stride in software testing: Generative AI-Powered Test Creation. With the might of AI and the simplicity of natural language, this feature transforms test creation from a coding chore to a conversation with AI.",
                    cta1: "Harness the Power of AI in Your Test Suites with Trailblu. Experience the future of test creation today.",
                    H2: "Solving the Puzzle of Software Testing",
                    H2Content: [
                        {
                            title: "Simplified Test Creation",
                            content: "Bid farewell to complex scripting. Our AI understands your requirements and generates test cases accordingly.",
                            imageUrl: (0, _1PuzzlePieceSvgDefault.default)
                        },
                        {
                            title: "Speed and Efficiency",
                            content: "AI speeds up test creation, enabling rapid iterations and swift project delivery.",
                            imageUrl: (0, _2StopwatchSvgDefault.default)
                        },
                        {
                            title: "Making Test Creation Accessible to All",
                            content: "Now, everyone on the team can contribute to test creation, regardless of their coding expertise.",
                            imageUrl: (0, _3ShieldSvgDefault.default)
                        },
                        {
                            title: "Reducing Human Error",
                            content: "AI minimizes the mistakes inherent in manual test writing, leading to more reliable and consistent test cases.",
                            imageUrl: (0, _4DangerSvgDefault.default)
                        },
                        {
                            title: "Transparent Test Scenarios",
                            content: "With AI-generated tests, stakeholders get a clear understanding of what is being tested and why.",
                            imageUrl: (0, _5TransparencySvgDefault.default)
                        },
                        {
                            title: "Quality Assurance at Its Core",
                            content: "Trailblu's AI ensures that each test case is geared towards the highest standards of quality and coverage.",
                            imageUrl: (0, _6QualitySvgDefault.default)
                        }
                    ],
                    killerFeatureTitle: "Revolutionize Testing with Trailblu\u2019s Generative AI",
                    killerFeatureImage: (0, _killerFeatureGenAIPngDefault.default),
                    killerFeatureContent: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            maxWidth: "1024px",
                            textAlign: "justify"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    marginTop: "40px"
                                },
                                className: "killer-content",
                                children: "Trailblu\u2019s Generative AI-Powered Test Creation is not just a feature; it's a transformative force. It crafts detailed test cases from simple descriptions, ensuring accuracy and thoroughness. The AI's ability to parse natural language means that it's like having an expert tester interpreting your needs and turning them into reality."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "killer-content",
                                style: {
                                    fontWeight: "650",
                                    marginBottom: "25px",
                                    marginTop: "32px",
                                    fontSize: "24px",
                                    color: "#3a3a3a"
                                },
                                children: "How Trailblu\u2019s AI-Driven Test Creation Elevates Your Project?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "killer-content",
                                children: "Our platform\u2019s intuitive AI uses advanced algorithms to generate comprehensive tests. This facilitates a collaborative environment where quality is everyone's business. The result? A robust, user-centric product that stands the test of time."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "killer-content",
                                children: "Embrace the future of test creation with Trailblu. Step into an era where AI does the heavy lifting, and innovation is at your fingertips."
                            })
                        ]
                    })
                };
        }
    };
    const renderFeature = (feature, index)=>{
        const isImageLeft = index % 2 === 0;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "feature-list",
            children: isImageLeft ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "feature-list-left-text-960",
                        children: feature.content
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feature-list-right-image-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: feature.imageUrl,
                            className: "feature-list-img"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "feature-list-right",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "feature-list-left-subheading",
                                children: feature.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "feature-list-right-text",
                                children: feature.content
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "feature-list-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "feature-list-left-subheading",
                                children: feature.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "feature-list-left-text",
                                children: feature.content
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feature-list-right-image-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: feature.imageUrl,
                            className: "feature-list-img"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "feature-list-left-text-960",
                        children: feature.content
                    })
                ]
            })
        }, index);
    };
    //make an available feature name list
    const featureData = getFeatureData(formattedFeatureName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "feature-main",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                        children: featureData.metaTitle
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "description",
                        content: featureData.metaDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "introduction-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "double-side-intro",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "left-intro",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "text-intro",
                                    children: featureData.heroBannerTitle
                                }),
                                featureData.heroBannerTitle2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "text-intro",
                                    children: featureData.heroBannerTitle2
                                }),
                                featureData.heroBannerTitle3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "text-intro",
                                    children: featureData.heroBannerTitle3
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "intro-body",
                                    children: featureData.platformOverview
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/request-a-demo",
                                    className: "feature-link",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        className: "button-2",
                                        stateProp: "normal",
                                        style: "solid",
                                        text: "Request a demo",
                                        type: "regular"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "right-intro",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: featureData.rightImg || (0, _workerPngDefault.default),
                                className: "right-img"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "general-feature-title",
                    children: featureData.cta1
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "features",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "feature-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            style: {
                                fontSize: "36px",
                                margin: "50px 8%",
                                textAlign: "center",
                                color: "#3a3a3a",
                                lineHeight: "3rem"
                            },
                            children: featureData.H2
                        }),
                        featureData.H2Content.map((feature, index)=>renderFeature(feature, index))
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "killer-feature",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "h1-killer",
                        children: featureData.killerFeatureTitle
                    }),
                    featureData.killerFeatureTitle2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "h1-killer",
                        children: featureData.killerFeatureTitle2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "killer-duo",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "killer-feature-img",
                                src: featureData.killerFeatureImage
                            }),
                            featureData.killerFeatureContent
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "frame-8-feature",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-wrapper-5",
                        children: "Real-World Impact: AI Solutions That Truly Help"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-9",
                        children: [
                            !(formattedFeatureName == "generative ai powered test creation") && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-2-copy-feature",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "starter",
                                                children: "Generative AI-Powered Test Creation"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "icon-instance-node-2",
                                                alt: "Trailblu mobile testing",
                                                src: (0, _mobileWebAppTestingSvgDefault.default)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32-copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "automate-mobile-and-2",
                                                children: "Embrace the future of testing with our advanced GPT technology, ensuring thorough coverage and reliability in every aspect of your application."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/feature/generative-ai-powered-test-creation",
                                                style: {
                                                    width: "100%",
                                                    justifyContent: "center",
                                                    display: "flex"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "outline",
                                                    text: "Read more",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !(formattedFeatureName == "ai powered no code test automation") && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-2-copy-feature",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "starter",
                                                children: "AI-Powered No-Code Testing"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsCloudLaptop.IconsCloudLaptop), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32-copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "automate-mobile-and-2",
                                                children: "Forget about tedious, time-consuming test writing. With No-Code Testing, you can quickly write tests and get fast insights."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/feature/ai-powered-no-code-test-automation",
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "outline",
                                                    text: "Read more",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !(formattedFeatureName == "ai powered visual testing") && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-2-copy-feature",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "starter",
                                                children: "AI-Powered Visual Testing"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsPhone.IconsPhone), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32-copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "automate-mobile-and-2",
                                                children: "Harness the power of AI to transform your visual quality assurance. Our tool provides comprehensive coverage, intuitive insights, and smart detection of even the most subtle visual issues."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/feature/ai-powered-visual-testing",
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "outline",
                                                    text: "Read more",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !(formattedFeatureName == "ai powered self healing") && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-2-copy-feature",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                className: "starter",
                                                children: "AI-Powered Self-Healing"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsPlug1.IconsPlug1), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32-copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "automate-mobile-and-2",
                                                children: "With TRAILBLU's AI-Powered self-healing, you can get more from your existing tests by automatically identifying and fixing flaky tests."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/feature/ai-powered-self-healing",
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "outline",
                                                    text: "Read more",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "frame-19",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-20",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-wrapper-10",
                                children: "Get started"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-wrapper-11",
                                children: "Choose one of our plans"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-21",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "starter",
                                                children: "Starter"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMill.IconsMill), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "automate-mobile-and-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Automate"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "mobile and web app testing",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/request-a-demo",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "solid",
                                                    text: "Request a demo",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "starter",
                                                children: "Business"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsHouse1.IconsHouse1), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "automate-mobile-and-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Automate"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "mobile and web app testing",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Professional features"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-13",
                                                        children: " for remote teams"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/request-a-demo",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "solid",
                                                    text: "Request a demo",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "CARD-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-10",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "starter",
                                                children: "Enterprise"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsHouse2.IconsHouse2), {
                                                className: "icon-instance-node"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-32",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "automate-mobile-and-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Automate"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "mobile and web app testing",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Professional features"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "for remote teams",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-12",
                                                        children: "Advanced features"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-13",
                                                        children: [
                                                            " ",
                                                            "for large teams, priority support",
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/request-a-demo",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    className: "design-component-instance-node-2",
                                                    stateProp: "normal",
                                                    style: "solid",
                                                    text: "Request a demo",
                                                    type: "regular"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = Feature;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../../components/Header/Header":"j0rW0","../../components/Footer/Footer":"2Br4S","react-helmet-async":"5Z9jX","../../components/Button":"d3NfG","../../icons/IconsMill":"d7m2z","../../icons/IconsHouse1":"cvuiF","../../icons/IconsHouse2":"gfYuP","../../icons/IconsPlug1":"99oWe","../../icons/IconsCloudLaptop":"5ghaX","../../icons/IconsPhone":"fEH0X","../../assets/mobile-web-app-testing.svg":"iJWO5","../../assets/worker.png":"kLtSv","../../assets/TrailbluNoCodeTesting.gif":"knbbb","../../assets/TrailbluSelfHealing.gif":"g7jqP","../../assets/TrailbluVisualTesting.gif":"dT9eh","../../assets/TrailbluGenAI.gif":"kYhtV","./style.css":"ebAGM","../../assets/killerFeatureGenAI.png":"lFBhE","../../assets/killerFeatureNoCode.png":"bSI1t","../../assets/killerFeatureSelfHealing.png":"lChOK","../../assets/killerFeatureVisualTesting.png":"exeui","../../assets/noCodeFeatureIcons/1write.svg":"bR24o","../../assets/noCodeFeatureIcons/2groupOfPeople.svg":"7S58M","../../assets/noCodeFeatureIcons/3RocketLaunching.svg":"2I7le","../../assets/noCodeFeatureIcons/4FixedSetting.svg":"2Rsr4","../../assets/genAiFeatureIcons/1puzzle-piece.svg":"9PsQY","../../assets/genAiFeatureIcons/2stopwatch.svg":"8lsaL","../../assets/genAiFeatureIcons/3shield.svg":"fHWtp","../../assets/genAiFeatureIcons/4danger.svg":"4qVoo","../../assets/genAiFeatureIcons/5transparency.svg":"ioGCw","../../assets/genAiFeatureIcons/6quality.svg":"kMRlw","../../assets/visualTestingFeatureIcons/1magnifying-glass.svg":"exRPr","../../assets/visualTestingFeatureIcons/2target.svg":"eyG8h","../../assets/visualTestingFeatureIcons/3responsive.svg":"kNHFd","../../assets/visualTestingFeatureIcons/4screenshot.svg":"7m4Zi","../../assets/visualTestingFeatureIcons/5analyzing.svg":"aT8Xy","../../assets/selfHealingFeatureIcons/1guarantee.svg":"4zALW","../../assets/selfHealingFeatureIcons/2automatic.svg":"fZu0c","../../assets/selfHealingFeatureIcons/3shield-update.svg":"i16yW","../../assets/selfHealingFeatureIcons/4increasing-bar.svg":"8jlFB","../../assets/selfHealingFeatureIcons/5decreasing-bar.svg":"fRzda","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knbbb":[function(require,module,exports) {
module.exports = require("552504ab0931c205").getBundleURL("4oMEl") + "TrailbluNoCodeTesting.61ac6ae4.gif";

},{"552504ab0931c205":"c7Tr5"}],"g7jqP":[function(require,module,exports) {
module.exports = require("bbd6a8397c93994").getBundleURL("4oMEl") + "TrailbluSelfHealing.07b6d22b.gif";

},{"bbd6a8397c93994":"c7Tr5"}],"dT9eh":[function(require,module,exports) {
module.exports = require("21063a05ce66177").getBundleURL("4oMEl") + "TrailbluVisualTesting.36235996.gif";

},{"21063a05ce66177":"c7Tr5"}],"kYhtV":[function(require,module,exports) {
module.exports = require("2c3ceb515d4878eb").getBundleURL("4oMEl") + "TrailbluGenAI.0b2ac43b.gif";

},{"2c3ceb515d4878eb":"c7Tr5"}],"ebAGM":[function() {},{}],"lFBhE":[function(require,module,exports) {
module.exports = require("eb2bd9173b169938").getBundleURL("4oMEl") + "killerFeatureGenAI.7ec76e29.png";

},{"eb2bd9173b169938":"c7Tr5"}],"bSI1t":[function(require,module,exports) {
module.exports = require("fffc3fe165c90cf4").getBundleURL("4oMEl") + "killerFeatureNoCode.99673061.png";

},{"fffc3fe165c90cf4":"c7Tr5"}],"lChOK":[function(require,module,exports) {
module.exports = require("2abed40613a8c8bd").getBundleURL("4oMEl") + "killerFeatureSelfHealing.db589f7d.png";

},{"2abed40613a8c8bd":"c7Tr5"}],"exeui":[function(require,module,exports) {
module.exports = require("154f64569494224f").getBundleURL("4oMEl") + "killerFeatureVisualTesting.e19e0d06.png";

},{"154f64569494224f":"c7Tr5"}],"bR24o":[function(require,module,exports) {
module.exports = require("b349e0af30a90b13").getBundleURL("4oMEl") + "1write.bb0c16f7.svg";

},{"b349e0af30a90b13":"c7Tr5"}],"7S58M":[function(require,module,exports) {
module.exports = require("decf6a94ca749851").getBundleURL("4oMEl") + "2groupOfPeople.9bf9a387.svg";

},{"decf6a94ca749851":"c7Tr5"}],"2I7le":[function(require,module,exports) {
module.exports = require("fd271822e5d7678b").getBundleURL("4oMEl") + "3RocketLaunching.df79e9c8.svg";

},{"fd271822e5d7678b":"c7Tr5"}],"2Rsr4":[function(require,module,exports) {
module.exports = require("49d6e116b135a9da").getBundleURL("4oMEl") + "4FixedSetting.9dc42b11.svg";

},{"49d6e116b135a9da":"c7Tr5"}],"9PsQY":[function(require,module,exports) {
module.exports = require("3c0e485cb53101b8").getBundleURL("4oMEl") + "1puzzle-piece.f26e506e.svg";

},{"3c0e485cb53101b8":"c7Tr5"}],"8lsaL":[function(require,module,exports) {
module.exports = require("f7d2fd3449bd3d1c").getBundleURL("4oMEl") + "2stopwatch.168e76b4.svg";

},{"f7d2fd3449bd3d1c":"c7Tr5"}],"fHWtp":[function(require,module,exports) {
module.exports = require("18f7aa2c3dc295f8").getBundleURL("4oMEl") + "3shield.1cf4f3d3.svg";

},{"18f7aa2c3dc295f8":"c7Tr5"}],"4qVoo":[function(require,module,exports) {
module.exports = require("dd908c046ddd7683").getBundleURL("4oMEl") + "4danger.ec699758.svg";

},{"dd908c046ddd7683":"c7Tr5"}],"ioGCw":[function(require,module,exports) {
module.exports = require("193121976a984c6").getBundleURL("4oMEl") + "5transparency.2ad7ee61.svg";

},{"193121976a984c6":"c7Tr5"}],"kMRlw":[function(require,module,exports) {
module.exports = require("b65c99f42071c2ed").getBundleURL("4oMEl") + "6quality.fb71439b.svg";

},{"b65c99f42071c2ed":"c7Tr5"}],"exRPr":[function(require,module,exports) {
module.exports = require("1dbb5425d399bf23").getBundleURL("4oMEl") + "1magnifying-glass.149046e5.svg";

},{"1dbb5425d399bf23":"c7Tr5"}],"eyG8h":[function(require,module,exports) {
module.exports = require("ffa84d809acabfc9").getBundleURL("4oMEl") + "2target.342a8945.svg";

},{"ffa84d809acabfc9":"c7Tr5"}],"kNHFd":[function(require,module,exports) {
module.exports = require("3a0b68bf9e2dd34").getBundleURL("4oMEl") + "3responsive.0b62c3c7.svg";

},{"3a0b68bf9e2dd34":"c7Tr5"}],"7m4Zi":[function(require,module,exports) {
module.exports = require("1bbe442508c6c66").getBundleURL("4oMEl") + "4screenshot.c2043cf9.svg";

},{"1bbe442508c6c66":"c7Tr5"}],"aT8Xy":[function(require,module,exports) {
module.exports = require("96091272bfbee460").getBundleURL("4oMEl") + "5analyzing.5c62edc9.svg";

},{"96091272bfbee460":"c7Tr5"}],"4zALW":[function(require,module,exports) {
module.exports = require("5e1882953e0999ae").getBundleURL("4oMEl") + "1guarantee.d361dc46.svg";

},{"5e1882953e0999ae":"c7Tr5"}],"fZu0c":[function(require,module,exports) {
module.exports = require("5f15f12b97426d8f").getBundleURL("4oMEl") + "2automatic.fc813c8d.svg";

},{"5f15f12b97426d8f":"c7Tr5"}],"i16yW":[function(require,module,exports) {
module.exports = require("192347debec3ff56").getBundleURL("4oMEl") + "3shield-update.22ef117d.svg";

},{"192347debec3ff56":"c7Tr5"}],"8jlFB":[function(require,module,exports) {
module.exports = require("b3bae489cc2a9f5f").getBundleURL("4oMEl") + "4increasing-bar.615c73ce.svg";

},{"b3bae489cc2a9f5f":"c7Tr5"}],"fRzda":[function(require,module,exports) {
module.exports = require("b95d677164f5ea25").getBundleURL("4oMEl") + "5decreasing-bar.f0fb167e.svg";

},{"b95d677164f5ea25":"c7Tr5"}],"lNOdI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestADemo", ()=>RequestADemo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("../../components/Header/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _reactHelmetAsync = require("react-helmet-async");
var _form = require("../../components/Form/Form");
var _coloredFibaBankaPng = require("../../assets/coloredFibaBanka.png");
var _coloredFibaBankaPngDefault = parcelHelpers.interopDefault(_coloredFibaBankaPng);
var _coloredAktifBankPng = require("../../assets/coloredAktifBank.png");
var _coloredAktifBankPngDefault = parcelHelpers.interopDefault(_coloredAktifBankPng);
var _osigoLogoPng = require("../../assets/osigoLogo.png");
var _osigoLogoPngDefault = parcelHelpers.interopDefault(_osigoLogoPng);
//import LogoCompany from "../../assets/coloredLogo.png";
var _reactGoogleRecaptchaV3 = require("react-google-recaptcha-v3");
var _styleCss = require("./style.css");
const RequestADemo = ()=>{
    const [windowWidth, setWindowWidth] = (0, _react.useState)(window.innerWidth);
    (0, _react.useEffect)(()=>{
        const handleResize = ()=>{
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main-demo",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                        children: "Request a Demo | AI-Powered Test Automation Tool - TRAILBLU"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        name: "description",
                        content: "Experience seamless app testing with TRAILBLU's AI-powered tool. Request a demo today to explore effortless test automation for mobile and web apps \u2013 no code required!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "demo-double-section",
                children: [
                    windowWidth < 700 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactGoogleRecaptchaV3.GoogleReCaptchaProvider), {
                            reCaptchaKey: "6Lebh0kmAAAAADBJ2_lCpmVKMTNtAKVmjCbn3bfv",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Form), {})
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "demo-first-section",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "/",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "home-style",
                                    children: " \u2190 Go Back"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "demo-first-inner-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                        className: "h1-demo",
                                        children: [
                                            "Experience the brilliance of AI-driven testing! Book your demo with",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "primary-color-demo",
                                                children: " TRAILBLU"
                                            }),
                                            " today."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-6-demo",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-4",
                                                    children: "Trusted by"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-7-demo",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "img-wrapper2-demo",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "companies-demo",
                                                                alt: "Fibabanka",
                                                                src: (0, _coloredFibaBankaPngDefault.default)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "img-wrapper2-demo",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "companies-demo",
                                                                alt: "Osigo",
                                                                src: (0, _osigoLogoPngDefault.default)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "img-wrapper2-demo",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "companies-demo",
                                                                alt: "Aktifbank",
                                                                src: (0, _coloredAktifBankPngDefault.default)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    windowWidth > 700 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactGoogleRecaptchaV3.GoogleReCaptchaProvider), {
                        reCaptchaKey: "6Lebh0kmAAAAADBJ2_lCpmVKMTNtAKVmjCbn3bfv",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Form), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = RequestADemo;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Header/Header":"j0rW0","../../components/Footer/Footer":"2Br4S","react-helmet-async":"5Z9jX","../../components/Form/Form":"cFlxM","../../assets/coloredFibaBanka.png":"1gu8p","../../assets/coloredAktifBank.png":"7ZdGm","../../assets/osigoLogo.png":"4MzbP","react-google-recaptcha-v3":"7ZWFw","./style.css":"kPaHl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFlxM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _button = require("../Button/Button");
var _inputLabel = require("../../components/InputLabel");
var _reactGoogleRecaptcha = require("react-google-recaptcha");
var _reactGoogleRecaptchaDefault = parcelHelpers.interopDefault(_reactGoogleRecaptcha);
var _formCss = require("./form.css");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _reactGoogleRecaptchaV3 = require("react-google-recaptcha-v3");
var _logoPng = require("../../assets/Logo.png");
var _logoPngDefault = parcelHelpers.interopDefault(_logoPng);
const Form = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { executeRecaptcha } = (0, _reactGoogleRecaptchaV3.useGoogleReCaptcha)();
    const [submitted, setSubmitted] = (0, _react.useState)(false);
    const [showPopup, setShowPopup] = (0, _react.useState)(false);
    const [showSuccessMessage, setShowSuccessMessage] = (0, _react.useState)(false);
    const [SuccessMsg, setSuccessMsg] = (0, _react.useState)("");
    const [ErrorMsg, setErrorMsg] = (0, _react.useState)("");
    const [valid_token, setValidToken] = (0, _react.useState)([]);
    const captchaRef = (0, _react.useRef)(null);
    const [formData, setFormData] = (0, _react.useState)({
        name: "",
        email: "",
        company: "",
        jobtitle: "",
        companyweb: "",
        phone: "",
        message: "",
        fax_number: ""
    });
    const [message, setMessage] = (0, _react.useState)("");
    const handleInputChange = (e)=>{
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const submitForm = (0, _react.useCallback)(async ()=>{
        try {
            // Perform reCAPTCHA verification
            if (!executeRecaptcha) {
                console.log("Execute recaptcha not yet available");
                return;
            }
            const recaptchaToken = await executeRecaptcha("formSubmission");
            // Include the recaptcha token in your form data
            const updatedFormData = {
                ...formData,
                recaptcha_token: recaptchaToken
            };
            // Perform form submission
            const url = "https://api.trailblu.com/users/sendform";
            (0, _axiosDefault.default)(url, {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                data: updatedFormData
            }).then((response1)=>{
                console.log("then", response1.data);
                navigate("/thank-you/submission");
                return response1.data;
            }).catch((error)=>{
                console.log("then2", response.data);
                throw error;
            });
            setSubmitted(true);
            setTimeout(()=>{
                setSubmitted(false);
                navigate("/thank-you/submission");
            }, 3000);
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "frame-12-form",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                href: "/",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: (0, _logoPngDefault.default),
                    className: "logo-style"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-22",
                id: "section7",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-24",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-wrapper-14-form",
                                children: "Schedule a product demo with expert Q&A"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                            className: "frame-25",
                            id: "section8",
                            action: "https://api.trailblu.com/users/sendform",
                            method: "POST",
                            onSubmit: (e)=>{
                                e.preventDefault();
                                submitForm();
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-28",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabel.InputLabel), {
                                            className: "input-label-4",
                                            inputPropertyDefaultClassName: "design-component-instance-node-2",
                                            placeholderText: "E.g: John Johnson",
                                            text: "Name",
                                            type: "name",
                                            name: "name",
                                            id: "name",
                                            minlength: "3",
                                            value: formData.name,
                                            onChange: handleInputChange
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabel.InputLabel), {
                                            className: "input-label-4",
                                            inputPropertyDefaultClassName: "design-component-instance-node-2",
                                            placeholderText: "E.g: john@tesla.com",
                                            text: "Business email address",
                                            type: "email",
                                            name: "email",
                                            id: "email",
                                            minlength: "3",
                                            value: formData.email,
                                            onChange: handleInputChange
                                        })
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-28",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabel.InputLabel), {
                                            className: "input-label-4",
                                            inputPropertyDefaultClassName: "design-component-instance-node-2",
                                            placeholderText: "E.g: Tesla",
                                            text: "Company name",
                                            minlength: "3",
                                            type: "text",
                                            name: "company",
                                            id: "company",
                                            value: formData.company,
                                            onChange: handleInputChange
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabel.InputLabel), {
                                            className: "input-label-4",
                                            inputPropertyDefaultClassName: "design-component-instance-node-2",
                                            placeholderText: "E.g: Vice president IT",
                                            text: "Job title",
                                            minlength: "3",
                                            type: "text",
                                            name: "jobtitle",
                                            id: "jobtitle",
                                            value: formData.jobtitle,
                                            onChange: handleInputChange
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-28",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabel.InputLabel), {
                                            className: "input-label-4",
                                            inputPropertyDefaultClassName: "design-component-instance-node-2",
                                            placeholderText: "E.g: tesla.com",
                                            text: "Company website",
                                            minlength: "4",
                                            type: "text",
                                            name: "companyweb",
                                            id: "companyweb",
                                            value: formData.companyweb,
                                            onChange: handleInputChange
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabel.InputLabel), {
                                            className: "input-label-4",
                                            inputPropertyDefaultClassName: "design-component-instance-node-2",
                                            placeholderText: "E.g: 05xxxxxxxxx",
                                            text: "Phone number",
                                            name: "phone",
                                            type: "text",
                                            minlength: "8",
                                            id: "phone",
                                            value: formData.phone,
                                            onChange: handleInputChange
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "input-label-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabel.InputLabel), {
                                        className: "design-component-instance-node-3",
                                        inputPlaceholderClassName: "input-label-3",
                                        inputPropertyDefaultClassName: "input-label-2",
                                        placeholderText: "Write your message here...",
                                        text: "Your message",
                                        minlength: "5",
                                        name: "message",
                                        id: "message",
                                        value: formData.message,
                                        onChange: handleInputChange,
                                        style: {
                                            height: "100px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    name: "fax_number",
                                    value: formData.fax_number,
                                    onChange: handleInputChange,
                                    tabIndex: -1,
                                    autoComplete: "off",
                                    "aria-hidden": "true",
                                    style: {
                                        position: "absolute",
                                        left: "-10000px",
                                        width: "1px",
                                        height: "1px",
                                        overflow: "hidden"
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-footer-has-text-centered-mt-10",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            className: "button-submit",
                                            stateProp: "normal",
                                            style: "solid",
                                            text: submitted ? "Submitting..." : "Request a demo",
                                            type: "regular",
                                            id: "submitbutton",
                                            disabled: submitted
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            id: "messageContainer",
                                            children: message
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../Button/Button":"jAaxT","../../components/InputLabel":"6qLwy","react-google-recaptcha":"cyyj8","./form.css":"7FgWD","axios":"gqqlV","react-google-recaptcha-v3":"7ZWFw","../../assets/Logo.png":"22Rfz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6qLwy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputLabel", ()=>(0, _inputLabel.InputLabel));
var _inputLabel = require("./InputLabel");

},{"./InputLabel":"1J1H8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1J1H8":[function(require,module,exports) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputLabel", ()=>InputLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _input = require("../Input/Input");
var _styleCss = require("./style.css");
const InputLabel = ({ className, text = "Label", placeholderText, inputPropertyDefaultClassName, inputPlaceholderClassName, onChange, value, name, type, id, minlength })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `input-label ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                children: text
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                PLACEHOLDERClassName: inputPlaceholderClassName,
                className: inputPropertyDefaultClassName,
                property1: "default",
                placeholderText: placeholderText,
                text: text,
                onChange: onChange,
                value: value,
                name: name,
                type: type,
                minlength: minlength,
                id: id
            })
        ]
    });
};
InputLabel.propTypes = {
    text: (0, _propTypesDefault.default).string,
    inputText: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gaGEj","prop-types":"6FKs7","react":"6uln9","../Input/Input":"aVB6e","./style.css":"isj6B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aVB6e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", ()=>Input);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const Input = ({ property1, className, placeholderText, PLACEHOLDERClassName, text, onChange, value, type, name, id, minlength })=>{
    const [state, dispatch] = (0, _react.useReducer)(reducer, {
        property1: property1 || "default"
    });
    //const [inputValue, setInputValue] = useState("");
    //const handleInputChange = (event) => {
    //setInputValue(event.target.value);
    //onChange(event);
    //};
    return text === "Your message" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
        className: `input-custom ${state.property1} ${className}`,
        placeholder: placeholderText,
        rows: "5" // Set the number of rows for the textarea
        ,
        required: true,
        onChange: onChange,
        value: value,
        type: type,
        name: name,
        id: id,
        minLength: minlength
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        value: value,
        required: true,
        //  className={`PLACEHOLDER ${PLACEHOLDERClassName}`}
        className: `input-custom ${state.property1} ${className}`,
        placeholder: placeholderText,
        onChange: onChange,
        type: type,
        name: name,
        id: id,
        minLength: minlength
    });
};
function reducer(state, action) {
    switch(action){
        case "mouse_enter":
            return {
                ...state,
                property1: "variant-2"
            };
        case "mouse_leave":
            return {
                ...state,
                property1: "default"
            };
    }
    return state;
}
Input.propTypes = {
    property1: (0, _propTypesDefault.default).oneOf([
        "variant-2",
        "default"
    ]),
    placeholderText: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gaGEj","prop-types":"6FKs7","react":"6uln9","./style.css":"30FHD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"30FHD":[function() {},{}],"isj6B":[function() {},{}],"cyyj8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReCAPTCHA", ()=>(0, _recaptchaDefault.default));
var _recaptchaWrapper = require("./recaptcha-wrapper");
var _recaptchaWrapperDefault = parcelHelpers.interopDefault(_recaptchaWrapper);
var _recaptcha = require("./recaptcha");
var _recaptchaDefault = parcelHelpers.interopDefault(_recaptcha);
exports.default = (0, _recaptchaWrapperDefault.default);

},{"./recaptcha-wrapper":"7nkmc","./recaptcha":"rV3Tt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7nkmc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _recaptcha = require("./recaptcha");
var _recaptchaDefault = parcelHelpers.interopDefault(_recaptcha);
var _reactAsyncScript = require("react-async-script");
var _reactAsyncScriptDefault = parcelHelpers.interopDefault(_reactAsyncScript);
var callbackName = "onloadcallback";
var globalName = "grecaptcha";
function getOptions() {
    return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function getURL() {
    var dynamicOptions = getOptions();
    var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
    if (dynamicOptions.enterprise) return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + callbackName + "&render=explicit";
    return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}
exports.default = (0, _reactAsyncScriptDefault.default)(getURL, {
    callbackName: callbackName,
    globalName: globalName,
    attributes: getOptions().nonce ? {
        nonce: getOptions().nonce
    } : {}
})((0, _recaptchaDefault.default));

},{"./recaptcha":"rV3Tt","react-async-script":"lh4jg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"rV3Tt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReCAPTCHA);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "sitekey",
    "onChange",
    "theme",
    "type",
    "tabindex",
    "onExpired",
    "onErrored",
    "size",
    "stoken",
    "grecaptcha",
    "badge",
    "hl",
    "isolated"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var ReCAPTCHA = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ReCAPTCHA, _React$Component);
    function ReCAPTCHA() {
        var _this;
        _this = _React$Component.call(this) || this;
        _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
        _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
        _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = ReCAPTCHA.prototype;
    _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
        if (this.props.grecaptcha) {
            if (this.props.grecaptcha.enterprise) return this.props.grecaptcha.enterprise[fnName];
            return this.props.grecaptcha[fnName];
        }
        return null;
    };
    _proto.getValue = function getValue() {
        var getResponse = this.getCaptchaFunction("getResponse");
        if (getResponse && this._widgetId !== undefined) return getResponse(this._widgetId);
        return null;
    };
    _proto.getWidgetId = function getWidgetId() {
        if (this.props.grecaptcha && this._widgetId !== undefined) return this._widgetId;
        return null;
    };
    _proto.execute = function execute() {
        var execute = this.getCaptchaFunction("execute");
        if (execute && this._widgetId !== undefined) return execute(this._widgetId);
        else this._executeRequested = true;
    };
    _proto.executeAsync = function executeAsync() {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.executionResolve = resolve;
            _this2.executionReject = reject;
            _this2.execute();
        });
    };
    _proto.reset = function reset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter && this._widgetId !== undefined) resetter(this._widgetId);
    };
    _proto.forceReset = function forceReset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter) resetter();
    };
    _proto.handleExpired = function handleExpired() {
        if (this.props.onExpired) this.props.onExpired();
        else this.handleChange(null);
    };
    _proto.handleErrored = function handleErrored() {
        if (this.props.onErrored) this.props.onErrored();
        if (this.executionReject) {
            this.executionReject();
            delete this.executionResolve;
            delete this.executionReject;
        }
    };
    _proto.handleChange = function handleChange(token) {
        if (this.props.onChange) this.props.onChange(token);
        if (this.executionResolve) {
            this.executionResolve(token);
            delete this.executionReject;
            delete this.executionResolve;
        }
    };
    _proto.explicitRender = function explicitRender() {
        var render = this.getCaptchaFunction("render");
        if (render && this._widgetId === undefined) {
            var wrapper = document.createElement("div");
            this._widgetId = render(wrapper, {
                sitekey: this.props.sitekey,
                callback: this.handleChange,
                theme: this.props.theme,
                type: this.props.type,
                tabindex: this.props.tabindex,
                "expired-callback": this.handleExpired,
                "error-callback": this.handleErrored,
                size: this.props.size,
                stoken: this.props.stoken,
                hl: this.props.hl,
                badge: this.props.badge,
                isolated: this.props.isolated
            });
            this.captcha.appendChild(wrapper);
        }
        if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
            this._executeRequested = false;
            this.execute();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        this.explicitRender();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.explicitRender();
    };
    _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
        this.captcha = elem;
    };
    _proto.render = function render() {
        // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
        /* eslint-disable no-unused-vars */ var _this$props = this.props, sitekey = _this$props.sitekey, onChange = _this$props.onChange, theme = _this$props.theme, type = _this$props.type, tabindex = _this$props.tabindex, onExpired = _this$props.onExpired, onErrored = _this$props.onErrored, size = _this$props.size, stoken = _this$props.stoken, grecaptcha = _this$props.grecaptcha, badge = _this$props.badge, hl = _this$props.hl, isolated = _this$props.isolated, childProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ _react.createElement("div", _extends({}, childProps, {
            ref: this.handleRecaptchaRef
        }));
    };
    return ReCAPTCHA;
}(_react.Component);
ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
    sitekey: (0, _propTypesDefault.default).string.isRequired,
    onChange: (0, _propTypesDefault.default).func,
    grecaptcha: (0, _propTypesDefault.default).object,
    theme: (0, _propTypesDefault.default).oneOf([
        "dark",
        "light"
    ]),
    type: (0, _propTypesDefault.default).oneOf([
        "image",
        "audio"
    ]),
    tabindex: (0, _propTypesDefault.default).number,
    onExpired: (0, _propTypesDefault.default).func,
    onErrored: (0, _propTypesDefault.default).func,
    size: (0, _propTypesDefault.default).oneOf([
        "compact",
        "normal",
        "invisible"
    ]),
    stoken: (0, _propTypesDefault.default).string,
    hl: (0, _propTypesDefault.default).string,
    badge: (0, _propTypesDefault.default).oneOf([
        "bottomright",
        "bottomleft",
        "inline"
    ]),
    isolated: (0, _propTypesDefault.default).bool
};
ReCAPTCHA.defaultProps = {
    onChange: function onChange() {},
    theme: "light",
    type: "image",
    tabindex: 0,
    size: "normal",
    badge: "bottomright"
};

},{"react":"6uln9","prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lh4jg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>makeAsyncScript);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            _inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if (SCRIPT_MAP[scriptURL]) {
                    var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if (SCRIPT_MAP[scriptURL]) {
                        var mapEntry = SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = _objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, _react.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, _react.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, _react.forwardRef)(function(props, ref) {
            return (0, _react.createElement)(AsyncScriptLoader, _extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, _propTypesDefault.default).func
        };
        return (0, _hoistNonReactStaticsDefault.default)(ForwardedComponent, WrappedComponent);
    };
}

},{"react":"6uln9","prop-types":"6FKs7","hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bvdc":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"69RSM"}],"69RSM":[function(require,module,exports) {
"use strict";
module.exports = require("569f914be4368a39");

},{"569f914be4368a39":"2UEgQ"}],"2UEgQ":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"7FgWD":[function() {},{}],"gqqlV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"bpQHr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bpQHr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"j4U5Z","./helpers/bind.js":"lsHw8","./core/Axios.js":"gSzLM","./core/mergeConfig.js":"hBFgb","./defaults/index.js":"5ajHU","./helpers/formDataToJSON.js":"lvQ77","./cancel/CanceledError.js":"2SXaM","./cancel/CancelToken.js":"d4MXP","./cancel/isCancel.js":"kQA2M","./env/data.js":"dV7xS","./helpers/toFormData.js":"SFWXV","./core/AxiosError.js":"e7UnU","./helpers/spread.js":"jQT5B","./helpers/isAxiosError.js":"2EXuU","./core/AxiosHeaders.js":"kmeTN","./adapters/adapters.js":"lFvV1","./helpers/HttpStatusCode.js":"8j5L4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j4U5Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== "object") return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable
};

},{"./helpers/bind.js":"lsHw8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lsHw8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
"use strict";
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSzLM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"j4U5Z","../helpers/buildURL.js":"hOGC1","./InterceptorManager.js":"g8bpG","./dispatchRequest.js":"98TLw","./mergeConfig.js":"hBFgb","./buildFullPath.js":"6MlRA","../helpers/validator.js":"ky4Bn","./AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hOGC1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

},{"../utils.js":"j4U5Z","../helpers/AxiosURLSearchParams.js":"9zMgc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zMgc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"SFWXV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"SFWXV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, _utilsJsDefault.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, "[]")) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"l5Twm","../utils.js":"j4U5Z","../core/AxiosError.js":"e7UnU","../platform/node/classes/FormData.js":"jlmg9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l5Twm":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6Pb1S":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"6ifNR":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"e7UnU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlmg9":[function(require,module,exports) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8bpG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98TLw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"74rSt","../cancel/isCancel.js":"kQA2M","../defaults/index.js":"5ajHU","../cancel/CanceledError.js":"2SXaM","../core/AxiosHeaders.js":"kmeTN","../adapters/adapters.js":"lFvV1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"74rSt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"j4U5Z","../defaults/index.js":"5ajHU","../core/AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ajHU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            }
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"j4U5Z","../core/AxiosError.js":"e7UnU","./transitional.js":"1sSt7","../helpers/toFormData.js":"SFWXV","../helpers/toURLEncodedForm.js":"f1oER","../platform/index.js":"Y0LSh","../helpers/formDataToJSON.js":"lvQ77","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1sSt7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f1oER":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"j4U5Z","./toFormData.js":"SFWXV","../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Y0LSh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"haxDI","./common/utils.js":"9bQaq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haxDI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

},{"./classes/URLSearchParams.js":"8vuBk","./classes/FormData.js":"bzfcl","./classes/Blob.js":"kfCzj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vuBk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
exports.default = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"9zMgc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzfcl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof FormData !== "undefined" ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfCzj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof Blob !== "undefined" ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9bQaq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = ((product)=>{
    return hasBrowserEnv && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvQ77":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kmeTN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
"use strict";
const $internals = Symbol("internals");
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"j4U5Z","../helpers/parseHeaders.js":"g7ZuC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g7ZuC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQA2M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
"use strict";
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SXaM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? "canceled" : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"e7UnU","../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lFvV1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"j4U5Z","./http.js":"jlmg9","./xhr.js":"hVrwR","../core/AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVrwR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _cookiesJs = require("./../helpers/cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildURLJs = require("./../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _isURLSameOriginJs = require("./../helpers/isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _speedometerJs = require("../helpers/speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
"use strict";
function progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(config.headers).normalize();
        let { responseType, withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, _utilsJsDefault.default).isFormData(requestData)) {
            if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)("Request aborted", (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)("Network Error", (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, _transitionalJsDefault.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, _cookiesJsDefault.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(fullPath);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)("Unsupported protocol " + protocol + ":", (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"j4U5Z","./../core/settle.js":"jaZcJ","./../helpers/cookies.js":"eD59s","./../helpers/buildURL.js":"hOGC1","../core/buildFullPath.js":"6MlRA","./../helpers/isURLSameOrigin.js":"3QStk","../defaults/transitional.js":"1sSt7","../core/AxiosError.js":"e7UnU","../cancel/CanceledError.js":"2SXaM","../helpers/parseProtocol.js":"lrlmI","../platform/index.js":"Y0LSh","../core/AxiosHeaders.js":"kmeTN","../helpers/speedometer.js":"jDdfD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jaZcJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)("Request failed with status code " + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eD59s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push("path=" + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"j4U5Z","../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6MlRA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
"use strict";
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"02G4G","../helpers/combineURLs.js":"6BOaY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"02G4G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
"use strict";
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6BOaY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
"use strict";
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3QStk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, _utilsJsDefault.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"./../utils.js":"j4U5Z","../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lrlmI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
"use strict";
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDdfD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBFgb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? thing.toJSON() : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties(headersToObject(a), headersToObject(b), true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"j4U5Z","./AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ky4Bn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
const validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, _dataJs.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, _axiosErrorJsDefault.default)("options must be an object", (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)("option " + opt + " must be " + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)("Unknown option " + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"dV7xS","../core/AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dV7xS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.6.2";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d4MXP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"2SXaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jQT5B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
"use strict";
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2EXuU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8j5L4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ZWFw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleReCaptcha", ()=>S);
parcelHelpers.export(exports, "GoogleReCaptchaConsumer", ()=>b);
parcelHelpers.export(exports, "GoogleReCaptchaContext", ()=>v);
parcelHelpers.export(exports, "GoogleReCaptchaProvider", ()=>h);
parcelHelpers.export(exports, "useGoogleReCaptcha", ()=>g);
parcelHelpers.export(exports, "withGoogleReCaptcha", ()=>ne);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var process = require("ff664b674bc9ea57");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var s = function() {
    return s = Object.assign || function(e) {
        for(var t, r = 1, o = arguments.length; r < o; r++)for(var n in t = arguments[r])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        return e;
    }, s.apply(this, arguments);
};
function u(e, t, r, o) {
    return new (r || (r = Promise))(function(n, a) {
        function c(e) {
            try {
                s(o.next(e));
            } catch (e) {
                a(e);
            }
        }
        function i(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function s(e) {
            var t;
            e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(c, i);
        }
        s((o = o.apply(e, t || [])).next());
    });
}
function l(e, t) {
    var r, o, n, a, c = {
        label: 0,
        sent: function() {
            if (1 & n[0]) throw n[1];
            return n[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: i(0),
        throw: i(1),
        return: i(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function i(a) {
        return function(i) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; c;)try {
                    if (r = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                    switch(o = 0, n && (a = [
                        2 & a[0],
                        n.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            n = a;
                            break;
                        case 4:
                            return c.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            c.label++, o = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = c.ops.pop(), c.trys.pop();
                            continue;
                        default:
                            if (!(n = c.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                c = 0;
                                continue;
                            }
                            if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                c.label = a[1];
                                break;
                            }
                            if (6 === a[0] && c.label < n[1]) {
                                c.label = n[1], n = a;
                                break;
                            }
                            if (n && c.label < n[2]) {
                                c.label = n[2], c.ops.push(a);
                                break;
                            }
                            n[2] && c.ops.pop(), c.trys.pop();
                            continue;
                    }
                    a = t.call(e, c);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    r = n = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                i
            ]);
        };
    }
}
var f, p = function(e) {
    var t;
    e ? function(e) {
        if (e) for(; e.lastChild;)e.lastChild.remove();
    }("string" == typeof e ? document.getElementById(e) : e) : (t = document.querySelector(".grecaptcha-badge")) && t.parentNode && document.body.removeChild(t.parentNode);
}, d = function(e, t) {
    p(t), window.___grecaptcha_cfg = void 0;
    var r = document.querySelector("#" + e);
    r && r.remove(), function() {
        var e = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
        e && e.remove();
    }();
}, y = function(e) {
    var t = e.render, r = e.onLoadCallbackName, o = e.language, n = e.onLoad, a = e.useRecaptchaNet, c = e.useEnterprise, i = e.scriptProps, s = void 0 === i ? {} : i, u = s.nonce, l = void 0 === u ? "" : u, f = s.defer, p = void 0 !== f && f, d = s.async, y = void 0 !== d && d, m = s.id, v = void 0 === m ? "" : m, b = s.appendTo, h = v || "google-recaptcha-v3";
    if (function(e) {
        return !!document.querySelector("#" + e);
    }(h)) n();
    else {
        var g = function(e) {
            return "https://www." + (e.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (e.useEnterprise ? "enterprise.js" : "api.js");
        }({
            useEnterprise: c,
            useRecaptchaNet: a
        }), S = document.createElement("script");
        S.id = h, S.src = g + "?render=" + t + ("explicit" === t ? "&onload=" + r : "") + (o ? "&hl=" + o : ""), l && (S.nonce = l), S.defer = !!p, S.async = !!y, S.onload = n, ("body" === b ? document.body : document.getElementsByTagName("head")[0]).appendChild(S);
    }
}, m = function(e) {
    "undefined" != typeof process && process.env, console.warn(e);
};
!function(e) {
    e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
}(f || (f = {}));
var v = (0, _react.createContext)({
    executeRecaptcha: function() {
        throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
    }
}), b = v.Consumer;
function h(t) {
    var i = t.reCaptchaKey, u = t.useEnterprise, l = void 0 !== u && u, p = t.useRecaptchaNet, b = void 0 !== p && p, h = t.scriptProps, g = t.language, S = t.container, w = t.children, $ = (0, _react.useState)(null), C = $[0], P = $[1], x = (0, _react.useRef)(i), E = JSON.stringify(h), R = JSON.stringify(null == S ? void 0 : S.parameters);
    (0, _react.useEffect)(function() {
        if (i) {
            var e = (null == h ? void 0 : h.id) || "google-recaptcha-v3", t = (null == h ? void 0 : h.onLoadCallbackName) || "onRecaptchaLoadCallback";
            window[t] = function() {
                var e = l ? window.grecaptcha.enterprise : window.grecaptcha, t = s({
                    badge: "inline",
                    size: "invisible",
                    sitekey: i
                }, (null == S ? void 0 : S.parameters) || {});
                x.current = e.render(null == S ? void 0 : S.element, t);
            };
            return y({
                render: (null == S ? void 0 : S.element) ? "explicit" : i,
                onLoadCallbackName: t,
                useEnterprise: l,
                useRecaptchaNet: b,
                scriptProps: h,
                language: g,
                onLoad: function() {
                    if (window && window.grecaptcha) {
                        var e = l ? window.grecaptcha.enterprise : window.grecaptcha;
                        e.ready(function() {
                            P(e);
                        });
                    } else m("<GoogleRecaptchaProvider /> " + f.SCRIPT_NOT_AVAILABLE);
                },
                onError: function() {
                    m("Error loading google recaptcha script");
                }
            }), function() {
                d(e, null == S ? void 0 : S.element);
            };
        }
        m("<GoogleReCaptchaProvider /> recaptcha key not provided");
    }, [
        l,
        b,
        E,
        R,
        g,
        i,
        null == S ? void 0 : S.element
    ]);
    var M = (0, _react.useCallback)(function(e) {
        if (!C || !C.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
        return C.execute(x.current, {
            action: e
        });
    }, [
        C,
        x
    ]), N = (0, _react.useMemo)(function() {
        return {
            executeRecaptcha: C ? M : void 0,
            container: null == S ? void 0 : S.element
        };
    }, [
        M,
        C,
        null == S ? void 0 : S.element
    ]);
    return (0, _reactDefault.default).createElement(v.Provider, {
        value: N
    }, w);
}
var g = function() {
    return (0, _react.useContext)(v);
};
function S(t) {
    var r = this, o = t.action, a = t.onVerify, c = t.refreshReCaptcha, i = g();
    (0, _react.useEffect)(function() {
        var e = i.executeRecaptcha;
        if (e) u(r, void 0, void 0, function() {
            var t;
            return l(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            e(o)
                        ];
                    case 1:
                        return t = r.sent(), a ? (a(t), [
                            2
                        ]) : (m("Please define an onVerify function"), [
                            2
                        ]);
                }
            });
        });
    }, [
        o,
        a,
        c,
        i
    ]);
    var s = i.container;
    return "string" == typeof s ? (0, _reactDefault.default).createElement("div", {
        id: s
    }) : null;
}
function w(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ }
var $ = "function" == typeof Symbol && Symbol.for, C = $ ? Symbol.for("react.element") : 60103, P = $ ? Symbol.for("react.portal") : 60106, x = $ ? Symbol.for("react.fragment") : 60107, E = $ ? Symbol.for("react.strict_mode") : 60108, R = $ ? Symbol.for("react.profiler") : 60114, M = $ ? Symbol.for("react.provider") : 60109, N = $ ? Symbol.for("react.context") : 60110, O = $ ? Symbol.for("react.async_mode") : 60111, _ = $ ? Symbol.for("react.concurrent_mode") : 60111, T = $ ? Symbol.for("react.forward_ref") : 60112, j = $ ? Symbol.for("react.suspense") : 60113, L = $ ? Symbol.for("react.suspense_list") : 60120, k = $ ? Symbol.for("react.memo") : 60115, F = $ ? Symbol.for("react.lazy") : 60116, A = $ ? Symbol.for("react.block") : 60121, V = $ ? Symbol.for("react.fundamental") : 60117, z = $ ? Symbol.for("react.responder") : 60118, G = $ ? Symbol.for("react.scope") : 60119;
function I(e) {
    if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch(t){
            case C:
                switch(e = e.type){
                    case O:
                    case _:
                    case x:
                    case R:
                    case E:
                    case j:
                        return e;
                    default:
                        switch(e = e && e.$$typeof){
                            case N:
                            case T:
                            case F:
                            case k:
                            case M:
                                return e;
                            default:
                                return t;
                        }
                }
            case P:
                return t;
        }
    }
}
function D(e) {
    return I(e) === _;
}
var q = {
    AsyncMode: O,
    ConcurrentMode: _,
    ContextConsumer: N,
    ContextProvider: M,
    Element: C,
    ForwardRef: T,
    Fragment: x,
    Lazy: F,
    Memo: k,
    Portal: P,
    Profiler: R,
    StrictMode: E,
    Suspense: j,
    isAsyncMode: function(e) {
        return D(e) || I(e) === O;
    },
    isConcurrentMode: D,
    isContextConsumer: function(e) {
        return I(e) === N;
    },
    isContextProvider: function(e) {
        return I(e) === M;
    },
    isElement: function(e) {
        return "object" == typeof e && null !== e && e.$$typeof === C;
    },
    isForwardRef: function(e) {
        return I(e) === T;
    },
    isFragment: function(e) {
        return I(e) === x;
    },
    isLazy: function(e) {
        return I(e) === F;
    },
    isMemo: function(e) {
        return I(e) === k;
    },
    isPortal: function(e) {
        return I(e) === P;
    },
    isProfiler: function(e) {
        return I(e) === R;
    },
    isStrictMode: function(e) {
        return I(e) === E;
    },
    isSuspense: function(e) {
        return I(e) === j;
    },
    isValidElementType: function(e) {
        return "string" == typeof e || "function" == typeof e || e === x || e === _ || e === R || e === E || e === j || e === L || "object" == typeof e && null !== e && (e.$$typeof === F || e.$$typeof === k || e.$$typeof === M || e.$$typeof === N || e.$$typeof === T || e.$$typeof === V || e.$$typeof === z || e.$$typeof === G || e.$$typeof === A);
    },
    typeOf: I
}, B = w(function(e, t) {}), J = (B.AsyncMode, B.ConcurrentMode, B.ContextConsumer, B.ContextProvider, B.Element, B.ForwardRef, B.Fragment, B.Lazy, B.Memo, B.Portal, B.Profiler, B.StrictMode, B.Suspense, B.isAsyncMode, B.isConcurrentMode, B.isContextConsumer, B.isContextProvider, B.isElement, B.isForwardRef, B.isFragment, B.isLazy, B.isMemo, B.isPortal, B.isProfiler, B.isStrictMode, B.isSuspense, B.isValidElementType, B.typeOf, w(function(e) {
    e.exports = q;
})), K = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, H = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, Q = {};
function W(e) {
    return J.isMemo(e) ? H : Q[e.$$typeof] || K;
}
Q[J.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, Q[J.Memo] = H;
var X = Object.defineProperty, Y = Object.getOwnPropertyNames, Z = Object.getOwnPropertySymbols, ee = Object.getOwnPropertyDescriptor, te = Object.getPrototypeOf, re = Object.prototype;
var oe = function e(t, r, o) {
    if ("string" != typeof r) {
        if (re) {
            var n = te(r);
            n && n !== re && e(t, n, o);
        }
        var a = Y(r);
        Z && (a = a.concat(Z(r)));
        for(var c = W(t), i = W(r), s = 0; s < a.length; ++s){
            var u = a[s];
            if (!(U[u] || o && o[u] || i && i[u] || c && c[u])) {
                var l = ee(r, u);
                try {
                    X(t, u, l);
                } catch (e) {}
            }
        }
    }
    return t;
}, ne = function(t) {
    var r = function(r) {
        return (0, _reactDefault.default).createElement(b, null, function(o) {
            return (0, _reactDefault.default).createElement(t, s({}, r, {
                googleReCaptchaProps: o
            }));
        });
    };
    return r.displayName = "withGoogleReCaptcha(" + (t.displayName || t.name || "Component") + ")", oe(r, t), r;
};

},{"ff664b674bc9ea57":"5QIF0","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5QIF0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"kPaHl":[function() {},{}],"71jiP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("../../components/Header/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _styleCss = require("./style.css");
const NotFoundPage = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "main-not-found-page",
                style: {
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "h1-not-found",
                        children: "Oops! Page Not Found"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "p-not-found",
                        children: "The page you are looking for doesn't exist or an other error occurred."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "go-back-home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "/",
                            children: "Go back to the homepage"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: "https://www.trailblu.com/worker.2a57633e.png",
                        alt: "Page Not Found",
                        style: {
                            maxWidth: "100%",
                            height: "auto",
                            width: "450px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = NotFoundPage;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Header/Header":"j0rW0","../../components/Footer/Footer":"2Br4S","./style.css":"ivvVG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ivvVG":[function() {},{}],"7UjHy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("../../components/Header/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("../../components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _reactHelmetAsync = require("react-helmet-async");
var _workerPng = require("../../assets/worker.png");
var _workerPngDefault = parcelHelpers.interopDefault(_workerPng);
var _styleCss = require("./style.css");
const ThanksForSubmission = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "thank-main",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmetAsync.Helmet), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-wrapper-thank",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "div-2-thank",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-wrapper-thank",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-4-thank",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "text-wrapper-3-thank",
                                        children: "Thank You for Your Interest in Trailblu!"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "p-thank",
                                        children: "We've received your request for a demo. Our team will be in touch shortly to schedule a meeting and showcase our AI-powered, no-code testing platform. Stay tuned!"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "img-wrapper-thank",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "worker-thank",
                                alt: "Trailblu Worker Image",
                                src: (0, _workerPngDefault.default)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
        ]
    });
};
exports.default = ThanksForSubmission;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../components/Header/Header":"j0rW0","../../components/Footer/Footer":"2Br4S","react-helmet-async":"5Z9jX","../../assets/worker.png":"kLtSv","./style.css":"gbFME","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gbFME":[function() {},{}]},["5Tqlz"], "5Tqlz", "parcelRequireb8e7")

//# sourceMappingURL=index.1ca8f6c7.js.map
